/*! instant.page v1.2.2 - (C) 2019 Alexandre Dieulot - https://instant.page/license */
"use strict";
var urlToPreload = void 0,
  mouseoverTimer = void 0,
  lastTouchTimestamp = void 0,
  prefetcher = document.createElement("link"),
  isSupported =
    prefetcher.relList &&
    prefetcher.relList.supports &&
    prefetcher.relList.supports("prefetch"),
  isDataSaverEnabled = navigator.connection && navigator.connection.saveData,
  allowQueryString = "instantAllowQueryString" in document.body.dataset,
  allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset;
if (isSupported && !isDataSaverEnabled) {
  ((prefetcher.rel = "prefetch"), document.head.appendChild(prefetcher));
  var eventListenersOptions = { capture: !0, passive: !0 };
  (document.addEventListener(
    "touchstart",
    touchstartListener,
    eventListenersOptions,
  ),
    document.addEventListener(
      "mouseover",
      mouseoverListener,
      eventListenersOptions,
    ));
}
function touchstartListener(t) {
  lastTouchTimestamp = performance.now();
  if (!t.target || !t.target.closest) return;
  var e = t.target.closest("a");
  isPreloadable(e) &&
    (e.addEventListener("touchcancel", touchendAndTouchcancelListener, {
      passive: !0,
    }),
    e.addEventListener("touchend", touchendAndTouchcancelListener, {
      passive: !0,
    }),
    (urlToPreload = e.href),
    preload(e.href));
}
function touchendAndTouchcancelListener() {
  ((urlToPreload = void 0), stopPreloading());
}
function mouseoverListener(t) {
  if (!(performance.now() - lastTouchTimestamp < 1100)) {
	if (!t.target || !t.target.closest) return;
    var e = t.target.closest("a");
    isPreloadable(e) &&
      (e.addEventListener("mouseout", mouseoutListener, { passive: !0 }),
      (urlToPreload = e.href),
      (mouseoverTimer = setTimeout(function () {
        (preload(e.href), (mouseoverTimer = void 0));
      }, 65)));
  }
}
function mouseoutListener(t) {
  (t.relatedTarget && t.target.closest("a") == t.relatedTarget.closest("a")) ||
    (mouseoverTimer
      ? (clearTimeout(mouseoverTimer), (mouseoverTimer = void 0))
      : ((urlToPreload = void 0), stopPreloading()));
}
function isPreloadable(t) {
  if (t && t.href && urlToPreload != t.href) {
    var e = new URL(t.href);
    if (
      (allowExternalLinks ||
        e.origin == location.origin ||
        "instant" in t.dataset) &&
      ["http:", "https:"].includes(e.protocol) &&
      ("http:" != e.protocol || "https:" != location.protocol) &&
      (allowQueryString || !e.search || "instant" in t.dataset) &&
      !(
        (e.hash &&
          e.pathname + e.search == location.pathname + location.search) ||
        "noInstant" in t.dataset
      )
    )
      return !0;
  }
}
function preload(t) {
  prefetcher.href = t;
}
function stopPreloading() {
  prefetcher.removeAttribute("href");
}
/*! npm.im/object-fit-images 3.2.3 */ var objectFitImages = (function () {
  function t(t, e, n) {
    var i = (function (t, e) {
      return (
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" +
        t +
        "' height='" +
        e +
        "'%3E%3C/svg%3E"
      );
    })(e || 1, n || 0);
    d.call(t, "src") !== i && f.call(t, "src", i);
  }
  function e(t, n) {
    t.naturalWidth ? n(t) : setTimeout(e, 100, t, n);
  }
  function n(n) {
    var o = (function (t) {
        for (
          var e, n = getComputedStyle(t).fontFamily, i = {};
          null !== (e = s.exec(n));
        )
          i[e[1]] = e[2];
        return i;
      })(n),
      a = n[r];
    if (((o["object-fit"] = o["object-fit"] || "fill"), !a.img)) {
      if ("fill" === o["object-fit"]) return;
      if (!a.skipTest && l && !o["object-position"]) return;
    }
    if (!a.img) {
      ((a.img = new Image(n.width, n.height)),
        (a.img.srcset = d.call(n, "data-ofi-srcset") || n.srcset),
        (a.img.src = d.call(n, "data-ofi-src") || n.src),
        f.call(n, "data-ofi-src", n.src),
        n.srcset && f.call(n, "data-ofi-srcset", n.srcset),
        t(n, n.naturalWidth || n.width, n.naturalHeight || n.height),
        n.srcset && (n.srcset = ""));
      try {
        i(n);
      } catch (n) {
        window.console && console.warn("https://bit.ly/ofi-old-browser");
      }
    }
    ((function (t) {
      if (t.srcset && !h && window.picturefill) {
        var e = window.picturefill._;
        ((t[e.ns] && t[e.ns].evaled) || e.fillImg(t, { reselect: !0 }),
          t[e.ns].curSrc ||
            ((t[e.ns].supported = !1), e.fillImg(t, { reselect: !0 })),
          (t.currentSrc = t[e.ns].curSrc || t.src));
      }
    })(a.img),
      (n.style.backgroundImage =
        'url("' + (a.img.currentSrc || a.img.src).replace(/"/g, '\\"') + '")'),
      (n.style.backgroundPosition = o["object-position"] || "center"),
      (n.style.backgroundRepeat = "no-repeat"),
      (n.style.backgroundOrigin = "content-box"),
      /scale-down/.test(o["object-fit"])
        ? e(a.img, function () {
            a.img.naturalWidth > n.width || a.img.naturalHeight > n.height
              ? (n.style.backgroundSize = "contain")
              : (n.style.backgroundSize = "auto");
          })
        : (n.style.backgroundSize = o["object-fit"]
            .replace("none", "auto")
            .replace("fill", "100% 100%")),
      e(a.img, function (e) {
        t(n, e.naturalWidth, e.naturalHeight);
      }));
  }
  function i(t) {
    var e = {
      get: function (e) {
        return t[r].img[e || "src"];
      },
      set: function (e, i) {
        return (
          (t[r].img[i || "src"] = e),
          f.call(t, "data-ofi-" + i, e),
          n(t),
          e
        );
      },
    };
    (Object.defineProperty(t, "src", e),
      Object.defineProperty(t, "currentSrc", {
        get: function () {
          return e.get("currentSrc");
        },
      }),
      Object.defineProperty(t, "srcset", {
        get: function () {
          return e.get("srcset");
        },
        set: function (t) {
          return e.set(t, "srcset");
        },
      }));
  }
  function o(t, e) {
    var i = !p && !t;
    if (((e = e || {}), (t = t || "img"), (c && !e.skipTest) || !u)) return !1;
    "img" === t
      ? (t = document.getElementsByTagName("img"))
      : "string" == typeof t
        ? (t = document.querySelectorAll(t))
        : "length" in t || (t = [t]);
    for (var s = 0; s < t.length; s++)
      ((t[s][r] = t[s][r] || { skipTest: e.skipTest }), n(t[s]));
    (i &&
      (document.body.addEventListener(
        "load",
        function (t) {
          "IMG" === t.target.tagName && o(t.target, { skipTest: e.skipTest });
        },
        !0,
      ),
      (p = !0),
      (t = "img")),
      e.watchMQ &&
        window.addEventListener(
          "resize",
          o.bind(null, t, { skipTest: e.skipTest }),
        ));
  }
  var r = "bfred-it:object-fit-images",
    s = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g,
    a =
      "undefined" == typeof Image
        ? { style: { "object-position": 1 } }
        : new Image(),
    l = "object-fit" in a.style,
    c = "object-position" in a.style,
    u = "background-size" in a.style,
    h = "string" == typeof a.currentSrc,
    d = a.getAttribute,
    f = a.setAttribute,
    p = !1;
  return (
    (o.supportsObjectFit = l),
    (o.supportsObjectPosition = c),
    (function () {
      function t(t, e) {
        return t[r] && t[r].img && ("src" === e || "srcset" === e)
          ? t[r].img
          : t;
      }
      c ||
        ((HTMLImageElement.prototype.getAttribute = function (e) {
          return d.call(t(this, e), e);
        }),
        (HTMLImageElement.prototype.setAttribute = function (e, n) {
          return f.call(t(this, e), e, String(n));
        }));
    })(),
    o
  );
})();
((window.lazySizesConfig = window.lazySizesConfig || {}),
  (lazySizesConfig.expand = 300),
  (lazySizesConfig.loadHidden = !1),
  (function (t) {
    var e = (function (t, e, n) {
      var i, o;
      if (
        ((function () {
          var e,
            n = {
              lazyClass: "lazyload",
              loadedClass: "lazyloaded",
              loadingClass: "lazyloading",
              preloadClass: "lazypreload",
              errorClass: "lazyerror",
              autosizesClass: "lazyautosizes",
              srcAttr: "data-src",
              srcsetAttr: "data-srcset",
              sizesAttr: "data-sizes",
              minSize: 40,
              customMedia: {},
              init: !0,
              expFactor: 1.5,
              hFac: 0.8,
              loadMode: 2,
              loadHidden: !0,
              ricTimeout: 0,
              throttleDelay: 125,
            };
          for (e in ((o = t.lazySizesConfig || t.lazysizesConfig || {}), n))
            e in o || (o[e] = n[e]);
        })(),
        !e || !e.getElementsByClassName)
      )
        return { init: function () {}, cfg: o, noSupport: !0 };
      var r = e.documentElement,
        s = t.HTMLPictureElement,
        a = "addEventListener",
        l = "getAttribute",
        c = t[a].bind(t),
        u = t.setTimeout,
        h = t.requestAnimationFrame || u,
        d = t.requestIdleCallback,
        f = /^picture$/i,
        p = ["load", "error", "lazyincluded", "_lazyloaded"],
        m = {},
        g = Array.prototype.forEach,
        v = function (t, e) {
          return (
            m[e] || (m[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")),
            m[e].test(t[l]("class") || "") && m[e]
          );
        },
        y = function (t, e) {
          v(t, e) ||
            t.setAttribute("class", (t[l]("class") || "").trim() + " " + e);
        },
        b = function (t, e) {
          var n;
          (n = v(t, e)) &&
            t.setAttribute("class", (t[l]("class") || "").replace(n, " "));
        },
        w = function (t, e, n) {
          var i = n ? a : "removeEventListener";
          (n && w(t, e),
            p.forEach(function (n) {
              t[i](n, e);
            }));
        },
        x = function (t, n, o, r, s) {
          var a = e.createEvent("Event");
          return (
            o || (o = {}),
            (o.instance = i),
            a.initEvent(n, !r, !s),
            (a.detail = o),
            t.dispatchEvent(a),
            a
          );
        },
        S = function (e, n) {
          var i;
          !s && (i = t.picturefill || o.pf)
            ? (n && n.src && !e[l]("srcset") && e.setAttribute("srcset", n.src),
              i({ reevaluate: !0, elements: [e] }))
            : n && n.src && (e.src = n.src);
        },
        k = function (t, e) {
          return (getComputedStyle(t, null) || {})[e];
        },
        E = function (t, e, n) {
          for (
            n = n || t.offsetWidth;
            n < o.minSize && e && !t._lazysizesWidth;
          )
            ((n = e.offsetWidth), (e = e.parentNode));
          return n;
        },
        C = (function () {
          var t,
            n,
            i = [],
            o = [],
            r = i,
            s = function () {
              var e = r;
              for (r = i.length ? o : i, t = !0, n = !1; e.length; )
                e.shift()();
              t = !1;
            },
            a = function (i, o) {
              t && !o
                ? i.apply(this, arguments)
                : (r.push(i), n || ((n = !0), (e.hidden ? u : h)(s)));
            };
          return ((a._lsFlush = s), a);
        })(),
        T = function (t, e) {
          return e
            ? function () {
                C(t);
              }
            : function () {
                var e = this,
                  n = arguments;
                C(function () {
                  t.apply(e, n);
                });
              };
        },
        P = function (t) {
          var e,
            i = 0,
            r = o.throttleDelay,
            s = o.ricTimeout,
            a = function () {
              ((e = !1), (i = n.now()), t());
            },
            l =
              d && s > 49
                ? function () {
                    (d(a, { timeout: s }),
                      s !== o.ricTimeout && (s = o.ricTimeout));
                  }
                : T(function () {
                    u(a);
                  }, !0);
          return function (t) {
            var o;
            ((t = !0 === t) && (s = 33),
              e ||
                ((e = !0),
                (o = r - (n.now() - i)) < 0 && (o = 0),
                t || o < 9 ? l() : u(l, o)));
          };
        },
        A = function (t) {
          var e,
            i,
            o = function () {
              ((e = null), t());
            },
            r = function () {
              var t = n.now() - i;
              t < 99 ? u(r, 99 - t) : (d || o)(o);
            };
          return function () {
            ((i = n.now()), e || (e = u(r, 99)));
          };
        },
        I = (function () {
          var s,
            d,
            p,
            m,
            E,
            I,
            L,
            z,
            M,
            j,
            O,
            D,
            F = /^img$/i,
            R = /^iframe$/i,
            N = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent),
            $ = 0,
            q = 0,
            H = -1,
            W = function (t) {
              (q--, (!t || q < 0 || !t.target) && (q = 0));
            },
            B = function (t) {
              return (
                null == D && (D = "hidden" == k(e.body, "visibility")),
                D ||
                  !(
                    "hidden" == k(t.parentNode, "visibility") &&
                    "hidden" == k(t, "visibility")
                  )
              );
            },
            U = function (t, n) {
              var i,
                o = t,
                s = B(t);
              for (
                z -= n, O += n, M -= n, j += n;
                s && (o = o.offsetParent) && o != e.body && o != r;
              )
                (s = (k(o, "opacity") || 1) > 0) &&
                  "visible" != k(o, "overflow") &&
                  ((i = o.getBoundingClientRect()),
                  (s =
                    j > i.left &&
                    M < i.right &&
                    O > i.top - 1 &&
                    z < i.bottom + 1));
              return s;
            },
            V = function () {
              var t,
                n,
                a,
                c,
                u,
                h,
                f,
                p,
                g,
                v,
                y,
                b,
                w = i.elements;
              if ((m = o.loadMode) && q < 8 && (t = w.length)) {
                for (n = 0, H++; n < t; n++)
                  if (w[n] && !w[n]._lazyRace)
                    if (!N || (i.prematureUnveil && i.prematureUnveil(w[n])))
                      J(w[n]);
                    else if (
                      (((p = w[n][l]("data-expand")) && (h = 1 * p)) || (h = $),
                      v ||
                        ((v =
                          !o.expand || o.expand < 1
                            ? r.clientHeight > 500 && r.clientWidth > 500
                              ? 500
                              : 370
                            : o.expand),
                        (i._defEx = v),
                        (y = v * o.expFactor),
                        (b = o.hFac),
                        (D = null),
                        $ < y && q < 1 && H > 2 && m > 2 && !e.hidden
                          ? (($ = y), (H = 0))
                          : ($ = m > 1 && H > 1 && q < 6 ? v : 0)),
                      g !== h &&
                        ((I = innerWidth + h * b),
                        (L = innerHeight + h),
                        (f = -1 * h),
                        (g = h)),
                      (a = w[n].getBoundingClientRect()),
                      (O = a.bottom) >= f &&
                        (z = a.top) <= L &&
                        (j = a.right) >= f * b &&
                        (M = a.left) <= I &&
                        (O || j || M || z) &&
                        (o.loadHidden || B(w[n])) &&
                        ((d && q < 3 && !p && (m < 3 || H < 4)) || U(w[n], h)))
                    ) {
                      if ((J(w[n]), (u = !0), q > 9)) break;
                    } else
                      !u &&
                        d &&
                        !c &&
                        q < 4 &&
                        H < 4 &&
                        m > 2 &&
                        (s[0] || o.preloadAfterLoad) &&
                        (s[0] ||
                          (!p &&
                            (O ||
                              j ||
                              M ||
                              z ||
                              "auto" != w[n][l](o.sizesAttr)))) &&
                        (c = s[0] || w[n]);
                c && !u && J(c);
              }
            },
            Y = P(V),
            X = function (t) {
              var e = t.target;
              e._lazyCache
                ? delete e._lazyCache
                : (W(t),
                  y(e, o.loadedClass),
                  b(e, o.loadingClass),
                  w(e, G),
                  x(e, "lazyloaded"));
            },
            Q = T(X),
            G = function (t) {
              Q({ target: t.target });
            },
            K = function (t) {
              var e,
                n = t[l](o.srcsetAttr);
              ((e = o.customMedia[t[l]("data-media") || t[l]("media")]) &&
                t.setAttribute("media", e),
                n && t.setAttribute("srcset", n));
            },
            Z = T(function (t, e, n, i, r) {
              var s, a, c, h, d, m;
              ((d = x(t, "lazybeforeunveil", e)).defaultPrevented ||
                (i && (n ? y(t, o.autosizesClass) : t.setAttribute("sizes", i)),
                (a = t[l](o.srcsetAttr)),
                (s = t[l](o.srcAttr)),
                r && (h = (c = t.parentNode) && f.test(c.nodeName || "")),
                (m = e.firesLoad || ("src" in t && (a || s || h))),
                (d = { target: t }),
                y(t, o.loadingClass),
                m && (clearTimeout(p), (p = u(W, 2500)), w(t, G, !0)),
                h && g.call(c.getElementsByTagName("source"), K),
                a
                  ? t.setAttribute("srcset", a)
                  : s &&
                    !h &&
                    (R.test(t.nodeName)
                      ? (function (t, e) {
                          try {
                            t.contentWindow.location.replace(e);
                          } catch (n) {
                            t.src = e;
                          }
                        })(t, s)
                      : (t.src = s)),
                r && (a || h) && S(t, { src: s })),
                t._lazyRace && delete t._lazyRace,
                b(t, o.lazyClass),
                C(function () {
                  var e = t.complete && t.naturalWidth > 1;
                  ((m && !e) ||
                    (e && y(t, "ls-is-cached"),
                    X(d),
                    (t._lazyCache = !0),
                    u(function () {
                      "_lazyCache" in t && delete t._lazyCache;
                    }, 9)),
                    "lazy" == t.loading && q--);
                }, !0));
            }),
            J = function (t) {
              if (!t._lazyRace) {
                var e,
                  n = F.test(t.nodeName),
                  i = n && (t[l](o.sizesAttr) || t[l]("sizes")),
                  r = "auto" == i;
                ((!r && d) ||
                  !n ||
                  (!t[l]("src") && !t.srcset) ||
                  t.complete ||
                  v(t, o.errorClass) ||
                  !v(t, o.lazyClass)) &&
                  ((e = x(t, "lazyunveilread").detail),
                  r && _.updateElem(t, !0, t.offsetWidth),
                  (t._lazyRace = !0),
                  q++,
                  Z(t, e, r, i, n));
              }
            },
            tt = A(function () {
              ((o.loadMode = 3), Y());
            }),
            et = function () {
              (3 == o.loadMode && (o.loadMode = 2), tt());
            },
            nt = function () {
              d ||
                (n.now() - E < 999
                  ? u(nt, 999)
                  : ((d = !0), (o.loadMode = 3), Y(), c("scroll", et, !0)));
            };
          return {
            _: function () {
              ((E = n.now()),
                (i.elements = e.getElementsByClassName(o.lazyClass)),
                (s = e.getElementsByClassName(
                  o.lazyClass + " " + o.preloadClass,
                )),
                c("scroll", Y, !0),
                c("resize", Y, !0),
                c("pageshow", function (t) {
                  if (t.persisted) {
                    var n = e.querySelectorAll("." + o.loadingClass);
                    n.length &&
                      n.forEach &&
                      h(function () {
                        n.forEach(function (t) {
                          t.complete && J(t);
                        });
                      });
                  }
                }),
                t.MutationObserver
                  ? new MutationObserver(Y).observe(r, {
                      childList: !0,
                      subtree: !0,
                      attributes: !0,
                    })
                  : (r[a]("DOMNodeInserted", Y, !0),
                    r[a]("DOMAttrModified", Y, !0),
                    setInterval(Y, 999)),
                c("hashchange", Y, !0),
                [
                  "focus",
                  "mouseover",
                  "click",
                  "load",
                  "transitionend",
                  "animationend",
                ].forEach(function (t) {
                  e[a](t, Y, !0);
                }),
                /d$|^c/.test(e.readyState)
                  ? nt()
                  : (c("load", nt), e[a]("DOMContentLoaded", Y), u(nt, 2e4)),
                i.elements.length ? (V(), C._lsFlush()) : Y());
            },
            checkElems: Y,
            unveil: J,
            _aLSL: et,
          };
        })(),
        _ = (function () {
          var t,
            n = T(function (t, e, n, i) {
              var o, r, s;
              if (
                ((t._lazysizesWidth = i),
                (i += "px"),
                t.setAttribute("sizes", i),
                f.test(e.nodeName || ""))
              )
                for (
                  r = 0, s = (o = e.getElementsByTagName("source")).length;
                  r < s;
                  r++
                )
                  o[r].setAttribute("sizes", i);
              n.detail.dataAttr || S(t, n.detail);
            }),
            i = function (t, e, i) {
              var o,
                r = t.parentNode;
              r &&
                ((i = E(t, r, i)),
                (o = x(t, "lazybeforesizes", { width: i, dataAttr: !!e }))
                  .defaultPrevented ||
                  ((i = o.detail.width) &&
                    i !== t._lazysizesWidth &&
                    n(t, r, o, i)));
            },
            r = A(function () {
              var e,
                n = t.length;
              if (n) for (e = 0; e < n; e++) i(t[e]);
            });
          return {
            _: function () {
              ((t = e.getElementsByClassName(o.autosizesClass)),
                c("resize", r));
            },
            checkElems: r,
            updateElem: i,
          };
        })(),
        L = function () {
          !L.i && e.getElementsByClassName && ((L.i = !0), _._(), I._());
        };
      return (
        u(function () {
          o.init && L();
        }),
        (i = {
          cfg: o,
          autoSizer: _,
          loader: I,
          init: L,
          uP: S,
          aC: y,
          rC: b,
          hC: v,
          fire: x,
          gW: E,
          rAF: C,
        })
      );
    })(t, t.document, Date);
    ((t.lazySizes = e),
      "object" == typeof module && module.exports && (module.exports = e));
  })("undefined" != typeof window ? window : {}),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("jquery-bridget/jquery-bridget", ["jquery"], function (n) {
          return e(t, n);
        })
      : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("jquery")))
        : (t.jQueryBridget = e(t, t.jQuery));
  })(window, function (t, e) {
    var n = Array.prototype.slice,
      i = t.console,
      o =
        void 0 === i
          ? function () {}
          : function (t) {
              i.error(t);
            };
    function r(i, r, a) {
      (a = a || e || t.jQuery) &&
        (r.prototype.option ||
          (r.prototype.option = function (t) {
            a.isPlainObject(t) &&
              (this.options = a.extend(!0, this.options, t));
          }),
        (a.fn[i] = function (t) {
          if ("string" != typeof t)
            return (
              (h = t),
              this.each(function (t, e) {
                var n = a.data(e, i);
                n
                  ? (n.option(h), n._init())
                  : ((n = new r(e, h)), a.data(e, i, n));
              }),
              this
            );
          var e,
            s,
            l,
            c,
            u,
            h,
            d = n.call(arguments, 1);
          return (
            (l = d),
            (u = "$()." + i + '("' + (s = t) + '")'),
            (e = this).each(function (t, e) {
              var n = a.data(e, i);
              if (n) {
                var r = n[s];
                if (r && "_" != s.charAt(0)) {
                  var h = r.apply(n, l);
                  c = void 0 === c ? h : c;
                } else o(u + " is not a valid method");
              } else o(i + " not initialized. Cannot call methods, i.e. " + u);
            }),
            void 0 !== c ? c : e
          );
        }),
        s(a));
    }
    function s(t) {
      !t || (t && t.bridget) || (t.bridget = r);
    }
    return (s(e || t.jQuery), r);
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", e)
      : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.EvEmitter = e());
  })("undefined" != typeof window ? window : this, function () {
    function t() {}
    var e = t.prototype;
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var n = (this._events = this._events || {}),
            i = (n[t] = n[t] || []);
          return (-1 == i.indexOf(e) && i.push(e), this);
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var n = (this._onceEvents = this._onceEvents || {});
          return (((n[t] = n[t] || {})[e] = !0), this);
        }
      }),
      (e.off = function (t, e) {
        var n = this._events && this._events[t];
        if (n && n.length) {
          var i = n.indexOf(e);
          return (-1 != i && n.splice(i, 1), this);
        }
      }),
      (e.emitEvent = function (t, e) {
        var n = this._events && this._events[t];
        if (n && n.length) {
          ((n = n.slice(0)), (e = e || []));
          for (
            var i = this._onceEvents && this._onceEvents[t], o = 0;
            o < n.length;
            o++
          ) {
            var r = n[o];
            (i && i[r] && (this.off(t, r), delete i[r]), r.apply(this, e));
          }
          return this;
        }
      }),
      (e.allOff = function () {
        (delete this._events, delete this._onceEvents);
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("get-size/get-size", e)
      : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.getSize = e());
  })(window, function () {
    function t(t) {
      var e = parseFloat(t);
      return -1 == t.indexOf("%") && !isNaN(e) && e;
    }
    var e =
        "undefined" == typeof console
          ? function () {}
          : function (t) {
              console.error(t);
            },
      n = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth",
      ],
      i = n.length;
    function o(t) {
      var n = getComputedStyle(t);
      return (
        n ||
          e(
            "Style returned " +
              n +
              ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1",
          ),
        n
      );
    }
    var r,
      s = !1;
    return function e(a) {
      if (
        ((function () {
          if (!s) {
            s = !0;
            var n = document.createElement("div");
            ((n.style.width = "200px"),
              (n.style.padding = "1px 2px 3px 4px"),
              (n.style.borderStyle = "solid"),
              (n.style.borderWidth = "1px 2px 3px 4px"),
              (n.style.boxSizing = "border-box"));
            var i = document.body || document.documentElement;
            i.appendChild(n);
            var a = o(n);
            ((r = 200 == Math.round(t(a.width))),
              (e.isBoxSizeOuter = r),
              i.removeChild(n));
          }
        })(),
        "string" == typeof a && (a = document.querySelector(a)),
        a && "object" == typeof a && a.nodeType)
      ) {
        var l = o(a);
        if ("none" == l.display)
          return (function () {
            for (
              var t = {
                  width: 0,
                  height: 0,
                  innerWidth: 0,
                  innerHeight: 0,
                  outerWidth: 0,
                  outerHeight: 0,
                },
                e = 0;
              e < i;
              e++
            )
              t[n[e]] = 0;
            return t;
          })();
        var c = {};
        ((c.width = a.offsetWidth), (c.height = a.offsetHeight));
        for (
          var u = (c.isBorderBox = "border-box" == l.boxSizing), h = 0;
          h < i;
          h++
        ) {
          var d = n[h],
            f = l[d],
            p = parseFloat(f);
          c[d] = isNaN(p) ? 0 : p;
        }
        var m = c.paddingLeft + c.paddingRight,
          g = c.paddingTop + c.paddingBottom,
          v = c.marginLeft + c.marginRight,
          y = c.marginTop + c.marginBottom,
          b = c.borderLeftWidth + c.borderRightWidth,
          w = c.borderTopWidth + c.borderBottomWidth,
          x = u && r,
          S = t(l.width);
        !1 !== S && (c.width = S + (x ? 0 : m + b));
        var k = t(l.height);
        return (
          !1 !== k && (c.height = k + (x ? 0 : g + w)),
          (c.innerWidth = c.width - (m + b)),
          (c.innerHeight = c.height - (g + w)),
          (c.outerWidth = c.width + v),
          (c.outerHeight = c.height + y),
          c
        );
      }
    };
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("desandro-matches-selector/matches-selector", e)
      : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.matchesSelector = e());
  })(window, function () {
    var t = (function () {
      var t = window.Element.prototype;
      if (t.matches) return "matches";
      if (t.matchesSelector) return "matchesSelector";
      for (var e = ["webkit", "moz", "ms", "o"], n = 0; n < e.length; n++) {
        var i = e[n] + "MatchesSelector";
        if (t[i]) return i;
      }
    })();
    return function (e, n) {
      return e[t](n);
    };
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "fizzy-ui-utils/utils",
          ["desandro-matches-selector/matches-selector"],
          function (n) {
            return e(t, n);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("desandro-matches-selector")))
        : (t.fizzyUIUtils = e(t, t.matchesSelector));
  })(window, function (t, e) {
    var n = {
        extend: function (t, e) {
          for (var n in e) t[n] = e[n];
          return t;
        },
        modulo: function (t, e) {
          return ((t % e) + e) % e;
        },
      },
      i = Array.prototype.slice;
    ((n.makeArray = function (t) {
      return Array.isArray(t)
        ? t
        : null == t
          ? []
          : "object" == typeof t && "number" == typeof t.length
            ? i.call(t)
            : [t];
    }),
      (n.removeFrom = function (t, e) {
        var n = t.indexOf(e);
        -1 != n && t.splice(n, 1);
      }),
      (n.getParent = function (t, n) {
        for (; t.parentNode && t != document.body; )
          if (((t = t.parentNode), e(t, n))) return t;
      }),
      (n.getQueryElement = function (t) {
        return "string" == typeof t ? document.querySelector(t) : t;
      }),
      (n.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (n.filterFindElements = function (t, i) {
        t = n.makeArray(t);
        var o = [];
        return (
          t.forEach(function (t) {
            if (t instanceof HTMLElement)
              if (i) {
                e(t, i) && o.push(t);
                for (var n = t.querySelectorAll(i), r = 0; r < n.length; r++)
                  o.push(n[r]);
              } else o.push(t);
          }),
          o
        );
      }),
      (n.debounceMethod = function (t, e, n) {
        n = n || 100;
        var i = t.prototype[e],
          o = e + "Timeout";
        t.prototype[e] = function () {
          var t = this[o];
          clearTimeout(t);
          var e = arguments,
            r = this;
          this[o] = setTimeout(function () {
            (i.apply(r, e), delete r[o]);
          }, n);
        };
      }),
      (n.docReady = function (t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e
          ? setTimeout(t)
          : document.addEventListener("DOMContentLoaded", t);
      }),
      (n.toDashed = function (t) {
        return t
          .replace(/(.)([A-Z])/g, function (t, e, n) {
            return e + "-" + n;
          })
          .toLowerCase();
      }));
    var o = t.console;
    return (
      (n.htmlInit = function (e, i) {
        n.docReady(function () {
          var r = n.toDashed(i),
            s = "data-" + r,
            a = document.querySelectorAll("[" + s + "]"),
            l = document.querySelectorAll(".js-" + r),
            c = n.makeArray(a).concat(n.makeArray(l)),
            u = s + "-options",
            h = t.jQuery;
          c.forEach(function (t) {
            var n,
              r = t.getAttribute(s) || t.getAttribute(u);
            try {
              n = r && JSON.parse(r);
            } catch (n) {
              return void (
                o &&
                o.error("Error parsing " + s + " on " + t.className + ": " + n)
              );
            }
            var a = new e(t, n);
            h && h.data(t, i, a);
          });
        });
      }),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("flickity/js/cell", ["get-size/get-size"], function (n) {
          return e(t, n);
        })
      : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("get-size")))
        : ((t.Flickity = t.Flickity || {}),
          (t.Flickity.Cell = e(t, t.getSize)));
  })(window, function (t, e) {
    function n(t, e) {
      ((this.element = t), (this.parent = e), this.create());
    }
    var i = n.prototype;
    return (
      (i.create = function () {
        ((this.element.style.position = "absolute"),
          this.element.setAttribute("aria-hidden", "true"),
          (this.x = 0),
          (this.shift = 0));
      }),
      (i.destroy = function () {
        (this.unselect(), (this.element.style.position = ""));
        var t = this.parent.originSide;
        this.element.style[t] = "";
      }),
      (i.getSize = function () {
        this.size = e(this.element);
      }),
      (i.setPosition = function (t) {
        ((this.x = t), this.updateTarget(), this.renderPosition(t));
      }),
      (i.updateTarget = i.setDefaultTarget =
        function () {
          var t =
            "left" == this.parent.originSide ? "marginLeft" : "marginRight";
          this.target =
            this.x + this.size[t] + this.size.width * this.parent.cellAlign;
        }),
      (i.renderPosition = function (t) {
        var e = this.parent.originSide;
        this.element.style[e] = this.parent.getPositionValue(t);
      }),
      (i.select = function () {
        (this.element.classList.add("is-selected"),
          this.element.removeAttribute("aria-hidden"));
      }),
      (i.unselect = function () {
        (this.element.classList.remove("is-selected"),
          this.element.setAttribute("aria-hidden", "true"));
      }),
      (i.wrapShift = function (t) {
        ((this.shift = t),
          this.renderPosition(this.x + this.parent.slideableWidth * t));
      }),
      (i.remove = function () {
        this.element.parentNode.removeChild(this.element);
      }),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("flickity/js/slide", e)
      : "object" == typeof module && module.exports
        ? (module.exports = e())
        : ((t.Flickity = t.Flickity || {}), (t.Flickity.Slide = e()));
  })(window, function () {
    function t(t) {
      ((this.parent = t),
        (this.isOriginLeft = "left" == t.originSide),
        (this.cells = []),
        (this.outerWidth = 0),
        (this.height = 0));
    }
    var e = t.prototype;
    return (
      (e.addCell = function (t) {
        if (
          (this.cells.push(t),
          (this.outerWidth += t.size.outerWidth),
          (this.height = Math.max(t.size.outerHeight, this.height)),
          1 == this.cells.length)
        ) {
          this.x = t.x;
          var e = this.isOriginLeft ? "marginLeft" : "marginRight";
          this.firstMargin = t.size[e];
        }
      }),
      (e.updateTarget = function () {
        var t = this.isOriginLeft ? "marginRight" : "marginLeft",
          e = this.getLastCell(),
          n = e ? e.size[t] : 0,
          i = this.outerWidth - (this.firstMargin + n);
        this.target = this.x + this.firstMargin + i * this.parent.cellAlign;
      }),
      (e.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      }),
      (e.select = function () {
        this.cells.forEach(function (t) {
          t.select();
        });
      }),
      (e.unselect = function () {
        this.cells.forEach(function (t) {
          t.unselect();
        });
      }),
      (e.getCellElements = function () {
        return this.cells.map(function (t) {
          return t.element;
        });
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (n) {
          return e(t, n);
        })
      : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("fizzy-ui-utils")))
        : ((t.Flickity = t.Flickity || {}),
          (t.Flickity.animatePrototype = e(t, t.fizzyUIUtils)));
  })(window, function (t, e) {
    var n = {
      startAnimation: function () {
        this.isAnimating ||
          ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
      },
      animate: function () {
        (this.applyDragForce(), this.applySelectedAttraction());
        var t = this.x;
        if (
          (this.integratePhysics(),
          this.positionSlider(),
          this.settle(t),
          this.isAnimating)
        ) {
          var e = this;
          requestAnimationFrame(function () {
            e.animate();
          });
        }
      },
      positionSlider: function () {
        var t = this.x;
        (this.options.wrapAround &&
          1 < this.cells.length &&
          ((t = e.modulo(t, this.slideableWidth)),
          (t -= this.slideableWidth),
          this.shiftWrapCells(t)),
          this.setTranslateX(t, this.isAnimating),
          this.dispatchScrollEvent());
      },
      setTranslateX: function (t, e) {
        ((t += this.cursorPosition), (t = this.options.rightToLeft ? -t : t));
        var n = this.getPositionValue(t);
        this.slider.style.transform = e
          ? "translate3d(" + n + ",0,0)"
          : "translateX(" + n + ")";
      },
      dispatchScrollEvent: function () {
        var t = this.slides[0];
        if (t) {
          var e = -this.x - t.target,
            n = e / this.slidesWidth;
          this.dispatchEvent("scroll", null, [n, e]);
        }
      },
      positionSliderAtSelected: function () {
        this.cells.length &&
          ((this.x = -this.selectedSlide.target),
          (this.velocity = 0),
          this.positionSlider());
      },
      getPositionValue: function (t) {
        return this.options.percentPosition
          ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%"
          : Math.round(t) + "px";
      },
      settle: function (t) {
        (this.isPointerDown ||
          Math.round(100 * this.x) != Math.round(100 * t) ||
          this.restingFrames++,
          2 < this.restingFrames &&
            ((this.isAnimating = !1),
            delete this.isFreeScrolling,
            this.positionSlider(),
            this.dispatchEvent("settle", null, [this.selectedIndex])));
      },
      shiftWrapCells: function (t) {
        var e = this.cursorPosition + t;
        this._shiftCells(this.beforeShiftCells, e, -1);
        var n =
          this.size.innerWidth -
          (t + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, n, 1);
      },
      _shiftCells: function (t, e, n) {
        for (var i = 0; i < t.length; i++) {
          var o = t[i],
            r = 0 < e ? n : 0;
          (o.wrapShift(r), (e -= o.size.outerWidth));
        }
      },
      _unshiftCells: function (t) {
        if (t && t.length) for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
      },
      integratePhysics: function () {
        ((this.x += this.velocity),
          (this.velocity *= this.getFrictionFactor()));
      },
      applyForce: function (t) {
        this.velocity += t;
      },
      getFrictionFactor: function () {
        return (
          1 -
          this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        );
      },
      getRestingPosition: function () {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
      },
      applyDragForce: function () {
        if (this.isDraggable && this.isPointerDown) {
          var t = this.dragX - this.x - this.velocity;
          this.applyForce(t);
        }
      },
      applySelectedAttraction: function () {
        if (
          (!this.isDraggable || !this.isPointerDown) &&
          !this.isFreeScrolling &&
          this.slides.length
        ) {
          var t =
            (-1 * this.selectedSlide.target - this.x) *
            this.options.selectedAttraction;
          this.applyForce(t);
        }
      },
    };
    return n;
  }),
  (function (t, e) {
    if ("function" == typeof define && define.amd)
      define("flickity/js/flickity", [
        "ev-emitter/ev-emitter",
        "get-size/get-size",
        "fizzy-ui-utils/utils",
        "./cell",
        "./slide",
        "./animate",
      ], function (n, i, o, r, s, a) {
        return e(t, n, i, o, r, s, a);
      });
    else if ("object" == typeof module && module.exports)
      module.exports = e(
        t,
        require("ev-emitter"),
        require("get-size"),
        require("fizzy-ui-utils"),
        require("./cell"),
        require("./slide"),
        require("./animate"),
      );
    else {
      var n = t.Flickity;
      t.Flickity = e(
        t,
        t.EvEmitter,
        t.getSize,
        t.fizzyUIUtils,
        n.Cell,
        n.Slide,
        n.animatePrototype,
      );
    }
  })(window, function (t, e, n, i, o, r, s) {
    var a = t.jQuery,
      l = t.getComputedStyle,
      c = t.console;
    function u(t, e) {
      for (t = i.makeArray(t); t.length; ) e.appendChild(t.shift());
    }
    var h = 0,
      d = {};
    function f(t, e) {
      var n = i.getQueryElement(t);
      if (n) {
        if (((this.element = n), this.element.flickityGUID)) {
          var o = d[this.element.flickityGUID];
          return (o.option(e), o);
        }
        (a && (this.$element = a(this.element)),
          (this.options = i.extend({}, this.constructor.defaults)),
          this.option(e),
          this._create());
      } else c && c.error("Bad element for Flickity: " + (n || t));
    }
    ((f.defaults = {
      accessibility: !0,
      cellAlign: "center",
      freeScrollFriction: 0.075,
      friction: 0.28,
      namespaceJQueryEvents: !0,
      percentPosition: !0,
      resize: !0,
      selectedAttraction: 0.025,
      setGallerySize: !0,
    }),
      (f.createMethods = []));
    var p = f.prototype;
    (i.extend(p, e.prototype),
      (p._create = function () {
        var e = (this.guid = ++h);
        for (var n in ((this.element.flickityGUID = e),
        ((d[e] = this).selectedIndex = 0),
        (this.restingFrames = 0),
        (this.x = 0),
        (this.velocity = 0),
        (this.originSide = this.options.rightToLeft ? "right" : "left"),
        (this.viewport = document.createElement("div")),
        (this.viewport.className = "flickity-viewport"),
        this._createSlider(),
        (this.options.resize || this.options.watchCSS) &&
          t.addEventListener("resize", this),
        this.options.on)) {
          var i = this.options.on[n];
          this.on(n, i);
        }
        (f.createMethods.forEach(function (t) {
          this[t]();
        }, this),
          this.options.watchCSS ? this.watchCSS() : this.activate());
      }),
      (p.option = function (t) {
        i.extend(this.options, t);
      }),
      (p.activate = function () {
        this.isActive ||
          ((this.isActive = !0),
          this.element.classList.add("flickity-enabled"),
          this.options.rightToLeft &&
            this.element.classList.add("flickity-rtl"),
          this.getSize(),
          u(this._filterFindCellElements(this.element.children), this.slider),
          this.viewport.appendChild(this.slider),
          this.element.appendChild(this.viewport),
          this.reloadCells(),
          this.options.accessibility &&
            ((this.element.tabIndex = 0),
            this.element.addEventListener("keydown", this)),
          this.emitEvent("activate"),
          this.selectInitialIndex(),
          (this.isInitActivated = !0),
          this.dispatchEvent("ready"));
      }),
      (p._createSlider = function () {
        var t = document.createElement("div");
        ((t.className = "flickity-slider"),
          (t.style[this.originSide] = 0),
          (this.slider = t));
      }),
      (p._filterFindCellElements = function (t) {
        return i.filterFindElements(t, this.options.cellSelector);
      }),
      (p.reloadCells = function () {
        ((this.cells = this._makeCells(this.slider.children)),
          this.positionCells(),
          this._getWrapShiftCells(),
          this.setGallerySize());
      }),
      (p._makeCells = function (t) {
        return this._filterFindCellElements(t).map(function (t) {
          return new o(t, this);
        }, this);
      }),
      (p.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      }),
      (p.getLastSlide = function () {
        return this.slides[this.slides.length - 1];
      }),
      (p.positionCells = function () {
        (this._sizeCells(this.cells), this._positionCells(0));
      }),
      (p._positionCells = function (t) {
        ((t = t || 0), (this.maxCellHeight = (t && this.maxCellHeight) || 0));
        var e = 0;
        if (0 < t) {
          var n = this.cells[t - 1];
          e = n.x + n.size.outerWidth;
        }
        for (var i = this.cells.length, o = t; o < i; o++) {
          var r = this.cells[o];
          (r.setPosition(e),
            (e += r.size.outerWidth),
            (this.maxCellHeight = Math.max(
              r.size.outerHeight,
              this.maxCellHeight,
            )));
        }
        ((this.slideableWidth = e),
          this.updateSlides(),
          this._containSlides(),
          (this.slidesWidth = i
            ? this.getLastSlide().target - this.slides[0].target
            : 0));
      }),
      (p._sizeCells = function (t) {
        t.forEach(function (t) {
          t.getSize();
        });
      }),
      (p.updateSlides = function () {
        if (((this.slides = []), this.cells.length)) {
          var t = new r(this);
          this.slides.push(t);
          var e = "left" == this.originSide ? "marginRight" : "marginLeft",
            n = this._getCanCellFit();
          (this.cells.forEach(function (i, o) {
            if (t.cells.length) {
              var s =
                t.outerWidth - t.firstMargin + (i.size.outerWidth - i.size[e]);
              (n.call(this, o, s) ||
                (t.updateTarget(), (t = new r(this)), this.slides.push(t)),
                t.addCell(i));
            } else t.addCell(i);
          }, this),
            t.updateTarget(),
            this.updateSelectedSlide());
        }
      }),
      (p._getCanCellFit = function () {
        var t = this.options.groupCells;
        if (!t)
          return function () {
            return !1;
          };
        if ("number" == typeof t) {
          var e = parseInt(t, 10);
          return function (t) {
            return t % e != 0;
          };
        }
        var n = "string" == typeof t && t.match(/^(\d+)%$/),
          i = n ? parseInt(n[1], 10) / 100 : 1;
        return function (t, e) {
          return e <= (this.size.innerWidth + 1) * i;
        };
      }),
      (p._init = p.reposition =
        function () {
          (this.positionCells(), this.positionSliderAtSelected());
        }),
      (p.getSize = function () {
        ((this.size = n(this.element)),
          this.setCellAlign(),
          (this.cursorPosition = this.size.innerWidth * this.cellAlign));
      }));
    var m = {
      center: { left: 0.5, right: 0.5 },
      left: { left: 0, right: 1 },
      right: { right: 0, left: 1 },
    };
    return (
      (p.setCellAlign = function () {
        var t = m[this.options.cellAlign];
        this.cellAlign = t ? t[this.originSide] : this.options.cellAlign;
      }),
      (p.setGallerySize = function () {
        if (this.options.setGallerySize) {
          var t =
            this.options.adaptiveHeight && this.selectedSlide
              ? this.selectedSlide.height
              : this.maxCellHeight;
          this.viewport.style.height = t + "px";
        }
      }),
      (p._getWrapShiftCells = function () {
        if (this.options.wrapAround) {
          (this._unshiftCells(this.beforeShiftCells),
            this._unshiftCells(this.afterShiftCells));
          var t = this.cursorPosition,
            e = this.cells.length - 1;
          ((this.beforeShiftCells = this._getGapCells(t, e, -1)),
            (t = this.size.innerWidth - this.cursorPosition),
            (this.afterShiftCells = this._getGapCells(t, 0, 1)));
        }
      }),
      (p._getGapCells = function (t, e, n) {
        for (var i = []; 0 < t; ) {
          var o = this.cells[e];
          if (!o) break;
          (i.push(o), (e += n), (t -= o.size.outerWidth));
        }
        return i;
      }),
      (p._containSlides = function () {
        if (
          this.options.contain &&
          !this.options.wrapAround &&
          this.cells.length
        ) {
          var t = this.options.rightToLeft,
            e = t ? "marginRight" : "marginLeft",
            n = t ? "marginLeft" : "marginRight",
            i = this.slideableWidth - this.getLastCell().size[n],
            o = i < this.size.innerWidth,
            r = this.cursorPosition + this.cells[0].size[e],
            s = i - this.size.innerWidth * (1 - this.cellAlign);
          this.slides.forEach(function (t) {
            t.target = o
              ? i * this.cellAlign
              : ((t.target = Math.max(t.target, r)), Math.min(t.target, s));
          }, this);
        }
      }),
      (p.dispatchEvent = function (t, e, n) {
        var i = e ? [e].concat(n) : n;
        if ((this.emitEvent(t, i), a && this.$element)) {
          var o = (t += this.options.namespaceJQueryEvents ? ".flickity" : "");
          if (e) {
            var r = a.Event(e);
            ((r.type = t), (o = r));
          }
          this.$element.trigger(o, n);
        }
      }),
      (p.select = function (t, e, n) {
        if (
          this.isActive &&
          ((t = parseInt(t, 10)),
          this._wrapSelect(t),
          (this.options.wrapAround || e) &&
            (t = i.modulo(t, this.slides.length)),
          this.slides[t])
        ) {
          var o = this.selectedIndex;
          ((this.selectedIndex = t),
            this.updateSelectedSlide(),
            n ? this.positionSliderAtSelected() : this.startAnimation(),
            this.options.adaptiveHeight && this.setGallerySize(),
            this.dispatchEvent("select", null, [t]),
            t != o && this.dispatchEvent("change", null, [t]),
            this.dispatchEvent("cellSelect"));
        }
      }),
      (p._wrapSelect = function (t) {
        var e = this.slides.length;
        if (!(this.options.wrapAround && 1 < e)) return t;
        var n = i.modulo(t, e),
          o = Math.abs(n - this.selectedIndex),
          r = Math.abs(n + e - this.selectedIndex),
          s = Math.abs(n - e - this.selectedIndex);
        (!this.isDragSelect && r < o
          ? (t += e)
          : !this.isDragSelect && s < o && (t -= e),
          t < 0
            ? (this.x -= this.slideableWidth)
            : e <= t && (this.x += this.slideableWidth));
      }),
      (p.previous = function (t, e) {
        this.select(this.selectedIndex - 1, t, e);
      }),
      (p.next = function (t, e) {
        this.select(this.selectedIndex + 1, t, e);
      }),
      (p.updateSelectedSlide = function () {
        var t = this.slides[this.selectedIndex];
        t &&
          (this.unselectSelectedSlide(),
          (this.selectedSlide = t).select(),
          (this.selectedCells = t.cells),
          (this.selectedElements = t.getCellElements()),
          (this.selectedCell = t.cells[0]),
          (this.selectedElement = this.selectedElements[0]));
      }),
      (p.unselectSelectedSlide = function () {
        this.selectedSlide && this.selectedSlide.unselect();
      }),
      (p.selectInitialIndex = function () {
        var t = this.options.initialIndex;
        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
        else {
          if (t && "string" == typeof t && this.queryCell(t))
            return void this.selectCell(t, !1, !0);
          var e = 0;
          (t && this.slides[t] && (e = t), this.select(e, !1, !0));
        }
      }),
      (p.selectCell = function (t, e, n) {
        var i = this.queryCell(t);
        if (i) {
          var o = this.getCellSlideIndex(i);
          this.select(o, e, n);
        }
      }),
      (p.getCellSlideIndex = function (t) {
        for (var e = 0; e < this.slides.length; e++)
          if (-1 != this.slides[e].cells.indexOf(t)) return e;
      }),
      (p.getCell = function (t) {
        for (var e = 0; e < this.cells.length; e++) {
          var n = this.cells[e];
          if (n.element == t) return n;
        }
      }),
      (p.getCells = function (t) {
        t = i.makeArray(t);
        var e = [];
        return (
          t.forEach(function (t) {
            var n = this.getCell(t);
            n && e.push(n);
          }, this),
          e
        );
      }),
      (p.getCellElements = function () {
        return this.cells.map(function (t) {
          return t.element;
        });
      }),
      (p.getParentCell = function (t) {
        return (
          this.getCell(t) ||
          ((t = i.getParent(t, ".flickity-slider > *")), this.getCell(t))
        );
      }),
      (p.getAdjacentCellElements = function (t, e) {
        if (!t) return this.selectedSlide.getCellElements();
        e = void 0 === e ? this.selectedIndex : e;
        var n = this.slides.length;
        if (n <= 1 + 2 * t) return this.getCellElements();
        for (var o = [], r = e - t; r <= e + t; r++) {
          var s = this.options.wrapAround ? i.modulo(r, n) : r,
            a = this.slides[s];
          a && (o = o.concat(a.getCellElements()));
        }
        return o;
      }),
      (p.queryCell = function (t) {
        if ("number" == typeof t) return this.cells[t];
        if ("string" == typeof t) {
          if (t.match(/^[#\.]?[\d\/]/)) return;
          t = this.element.querySelector(t);
        }
        return this.getCell(t);
      }),
      (p.uiChange = function () {
        this.emitEvent("uiChange");
      }),
      (p.childUIPointerDown = function (t) {
        ("touchstart" != t.type && t.preventDefault(), this.focus());
      }),
      (p.onresize = function () {
        (this.watchCSS(), this.resize());
      }),
      i.debounceMethod(f, "onresize", 150),
      (p.resize = function () {
        if (this.isActive) {
          (this.getSize(),
            this.options.wrapAround &&
              (this.x = i.modulo(this.x, this.slideableWidth)),
            this.positionCells(),
            this._getWrapShiftCells(),
            this.setGallerySize(),
            this.emitEvent("resize"));
          var t = this.selectedElements && this.selectedElements[0];
          this.selectCell(t, !1, !0);
        }
      }),
      (p.watchCSS = function () {
        this.options.watchCSS &&
          (-1 != l(this.element, ":after").content.indexOf("flickity")
            ? this.activate()
            : this.deactivate());
      }),
      (p.onkeydown = function (t) {
        var e =
          document.activeElement && document.activeElement != this.element;
        if (this.options.accessibility && !e) {
          var n = f.keyboardHandlers[t.keyCode];
          n && n.call(this);
        }
      }),
      (f.keyboardHandlers = {
        37: function () {
          var t = this.options.rightToLeft ? "next" : "previous";
          (this.uiChange(), this[t]());
        },
        39: function () {
          var t = this.options.rightToLeft ? "previous" : "next";
          (this.uiChange(), this[t]());
        },
      }),
      (p.focus = function () {
        var e = t.pageYOffset;
        (this.element.focus({ preventScroll: !0 }),
          t.pageYOffset != e && t.scrollTo(t.pageXOffset, e));
      }),
      (p.deactivate = function () {
        this.isActive &&
          (this.element.classList.remove("flickity-enabled"),
          this.element.classList.remove("flickity-rtl"),
          this.unselectSelectedSlide(),
          this.cells.forEach(function (t) {
            t.destroy();
          }),
          this.element.removeChild(this.viewport),
          u(this.slider.children, this.element),
          this.options.accessibility &&
            (this.element.removeAttribute("tabIndex"),
            this.element.removeEventListener("keydown", this)),
          (this.isActive = !1),
          this.emitEvent("deactivate"));
      }),
      (p.destroy = function () {
        (this.deactivate(),
          t.removeEventListener("resize", this),
          this.allOff(),
          this.emitEvent("destroy"),
          a && this.$element && a.removeData(this.element, "flickity"),
          delete this.element.flickityGUID,
          delete d[this.guid]);
      }),
      i.extend(p, s),
      (f.data = function (t) {
        var e = (t = i.getQueryElement(t)) && t.flickityGUID;
        return e && d[e];
      }),
      i.htmlInit(f, "flickity"),
      a && a.bridget && a.bridget("flickity", f),
      (f.setJQuery = function (t) {
        a = t;
      }),
      (f.Cell = o),
      (f.Slide = r),
      f
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "unipointer/unipointer",
          ["ev-emitter/ev-emitter"],
          function (n) {
            return e(t, n);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("ev-emitter")))
        : (t.Unipointer = e(t, t.EvEmitter));
  })(window, function (t, e) {
    function n() {}
    var i = (n.prototype = Object.create(e.prototype));
    ((i.bindStartEvent = function (t) {
      this._bindStartEvent(t, !0);
    }),
      (i.unbindStartEvent = function (t) {
        this._bindStartEvent(t, !1);
      }),
      (i._bindStartEvent = function (e, n) {
        var i = (n = void 0 === n || n)
            ? "addEventListener"
            : "removeEventListener",
          o = "mousedown";
        (t.PointerEvent
          ? (o = "pointerdown")
          : "ontouchstart" in t && (o = "touchstart"),
          e[i](o, this));
      }),
      (i.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (i.getTouch = function (t) {
        for (var e = 0; e < t.length; e++) {
          var n = t[e];
          if (n.identifier == this.pointerIdentifier) return n;
        }
      }),
      (i.onmousedown = function (t) {
        var e = t.button;
        (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
      }),
      (i.ontouchstart = function (t) {
        this._pointerDown(t, t.changedTouches[0]);
      }),
      (i.onpointerdown = function (t) {
        this._pointerDown(t, t);
      }),
      (i._pointerDown = function (t, e) {
        t.button ||
          this.isPointerDown ||
          ((this.isPointerDown = !0),
          (this.pointerIdentifier =
            void 0 !== e.pointerId ? e.pointerId : e.identifier),
          this.pointerDown(t, e));
      }),
      (i.pointerDown = function (t, e) {
        (this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]));
      }));
    var o = {
      mousedown: ["mousemove", "mouseup"],
      touchstart: ["touchmove", "touchend", "touchcancel"],
      pointerdown: ["pointermove", "pointerup", "pointercancel"],
    };
    return (
      (i._bindPostStartEvents = function (e) {
        if (e) {
          var n = o[e.type];
          (n.forEach(function (e) {
            t.addEventListener(e, this);
          }, this),
            (this._boundPointerEvents = n));
        }
      }),
      (i._unbindPostStartEvents = function () {
        this._boundPointerEvents &&
          (this._boundPointerEvents.forEach(function (e) {
            t.removeEventListener(e, this);
          }, this),
          delete this._boundPointerEvents);
      }),
      (i.onmousemove = function (t) {
        this._pointerMove(t, t);
      }),
      (i.onpointermove = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerMove(t, t);
      }),
      (i.ontouchmove = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerMove(t, e);
      }),
      (i._pointerMove = function (t, e) {
        this.pointerMove(t, e);
      }),
      (i.pointerMove = function (t, e) {
        this.emitEvent("pointerMove", [t, e]);
      }),
      (i.onmouseup = function (t) {
        this._pointerUp(t, t);
      }),
      (i.onpointerup = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerUp(t, t);
      }),
      (i.ontouchend = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerUp(t, e);
      }),
      (i._pointerUp = function (t, e) {
        (this._pointerDone(), this.pointerUp(t, e));
      }),
      (i.pointerUp = function (t, e) {
        this.emitEvent("pointerUp", [t, e]);
      }),
      (i._pointerDone = function () {
        (this._pointerReset(),
          this._unbindPostStartEvents(),
          this.pointerDone());
      }),
      (i._pointerReset = function () {
        ((this.isPointerDown = !1), delete this.pointerIdentifier);
      }),
      (i.pointerDone = function () {}),
      (i.onpointercancel = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t);
      }),
      (i.ontouchcancel = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerCancel(t, e);
      }),
      (i._pointerCancel = function (t, e) {
        (this._pointerDone(), this.pointerCancel(t, e));
      }),
      (i.pointerCancel = function (t, e) {
        this.emitEvent("pointerCancel", [t, e]);
      }),
      (n.getPointerPoint = function (t) {
        return { x: t.pageX, y: t.pageY };
      }),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "unidragger/unidragger",
          ["unipointer/unipointer"],
          function (n) {
            return e(t, n);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("unipointer")))
        : (t.Unidragger = e(t, t.Unipointer));
  })(window, function (t, e) {
    function n() {}
    var i = (n.prototype = Object.create(e.prototype));
    ((i.bindHandles = function () {
      this._bindHandles(!0);
    }),
      (i.unbindHandles = function () {
        this._bindHandles(!1);
      }),
      (i._bindHandles = function (e) {
        for (
          var n = (e = void 0 === e || e)
              ? "addEventListener"
              : "removeEventListener",
            i = e ? this._touchActionValue : "",
            o = 0;
          o < this.handles.length;
          o++
        ) {
          var r = this.handles[o];
          (this._bindStartEvent(r, e),
            r[n]("click", this),
            t.PointerEvent && (r.style.touchAction = i));
        }
      }),
      (i._touchActionValue = "none"),
      (i.pointerDown = function (t, e) {
        this.okayPointerDown(t) &&
          ((this.pointerDownPointer = e),
          t.preventDefault(),
          this.pointerDownBlur(),
          this._bindPostStartEvents(t),
          this.emitEvent("pointerDown", [t, e]));
      }));
    var o = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
      r = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0,
      };
    return (
      (i.okayPointerDown = function (t) {
        var e = o[t.target.nodeName],
          n = r[t.target.type],
          i = !e || n;
        return (i || this._pointerReset(), i);
      }),
      (i.pointerDownBlur = function () {
        var t = document.activeElement;
        t && t.blur && t != document.body && t.blur();
      }),
      (i.pointerMove = function (t, e) {
        var n = this._dragPointerMove(t, e);
        (this.emitEvent("pointerMove", [t, e, n]), this._dragMove(t, e, n));
      }),
      (i._dragPointerMove = function (t, e) {
        var n = {
          x: e.pageX - this.pointerDownPointer.pageX,
          y: e.pageY - this.pointerDownPointer.pageY,
        };
        return (
          !this.isDragging && this.hasDragStarted(n) && this._dragStart(t, e),
          n
        );
      }),
      (i.hasDragStarted = function (t) {
        return 3 < Math.abs(t.x) || 3 < Math.abs(t.y);
      }),
      (i.pointerUp = function (t, e) {
        (this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e));
      }),
      (i._dragPointerUp = function (t, e) {
        this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e);
      }),
      (i._dragStart = function (t, e) {
        ((this.isDragging = !0),
          (this.isPreventingClicks = !0),
          this.dragStart(t, e));
      }),
      (i.dragStart = function (t, e) {
        this.emitEvent("dragStart", [t, e]);
      }),
      (i._dragMove = function (t, e, n) {
        this.isDragging && this.dragMove(t, e, n);
      }),
      (i.dragMove = function (t, e, n) {
        (t.preventDefault(), this.emitEvent("dragMove", [t, e, n]));
      }),
      (i._dragEnd = function (t, e) {
        ((this.isDragging = !1),
          setTimeout(
            function () {
              delete this.isPreventingClicks;
            }.bind(this),
          ),
          this.dragEnd(t, e));
      }),
      (i.dragEnd = function (t, e) {
        this.emitEvent("dragEnd", [t, e]);
      }),
      (i.onclick = function (t) {
        this.isPreventingClicks && t.preventDefault();
      }),
      (i._staticClick = function (t, e) {
        (this.isIgnoringMouseUp && "mouseup" == t.type) ||
          (this.staticClick(t, e),
          "mouseup" != t.type &&
            ((this.isIgnoringMouseUp = !0),
            setTimeout(
              function () {
                delete this.isIgnoringMouseUp;
              }.bind(this),
              400,
            )));
      }),
      (i.staticClick = function (t, e) {
        this.emitEvent("staticClick", [t, e]);
      }),
      (n.getPointerPoint = e.getPointerPoint),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/drag",
          ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"],
          function (n, i, o) {
            return e(t, n, i, o);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(
            t,
            require("./flickity"),
            require("unidragger"),
            require("fizzy-ui-utils"),
          ))
        : (t.Flickity = e(t, t.Flickity, t.Unidragger, t.fizzyUIUtils));
  })(window, function (t, e, n, i) {
    (i.extend(e.defaults, { draggable: ">1", dragThreshold: 3 }),
      e.createMethods.push("_createDrag"));
    var o = e.prototype;
    (i.extend(o, n.prototype), (o._touchActionValue = "pan-y"));
    var r = "createTouch" in document,
      s = !1;
    ((o._createDrag = function () {
      (this.on("activate", this.onActivateDrag),
        this.on("uiChange", this._uiChangeDrag),
        this.on("deactivate", this.onDeactivateDrag),
        this.on("cellChange", this.updateDraggable),
        r && !s && (t.addEventListener("touchmove", function () {}), (s = !0)));
    }),
      (o.onActivateDrag = function () {
        ((this.handles = [this.viewport]),
          this.bindHandles(),
          this.updateDraggable());
      }),
      (o.onDeactivateDrag = function () {
        (this.unbindHandles(), this.element.classList.remove("is-draggable"));
      }),
      (o.updateDraggable = function () {
        (">1" == this.options.draggable
          ? (this.isDraggable = 1 < this.slides.length)
          : (this.isDraggable = this.options.draggable),
          this.isDraggable
            ? this.element.classList.add("is-draggable")
            : this.element.classList.remove("is-draggable"));
      }),
      (o.bindDrag = function () {
        ((this.options.draggable = !0), this.updateDraggable());
      }),
      (o.unbindDrag = function () {
        ((this.options.draggable = !1), this.updateDraggable());
      }),
      (o._uiChangeDrag = function () {
        delete this.isFreeScrolling;
      }),
      (o.pointerDown = function (e, n) {
        this.isDraggable
          ? this.okayPointerDown(e) &&
            (this._pointerDownPreventDefault(e),
            this.pointerDownFocus(e),
            document.activeElement != this.element && this.pointerDownBlur(),
            (this.dragX = this.x),
            this.viewport.classList.add("is-pointer-down"),
            (this.pointerDownScroll = l()),
            t.addEventListener("scroll", this),
            this._pointerDownDefault(e, n))
          : this._pointerDownDefault(e, n);
      }),
      (o._pointerDownDefault = function (t, e) {
        ((this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }),
          this._bindPostStartEvents(t),
          this.dispatchEvent("pointerDown", t, [e]));
      }));
    var a = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
    function l() {
      return { x: t.pageXOffset, y: t.pageYOffset };
    }
    return (
      (o.pointerDownFocus = function (t) {
        a[t.target.nodeName] || this.focus();
      }),
      (o._pointerDownPreventDefault = function (t) {
        var e = "touchstart" == t.type,
          n = "touch" == t.pointerType,
          i = a[t.target.nodeName];
        e || n || i || t.preventDefault();
      }),
      (o.hasDragStarted = function (t) {
        return Math.abs(t.x) > this.options.dragThreshold;
      }),
      (o.pointerUp = function (t, e) {
        (delete this.isTouchScrolling,
          this.viewport.classList.remove("is-pointer-down"),
          this.dispatchEvent("pointerUp", t, [e]),
          this._dragPointerUp(t, e));
      }),
      (o.pointerDone = function () {
        (t.removeEventListener("scroll", this), delete this.pointerDownScroll);
      }),
      (o.dragStart = function (e, n) {
        this.isDraggable &&
          ((this.dragStartPosition = this.x),
          this.startAnimation(),
          t.removeEventListener("scroll", this),
          this.dispatchEvent("dragStart", e, [n]));
      }),
      (o.pointerMove = function (t, e) {
        var n = this._dragPointerMove(t, e);
        (this.dispatchEvent("pointerMove", t, [e, n]), this._dragMove(t, e, n));
      }),
      (o.dragMove = function (t, e, n) {
        if (this.isDraggable) {
          (t.preventDefault(), (this.previousDragX = this.dragX));
          var i = this.options.rightToLeft ? -1 : 1;
          this.options.wrapAround && (n.x = n.x % this.slideableWidth);
          var o = this.dragStartPosition + n.x * i;
          if (!this.options.wrapAround && this.slides.length) {
            var r = Math.max(-this.slides[0].target, this.dragStartPosition);
            o = r < o ? 0.5 * (o + r) : o;
            var s = Math.min(
              -this.getLastSlide().target,
              this.dragStartPosition,
            );
            o = o < s ? 0.5 * (o + s) : o;
          }
          ((this.dragX = o),
            (this.dragMoveTime = new Date()),
            this.dispatchEvent("dragMove", t, [e, n]));
        }
      }),
      (o.dragEnd = function (t, e) {
        if (this.isDraggable) {
          this.options.freeScroll && (this.isFreeScrolling = !0);
          var n = this.dragEndRestingSelect();
          if (this.options.freeScroll && !this.options.wrapAround) {
            var i = this.getRestingPosition();
            this.isFreeScrolling =
              -i > this.slides[0].target && -i < this.getLastSlide().target;
          } else
            this.options.freeScroll ||
              n != this.selectedIndex ||
              (n += this.dragEndBoostSelect());
          (delete this.previousDragX,
            (this.isDragSelect = this.options.wrapAround),
            this.select(n),
            delete this.isDragSelect,
            this.dispatchEvent("dragEnd", t, [e]));
        }
      }),
      (o.dragEndRestingSelect = function () {
        var t = this.getRestingPosition(),
          e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
          n = this._getClosestResting(t, e, 1),
          i = this._getClosestResting(t, e, -1);
        return n.distance < i.distance ? n.index : i.index;
      }),
      (o._getClosestResting = function (t, e, n) {
        for (
          var i = this.selectedIndex,
            o = 1 / 0,
            r =
              this.options.contain && !this.options.wrapAround
                ? function (t, e) {
                    return t <= e;
                  }
                : function (t, e) {
                    return t < e;
                  };
          r(e, o) &&
          ((i += n), (o = e), null !== (e = this.getSlideDistance(-t, i)));
        )
          e = Math.abs(e);
        return { distance: o, index: i - n };
      }),
      (o.getSlideDistance = function (t, e) {
        var n = this.slides.length,
          o = this.options.wrapAround && 1 < n,
          r = o ? i.modulo(e, n) : e,
          s = this.slides[r];
        if (!s) return null;
        var a = o ? this.slideableWidth * Math.floor(e / n) : 0;
        return t - (s.target + a);
      }),
      (o.dragEndBoostSelect = function () {
        if (
          void 0 === this.previousDragX ||
          !this.dragMoveTime ||
          100 < new Date() - this.dragMoveTime
        )
          return 0;
        var t = this.getSlideDistance(-this.dragX, this.selectedIndex),
          e = this.previousDragX - this.dragX;
        return 0 < t && 0 < e ? 1 : t < 0 && e < 0 ? -1 : 0;
      }),
      (o.staticClick = function (t, e) {
        var n = this.getParentCell(t.target),
          i = n && n.element,
          o = n && this.cells.indexOf(n);
        this.dispatchEvent("staticClick", t, [e, i, o]);
      }),
      (o.onscroll = function () {
        var t = l(),
          e = this.pointerDownScroll.x - t.x,
          n = this.pointerDownScroll.y - t.y;
        (3 < Math.abs(e) || 3 < Math.abs(n)) && this._pointerDone();
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/prev-next-button",
          ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"],
          function (n, i, o) {
            return e(t, n, i, o);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(
            t,
            require("./flickity"),
            require("unipointer"),
            require("fizzy-ui-utils"),
          ))
        : e(t, t.Flickity, t.Unipointer, t.fizzyUIUtils);
  })(window, function (t, e, n, i) {
    var o = "http://www.w3.org/2000/svg";
    function r(t, e) {
      ((this.direction = t), (this.parent = e), this._create());
    }
    (((r.prototype = Object.create(n.prototype))._create = function () {
      ((this.isEnabled = !0), (this.isPrevious = -1 == this.direction));
      var t = this.parent.options.rightToLeft ? 1 : -1;
      this.isLeft = this.direction == t;
      var e = (this.element = document.createElement("button"));
      ((e.className = "flickity-button flickity-prev-next-button"),
        (e.className += this.isPrevious ? " previous" : " next"),
        e.setAttribute("type", "button"),
        this.disable(),
        e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next"));
      var n = this.createSVG();
      (e.appendChild(n),
        this.parent.on("select", this.update.bind(this)),
        this.on(
          "pointerDown",
          this.parent.childUIPointerDown.bind(this.parent),
        ));
    }),
      (r.prototype.activate = function () {
        (this.bindStartEvent(this.element),
          this.element.addEventListener("click", this),
          this.parent.element.appendChild(this.element));
      }),
      (r.prototype.deactivate = function () {
        (this.parent.element.removeChild(this.element),
          this.unbindStartEvent(this.element),
          this.element.removeEventListener("click", this));
      }),
      (r.prototype.createSVG = function () {
        var t = document.createElementNS(o, "svg");
        (t.setAttribute("class", "flickity-button-icon"),
          t.setAttribute("viewBox", "0 0 100 100"));
        var e,
          n = document.createElementNS(o, "path"),
          i =
            "string" != typeof (e = this.parent.options.arrowShape)
              ? "M " +
                e.x0 +
                ",50 L " +
                e.x1 +
                "," +
                (e.y1 + 50) +
                " L " +
                e.x2 +
                "," +
                (e.y2 + 50) +
                " L " +
                e.x3 +
                ",50  L " +
                e.x2 +
                "," +
                (50 - e.y2) +
                " L " +
                e.x1 +
                "," +
                (50 - e.y1) +
                " Z"
              : e;
        return (
          n.setAttribute("d", i),
          n.setAttribute("class", "arrow"),
          this.isLeft ||
            n.setAttribute("transform", "translate(100, 100) rotate(180) "),
          t.appendChild(n),
          t
        );
      }),
      (r.prototype.handleEvent = i.handleEvent),
      (r.prototype.onclick = function () {
        if (this.isEnabled) {
          this.parent.uiChange();
          var t = this.isPrevious ? "previous" : "next";
          this.parent[t]();
        }
      }),
      (r.prototype.enable = function () {
        this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
      }),
      (r.prototype.disable = function () {
        this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
      }),
      (r.prototype.update = function () {
        var t = this.parent.slides;
        if (this.parent.options.wrapAround && 1 < t.length) this.enable();
        else {
          var e = t.length ? t.length - 1 : 0,
            n = this.isPrevious ? 0 : e;
          this[this.parent.selectedIndex == n ? "disable" : "enable"]();
        }
      }),
      (r.prototype.destroy = function () {
        (this.deactivate(), this.allOff());
      }),
      i.extend(e.defaults, {
        prevNextButtons: !0,
        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
      }),
      e.createMethods.push("_createPrevNextButtons"));
    var s = e.prototype;
    return (
      (s._createPrevNextButtons = function () {
        this.options.prevNextButtons &&
          ((this.prevButton = new r(-1, this)),
          (this.nextButton = new r(1, this)),
          this.on("activate", this.activatePrevNextButtons));
      }),
      (s.activatePrevNextButtons = function () {
        (this.prevButton.activate(),
          this.nextButton.activate(),
          this.on("deactivate", this.deactivatePrevNextButtons));
      }),
      (s.deactivatePrevNextButtons = function () {
        (this.prevButton.deactivate(),
          this.nextButton.deactivate(),
          this.off("deactivate", this.deactivatePrevNextButtons));
      }),
      (e.PrevNextButton = r),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/page-dots",
          ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"],
          function (n, i, o) {
            return e(t, n, i, o);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(
            t,
            require("./flickity"),
            require("unipointer"),
            require("fizzy-ui-utils"),
          ))
        : e(t, t.Flickity, t.Unipointer, t.fizzyUIUtils);
  })(window, function (t, e, n, i) {
    function o(t) {
      ((this.parent = t), this._create());
    }
    (((o.prototype = Object.create(n.prototype))._create = function () {
      ((this.holder = document.createElement("ol")),
        (this.holder.className = "flickity-page-dots"),
        (this.dots = []),
        (this.handleClick = this.onClick.bind(this)),
        this.on(
          "pointerDown",
          this.parent.childUIPointerDown.bind(this.parent),
        ));
    }),
      (o.prototype.activate = function () {
        (this.setDots(),
          this.holder.addEventListener("click", this.handleClick),
          this.bindStartEvent(this.holder),
          this.parent.element.appendChild(this.holder));
      }),
      (o.prototype.deactivate = function () {
        (this.holder.removeEventListener("click", this.handleClick),
          this.unbindStartEvent(this.holder),
          this.parent.element.removeChild(this.holder));
      }),
      (o.prototype.setDots = function () {
        var t = this.parent.slides.length - this.dots.length;
        0 < t ? this.addDots(t) : t < 0 && this.removeDots(-t);
      }),
      (o.prototype.addDots = function (t) {
        for (
          var e = document.createDocumentFragment(),
            n = [],
            i = this.dots.length,
            o = i + t,
            r = i;
          r < o;
          r++
        ) {
          var s = document.createElement("li");
          ((s.className = "dot"),
            s.setAttribute("aria-label", "Page dot " + (r + 1)),
            e.appendChild(s),
            n.push(s));
        }
        (this.holder.appendChild(e), (this.dots = this.dots.concat(n)));
      }),
      (o.prototype.removeDots = function (t) {
        this.dots.splice(this.dots.length - t, t).forEach(function (t) {
          this.holder.removeChild(t);
        }, this);
      }),
      (o.prototype.updateSelected = function () {
        (this.selectedDot &&
          ((this.selectedDot.className = "dot"),
          this.selectedDot.removeAttribute("aria-current")),
          this.dots.length &&
            ((this.selectedDot = this.dots[this.parent.selectedIndex]),
            (this.selectedDot.className = "dot is-selected"),
            this.selectedDot.setAttribute("aria-current", "step")));
      }),
      (o.prototype.onTap = o.prototype.onClick =
        function (t) {
          var e = t.target;
          if ("LI" == e.nodeName) {
            this.parent.uiChange();
            var n = this.dots.indexOf(e);
            this.parent.select(n);
          }
        }),
      (o.prototype.destroy = function () {
        (this.deactivate(), this.allOff());
      }),
      (e.PageDots = o),
      i.extend(e.defaults, { pageDots: !0 }),
      e.createMethods.push("_createPageDots"));
    var r = e.prototype;
    return (
      (r._createPageDots = function () {
        this.options.pageDots &&
          ((this.pageDots = new o(this)),
          this.on("activate", this.activatePageDots),
          this.on("select", this.updateSelectedPageDots),
          this.on("cellChange", this.updatePageDots),
          this.on("resize", this.updatePageDots),
          this.on("deactivate", this.deactivatePageDots));
      }),
      (r.activatePageDots = function () {
        this.pageDots.activate();
      }),
      (r.updateSelectedPageDots = function () {
        this.pageDots.updateSelected();
      }),
      (r.updatePageDots = function () {
        this.pageDots.setDots();
      }),
      (r.deactivatePageDots = function () {
        this.pageDots.deactivate();
      }),
      (e.PageDots = o),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/player",
          ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"],
          function (t, n, i) {
            return e(t, n, i);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(
            require("ev-emitter"),
            require("fizzy-ui-utils"),
            require("./flickity"),
          ))
        : e(t.EvEmitter, t.fizzyUIUtils, t.Flickity);
  })(window, function (t, e, n) {
    function i(t) {
      ((this.parent = t),
        (this.state = "stopped"),
        (this.onVisibilityChange = this.visibilityChange.bind(this)),
        (this.onVisibilityPlay = this.visibilityPlay.bind(this)));
    }
    (((i.prototype = Object.create(t.prototype)).play = function () {
      "playing" != this.state &&
        (document.hidden
          ? document.addEventListener("visibilitychange", this.onVisibilityPlay)
          : ((this.state = "playing"),
            document.addEventListener(
              "visibilitychange",
              this.onVisibilityChange,
            ),
            this.tick()));
    }),
      (i.prototype.tick = function () {
        if ("playing" == this.state) {
          var t = this.parent.options.autoPlay;
          t = "number" == typeof t ? t : 3e3;
          var e = this;
          (this.clear(),
            (this.timeout = setTimeout(function () {
              (e.parent.next(!0), e.tick());
            }, t)));
        }
      }),
      (i.prototype.stop = function () {
        ((this.state = "stopped"),
          this.clear(),
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityChange,
          ));
      }),
      (i.prototype.clear = function () {
        clearTimeout(this.timeout);
      }),
      (i.prototype.pause = function () {
        "playing" == this.state && ((this.state = "paused"), this.clear());
      }),
      (i.prototype.unpause = function () {
        "paused" == this.state && this.play();
      }),
      (i.prototype.visibilityChange = function () {
        this[document.hidden ? "pause" : "unpause"]();
      }),
      (i.prototype.visibilityPlay = function () {
        (this.play(),
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityPlay,
          ));
      }),
      e.extend(n.defaults, { pauseAutoPlayOnHover: !0 }),
      n.createMethods.push("_createPlayer"));
    var o = n.prototype;
    return (
      (o._createPlayer = function () {
        ((this.player = new i(this)),
          this.on("activate", this.activatePlayer),
          this.on("uiChange", this.stopPlayer),
          this.on("pointerDown", this.stopPlayer),
          this.on("deactivate", this.deactivatePlayer));
      }),
      (o.activatePlayer = function () {
        this.options.autoPlay &&
          (this.player.play(),
          this.element.addEventListener("mouseenter", this));
      }),
      (o.playPlayer = function () {
        this.player.play();
      }),
      (o.stopPlayer = function () {
        this.player.stop();
      }),
      (o.pausePlayer = function () {
        this.player.pause();
      }),
      (o.unpausePlayer = function () {
        this.player.unpause();
      }),
      (o.deactivatePlayer = function () {
        (this.player.stop(),
          this.element.removeEventListener("mouseenter", this));
      }),
      (o.onmouseenter = function () {
        this.options.pauseAutoPlayOnHover &&
          (this.player.pause(),
          this.element.addEventListener("mouseleave", this));
      }),
      (o.onmouseleave = function () {
        (this.player.unpause(),
          this.element.removeEventListener("mouseleave", this));
      }),
      (n.Player = i),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/add-remove-cell",
          ["./flickity", "fizzy-ui-utils/utils"],
          function (n, i) {
            return e(t, n, i);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(
            t,
            require("./flickity"),
            require("fizzy-ui-utils"),
          ))
        : e(t, t.Flickity, t.fizzyUIUtils);
  })(window, function (t, e, n) {
    var i = e.prototype;
    return (
      (i.insert = function (t, e) {
        var n = this._makeCells(t);
        if (n && n.length) {
          var i = this.cells.length;
          e = void 0 === e ? i : e;
          var o,
            r,
            s =
              ((o = n),
              (r = document.createDocumentFragment()),
              o.forEach(function (t) {
                r.appendChild(t.element);
              }),
              r),
            a = e == i;
          if (a) this.slider.appendChild(s);
          else {
            var l = this.cells[e].element;
            this.slider.insertBefore(s, l);
          }
          if (0 === e) this.cells = n.concat(this.cells);
          else if (a) this.cells = this.cells.concat(n);
          else {
            var c = this.cells.splice(e, i - e);
            this.cells = this.cells.concat(n).concat(c);
          }
          (this._sizeCells(n), this.cellChange(e, !0));
        }
      }),
      (i.append = function (t) {
        this.insert(t, this.cells.length);
      }),
      (i.prepend = function (t) {
        this.insert(t, 0);
      }),
      (i.remove = function (t) {
        var e = this.getCells(t);
        if (e && e.length) {
          var i = this.cells.length - 1;
          (e.forEach(function (t) {
            t.remove();
            var e = this.cells.indexOf(t);
            ((i = Math.min(e, i)), n.removeFrom(this.cells, t));
          }, this),
            this.cellChange(i, !0));
        }
      }),
      (i.cellSizeChange = function (t) {
        var e = this.getCell(t);
        if (e) {
          e.getSize();
          var n = this.cells.indexOf(e);
          this.cellChange(n);
        }
      }),
      (i.cellChange = function (t, e) {
        var n = this.selectedElement;
        (this._positionCells(t),
          this._getWrapShiftCells(),
          this.setGallerySize());
        var i = this.getCell(n);
        (i && (this.selectedIndex = this.getCellSlideIndex(i)),
          (this.selectedIndex = Math.min(
            this.slides.length - 1,
            this.selectedIndex,
          )),
          this.emitEvent("cellChange", [t]),
          this.select(this.selectedIndex),
          e && this.positionSliderAtSelected());
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/lazyload",
          ["./flickity", "fizzy-ui-utils/utils"],
          function (n, i) {
            return e(t, n, i);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(
            t,
            require("./flickity"),
            require("fizzy-ui-utils"),
          ))
        : e(t, t.Flickity, t.fizzyUIUtils);
  })(window, function (t, e, n) {
    e.createMethods.push("_createLazyload");
    var i = e.prototype;
    function o(t, e) {
      ((this.img = t), (this.flickity = e), this.load());
    }
    return (
      (i._createLazyload = function () {
        this.on("select", this.lazyLoad);
      }),
      (i.lazyLoad = function () {
        var t = this.options.lazyLoad;
        if (t) {
          var e = "number" == typeof t ? t : 0,
            i = this.getAdjacentCellElements(e),
            r = [];
          (i.forEach(function (t) {
            var e = (function (t) {
              if ("IMG" == t.nodeName) {
                var e = t.getAttribute("data-flickity-lazyload"),
                  i = t.getAttribute("data-flickity-lazyload-src"),
                  o = t.getAttribute("data-flickity-lazyload-srcset");
                if (e || i || o) return [t];
              }
              var r = t.querySelectorAll(
                "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
              );
              return n.makeArray(r);
            })(t);
            r = r.concat(e);
          }),
            r.forEach(function (t) {
              new o(t, this);
            }, this));
        }
      }),
      (o.prototype.handleEvent = n.handleEvent),
      (o.prototype.load = function () {
        (this.img.addEventListener("load", this),
          this.img.addEventListener("error", this));
        var t =
            this.img.getAttribute("data-flickity-lazyload") ||
            this.img.getAttribute("data-flickity-lazyload-src"),
          e = this.img.getAttribute("data-flickity-lazyload-srcset");
        ((this.img.src = t),
          e && this.img.setAttribute("srcset", e),
          this.img.removeAttribute("data-flickity-lazyload"),
          this.img.removeAttribute("data-flickity-lazyload-src"),
          this.img.removeAttribute("data-flickity-lazyload-srcset"));
      }),
      (o.prototype.onload = function (t) {
        this.complete(t, "flickity-lazyloaded");
      }),
      (o.prototype.onerror = function (t) {
        this.complete(t, "flickity-lazyerror");
      }),
      (o.prototype.complete = function (t, e) {
        (this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this));
        var n = this.flickity.getParentCell(this.img),
          i = n && n.element;
        (this.flickity.cellSizeChange(i),
          this.img.classList.add(e),
          this.flickity.dispatchEvent("lazyLoad", t, i));
      }),
      (e.LazyLoader = o),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/index",
          [
            "./flickity",
            "./drag",
            "./prev-next-button",
            "./page-dots",
            "./player",
            "./add-remove-cell",
            "./lazyload",
          ],
          e,
        )
      : "object" == typeof module &&
        module.exports &&
        (module.exports = e(
          require("./flickity"),
          require("./drag"),
          require("./prev-next-button"),
          require("./page-dots"),
          require("./player"),
          require("./add-remove-cell"),
          require("./lazyload"),
        ));
  })(window, function (t) {
    return t;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity-as-nav-for/as-nav-for",
          ["flickity/js/index", "fizzy-ui-utils/utils"],
          e,
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(require("flickity"), require("fizzy-ui-utils")))
        : (t.Flickity = e(t.Flickity, t.fizzyUIUtils));
  })(window, function (t, e) {
    t.createMethods.push("_createAsNavFor");
    var n = t.prototype;
    return (
      (n._createAsNavFor = function () {
        (this.on("activate", this.activateAsNavFor),
          this.on("deactivate", this.deactivateAsNavFor),
          this.on("destroy", this.destroyAsNavFor));
        var t = this.options.asNavFor;
        if (t) {
          var e = this;
          setTimeout(function () {
            e.setNavCompanion(t);
          });
        }
      }),
      (n.setNavCompanion = function (n) {
        n = e.getQueryElement(n);
        var i = t.data(n);
        if (i && i != this) {
          this.navCompanion = i;
          var o = this;
          ((this.onNavCompanionSelect = function () {
            o.navCompanionSelect();
          }),
            i.on("select", this.onNavCompanionSelect),
            this.on("staticClick", this.onNavStaticClick),
            this.navCompanionSelect(!0));
        }
      }),
      (n.navCompanionSelect = function (t) {
        if (this.navCompanion) {
          var e,
            n = this.navCompanion.selectedCells[0],
            i = this.navCompanion.cells.indexOf(n),
            o = i + this.navCompanion.selectedCells.length - 1,
            r = Math.floor((o - (e = i)) * this.navCompanion.cellAlign + e);
          if (
            (this.selectCell(r, !1, t),
            this.removeNavSelectedElements(),
            !(r >= this.cells.length))
          ) {
            var s = this.cells.slice(i, o + 1);
            ((this.navSelectedElements = s.map(function (t) {
              return t.element;
            })),
              this.changeNavSelectedClass("add"));
          }
        }
      }),
      (n.changeNavSelectedClass = function (t) {
        this.navSelectedElements.forEach(function (e) {
          e.classList[t]("is-nav-selected");
        });
      }),
      (n.activateAsNavFor = function () {
        this.navCompanionSelect(!0);
      }),
      (n.removeNavSelectedElements = function () {
        this.navSelectedElements &&
          (this.changeNavSelectedClass("remove"),
          delete this.navSelectedElements);
      }),
      (n.onNavStaticClick = function (t, e, n, i) {
        "number" == typeof i && this.navCompanion.selectCell(i);
      }),
      (n.deactivateAsNavFor = function () {
        this.removeNavSelectedElements();
      }),
      (n.destroyAsNavFor = function () {
        this.navCompanion &&
          (this.navCompanion.off("select", this.onNavCompanionSelect),
          this.off("staticClick", this.onNavStaticClick),
          delete this.navCompanion);
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "imagesloaded/imagesloaded",
          ["ev-emitter/ev-emitter"],
          function (n) {
            return e(t, n);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("ev-emitter")))
        : (t.imagesLoaded = e(t, t.EvEmitter));
  })("undefined" != typeof window ? window : this, function (t, e) {
    var n = t.jQuery,
      i = t.console;
    function o(t, e) {
      for (var n in e) t[n] = e[n];
      return t;
    }
    var r = Array.prototype.slice;
    function s(t, e, a) {
      if (!(this instanceof s)) return new s(t, e, a);
      var l,
        c = t;
      ("string" == typeof t && (c = document.querySelectorAll(t)),
        c
          ? ((this.elements =
              ((l = c),
              Array.isArray(l)
                ? l
                : "object" == typeof l && "number" == typeof l.length
                  ? r.call(l)
                  : [l])),
            (this.options = o({}, this.options)),
            "function" == typeof e ? (a = e) : o(this.options, e),
            a && this.on("always", a),
            this.getImages(),
            n && (this.jqDeferred = new n.Deferred()),
            setTimeout(this.check.bind(this)))
          : i.error("Bad element for imagesLoaded " + (c || t)));
    }
    (((s.prototype = Object.create(e.prototype)).options = {}),
      (s.prototype.getImages = function () {
        ((this.images = []),
          this.elements.forEach(this.addElementImages, this));
      }),
      (s.prototype.addElementImages = function (t) {
        ("IMG" == t.nodeName && this.addImage(t),
          !0 === this.options.background && this.addElementBackgroundImages(t));
        var e = t.nodeType;
        if (e && a[e]) {
          for (var n = t.querySelectorAll("img"), i = 0; i < n.length; i++) {
            var o = n[i];
            this.addImage(o);
          }
          if ("string" == typeof this.options.background) {
            var r = t.querySelectorAll(this.options.background);
            for (i = 0; i < r.length; i++) {
              var s = r[i];
              this.addElementBackgroundImages(s);
            }
          }
        }
      }));
    var a = { 1: !0, 9: !0, 11: !0 };
    function l(t) {
      this.img = t;
    }
    function c(t, e) {
      ((this.url = t), (this.element = e), (this.img = new Image()));
    }
    return (
      (s.prototype.addElementBackgroundImages = function (t) {
        var e = getComputedStyle(t);
        if (e)
          for (
            var n = /url\((['"])?(.*?)\1\)/gi, i = n.exec(e.backgroundImage);
            null !== i;
          ) {
            var o = i && i[2];
            (o && this.addBackground(o, t), (i = n.exec(e.backgroundImage)));
          }
      }),
      (s.prototype.addImage = function (t) {
        var e = new l(t);
        this.images.push(e);
      }),
      (s.prototype.addBackground = function (t, e) {
        var n = new c(t, e);
        this.images.push(n);
      }),
      (s.prototype.check = function () {
        var t = this;
        function e(e, n, i) {
          setTimeout(function () {
            t.progress(e, n, i);
          });
        }
        ((this.progressedCount = 0),
          (this.hasAnyBroken = !1),
          this.images.length
            ? this.images.forEach(function (t) {
                (t.once("progress", e), t.check());
              })
            : this.complete());
      }),
      (s.prototype.progress = function (t, e, n) {
        (this.progressedCount++,
          (this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded),
          this.emitEvent("progress", [this, t, e]),
          this.jqDeferred &&
            this.jqDeferred.notify &&
            this.jqDeferred.notify(this, t),
          this.progressedCount == this.images.length && this.complete(),
          this.options.debug && i && i.log("progress: " + n, t, e));
      }),
      (s.prototype.complete = function () {
        var t = this.hasAnyBroken ? "fail" : "done";
        if (
          ((this.isComplete = !0),
          this.emitEvent(t, [this]),
          this.emitEvent("always", [this]),
          this.jqDeferred)
        ) {
          var e = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[e](this);
        }
      }),
      ((l.prototype = Object.create(e.prototype)).check = function () {
        this.getIsImageComplete()
          ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
          : ((this.proxyImage = new Image()),
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            (this.proxyImage.src = this.img.src));
      }),
      (l.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth;
      }),
      (l.prototype.confirm = function (t, e) {
        ((this.isLoaded = t), this.emitEvent("progress", [this, this.img, e]));
      }),
      (l.prototype.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (l.prototype.onload = function () {
        (this.confirm(!0, "onload"), this.unbindEvents());
      }),
      (l.prototype.onerror = function () {
        (this.confirm(!1, "onerror"), this.unbindEvents());
      }),
      (l.prototype.unbindEvents = function () {
        (this.proxyImage.removeEventListener("load", this),
          this.proxyImage.removeEventListener("error", this),
          this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this));
      }),
      ((c.prototype = Object.create(l.prototype)).check = function () {
        (this.img.addEventListener("load", this),
          this.img.addEventListener("error", this),
          (this.img.src = this.url),
          this.getIsImageComplete() &&
            (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
            this.unbindEvents()));
      }),
      (c.prototype.unbindEvents = function () {
        (this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this));
      }),
      (c.prototype.confirm = function (t, e) {
        ((this.isLoaded = t),
          this.emitEvent("progress", [this, this.element, e]));
      }),
      (s.makeJQueryPlugin = function (e) {
        (e = e || t.jQuery) &&
          ((n = e).fn.imagesLoaded = function (t, e) {
            return new s(this, t, e).jqDeferred.promise(n(this));
          });
      }),
      s.makeJQueryPlugin(),
      s
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          ["flickity/js/index", "imagesloaded/imagesloaded"],
          function (n, i) {
            return e(t, n, i);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("flickity"), require("imagesloaded")))
        : (t.Flickity = e(t, t.Flickity, t.imagesLoaded));
  })(window, function (t, e, n) {
    e.createMethods.push("_createImagesLoaded");
    var i = e.prototype;
    return (
      (i._createImagesLoaded = function () {
        this.on("activate", this.imagesLoaded);
      }),
      (i.imagesLoaded = function () {
        if (this.options.imagesLoaded) {
          var t = this;
          n(this.slider).on("progress", function (e, n) {
            var i = t.getParentCell(n.img);
            (t.cellSizeChange(i && i.element),
              t.options.freeScroll || t.positionSliderAtSelected());
          });
        }
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(["flickity/js/index", "fizzy-ui-utils/utils"], e)
      : "object" == typeof module && module.exports
        ? (module.exports = e(require("flickity"), require("fizzy-ui-utils")))
        : e(t.Flickity, t.fizzyUIUtils);
  })(this, function (t, e) {
    var n = t.Slide,
      i = n.prototype.updateTarget;
    ((n.prototype.updateTarget = function () {
      if ((i.apply(this, arguments), this.parent.options.fade)) {
        var t = this.target - this.x,
          e = this.cells[0].x;
        this.cells.forEach(function (n) {
          var i = n.x - e - t;
          n.renderPosition(i);
        });
      }
    }),
      (n.prototype.setOpacity = function (t) {
        this.cells.forEach(function (e) {
          e.element.style.opacity = t;
        });
      }));
    var o = t.prototype;
    (t.createMethods.push("_createFade"),
      (o._createFade = function () {
        ((this.fadeIndex = this.selectedIndex),
          (this.prevSelectedIndex = this.selectedIndex),
          this.on("select", this.onSelectFade),
          this.on("dragEnd", this.onDragEndFade),
          this.on("settle", this.onSettleFade),
          this.on("activate", this.onActivateFade),
          this.on("deactivate", this.onDeactivateFade));
      }));
    var r = o.updateSlides;
    ((o.updateSlides = function () {
      (r.apply(this, arguments),
        this.options.fade &&
          this.slides.forEach(function (t, e) {
            var n = e == this.selectedIndex ? 1 : 0;
            t.setOpacity(n);
          }, this));
    }),
      (o.onSelectFade = function () {
        ((this.fadeIndex = Math.min(
          this.prevSelectedIndex,
          this.slides.length - 1,
        )),
          (this.prevSelectedIndex = this.selectedIndex));
      }),
      (o.onSettleFade = function () {
        (delete this.didDragEnd, this.options.fade) &&
          (this.selectedSlide.setOpacity(1),
          this.slides[this.fadeIndex] &&
            this.fadeIndex != this.selectedIndex &&
            this.slides[this.fadeIndex].setOpacity(0));
      }),
      (o.onDragEndFade = function () {
        this.didDragEnd = !0;
      }),
      (o.onActivateFade = function () {
        this.options.fade && this.element.classList.add("is-fade");
      }),
      (o.onDeactivateFade = function () {
        this.options.fade &&
          (this.element.classList.remove("is-fade"),
          this.slides.forEach(function (t) {
            t.setOpacity("");
          }));
      }));
    var s = o.positionSlider;
    o.positionSlider = function () {
      this.options.fade
        ? (this.fadeSlides(), this.dispatchScrollEvent())
        : s.apply(this, arguments);
    };
    var a = o.positionSliderAtSelected;
    ((o.positionSliderAtSelected = function () {
      (this.options.fade && this.setTranslateX(0), a.apply(this, arguments));
    }),
      (o.fadeSlides = function () {
        if (!(this.slides.length < 2)) {
          var t = this.getFadeIndexes(),
            e = this.slides[t.a],
            n = this.slides[t.b],
            i = this.wrapDifference(e.target, n.target),
            o = this.wrapDifference(e.target, -this.x);
          ((o /= i), e.setOpacity(1 - o), n.setOpacity(o));
          var r = t.a;
          (this.isDragging && (r = o > 0.5 ? t.a : t.b),
            null != this.fadeHideIndex &&
              this.fadeHideIndex != r &&
              this.fadeHideIndex != t.a &&
              this.fadeHideIndex != t.b &&
              this.slides[this.fadeHideIndex].setOpacity(0),
            (this.fadeHideIndex = r));
        }
      }),
      (o.getFadeIndexes = function () {
        return this.isDragging || this.didDragEnd
          ? this.options.wrapAround
            ? this.getFadeDragWrapIndexes()
            : this.getFadeDragLimitIndexes()
          : { a: this.fadeIndex, b: this.selectedIndex };
      }),
      (o.getFadeDragWrapIndexes = function () {
        var t = this.slides.map(function (t, e) {
            return this.getSlideDistance(-this.x, e);
          }, this),
          n = t.map(function (t) {
            return Math.abs(t);
          }),
          i = Math.min.apply(Math, n),
          o = n.indexOf(i),
          r = t[o],
          s = this.slides.length,
          a = r >= 0 ? 1 : -1;
        return { a: o, b: e.modulo(o + a, s) };
      }),
      (o.getFadeDragLimitIndexes = function () {
        for (var t = 0, e = 0; e < this.slides.length - 1; e++) {
          var n = this.slides[e];
          if (-this.x < n.target) break;
          t = e;
        }
        return { a: t, b: t + 1 };
      }),
      (o.wrapDifference = function (t, e) {
        var n = e - t;
        if (!this.options.wrapAround) return n;
        var i = n + this.slideableWidth,
          o = n - this.slideableWidth;
        return (
          Math.abs(i) < Math.abs(n) && (n = i),
          Math.abs(o) < Math.abs(n) && (n = o),
          n
        );
      }));
    var l = o._getWrapShiftCells;
    o._getWrapShiftCells = function () {
      this.options.fade || l.apply(this, arguments);
    };
    var c = o.shiftWrapCells;
    return (
      (o.shiftWrapCells = function () {
        this.options.fade || c.apply(this, arguments);
      }),
      t
    );
  }),
  (Flickity.prototype._createResizeClass = function () {
    this.element.classList.add("flickity-resize");
  }),
  Flickity.createMethods.push("_createResizeClass"));
var resize = Flickity.prototype.resize;
((Flickity.prototype.resize = function () {
  (this.element.classList.remove("flickity-resize"),
    resize.call(this),
    this.element.classList.add("flickity-resize"));
}),
  (function (t, e, n, i) {
    function o(t, e) {
      var i,
        o,
        r,
        s = [],
        a = 0;
      (t && t.isDefaultPrevented()) ||
        (t.preventDefault(),
        (e = e || {}),
        t && t.data && (e = f(t.data.options, e)),
        (i = e.$target || n(t.currentTarget).trigger("blur")),
        ((r = n.fancybox.getInstance()) && r.$trigger && r.$trigger.is(i)) ||
          (e.selector
            ? (s = n(e.selector))
            : (o = i.attr("data-fancybox") || "")
              ? (s = (s = t.data ? t.data.items : []).length
                  ? s.filter('[data-fancybox="' + o + '"]')
                  : n('[data-fancybox="' + o + '"]'))
              : (s = [i]),
          (a = n(s).index(i)) < 0 && (a = 0),
          ((r = n.fancybox.open(s, e, a)).$trigger = i)));
    }
    if (((t.console = t.console || { info: function (t) {} }), n)) {
      if (n.fn.fancybox)
        return void console.info("fancyBox already initialized");
      var r = {
          closeExisting: !1,
          loop: !1,
          gutter: 50,
          keyboard: !0,
          preventCaptionOverlap: !0,
          arrows: !0,
          infobar: !0,
          smallBtn: "auto",
          toolbar: "auto",
          buttons: ["zoom", "slideShow", "thumbs", "close"],
          idleTime: 3,
          protect: !1,
          modal: !1,
          image: { preload: !1 },
          ajax: { settings: { data: { fancybox: !0 } } },
          iframe: {
            tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
            preload: !0,
            css: {},
            attr: { scrolling: "auto" },
          },
          video: {
            tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
            format: "",
            autoStart: !0,
          },
          defaultType: "image",
          animationEffect: "zoom",
          animationDuration: 366,
          zoomOpacity: "auto",
          transitionEffect: "fade",
          transitionDuration: 366,
          slideClass: "",
          baseClass: "",
          baseTpl:
            '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
          spinnerTpl: '<div class="fancybox-loading"></div>',
          errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
          btnTpl: {
            download:
              '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
            zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
            close:
              '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
            arrowLeft:
              '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
            arrowRight:
              '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
            smallBtn:
              '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>',
          },
          parentEl: "body",
          hideScrollbar: !0,
          autoFocus: !0,
          backFocus: !0,
          trapFocus: !0,
          fullScreen: { autoStart: !1 },
          touch: { vertical: !0, momentum: !0 },
          hash: null,
          media: {},
          slideShow: { autoStart: !1, speed: 3e3 },
          thumbs: {
            autoStart: !1,
            hideOnClose: !0,
            parentEl: ".fancybox-container",
            axis: "y",
          },
          wheel: "auto",
          onInit: n.noop,
          beforeLoad: n.noop,
          afterLoad: n.noop,
          beforeShow: n.noop,
          afterShow: n.noop,
          beforeClose: n.noop,
          afterClose: n.noop,
          onActivate: n.noop,
          onDeactivate: n.noop,
          clickContent: function (t, e) {
            return "image" === t.type && "zoom";
          },
          clickSlide: "close",
          clickOutside: "close",
          dblclickContent: !1,
          dblclickSlide: !1,
          dblclickOutside: !1,
          mobile: {
            preventCaptionOverlap: !1,
            idleTime: !1,
            clickContent: function (t, e) {
              return "image" === t.type && "toggleControls";
            },
            clickSlide: function (t, e) {
              return "image" === t.type ? "toggleControls" : "close";
            },
            dblclickContent: function (t, e) {
              return "image" === t.type && "zoom";
            },
            dblclickSlide: function (t, e) {
              return "image" === t.type && "zoom";
            },
          },
          lang: "en",
          i18n: {
            en: {
              CLOSE: "Close",
              NEXT: "Next",
              PREV: "Previous",
              ERROR:
                "The requested content cannot be loaded. <br/> Please try again later.",
              PLAY_START: "Start slideshow",
              PLAY_STOP: "Pause slideshow",
              FULL_SCREEN: "Full screen",
              THUMBS: "Thumbnails",
              DOWNLOAD: "Download",
              SHARE: "Share",
              ZOOM: "Zoom",
            },
            de: {
              CLOSE: "Schlie&szlig;en",
              NEXT: "Weiter",
              PREV: "Zur&uuml;ck",
              ERROR:
                "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
              PLAY_START: "Diaschau starten",
              PLAY_STOP: "Diaschau beenden",
              FULL_SCREEN: "Vollbild",
              THUMBS: "Vorschaubilder",
              DOWNLOAD: "Herunterladen",
              SHARE: "Teilen",
              ZOOM: "Vergr&ouml;&szlig;ern",
            },
          },
        },
        s = n(t),
        a = n(e),
        l = 0,
        c =
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          },
        u =
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          },
        h = (function () {
          var t,
            n = e.createElement("fakeelement"),
            i = {
              transition: "transitionend",
              OTransition: "oTransitionEnd",
              MozTransition: "transitionend",
              WebkitTransition: "webkitTransitionEnd",
            };
          for (t in i) if (void 0 !== n.style[t]) return i[t];
          return "transitionend";
        })(),
        d = function (t) {
          return t && t.length && t[0].offsetHeight;
        },
        f = function (t, e) {
          var i = n.extend(!0, {}, t, e);
          return (
            n.each(e, function (t, e) {
              n.isArray(e) && (i[t] = e);
            }),
            i
          );
        },
        p = function (t) {
          var i, o;
          return (
            !(!t || t.ownerDocument !== e) &&
            (n(".fancybox-container").css("pointer-events", "none"),
            (i = {
              x: t.getBoundingClientRect().left + t.offsetWidth / 2,
              y: t.getBoundingClientRect().top + t.offsetHeight / 2,
            }),
            (o = e.elementFromPoint(i.x, i.y) === t),
            n(".fancybox-container").css("pointer-events", ""),
            o)
          );
        },
        m = function (t, e, i) {
          var o = this;
          ((o.opts = f({ index: i }, n.fancybox.defaults)),
            n.isPlainObject(e) && (o.opts = f(o.opts, e)),
            n.fancybox.isMobile && (o.opts = f(o.opts, o.opts.mobile)),
            (o.id = o.opts.id || ++l),
            (o.currIndex = parseInt(o.opts.index, 10) || 0),
            (o.prevIndex = null),
            (o.prevPos = null),
            (o.currPos = 0),
            (o.firstRun = !0),
            (o.group = []),
            (o.slides = {}),
            o.addContent(t),
            o.group.length && o.init());
        };
      (n.extend(m.prototype, {
        init: function () {
          var i,
            o,
            r = this,
            s = r.group[r.currIndex].opts;
          (s.closeExisting && n.fancybox.close(!0),
            n("body").addClass("fancybox-active"),
            !n.fancybox.getInstance() &&
              !1 !== s.hideScrollbar &&
              !n.fancybox.isMobile &&
              e.body.scrollHeight > t.innerHeight &&
              (n("head").append(
                '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' +
                  (t.innerWidth - e.documentElement.clientWidth) +
                  "px;}</style>",
              ),
              n("body").addClass("compensate-for-scrollbar")),
            (o = ""),
            n.each(s.buttons, function (t, e) {
              o += s.btnTpl[e] || "";
            }),
            (i = n(
              r.translate(
                r,
                s.baseTpl
                  .replace("{{buttons}}", o)
                  .replace(
                    "{{arrows}}",
                    s.btnTpl.arrowLeft + s.btnTpl.arrowRight,
                  ),
              ),
            )
              .attr("id", "fancybox-container-" + r.id)
              .addClass(s.baseClass)
              .data("FancyBox", r)
              .appendTo(s.parentEl)),
            (r.$refs = { container: i }),
            [
              "bg",
              "inner",
              "infobar",
              "toolbar",
              "stage",
              "caption",
              "navigation",
            ].forEach(function (t) {
              r.$refs[t] = i.find(".fancybox-" + t);
            }),
            r.trigger("onInit"),
            r.activate(),
            r.jumpTo(r.currIndex));
        },
        translate: function (t, e) {
          var n = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
          return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
            return void 0 === n[e] ? t : n[e];
          });
        },
        addContent: function (t) {
          var e,
            i = this,
            o = n.makeArray(t);
          (n.each(o, function (t, e) {
            var o,
              r,
              s,
              a,
              l,
              c = {},
              u = {};
            (n.isPlainObject(e)
              ? ((c = e), (u = e.opts || e))
              : "object" === n.type(e) && n(e).length
                ? ((u = (o = n(e)).data() || {}),
                  ((u = n.extend(!0, {}, u, u.options)).$orig = o),
                  (c.src = i.opts.src || u.src || o.attr("href")),
                  c.type || c.src || ((c.type = "inline"), (c.src = e)))
                : (c = { type: "html", src: e + "" }),
              (c.opts = n.extend(!0, {}, i.opts, u)),
              n.isArray(u.buttons) && (c.opts.buttons = u.buttons),
              n.fancybox.isMobile &&
                c.opts.mobile &&
                (c.opts = f(c.opts, c.opts.mobile)),
              (r = c.type || c.opts.type),
              (a = c.src || ""),
              !r &&
                a &&
                ((s = a.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                  ? ((r = "video"),
                    c.opts.video.format ||
                      (c.opts.video.format =
                        "video/" + ("ogv" === s[1] ? "ogg" : s[1])))
                  : a.match(
                        /(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i,
                      )
                    ? (r = "image")
                    : a.match(/\.(pdf)((\?|#).*)?$/i)
                      ? ((r = "iframe"),
                        (c = n.extend(!0, c, {
                          contentType: "pdf",
                          opts: { iframe: { preload: !1 } },
                        })))
                      : "#" === a.charAt(0) && (r = "inline")),
              r ? (c.type = r) : i.trigger("objectNeedsType", c),
              c.contentType ||
                (c.contentType =
                  n.inArray(c.type, ["html", "inline", "ajax"]) > -1
                    ? "html"
                    : c.type),
              (c.index = i.group.length),
              "auto" == c.opts.smallBtn &&
                (c.opts.smallBtn =
                  n.inArray(c.type, ["html", "inline", "ajax"]) > -1),
              "auto" === c.opts.toolbar && (c.opts.toolbar = !c.opts.smallBtn),
              (c.$thumb = c.opts.$thumb || null),
              c.opts.$trigger &&
                c.index === i.opts.index &&
                ((c.$thumb = c.opts.$trigger.find("img:first")),
                c.$thumb.length && (c.opts.$orig = c.opts.$trigger)),
              (c.$thumb && c.$thumb.length) ||
                !c.opts.$orig ||
                (c.$thumb = c.opts.$orig.find("img:first")),
              c.$thumb && !c.$thumb.length && (c.$thumb = null),
              (c.thumb = c.opts.thumb || (c.$thumb ? c.$thumb[0].src : null)),
              "function" === n.type(c.opts.caption) &&
                (c.opts.caption = c.opts.caption.apply(e, [i, c])),
              "function" === n.type(i.opts.caption) &&
                (c.opts.caption = i.opts.caption.apply(e, [i, c])),
              c.opts.caption instanceof n ||
                (c.opts.caption =
                  void 0 === c.opts.caption ? "" : c.opts.caption + ""),
              "ajax" === c.type &&
                (l = a.split(/\s+/, 2)).length > 1 &&
                ((c.src = l.shift()), (c.opts.filter = l.shift())),
              c.opts.modal &&
                (c.opts = n.extend(!0, c.opts, {
                  trapFocus: !0,
                  infobar: 0,
                  toolbar: 0,
                  smallBtn: 0,
                  keyboard: 0,
                  slideShow: 0,
                  fullScreen: 0,
                  thumbs: 0,
                  touch: 0,
                  clickContent: !1,
                  clickSlide: !1,
                  clickOutside: !1,
                  dblclickContent: !1,
                  dblclickSlide: !1,
                  dblclickOutside: !1,
                })),
              i.group.push(c));
          }),
            Object.keys(i.slides).length &&
              (i.updateControls(),
              (e = i.Thumbs) && e.isActive && (e.create(), e.focus())));
        },
        addEvents: function () {
          var e = this;
          (e.removeEvents(),
            e.$refs.container
              .on("click.fb-close", "[data-fancybox-close]", function (t) {
                (t.stopPropagation(), t.preventDefault(), e.close(t));
              })
              .on(
                "touchstart.fb-prev click.fb-prev",
                "[data-fancybox-prev]",
                function (t) {
                  (t.stopPropagation(), t.preventDefault(), e.previous());
                },
              )
              .on(
                "touchstart.fb-next click.fb-next",
                "[data-fancybox-next]",
                function (t) {
                  (t.stopPropagation(), t.preventDefault(), e.next());
                },
              )
              .on("click.fb", "[data-fancybox-zoom]", function (t) {
                e[e.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
              }),
            s.on("orientationchange.fb resize.fb", function (t) {
              t && t.originalEvent && "resize" === t.originalEvent.type
                ? (e.requestId && u(e.requestId),
                  (e.requestId = c(function () {
                    e.update(t);
                  })))
                : (e.current &&
                    "iframe" === e.current.type &&
                    e.$refs.stage.hide(),
                  setTimeout(
                    function () {
                      (e.$refs.stage.show(), e.update(t));
                    },
                    n.fancybox.isMobile ? 600 : 250,
                  ));
            }),
            a.on("keydown.fb", function (t) {
              var i = (n.fancybox ? n.fancybox.getInstance() : null).current,
                o = t.keyCode || t.which;
              if (9 != o)
                return !i.opts.keyboard ||
                  t.ctrlKey ||
                  t.altKey ||
                  t.shiftKey ||
                  n(t.target).is("input,textarea,video,audio,select")
                  ? void 0
                  : 8 === o || 27 === o
                    ? (t.preventDefault(), void e.close(t))
                    : 37 === o || 38 === o
                      ? (t.preventDefault(), void e.previous())
                      : 39 === o || 40 === o
                        ? (t.preventDefault(), void e.next())
                        : void e.trigger("afterKeydown", t, o);
              i.opts.trapFocus && e.focus(t);
            }),
            e.group[e.currIndex].opts.idleTime &&
              ((e.idleSecondsCounter = 0),
              a.on(
                "mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",
                function (t) {
                  ((e.idleSecondsCounter = 0),
                    e.isIdle && e.showControls(),
                    (e.isIdle = !1));
                },
              ),
              (e.idleInterval = t.setInterval(function () {
                ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime &&
                  !e.isDragging &&
                  ((e.isIdle = !0),
                  (e.idleSecondsCounter = 0),
                  e.hideControls());
              }, 1e3))));
        },
        removeEvents: function () {
          var e = this;
          (s.off("orientationchange.fb resize.fb"),
            a.off("keydown.fb .fb-idle"),
            this.$refs.container.off(".fb-close .fb-prev .fb-next"),
            e.idleInterval &&
              (t.clearInterval(e.idleInterval), (e.idleInterval = null)));
        },
        previous: function (t) {
          return this.jumpTo(this.currPos - 1, t);
        },
        next: function (t) {
          return this.jumpTo(this.currPos + 1, t);
        },
        jumpTo: function (t, e) {
          var i,
            o,
            r,
            s,
            a,
            l,
            c,
            u,
            h,
            f = this,
            p = f.group.length;
          if (!(f.isDragging || f.isClosing || (f.isAnimating && f.firstRun))) {
            if (
              ((t = parseInt(t, 10)),
              !(r = f.current ? f.current.opts.loop : f.opts.loop) &&
                (t < 0 || t >= p))
            )
              return !1;
            if (
              ((i = f.firstRun = !Object.keys(f.slides).length),
              (a = f.current),
              (f.prevIndex = f.currIndex),
              (f.prevPos = f.currPos),
              (s = f.createSlide(t)),
              p > 1 &&
                ((r || s.index < p - 1) && f.createSlide(t + 1),
                (r || s.index > 0) && f.createSlide(t - 1)),
              (f.current = s),
              (f.currIndex = s.index),
              (f.currPos = s.pos),
              f.trigger("beforeShow", i),
              f.updateControls(),
              (s.forcedDuration = void 0),
              n.isNumeric(e)
                ? (s.forcedDuration = e)
                : (e = s.opts[i ? "animationDuration" : "transitionDuration"]),
              (e = parseInt(e, 10)),
              (o = f.isMoved(s)),
              s.$slide.addClass("fancybox-slide--current"),
              i)
            )
              return (
                s.opts.animationEffect &&
                  e &&
                  f.$refs.container.css("transition-duration", e + "ms"),
                f.$refs.container.addClass("fancybox-is-open").trigger("focus"),
                f.loadSlide(s),
                void f.preload("image")
              );
            ((l = n.fancybox.getTranslate(a.$slide)),
              (c = n.fancybox.getTranslate(f.$refs.stage)),
              n.each(f.slides, function (t, e) {
                n.fancybox.stop(e.$slide, !0);
              }),
              a.pos !== s.pos && (a.isComplete = !1),
              a.$slide.removeClass(
                "fancybox-slide--complete fancybox-slide--current",
              ),
              o
                ? ((h = l.left - (a.pos * l.width + a.pos * a.opts.gutter)),
                  n.each(f.slides, function (t, i) {
                    i.$slide
                      .removeClass("fancybox-animated")
                      .removeClass(function (t, e) {
                        return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(
                          " ",
                        );
                      });
                    var o = i.pos * l.width + i.pos * i.opts.gutter;
                    (n.fancybox.setTranslate(i.$slide, {
                      top: 0,
                      left: o - c.left + h,
                    }),
                      i.pos !== s.pos &&
                        i.$slide.addClass(
                          "fancybox-slide--" +
                            (i.pos > s.pos ? "next" : "previous"),
                        ),
                      d(i.$slide),
                      n.fancybox.animate(
                        i.$slide,
                        {
                          top: 0,
                          left:
                            (i.pos - s.pos) * l.width +
                            (i.pos - s.pos) * i.opts.gutter,
                        },
                        e,
                        function () {
                          (i.$slide
                            .css({ transform: "", opacity: "" })
                            .removeClass(
                              "fancybox-slide--next fancybox-slide--previous",
                            ),
                            i.pos === f.currPos && f.complete());
                        },
                      ));
                  }))
                : e &&
                  s.opts.transitionEffect &&
                  ((u =
                    "fancybox-animated fancybox-fx-" + s.opts.transitionEffect),
                  a.$slide.addClass(
                    "fancybox-slide--" + (a.pos > s.pos ? "next" : "previous"),
                  ),
                  n.fancybox.animate(
                    a.$slide,
                    u,
                    e,
                    function () {
                      a.$slide
                        .removeClass(u)
                        .removeClass(
                          "fancybox-slide--next fancybox-slide--previous",
                        );
                    },
                    !1,
                  )),
              s.isLoaded ? f.revealContent(s) : f.loadSlide(s),
              f.preload("image"));
          }
        },
        createSlide: function (t) {
          var e,
            i,
            o = this;
          return (
            (i = (i = t % o.group.length) < 0 ? o.group.length + i : i),
            !o.slides[t] &&
              o.group[i] &&
              ((e = n('<div class="fancybox-slide"></div>').appendTo(
                o.$refs.stage,
              )),
              (o.slides[t] = n.extend(!0, {}, o.group[i], {
                pos: t,
                $slide: e,
                isLoaded: !1,
              })),
              o.updateSlide(o.slides[t])),
            o.slides[t]
          );
        },
        scaleToActual: function (t, e, i) {
          var o,
            r,
            s,
            a,
            l,
            c = this,
            u = c.current,
            h = u.$content,
            d = n.fancybox.getTranslate(u.$slide).width,
            f = n.fancybox.getTranslate(u.$slide).height,
            p = u.width,
            m = u.height;
          c.isAnimating ||
            c.isMoved() ||
            !h ||
            "image" != u.type ||
            !u.isLoaded ||
            u.hasError ||
            ((c.isAnimating = !0),
            n.fancybox.stop(h),
            (t = void 0 === t ? 0.5 * d : t),
            (e = void 0 === e ? 0.5 * f : e),
            ((o = n.fancybox.getTranslate(h)).top -= n.fancybox.getTranslate(
              u.$slide,
            ).top),
            (o.left -= n.fancybox.getTranslate(u.$slide).left),
            (a = p / o.width),
            (l = m / o.height),
            (r = 0.5 * d - 0.5 * p),
            (s = 0.5 * f - 0.5 * m),
            p > d &&
              ((r = o.left * a - (t * a - t)) > 0 && (r = 0),
              r < d - p && (r = d - p)),
            m > f &&
              ((s = o.top * l - (e * l - e)) > 0 && (s = 0),
              s < f - m && (s = f - m)),
            c.updateCursor(p, m),
            n.fancybox.animate(
              h,
              { top: s, left: r, scaleX: a, scaleY: l },
              i || 366,
              function () {
                c.isAnimating = !1;
              },
            ),
            c.SlideShow && c.SlideShow.isActive && c.SlideShow.stop());
        },
        scaleToFit: function (t) {
          var e,
            i = this,
            o = i.current,
            r = o.$content;
          i.isAnimating ||
            i.isMoved() ||
            !r ||
            "image" != o.type ||
            !o.isLoaded ||
            o.hasError ||
            ((i.isAnimating = !0),
            n.fancybox.stop(r),
            (e = i.getFitPos(o)),
            i.updateCursor(e.width, e.height),
            n.fancybox.animate(
              r,
              {
                top: e.top,
                left: e.left,
                scaleX: e.width / r.width(),
                scaleY: e.height / r.height(),
              },
              t || 366,
              function () {
                i.isAnimating = !1;
              },
            ));
        },
        getFitPos: function (t) {
          var e,
            i,
            o,
            r,
            s = t.$content,
            a = t.$slide,
            l = t.width || t.opts.width,
            c = t.height || t.opts.height,
            u = {};
          return (
            !!(t.isLoaded && s && s.length) &&
            ((e = n.fancybox.getTranslate(this.$refs.stage).width),
            (i = n.fancybox.getTranslate(this.$refs.stage).height),
            (e -=
              parseFloat(a.css("paddingLeft")) +
              parseFloat(a.css("paddingRight")) +
              parseFloat(s.css("marginLeft")) +
              parseFloat(s.css("marginRight"))),
            (i -=
              parseFloat(a.css("paddingTop")) +
              parseFloat(a.css("paddingBottom")) +
              parseFloat(s.css("marginTop")) +
              parseFloat(s.css("marginBottom"))),
            (l && c) || ((l = e), (c = i)),
            (l *= o = Math.min(1, e / l, i / c)) > e - 0.5 && (l = e),
            (c *= o) > i - 0.5 && (c = i),
            "image" === t.type
              ? ((u.top =
                  Math.floor(0.5 * (i - c)) + parseFloat(a.css("paddingTop"))),
                (u.left =
                  Math.floor(0.5 * (e - l)) + parseFloat(a.css("paddingLeft"))))
              : "video" === t.contentType &&
                (c >
                l /
                  (r =
                    t.opts.width && t.opts.height
                      ? l / c
                      : t.opts.ratio || 16 / 9)
                  ? (c = l / r)
                  : l > c * r && (l = c * r)),
            (u.width = l),
            (u.height = c),
            u)
          );
        },
        update: function (t) {
          var e = this;
          n.each(e.slides, function (n, i) {
            e.updateSlide(i, t);
          });
        },
        updateSlide: function (t, e) {
          var i = this,
            o = t && t.$content,
            r = t.width || t.opts.width,
            s = t.height || t.opts.height,
            a = t.$slide;
          (i.adjustCaption(t),
            o &&
              (r || s || "video" === t.contentType) &&
              !t.hasError &&
              (n.fancybox.stop(o),
              n.fancybox.setTranslate(o, i.getFitPos(t)),
              t.pos === i.currPos && ((i.isAnimating = !1), i.updateCursor())),
            i.adjustLayout(t),
            a.length &&
              (a.trigger("refresh"),
              t.pos === i.currPos &&
                i.$refs.toolbar
                  .add(i.$refs.navigation.find(".fancybox-button--arrow_right"))
                  .toggleClass(
                    "compensate-for-scrollbar",
                    a.get(0).scrollHeight > a.get(0).clientHeight,
                  )),
            i.trigger("onUpdate", t, e));
        },
        centerSlide: function (t) {
          var e = this,
            i = e.current,
            o = i.$slide;
          !e.isClosing &&
            i &&
            (o.siblings().css({ transform: "", opacity: "" }),
            o
              .parent()
              .children()
              .removeClass("fancybox-slide--previous fancybox-slide--next"),
            n.fancybox.animate(
              o,
              { top: 0, left: 0, opacity: 1 },
              void 0 === t ? 0 : t,
              function () {
                (o.css({ transform: "", opacity: "" }),
                  i.isComplete || e.complete());
              },
              !1,
            ));
        },
        isMoved: function (t) {
          var e,
            i,
            o = t || this.current;
          return (
            !!o &&
            ((i = n.fancybox.getTranslate(this.$refs.stage)),
            (e = n.fancybox.getTranslate(o.$slide)),
            !o.$slide.hasClass("fancybox-animated") &&
              (Math.abs(e.top - i.top) > 0.5 ||
                Math.abs(e.left - i.left) > 0.5))
          );
        },
        updateCursor: function (t, e) {
          var i,
            o,
            r = this,
            s = r.current,
            a = r.$refs.container;
          s &&
            !r.isClosing &&
            r.Guestures &&
            (a.removeClass(
              "fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan",
            ),
            (o = !!(i = r.canPan(t, e)) || r.isZoomable()),
            a.toggleClass("fancybox-is-zoomable", o),
            n("[data-fancybox-zoom]").prop("disabled", !o),
            i
              ? a.addClass("fancybox-can-pan")
              : o &&
                  ("zoom" === s.opts.clickContent ||
                    (n.isFunction(s.opts.clickContent) &&
                      "zoom" == s.opts.clickContent(s)))
                ? a.addClass("fancybox-can-zoomIn")
                : s.opts.touch &&
                  (s.opts.touch.vertical || r.group.length > 1) &&
                  "video" !== s.contentType &&
                  a.addClass("fancybox-can-swipe"));
        },
        isZoomable: function () {
          var t,
            e = this,
            n = e.current;
          if (n && !e.isClosing && "image" === n.type && !n.hasError) {
            if (!n.isLoaded) return !0;
            if (
              (t = e.getFitPos(n)) &&
              (n.width > t.width || n.height > t.height)
            )
              return !0;
          }
          return !1;
        },
        isScaledDown: function (t, e) {
          var i = !1,
            o = this.current,
            r = o.$content;
          return (
            void 0 !== t && void 0 !== e
              ? (i = t < o.width && e < o.height)
              : r &&
                (i =
                  (i = n.fancybox.getTranslate(r)).width < o.width &&
                  i.height < o.height),
            i
          );
        },
        canPan: function (t, e) {
          var i = this.current,
            o = null,
            r = !1;
          return (
            "image" === i.type &&
              (i.isComplete || (t && e)) &&
              !i.hasError &&
              ((r = this.getFitPos(i)),
              void 0 !== t && void 0 !== e
                ? (o = { width: t, height: e })
                : i.isComplete && (o = n.fancybox.getTranslate(i.$content)),
              o &&
                r &&
                (r =
                  Math.abs(o.width - r.width) > 1.5 ||
                  Math.abs(o.height - r.height) > 1.5)),
            r
          );
        },
        loadSlide: function (t) {
          var e,
            i,
            o,
            r = this;
          if (!t.isLoading && !t.isLoaded) {
            if (((t.isLoading = !0), !1 === r.trigger("beforeLoad", t)))
              return ((t.isLoading = !1), !1);
            switch (
              ((e = t.type),
              (i = t.$slide)
                .off("refresh")
                .trigger("onReset")
                .addClass(t.opts.slideClass),
              e)
            ) {
              case "image":
                r.setImage(t);
                break;
              case "iframe":
                r.setIframe(t);
                break;
              case "html":
                r.setContent(t, t.src || t.content);
                break;
              case "video":
                r.setContent(
                  t,
                  t.opts.video.tpl
                    .replace(/\{\{src\}\}/gi, t.src)
                    .replace(
                      "{{format}}",
                      t.opts.videoFormat || t.opts.video.format || "",
                    )
                    .replace("{{poster}}", t.thumb || ""),
                );
                break;
              case "inline":
                n(t.src).length ? r.setContent(t, n(t.src)) : r.setError(t);
                break;
              case "ajax":
                (r.showLoading(t),
                  (o = n.ajax(
                    n.extend({}, t.opts.ajax.settings, {
                      url: t.src,
                      success: function (e, n) {
                        "success" === n && r.setContent(t, e);
                      },
                      error: function (e, n) {
                        e && "abort" !== n && r.setError(t);
                      },
                    }),
                  )),
                  i.one("onReset", function () {
                    o.abort();
                  }));
                break;
              default:
                r.setError(t);
            }
            return !0;
          }
        },
        setImage: function (t) {
          var i,
            o = this;
          (setTimeout(function () {
            var e = t.$image;
            o.isClosing ||
              !t.isLoading ||
              (e && e.length && e[0].complete) ||
              t.hasError ||
              o.showLoading(t);
          }, 50),
            o.checkSrcset(t),
            (t.$content = n('<div class="fancybox-content"></div>')
              .addClass("fancybox-is-hidden")
              .appendTo(t.$slide.addClass("fancybox-slide--image"))),
            !1 !== t.opts.preload &&
              t.opts.width &&
              t.opts.height &&
              t.thumb &&
              ((t.width = t.opts.width),
              (t.height = t.opts.height),
              ((i = e.createElement("img")).onerror = function () {
                (n(this).remove(), (t.$ghost = null));
              }),
              (i.onload = function () {
                o.afterLoad(t);
              }),
              (t.$ghost = n(i)
                .addClass("fancybox-image")
                .appendTo(t.$content)
                .attr("src", t.thumb))),
            o.setBigImage(t));
        },
        checkSrcset: function (e) {
          var n,
            i,
            o,
            r,
            s = e.opts.srcset || e.opts.image.srcset;
          if (s) {
            ((o = t.devicePixelRatio || 1),
              (r = t.innerWidth * o),
              (i = s.split(",").map(function (t) {
                var e = {};
                return (
                  t
                    .trim()
                    .split(/\s+/)
                    .forEach(function (t, n) {
                      var i = parseInt(t.substring(0, t.length - 1), 10);
                      if (0 === n) return (e.url = t);
                      i && ((e.value = i), (e.postfix = t[t.length - 1]));
                    }),
                  e
                );
              })),
              i.sort(function (t, e) {
                return t.value - e.value;
              }));
            for (var a = 0; a < i.length; a++) {
              var l = i[a];
              if (
                ("w" === l.postfix && l.value >= r) ||
                ("x" === l.postfix && l.value >= o)
              ) {
                n = l;
                break;
              }
            }
            (!n && i.length && (n = i[i.length - 1]),
              n &&
                ((e.src = n.url),
                e.width &&
                  e.height &&
                  "w" == n.postfix &&
                  ((e.height = (e.width / e.height) * n.value),
                  (e.width = n.value)),
                (e.opts.srcset = s)));
          }
        },
        setBigImage: function (t) {
          var i = this,
            o = e.createElement("img"),
            r = n(o);
          ((t.$image = r
            .one("error", function () {
              i.setError(t);
            })
            .one("load", function () {
              var e;
              (t.$ghost ||
                (i.resolveImageSlideSize(
                  t,
                  this.naturalWidth,
                  this.naturalHeight,
                ),
                i.afterLoad(t)),
                i.isClosing ||
                  (t.opts.srcset &&
                    (((e = t.opts.sizes) && "auto" !== e) ||
                      (e =
                        (t.width / t.height > 1 && s.width() / s.height() > 1
                          ? "100"
                          : Math.round((t.width / t.height) * 100)) + "vw"),
                    r.attr("sizes", e).attr("srcset", t.opts.srcset)),
                  t.$ghost &&
                    setTimeout(
                      function () {
                        t.$ghost && !i.isClosing && t.$ghost.hide();
                      },
                      Math.min(300, Math.max(1e3, t.height / 1600)),
                    ),
                  i.hideLoading(t)));
            })
            .addClass("fancybox-image")
            .attr("src", t.src)
            .appendTo(t.$content)),
            (o.complete || "complete" == o.readyState) &&
            r.naturalWidth &&
            r.naturalHeight
              ? r.trigger("load")
              : o.error && r.trigger("error"));
        },
        resolveImageSlideSize: function (t, e, n) {
          var i = parseInt(t.opts.width, 10),
            o = parseInt(t.opts.height, 10);
          ((t.width = e),
            (t.height = n),
            i > 0 && ((t.width = i), (t.height = Math.floor((i * n) / e))),
            o > 0 && ((t.width = Math.floor((o * e) / n)), (t.height = o)));
        },
        setIframe: function (t) {
          var e,
            i = this,
            o = t.opts.iframe,
            r = t.$slide;
          ((t.$content = n(
            '<div class="fancybox-content' +
              (o.preload ? " fancybox-is-hidden" : "") +
              '"></div>',
          )
            .css(o.css)
            .appendTo(r)),
            r.addClass("fancybox-slide--" + t.contentType),
            (t.$iframe = e =
              n(o.tpl.replace(/\{rnd\}/g, new Date().getTime()))
                .attr(o.attr)
                .appendTo(t.$content)),
            o.preload
              ? (i.showLoading(t),
                e.on("load.fb error.fb", function (e) {
                  ((this.isReady = 1),
                    t.$slide.trigger("refresh"),
                    i.afterLoad(t));
                }),
                r.on("refresh.fb", function () {
                  var n,
                    i = t.$content,
                    s = o.css.width,
                    a = o.css.height;
                  if (1 === e[0].isReady) {
                    try {
                      n = e.contents().find("body");
                    } catch (t) {}
                    (n &&
                      n.length &&
                      n.children().length &&
                      (r.css("overflow", "visible"),
                      i.css({
                        width: "100%",
                        "max-width": "100%",
                        height: "9999px",
                      }),
                      void 0 === s &&
                        (s = Math.ceil(
                          Math.max(n[0].clientWidth, n.outerWidth(!0)),
                        )),
                      i.css("width", s || "").css("max-width", ""),
                      void 0 === a &&
                        (a = Math.ceil(
                          Math.max(n[0].clientHeight, n.outerHeight(!0)),
                        )),
                      i.css("height", a || ""),
                      r.css("overflow", "auto")),
                      i.removeClass("fancybox-is-hidden"));
                  }
                }))
              : i.afterLoad(t),
            e.attr("src", t.src),
            r.one("onReset", function () {
              try {
                n(this)
                  .find("iframe")
                  .hide()
                  .unbind()
                  .attr("src", "//about:blank");
              } catch (t) {}
              (n(this).off("refresh.fb").empty(),
                (t.isLoaded = !1),
                (t.isRevealed = !1));
            }));
        },
        setContent: function (t, e) {
          var i = this;
          i.isClosing ||
            (i.hideLoading(t),
            t.$content && n.fancybox.stop(t.$content),
            t.$slide.empty(),
            (function (t) {
              return t && t.hasOwnProperty && t instanceof n;
            })(e) && e.parent().length
              ? ((e.hasClass("fancybox-content") ||
                  e.parent().hasClass("fancybox-content")) &&
                  e.parents(".fancybox-slide").trigger("onReset"),
                (t.$placeholder = n("<div>").hide().insertAfter(e)),
                e.css("display", "inline-block"))
              : t.hasError ||
                ("string" === n.type(e) &&
                  (e = n("<div>").append(n.trim(e)).contents()),
                t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))),
            t.$slide.one("onReset", function () {
              (n(this).find("video,audio").trigger("pause"),
                t.$placeholder &&
                  (t.$placeholder
                    .after(e.removeClass("fancybox-content").hide())
                    .remove(),
                  (t.$placeholder = null)),
                t.$smallBtn && (t.$smallBtn.remove(), (t.$smallBtn = null)),
                t.hasError ||
                  (n(this).empty(), (t.isLoaded = !1), (t.isRevealed = !1)));
            }),
            n(e).appendTo(t.$slide),
            n(e).is("video,audio") &&
              (n(e).addClass("fancybox-video"),
              n(e).wrap("<div></div>"),
              (t.contentType = "video"),
              (t.opts.width = t.opts.width || n(e).attr("width")),
              (t.opts.height = t.opts.height || n(e).attr("height"))),
            (t.$content = t.$slide
              .children()
              .filter("div,form,main,video,audio,article,.fancybox-content")
              .first()),
            t.$content.siblings().hide(),
            t.$content.length ||
              (t.$content = t.$slide
                .wrapInner("<div></div>")
                .children()
                .first()),
            t.$content.addClass("fancybox-content"),
            t.$slide.addClass("fancybox-slide--" + t.contentType),
            i.afterLoad(t));
        },
        setError: function (t) {
          ((t.hasError = !0),
            t.$slide
              .trigger("onReset")
              .removeClass("fancybox-slide--" + t.contentType)
              .addClass("fancybox-slide--error"),
            (t.contentType = "html"),
            this.setContent(t, this.translate(t, t.opts.errorTpl)),
            t.pos === this.currPos && (this.isAnimating = !1));
        },
        showLoading: function (t) {
          var e = this;
          (t = t || e.current) &&
            !t.$spinner &&
            (t.$spinner = n(e.translate(e, e.opts.spinnerTpl))
              .appendTo(t.$slide)
              .hide()
              .fadeIn("fast"));
        },
        hideLoading: function (t) {
          (t = t || this.current) &&
            t.$spinner &&
            (t.$spinner.stop().remove(), delete t.$spinner);
        },
        afterLoad: function (t) {
          var e = this;
          e.isClosing ||
            ((t.isLoading = !1),
            (t.isLoaded = !0),
            e.trigger("afterLoad", t),
            e.hideLoading(t),
            !t.opts.smallBtn ||
              (t.$smallBtn && t.$smallBtn.length) ||
              (t.$smallBtn = n(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(
                t.$content,
              )),
            t.opts.protect &&
              t.$content &&
              !t.hasError &&
              (t.$content.on("contextmenu.fb", function (t) {
                return (2 == t.button && t.preventDefault(), !0);
              }),
              "image" === t.type &&
                n('<div class="fancybox-spaceball"></div>').appendTo(
                  t.$content,
                )),
            e.adjustCaption(t),
            e.adjustLayout(t),
            t.pos === e.currPos && e.updateCursor(),
            e.revealContent(t));
        },
        adjustCaption: function (t) {
          var e,
            n = this,
            i = t || n.current,
            o = i.opts.caption,
            r = i.opts.preventCaptionOverlap,
            s = n.$refs.caption,
            a = !1;
          (s.toggleClass("fancybox-caption--separate", r),
            r &&
              o &&
              o.length &&
              (i.pos !== n.currPos
                ? ((e = s.clone().appendTo(s.parent()))
                    .children()
                    .eq(0)
                    .empty()
                    .html(o),
                  (a = e.outerHeight(!0)),
                  e.empty().remove())
                : n.$caption && (a = n.$caption.outerHeight(!0)),
              i.$slide.css("padding-bottom", a || "")));
        },
        adjustLayout: function (t) {
          var e,
            n,
            i,
            o,
            r = t || this.current;
          r.isLoaded &&
            !0 !== r.opts.disableLayoutFix &&
            (r.$content.css("margin-bottom", ""),
            r.$content.outerHeight() > r.$slide.height() + 0.5 &&
              ((i = r.$slide[0].style["padding-bottom"]),
              (o = r.$slide.css("padding-bottom")),
              parseFloat(o) > 0 &&
                ((e = r.$slide[0].scrollHeight),
                r.$slide.css("padding-bottom", 0),
                Math.abs(e - r.$slide[0].scrollHeight) < 1 && (n = o),
                r.$slide.css("padding-bottom", i))),
            r.$content.css("margin-bottom", n));
        },
        revealContent: function (t) {
          var e,
            i,
            o,
            r,
            s = this,
            a = t.$slide,
            l = !1,
            c = !1,
            u = s.isMoved(t),
            h = t.isRevealed;
          return (
            (t.isRevealed = !0),
            (e = t.opts[s.firstRun ? "animationEffect" : "transitionEffect"]),
            (o =
              t.opts[s.firstRun ? "animationDuration" : "transitionDuration"]),
            (o = parseInt(
              void 0 === t.forcedDuration ? o : t.forcedDuration,
              10,
            )),
            (!u && t.pos === s.currPos && o) || (e = !1),
            "zoom" === e &&
              (t.pos === s.currPos &&
              o &&
              "image" === t.type &&
              !t.hasError &&
              (c = s.getThumbPos(t))
                ? (l = s.getFitPos(t))
                : (e = "fade")),
            "zoom" === e
              ? ((s.isAnimating = !0),
                (l.scaleX = l.width / c.width),
                (l.scaleY = l.height / c.height),
                "auto" == (r = t.opts.zoomOpacity) &&
                  (r = Math.abs(t.width / t.height - c.width / c.height) > 0.1),
                r && ((c.opacity = 0.1), (l.opacity = 1)),
                n.fancybox.setTranslate(
                  t.$content.removeClass("fancybox-is-hidden"),
                  c,
                ),
                d(t.$content),
                void n.fancybox.animate(t.$content, l, o, function () {
                  ((s.isAnimating = !1), s.complete());
                }))
              : (s.updateSlide(t),
                e
                  ? (n.fancybox.stop(a),
                    (i =
                      "fancybox-slide--" +
                      (t.pos >= s.prevPos ? "next" : "previous") +
                      " fancybox-animated fancybox-fx-" +
                      e),
                    a.addClass(i).removeClass("fancybox-slide--current"),
                    t.$content.removeClass("fancybox-is-hidden"),
                    d(a),
                    "image" !== t.type && t.$content.hide().show(0),
                    void n.fancybox.animate(
                      a,
                      "fancybox-slide--current",
                      o,
                      function () {
                        (a.removeClass(i).css({ transform: "", opacity: "" }),
                          t.pos === s.currPos && s.complete());
                      },
                      !0,
                    ))
                  : (t.$content.removeClass("fancybox-is-hidden"),
                    h ||
                      !u ||
                      "image" !== t.type ||
                      t.hasError ||
                      t.$content.hide().fadeIn("fast"),
                    void (t.pos === s.currPos && s.complete())))
          );
        },
        getThumbPos: function (t) {
          var e,
            i,
            o,
            r,
            s,
            a = !1,
            l = t.$thumb;
          return (
            !(!l || !p(l[0])) &&
            ((e = n.fancybox.getTranslate(l)),
            (i = parseFloat(l.css("border-top-width") || 0)),
            (o = parseFloat(l.css("border-right-width") || 0)),
            (r = parseFloat(l.css("border-bottom-width") || 0)),
            (s = parseFloat(l.css("border-left-width") || 0)),
            (a = {
              top: e.top + i,
              left: e.left + s,
              width: e.width - o - s,
              height: e.height - i - r,
              scaleX: 1,
              scaleY: 1,
            }),
            e.width > 0 && e.height > 0 && a)
          );
        },
        complete: function () {
          var t,
            e = this,
            i = e.current,
            o = {};
          !e.isMoved() &&
            i.isLoaded &&
            (i.isComplete ||
              ((i.isComplete = !0),
              i.$slide.siblings().trigger("onReset"),
              e.preload("inline"),
              d(i.$slide),
              i.$slide.addClass("fancybox-slide--complete"),
              n.each(e.slides, function (t, i) {
                i.pos >= e.currPos - 1 && i.pos <= e.currPos + 1
                  ? (o[i.pos] = i)
                  : i && (n.fancybox.stop(i.$slide), i.$slide.off().remove());
              }),
              (e.slides = o)),
            (e.isAnimating = !1),
            e.updateCursor(),
            e.trigger("afterShow"),
            i.opts.video.autoStart &&
              i.$slide
                .find("video,audio")
                .filter(":visible:first")
                .trigger("play")
                .one("ended", function () {
                  (Document.exitFullscreen
                    ? Document.exitFullscreen()
                    : this.webkitExitFullscreen && this.webkitExitFullscreen(),
                    e.next());
                }),
            i.opts.autoFocus &&
              "html" === i.contentType &&
              ((t = i.$content.find("input[autofocus]:enabled:visible:first"))
                .length
                ? t.trigger("focus")
                : e.focus(null, !0)),
            i.$slide.scrollTop(0).scrollLeft(0));
        },
        preload: function (t) {
          var e,
            n,
            i = this;
          i.group.length < 2 ||
            ((n = i.slides[i.currPos + 1]),
            (e = i.slides[i.currPos - 1]) && e.type === t && i.loadSlide(e),
            n && n.type === t && i.loadSlide(n));
        },
        focus: function (t, i) {
          var o,
            r,
            s = this,
            a = [
              "a[href]",
              "area[href]",
              'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
              "select:not([disabled]):not([aria-hidden])",
              "textarea:not([disabled]):not([aria-hidden])",
              "button:not([disabled]):not([aria-hidden])",
              "iframe",
              "object",
              "embed",
              "video",
              "audio",
              "[contenteditable]",
              '[tabindex]:not([tabindex^="-"])',
            ].join(",");
          s.isClosing ||
            ((o = (o =
              !t && s.current && s.current.isComplete
                ? s.current.$slide.find(
                    "*:visible" + (i ? ":not(.fancybox-close-small)" : ""),
                  )
                : s.$refs.container.find("*:visible"))
              .filter(a)
              .filter(function () {
                return (
                  "hidden" !== n(this).css("visibility") &&
                  !n(this).hasClass("disabled")
                );
              })).length
              ? ((r = o.index(e.activeElement)),
                t && t.shiftKey
                  ? (r < 0 || 0 == r) &&
                    (t.preventDefault(), o.eq(o.length - 1).trigger("focus"))
                  : (r < 0 || r == o.length - 1) &&
                    (t && t.preventDefault(), o.eq(0).trigger("focus")))
              : s.$refs.container.trigger("focus"));
        },
        activate: function () {
          var t = this;
          (n(".fancybox-container").each(function () {
            var e = n(this).data("FancyBox");
            e &&
              e.id !== t.id &&
              !e.isClosing &&
              (e.trigger("onDeactivate"), e.removeEvents(), (e.isVisible = !1));
          }),
            (t.isVisible = !0),
            (t.current || t.isIdle) && (t.update(), t.updateControls()),
            t.trigger("onActivate"),
            t.addEvents());
        },
        close: function (t, e) {
          var i,
            o,
            r,
            s,
            a,
            l,
            u,
            h = this,
            f = h.current,
            p = function () {
              h.cleanUp(t);
            };
          return !(
            h.isClosing ||
            ((h.isClosing = !0),
            !1 === h.trigger("beforeClose", t)
              ? ((h.isClosing = !1),
                c(function () {
                  h.update();
                }),
                1)
              : (h.removeEvents(),
                (r = f.$content),
                (i = f.opts.animationEffect),
                (o = n.isNumeric(e) ? e : i ? f.opts.animationDuration : 0),
                f.$slide.removeClass(
                  "fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated",
                ),
                !0 !== t ? n.fancybox.stop(f.$slide) : (i = !1),
                f.$slide.siblings().trigger("onReset").remove(),
                o &&
                  h.$refs.container
                    .removeClass("fancybox-is-open")
                    .addClass("fancybox-is-closing")
                    .css("transition-duration", o + "ms"),
                h.hideLoading(f),
                h.hideControls(!0),
                h.updateCursor(),
                "zoom" !== i ||
                  (r &&
                    o &&
                    "image" === f.type &&
                    !h.isMoved() &&
                    !f.hasError &&
                    (u = h.getThumbPos(f))) ||
                  (i = "fade"),
                "zoom" === i
                  ? (n.fancybox.stop(r),
                    (s = n.fancybox.getTranslate(r)),
                    (l = {
                      top: s.top,
                      left: s.left,
                      scaleX: s.width / u.width,
                      scaleY: s.height / u.height,
                      width: u.width,
                      height: u.height,
                    }),
                    (a = f.opts.zoomOpacity),
                    "auto" == a &&
                      (a =
                        Math.abs(f.width / f.height - u.width / u.height) >
                        0.1),
                    a && (u.opacity = 0),
                    n.fancybox.setTranslate(r, l),
                    d(r),
                    n.fancybox.animate(r, u, o, p),
                    0)
                  : (i && o
                      ? n.fancybox.animate(
                          f.$slide
                            .addClass("fancybox-slide--previous")
                            .removeClass("fancybox-slide--current"),
                          "fancybox-animated fancybox-fx-" + i,
                          o,
                          p,
                        )
                      : !0 === t
                        ? setTimeout(p, o)
                        : p(),
                    0)))
          );
        },
        cleanUp: function (e) {
          var i,
            o,
            r,
            s = this,
            a = s.current.opts.$orig;
          (s.current.$slide.trigger("onReset"),
            s.$refs.container.empty().remove(),
            s.trigger("afterClose", e),
            s.current.opts.backFocus &&
              ((a && a.length && a.is(":visible")) || (a = s.$trigger),
              a &&
                a.length &&
                ((o = t.scrollX),
                (r = t.scrollY),
                a.trigger("focus"),
                n("html, body").scrollTop(r).scrollLeft(o))),
            (s.current = null),
            (i = n.fancybox.getInstance())
              ? i.activate()
              : (n("body").removeClass(
                  "fancybox-active compensate-for-scrollbar",
                ),
                n("#fancybox-style-noscroll").remove()));
        },
        trigger: function (t, e) {
          var i,
            o = Array.prototype.slice.call(arguments, 1),
            r = this,
            s = e && e.opts ? e : r.current;
          if (
            (s ? o.unshift(s) : (s = r),
            o.unshift(r),
            n.isFunction(s.opts[t]) && (i = s.opts[t].apply(s, o)),
            !1 === i)
          )
            return i;
          "afterClose" !== t && r.$refs
            ? r.$refs.container.trigger(t + ".fb", o)
            : a.trigger(t + ".fb", o);
        },
        updateControls: function () {
          var t = this,
            i = t.current,
            o = i.index,
            r = t.$refs.container,
            s = t.$refs.caption,
            a = i.opts.caption;
          (i.$slide.trigger("refresh"),
            a && a.length
              ? ((t.$caption = s), s.children().eq(0).html(a))
              : (t.$caption = null),
            t.hasHiddenControls || t.isIdle || t.showControls(),
            r.find("[data-fancybox-count]").html(t.group.length),
            r.find("[data-fancybox-index]").html(o + 1),
            r
              .find("[data-fancybox-prev]")
              .prop("disabled", !i.opts.loop && o <= 0),
            r
              .find("[data-fancybox-next]")
              .prop("disabled", !i.opts.loop && o >= t.group.length - 1),
            "image" === i.type
              ? r
                  .find("[data-fancybox-zoom]")
                  .show()
                  .end()
                  .find("[data-fancybox-download]")
                  .attr("href", i.opts.image.src || i.src)
                  .show()
              : i.opts.toolbar &&
                r.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),
            n(e.activeElement).is(":hidden,[disabled]") &&
              t.$refs.container.trigger("focus"));
        },
        hideControls: function (t) {
          var e = ["infobar", "toolbar", "nav"];
          ((!t && this.current.opts.preventCaptionOverlap) || e.push("caption"),
            this.$refs.container.removeClass(
              e
                .map(function (t) {
                  return "fancybox-show-" + t;
                })
                .join(" "),
            ),
            (this.hasHiddenControls = !0));
        },
        showControls: function () {
          var t = this,
            e = t.current ? t.current.opts : t.opts,
            n = t.$refs.container;
          ((t.hasHiddenControls = !1),
            (t.idleSecondsCounter = 0),
            n
              .toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons))
              .toggleClass(
                "fancybox-show-infobar",
                !!(e.infobar && t.group.length > 1),
              )
              .toggleClass("fancybox-show-caption", !!t.$caption)
              .toggleClass(
                "fancybox-show-nav",
                !!(e.arrows && t.group.length > 1),
              )
              .toggleClass("fancybox-is-modal", !!e.modal));
        },
        toggleControls: function () {
          this.hasHiddenControls ? this.showControls() : this.hideControls();
        },
      }),
        (n.fancybox = {
          version: "3.5.7",
          defaults: r,
          getInstance: function (t) {
            var e = n(
                '.fancybox-container:not(".fancybox-is-closing"):last',
              ).data("FancyBox"),
              i = Array.prototype.slice.call(arguments, 1);
            return (
              e instanceof m &&
              ("string" === n.type(t)
                ? e[t].apply(e, i)
                : "function" === n.type(t) && t.apply(e, i),
              e)
            );
          },
          open: function (t, e, n) {
            return new m(t, e, n);
          },
          close: function (t) {
            var e = this.getInstance();
            e && (e.close(), !0 === t && this.close(t));
          },
          destroy: function () {
            (this.close(!0), a.add("body").off("click.fb-start", "**"));
          },
          isMobile:
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent,
            ),
          use3d: (function () {
            var n = e.createElement("div");
            return (
              t.getComputedStyle &&
              t.getComputedStyle(n) &&
              t.getComputedStyle(n).getPropertyValue("transform") &&
              !(e.documentMode && e.documentMode < 11)
            );
          })(),
          getTranslate: function (t) {
            var e;
            return (
              !(!t || !t.length) && {
                top: (e = t[0].getBoundingClientRect()).top || 0,
                left: e.left || 0,
                width: e.width,
                height: e.height,
                opacity: parseFloat(t.css("opacity")),
              }
            );
          },
          setTranslate: function (t, e) {
            var n = "",
              i = {};
            if (t && e)
              return (
                (void 0 === e.left && void 0 === e.top) ||
                  ((n =
                    (void 0 === e.left ? t.position().left : e.left) +
                    "px, " +
                    (void 0 === e.top ? t.position().top : e.top) +
                    "px"),
                  (n = this.use3d
                    ? "translate3d(" + n + ", 0px)"
                    : "translate(" + n + ")")),
                void 0 !== e.scaleX && void 0 !== e.scaleY
                  ? (n += " scale(" + e.scaleX + ", " + e.scaleY + ")")
                  : void 0 !== e.scaleX && (n += " scaleX(" + e.scaleX + ")"),
                n.length && (i.transform = n),
                void 0 !== e.opacity && (i.opacity = e.opacity),
                void 0 !== e.width && (i.width = e.width),
                void 0 !== e.height && (i.height = e.height),
                t.css(i)
              );
          },
          animate: function (t, e, i, o, r) {
            var s,
              a = this;
            (n.isFunction(i) && ((o = i), (i = null)),
              a.stop(t),
              (s = a.getTranslate(t)),
              t.on(h, function (l) {
                (!l ||
                  !l.originalEvent ||
                  (t.is(l.originalEvent.target) &&
                    "z-index" != l.originalEvent.propertyName)) &&
                  (a.stop(t),
                  n.isNumeric(i) && t.css("transition-duration", ""),
                  n.isPlainObject(e)
                    ? void 0 !== e.scaleX &&
                      void 0 !== e.scaleY &&
                      a.setTranslate(t, {
                        top: e.top,
                        left: e.left,
                        width: s.width * e.scaleX,
                        height: s.height * e.scaleY,
                        scaleX: 1,
                        scaleY: 1,
                      })
                    : !0 !== r && t.removeClass(e),
                  n.isFunction(o) && o(l));
              }),
              n.isNumeric(i) && t.css("transition-duration", i + "ms"),
              n.isPlainObject(e)
                ? (void 0 !== e.scaleX &&
                    void 0 !== e.scaleY &&
                    (delete e.width,
                    delete e.height,
                    t.parent().hasClass("fancybox-slide--image") &&
                      t.parent().addClass("fancybox-is-scaling")),
                  n.fancybox.setTranslate(t, e))
                : t.addClass(e),
              t.data(
                "timer",
                setTimeout(function () {
                  t.trigger(h);
                }, i + 33),
              ));
          },
          stop: function (t, e) {
            t &&
              t.length &&
              (clearTimeout(t.data("timer")),
              e && t.trigger(h),
              t.off(h).css("transition-duration", ""),
              t.parent().removeClass("fancybox-is-scaling"));
          },
        }),
        (n.fn.fancybox = function (t) {
          var e;
          return (
            (e = (t = t || {}).selector || !1)
              ? n("body")
                  .off("click.fb-start", e)
                  .on("click.fb-start", e, { options: t }, o)
              : this.off("click.fb-start").on(
                  "click.fb-start",
                  { items: this, options: t },
                  o,
                ),
            this
          );
        }),
        a.on("click.fb-start", "[data-fancybox]", o),
        a.on("click.fb-start", "[data-fancybox-trigger]", function (t) {
          n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]')
            .eq(n(this).attr("data-fancybox-index") || 0)
            .trigger("click.fb-start", { $trigger: n(this) });
        }),
        (function () {
          var t = null;
          a.on(
            "mousedown mouseup focus blur",
            ".fancybox-button",
            function (e) {
              switch (e.type) {
                case "mousedown":
                  t = n(this);
                  break;
                case "mouseup":
                  t = null;
                  break;
                case "focusin":
                  (n(".fancybox-button").removeClass("fancybox-focus"),
                    n(this).is(t) ||
                      n(this).is("[disabled]") ||
                      n(this).addClass("fancybox-focus"));
                  break;
                case "focusout":
                  n(".fancybox-button").removeClass("fancybox-focus");
              }
            },
          );
        })());
    }
  })(window, document, jQuery),
  (function (t) {
    var e = {
        youtube: {
          matcher:
            /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
          params: {
            autoplay: 1,
            autohide: 1,
            fs: 1,
            rel: 0,
            hd: 1,
            wmode: "transparent",
            enablejsapi: 1,
            html5: 1,
          },
          paramPlace: 8,
          type: "iframe",
          url: "https://www.youtube-nocookie.com/embed/$4",
          thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg",
        },
        vimeo: {
          matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
          params: {
            autoplay: 1,
            hd: 1,
            show_title: 1,
            show_byline: 1,
            show_portrait: 0,
            fullscreen: 1,
          },
          paramPlace: 3,
          type: "iframe",
          url: "//player.vimeo.com/video/$2",
        },
        instagram: {
          matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
          type: "image",
          url: "//$1/p/$2/media/?size=l",
        },
        gmap_place: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
          type: "iframe",
          url: function (t) {
            return (
              "//maps.google." +
              t[2] +
              "/?ll=" +
              (t[9]
                ? t[9] +
                  "&z=" +
                  Math.floor(t[10]) +
                  (t[12] ? t[12].replace(/^\//, "&") : "")
                : t[12] + ""
              ).replace(/\?/, "&") +
              "&output=" +
              (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
            );
          },
        },
        gmap_search: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
          type: "iframe",
          url: function (t) {
            return (
              "//maps.google." +
              t[2] +
              "/maps?q=" +
              t[5].replace("query=", "q=").replace("api=1", "") +
              "&output=embed"
            );
          },
        },
      },
      n = function (e, n, i) {
        if (e)
          return (
            (i = i || ""),
            "object" === t.type(i) && (i = t.param(i, !0)),
            t.each(n, function (t, n) {
              e = e.replace("$" + t, n || "");
            }),
            i.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + i),
            e
          );
      };
    t(document).on("objectNeedsType.fb", function (i, o, r) {
      var s,
        a,
        l,
        c,
        u,
        h,
        d,
        f = r.src || "",
        p = !1;
      ((s = t.extend(!0, {}, e, r.opts.media)),
        t.each(s, function (e, i) {
          if ((l = f.match(i.matcher))) {
            if (
              ((p = i.type), (d = e), (h = {}), i.paramPlace && l[i.paramPlace])
            ) {
              ("?" == (u = l[i.paramPlace])[0] && (u = u.substring(1)),
                (u = u.split("&")));
              for (var o = 0; o < u.length; ++o) {
                var s = u[o].split("=", 2);
                2 == s.length &&
                  (h[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")));
              }
            }
            return (
              (c = t.extend(!0, {}, i.params, r.opts[e], h)),
              (f =
                "function" === t.type(i.url)
                  ? i.url.call(this, l, c, r)
                  : n(i.url, l, c)),
              (a =
                "function" === t.type(i.thumb)
                  ? i.thumb.call(this, l, c, r)
                  : n(i.thumb, l)),
              "youtube" === e
                ? (f = f.replace(/&t=((\d+)m)?(\d+)s/, function (t, e, n, i) {
                    return (
                      "&start=" +
                      ((n ? 60 * parseInt(n, 10) : 0) + parseInt(i, 10))
                    );
                  }))
                : "vimeo" === e && (f = f.replace("&%23", "#")),
              !1
            );
          }
        }),
        p
          ? (r.opts.thumb ||
              (r.opts.$thumb && r.opts.$thumb.length) ||
              (r.opts.thumb = a),
            "iframe" === p &&
              (r.opts = t.extend(!0, r.opts, {
                iframe: { preload: !1, attr: { scrolling: "no" } },
              })),
            t.extend(r, {
              type: p,
              src: f,
              origSrc: r.src,
              contentSource: d,
              contentType:
                "image" === p
                  ? "image"
                  : "gmap_place" == d || "gmap_search" == d
                    ? "map"
                    : "video",
            }))
          : f && (r.type = r.opts.defaultType));
    });
    var i = {
      youtube: {
        src: "https://www.youtube.com/iframe_api",
        class: "YT",
        loading: !1,
        loaded: !1,
      },
      vimeo: {
        src: "https://player.vimeo.com/api/player.js",
        class: "Vimeo",
        loading: !1,
        loaded: !1,
      },
      load: function (t) {
        var e,
          n = this;
        this[t].loaded
          ? setTimeout(function () {
              n.done(t);
            })
          : this[t].loading ||
            ((this[t].loading = !0),
            ((e = document.createElement("script")).type = "text/javascript"),
            (e.src = this[t].src),
            "youtube" === t
              ? (window.onYouTubeIframeAPIReady = function () {
                  ((n[t].loaded = !0), n.done(t));
                })
              : (e.onload = function () {
                  ((n[t].loaded = !0), n.done(t));
                }),
            document.body.appendChild(e));
      },
      done: function (e) {
        var n, i;
        ("youtube" === e && delete window.onYouTubeIframeAPIReady,
          (n = t.fancybox.getInstance()) &&
            ((i = n.current.$content.find("iframe")),
            "youtube" === e && void 0 !== YT && YT
              ? new YT.Player(i.attr("id"), {
                  events: {
                    onStateChange: function (t) {
                      0 == t.data && n.next();
                    },
                  },
                })
              : "vimeo" === e &&
                void 0 !== Vimeo &&
                Vimeo &&
                new Vimeo.Player(i).on("ended", function () {
                  n.next();
                })));
      },
    };
    t(document).on({
      "afterShow.fb": function (t, e, n) {
        e.group.length > 1 &&
          ("youtube" === n.contentSource || "vimeo" === n.contentSource) &&
          i.load(n.contentSource);
      },
    });
  })(jQuery),
  (function (t, e, n) {
    var i =
        t.requestAnimationFrame ||
        t.webkitRequestAnimationFrame ||
        t.mozRequestAnimationFrame ||
        t.oRequestAnimationFrame ||
        function (e) {
          return t.setTimeout(e, 1e3 / 60);
        },
      o =
        t.cancelAnimationFrame ||
        t.webkitCancelAnimationFrame ||
        t.mozCancelAnimationFrame ||
        t.oCancelAnimationFrame ||
        function (e) {
          t.clearTimeout(e);
        },
      r = function (e) {
        var n = [];
        for (var i in (e =
          (e = e.originalEvent || e || t.e).touches && e.touches.length
            ? e.touches
            : e.changedTouches && e.changedTouches.length
              ? e.changedTouches
              : [e]))
          e[i].pageX
            ? n.push({ x: e[i].pageX, y: e[i].pageY })
            : e[i].clientX && n.push({ x: e[i].clientX, y: e[i].clientY });
        return n;
      },
      s = function (t, e, n) {
        return e && t
          ? "x" === n
            ? t.x - e.x
            : "y" === n
              ? t.y - e.y
              : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2))
          : 0;
      },
      a = function (t) {
        if (
          t.is(
            'a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe',
          ) ||
          n.isFunction(t.get(0).onclick) ||
          t.data("selectable")
        )
          return !0;
        for (var e = 0, i = t[0].attributes, o = i.length; e < o; e++)
          if ("data-fancybox-" === i[e].nodeName.substr(0, 14)) return !0;
        return !1;
      },
      l = function (e) {
        var n = t.getComputedStyle(e)["overflow-y"],
          i = t.getComputedStyle(e)["overflow-x"],
          o =
            ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
          r = ("scroll" === i || "auto" === i) && e.scrollWidth > e.clientWidth;
        return o || r;
      },
      c = function (t) {
        for (
          var e = !1;
          !(e = l(t.get(0))) &&
          (t = t.parent()).length &&
          !t.hasClass("fancybox-stage") &&
          !t.is("body");
        );
        return e;
      },
      u = function (t) {
        var e = this;
        ((e.instance = t),
          (e.$bg = t.$refs.bg),
          (e.$stage = t.$refs.stage),
          (e.$container = t.$refs.container),
          e.destroy(),
          e.$container.on(
            "touchstart.fb.touch mousedown.fb.touch",
            n.proxy(e, "ontouchstart"),
          ));
      };
    ((u.prototype.destroy = function () {
      var t = this;
      (t.$container.off(".fb.touch"),
        n(e).off(".fb.touch"),
        t.requestId && (o(t.requestId), (t.requestId = null)),
        t.tapped && (clearTimeout(t.tapped), (t.tapped = null)));
    }),
      (u.prototype.ontouchstart = function (i) {
        var o = this,
          l = n(i.target),
          u = o.instance,
          h = u.current,
          d = h.$slide,
          f = h.$content,
          p = "touchstart" == i.type;
        if (
          (p && o.$container.off("mousedown.fb.touch"),
          (!i.originalEvent || 2 != i.originalEvent.button) &&
            d.length &&
            l.length &&
            !a(l) &&
            !a(l.parent()) &&
            (l.is("img") ||
              !(i.originalEvent.clientX > l[0].clientWidth + l.offset().left)))
        ) {
          if (!h || u.isAnimating || h.$slide.hasClass("fancybox-animated"))
            return (i.stopPropagation(), void i.preventDefault());
          ((o.realPoints = o.startPoints = r(i)),
            o.startPoints.length &&
              (h.touch && i.stopPropagation(),
              (o.startEvent = i),
              (o.canTap = !0),
              (o.$target = l),
              (o.$content = f),
              (o.opts = h.opts.touch),
              (o.isPanning = !1),
              (o.isSwiping = !1),
              (o.isZooming = !1),
              (o.isScrolling = !1),
              (o.canPan = u.canPan()),
              (o.startTime = new Date().getTime()),
              (o.distanceX = o.distanceY = o.distance = 0),
              (o.canvasWidth = Math.round(d[0].clientWidth)),
              (o.canvasHeight = Math.round(d[0].clientHeight)),
              (o.contentLastPos = null),
              (o.contentStartPos = n.fancybox.getTranslate(o.$content) || {
                top: 0,
                left: 0,
              }),
              (o.sliderStartPos = n.fancybox.getTranslate(d)),
              (o.stagePos = n.fancybox.getTranslate(u.$refs.stage)),
              (o.sliderStartPos.top -= o.stagePos.top),
              (o.sliderStartPos.left -= o.stagePos.left),
              (o.contentStartPos.top -= o.stagePos.top),
              (o.contentStartPos.left -= o.stagePos.left),
              n(e)
                .off(".fb.touch")
                .on(
                  p
                    ? "touchend.fb.touch touchcancel.fb.touch"
                    : "mouseup.fb.touch mouseleave.fb.touch",
                  n.proxy(o, "ontouchend"),
                )
                .on(
                  p ? "touchmove.fb.touch" : "mousemove.fb.touch",
                  n.proxy(o, "ontouchmove"),
                ),
              n.fancybox.isMobile &&
                e.addEventListener("scroll", o.onscroll, !0),
              (((o.opts || o.canPan) &&
                (l.is(o.$stage) || o.$stage.find(l).length)) ||
                (l.is(".fancybox-image") && i.preventDefault(),
                n.fancybox.isMobile &&
                  l.parents(".fancybox-caption").length)) &&
                ((o.isScrollable = c(l) || c(l.parent())),
                (n.fancybox.isMobile && o.isScrollable) || i.preventDefault(),
                (1 === o.startPoints.length || h.hasError) &&
                  (o.canPan
                    ? (n.fancybox.stop(o.$content), (o.isPanning = !0))
                    : (o.isSwiping = !0),
                  o.$container.addClass("fancybox-is-grabbing")),
                2 === o.startPoints.length &&
                  "image" === h.type &&
                  (h.isLoaded || h.$ghost) &&
                  ((o.canTap = !1),
                  (o.isSwiping = !1),
                  (o.isPanning = !1),
                  (o.isZooming = !0),
                  n.fancybox.stop(o.$content),
                  (o.centerPointStartX =
                    0.5 * (o.startPoints[0].x + o.startPoints[1].x) -
                    n(t).scrollLeft()),
                  (o.centerPointStartY =
                    0.5 * (o.startPoints[0].y + o.startPoints[1].y) -
                    n(t).scrollTop()),
                  (o.percentageOfImageAtPinchPointX =
                    (o.centerPointStartX - o.contentStartPos.left) /
                    o.contentStartPos.width),
                  (o.percentageOfImageAtPinchPointY =
                    (o.centerPointStartY - o.contentStartPos.top) /
                    o.contentStartPos.height),
                  (o.startDistanceBetweenFingers = s(
                    o.startPoints[0],
                    o.startPoints[1],
                  ))))));
        }
      }),
      (u.prototype.onscroll = function (t) {
        ((this.isScrolling = !0),
          e.removeEventListener("scroll", this.onscroll, !0));
      }),
      (u.prototype.ontouchmove = function (t) {
        var e = this;
        return void 0 !== t.originalEvent.buttons &&
          0 === t.originalEvent.buttons
          ? void e.ontouchend(t)
          : e.isScrolling
            ? void (e.canTap = !1)
            : ((e.newPoints = r(t)),
              void (
                (e.opts || e.canPan) &&
                e.newPoints.length &&
                e.newPoints.length &&
                ((e.isSwiping && !0 === e.isSwiping) || t.preventDefault(),
                (e.distanceX = s(e.newPoints[0], e.startPoints[0], "x")),
                (e.distanceY = s(e.newPoints[0], e.startPoints[0], "y")),
                (e.distance = s(e.newPoints[0], e.startPoints[0])),
                e.distance > 0 &&
                  (e.isSwiping
                    ? e.onSwipe(t)
                    : e.isPanning
                      ? e.onPan()
                      : e.isZooming && e.onZoom()))
              ));
      }),
      (u.prototype.onSwipe = function (e) {
        var r,
          s = this,
          a = s.instance,
          l = s.isSwiping,
          c = s.sliderStartPos.left || 0;
        if (!0 !== l)
          ("x" == l &&
            (s.distanceX > 0 &&
            (s.instance.group.length < 2 ||
              (0 === s.instance.current.index && !s.instance.current.opts.loop))
              ? (c += Math.pow(s.distanceX, 0.8))
              : s.distanceX < 0 &&
                  (s.instance.group.length < 2 ||
                    (s.instance.current.index === s.instance.group.length - 1 &&
                      !s.instance.current.opts.loop))
                ? (c -= Math.pow(-s.distanceX, 0.8))
                : (c += s.distanceX)),
            (s.sliderLastPos = {
              top: "x" == l ? 0 : s.sliderStartPos.top + s.distanceY,
              left: c,
            }),
            s.requestId && (o(s.requestId), (s.requestId = null)),
            (s.requestId = i(function () {
              s.sliderLastPos &&
                (n.each(s.instance.slides, function (t, e) {
                  var i = e.pos - s.instance.currPos;
                  n.fancybox.setTranslate(e.$slide, {
                    top: s.sliderLastPos.top,
                    left:
                      s.sliderLastPos.left +
                      i * s.canvasWidth +
                      i * e.opts.gutter,
                  });
                }),
                s.$container.addClass("fancybox-is-sliding"));
            })));
        else if (Math.abs(s.distance) > 10) {
          if (
            ((s.canTap = !1),
            a.group.length < 2 && s.opts.vertical
              ? (s.isSwiping = "y")
              : a.isDragging ||
                  !1 === s.opts.vertical ||
                  ("auto" === s.opts.vertical && n(t).width() > 800)
                ? (s.isSwiping = "x")
                : ((r = Math.abs(
                    (180 * Math.atan2(s.distanceY, s.distanceX)) / Math.PI,
                  )),
                  (s.isSwiping = r > 45 && r < 135 ? "y" : "x")),
            "y" === s.isSwiping && n.fancybox.isMobile && s.isScrollable)
          )
            return void (s.isScrolling = !0);
          ((a.isDragging = s.isSwiping),
            (s.startPoints = s.newPoints),
            n.each(a.slides, function (t, e) {
              var i, o;
              (n.fancybox.stop(e.$slide),
                (i = n.fancybox.getTranslate(e.$slide)),
                (o = n.fancybox.getTranslate(a.$refs.stage)),
                e.$slide
                  .css({
                    transform: "",
                    opacity: "",
                    "transition-duration": "",
                  })
                  .removeClass("fancybox-animated")
                  .removeClass(function (t, e) {
                    return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                  }),
                e.pos === a.current.pos &&
                  ((s.sliderStartPos.top = i.top - o.top),
                  (s.sliderStartPos.left = i.left - o.left)),
                n.fancybox.setTranslate(e.$slide, {
                  top: i.top - o.top,
                  left: i.left - o.left,
                }));
            }),
            a.SlideShow && a.SlideShow.isActive && a.SlideShow.stop());
        }
      }),
      (u.prototype.onPan = function () {
        var t = this;
        s(t.newPoints[0], t.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5)
          ? (t.startPoints = t.newPoints)
          : ((t.canTap = !1),
            (t.contentLastPos = t.limitMovement()),
            t.requestId && o(t.requestId),
            (t.requestId = i(function () {
              n.fancybox.setTranslate(t.$content, t.contentLastPos);
            })));
      }),
      (u.prototype.limitMovement = function () {
        var t,
          e,
          n,
          i,
          o,
          r,
          s = this,
          a = s.canvasWidth,
          l = s.canvasHeight,
          c = s.distanceX,
          u = s.distanceY,
          h = s.contentStartPos,
          d = h.left,
          f = h.top,
          p = h.width,
          m = h.height;
        return (
          (o = p > a ? d + c : d),
          (r = f + u),
          (t = Math.max(0, 0.5 * a - 0.5 * p)),
          (e = Math.max(0, 0.5 * l - 0.5 * m)),
          (n = Math.min(a - p, 0.5 * a - 0.5 * p)),
          (i = Math.min(l - m, 0.5 * l - 0.5 * m)),
          c > 0 && o > t && (o = t - 1 + Math.pow(-t + d + c, 0.8) || 0),
          c < 0 && o < n && (o = n + 1 - Math.pow(n - d - c, 0.8) || 0),
          u > 0 && r > e && (r = e - 1 + Math.pow(-e + f + u, 0.8) || 0),
          u < 0 && r < i && (r = i + 1 - Math.pow(i - f - u, 0.8) || 0),
          { top: r, left: o }
        );
      }),
      (u.prototype.limitPosition = function (t, e, n, i) {
        var o = this.canvasWidth,
          r = this.canvasHeight;
        return (
          n > o
            ? (t = (t = t > 0 ? 0 : t) < o - n ? o - n : t)
            : (t = Math.max(0, o / 2 - n / 2)),
          i > r
            ? (e = (e = e > 0 ? 0 : e) < r - i ? r - i : e)
            : (e = Math.max(0, r / 2 - i / 2)),
          { top: e, left: t }
        );
      }),
      (u.prototype.onZoom = function () {
        var e = this,
          r = e.contentStartPos,
          a = r.width,
          l = r.height,
          c = r.left,
          u = r.top,
          h = s(e.newPoints[0], e.newPoints[1]) / e.startDistanceBetweenFingers,
          d = Math.floor(a * h),
          f = Math.floor(l * h),
          p = (a - d) * e.percentageOfImageAtPinchPointX,
          m = (l - f) * e.percentageOfImageAtPinchPointY,
          g = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
          v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
          y = g - e.centerPointStartX,
          b = {
            top: u + (m + (v - e.centerPointStartY)),
            left: c + (p + y),
            scaleX: h,
            scaleY: h,
          };
        ((e.canTap = !1),
          (e.newWidth = d),
          (e.newHeight = f),
          (e.contentLastPos = b),
          e.requestId && o(e.requestId),
          (e.requestId = i(function () {
            n.fancybox.setTranslate(e.$content, e.contentLastPos);
          })));
      }),
      (u.prototype.ontouchend = function (t) {
        var i = this,
          s = i.isSwiping,
          a = i.isPanning,
          l = i.isZooming,
          c = i.isScrolling;
        if (
          ((i.endPoints = r(t)),
          (i.dMs = Math.max(new Date().getTime() - i.startTime, 1)),
          i.$container.removeClass("fancybox-is-grabbing"),
          n(e).off(".fb.touch"),
          e.removeEventListener("scroll", i.onscroll, !0),
          i.requestId && (o(i.requestId), (i.requestId = null)),
          (i.isSwiping = !1),
          (i.isPanning = !1),
          (i.isZooming = !1),
          (i.isScrolling = !1),
          (i.instance.isDragging = !1),
          i.canTap)
        )
          return i.onTap(t);
        ((i.speed = 100),
          (i.velocityX = (i.distanceX / i.dMs) * 0.5),
          (i.velocityY = (i.distanceY / i.dMs) * 0.5),
          a ? i.endPanning() : l ? i.endZooming() : i.endSwiping(s, c));
      }),
      (u.prototype.endSwiping = function (t, e) {
        var i = this,
          o = !1,
          r = i.instance.group.length,
          s = Math.abs(i.distanceX),
          a = "x" == t && r > 1 && ((i.dMs > 130 && s > 10) || s > 50);
        ((i.sliderLastPos = null),
          "y" == t && !e && Math.abs(i.distanceY) > 50
            ? (n.fancybox.animate(
                i.instance.current.$slide,
                {
                  top: i.sliderStartPos.top + i.distanceY + 150 * i.velocityY,
                  opacity: 0,
                },
                200,
              ),
              (o = i.instance.close(!0, 250)))
            : a && i.distanceX > 0
              ? (o = i.instance.previous(300))
              : a && i.distanceX < 0 && (o = i.instance.next(300)),
          !1 !== o || ("x" != t && "y" != t) || i.instance.centerSlide(200),
          i.$container.removeClass("fancybox-is-sliding"));
      }),
      (u.prototype.endPanning = function () {
        var t,
          e,
          i,
          o = this;
        o.contentLastPos &&
          (!1 === o.opts.momentum || o.dMs > 350
            ? ((t = o.contentLastPos.left), (e = o.contentLastPos.top))
            : ((t = o.contentLastPos.left + 500 * o.velocityX),
              (e = o.contentLastPos.top + 500 * o.velocityY)),
          ((i = o.limitPosition(
            t,
            e,
            o.contentStartPos.width,
            o.contentStartPos.height,
          )).width = o.contentStartPos.width),
          (i.height = o.contentStartPos.height),
          n.fancybox.animate(o.$content, i, 366));
      }),
      (u.prototype.endZooming = function () {
        var t,
          e,
          i,
          o,
          r = this,
          s = r.instance.current,
          a = r.newWidth,
          l = r.newHeight;
        r.contentLastPos &&
          ((t = r.contentLastPos.left),
          (o = {
            top: (e = r.contentLastPos.top),
            left: t,
            width: a,
            height: l,
            scaleX: 1,
            scaleY: 1,
          }),
          n.fancybox.setTranslate(r.$content, o),
          a < r.canvasWidth && l < r.canvasHeight
            ? r.instance.scaleToFit(150)
            : a > s.width || l > s.height
              ? r.instance.scaleToActual(
                  r.centerPointStartX,
                  r.centerPointStartY,
                  150,
                )
              : ((i = r.limitPosition(t, e, a, l)),
                n.fancybox.animate(r.$content, i, 150)));
      }),
      (u.prototype.onTap = function (e) {
        var i,
          o = this,
          s = n(e.target),
          a = o.instance,
          l = a.current,
          c = (e && r(e)) || o.startPoints,
          u = c[0] ? c[0].x - n(t).scrollLeft() - o.stagePos.left : 0,
          h = c[0] ? c[0].y - n(t).scrollTop() - o.stagePos.top : 0,
          d = function (t) {
            var i = l.opts[t];
            if ((n.isFunction(i) && (i = i.apply(a, [l, e])), i))
              switch (i) {
                case "close":
                  a.close(o.startEvent);
                  break;
                case "toggleControls":
                  a.toggleControls();
                  break;
                case "next":
                  a.next();
                  break;
                case "nextOrClose":
                  a.group.length > 1 ? a.next() : a.close(o.startEvent);
                  break;
                case "zoom":
                  "image" == l.type &&
                    (l.isLoaded || l.$ghost) &&
                    (a.canPan()
                      ? a.scaleToFit()
                      : a.isScaledDown()
                        ? a.scaleToActual(u, h)
                        : a.group.length < 2 && a.close(o.startEvent));
              }
          };
        if (
          (!e.originalEvent || 2 != e.originalEvent.button) &&
          (s.is("img") || !(u > s[0].clientWidth + s.offset().left))
        ) {
          if (
            s.is(
              ".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container",
            )
          )
            i = "Outside";
          else if (s.is(".fancybox-slide")) i = "Slide";
          else {
            if (
              !a.current.$content ||
              !a.current.$content.find(s).addBack().filter(s).length
            )
              return;
            i = "Content";
          }
          if (o.tapped) {
            if (
              (clearTimeout(o.tapped),
              (o.tapped = null),
              Math.abs(u - o.tapX) > 50 || Math.abs(h - o.tapY) > 50)
            )
              return this;
            d("dblclick" + i);
          } else
            ((o.tapX = u),
              (o.tapY = h),
              l.opts["dblclick" + i] &&
              l.opts["dblclick" + i] !== l.opts["click" + i]
                ? (o.tapped = setTimeout(function () {
                    ((o.tapped = null), a.isAnimating || d("click" + i));
                  }, 500))
                : d("click" + i));
          return this;
        }
      }),
      n(e)
        .on("onActivate.fb", function (t, e) {
          e && !e.Guestures && (e.Guestures = new u(e));
        })
        .on("beforeClose.fb", function (t, e) {
          e && e.Guestures && e.Guestures.destroy();
        }));
  })(window, document, jQuery),
  (function (t, e) {
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        slideShow:
          '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>',
      },
      slideShow: { autoStart: !1, speed: 3e3, progress: !0 },
    });
    var n = function (t) {
      ((this.instance = t), this.init());
    };
    (e.extend(n.prototype, {
      timer: null,
      isActive: !1,
      $button: null,
      init: function () {
        var t = this,
          n = t.instance,
          i = n.group[n.currIndex].opts.slideShow;
        ((t.$button = n.$refs.toolbar
          .find("[data-fancybox-play]")
          .on("click", function () {
            t.toggle();
          })),
          n.group.length < 2 || !i
            ? t.$button.hide()
            : i.progress &&
              (t.$progress = e(
                '<div class="fancybox-progress"></div>',
              ).appendTo(n.$refs.inner)));
      },
      set: function (t) {
        var n = this,
          i = n.instance,
          o = i.current;
        o && (!0 === t || o.opts.loop || i.currIndex < i.group.length - 1)
          ? n.isActive &&
            "video" !== o.contentType &&
            (n.$progress &&
              e.fancybox.animate(
                n.$progress.show(),
                { scaleX: 1 },
                o.opts.slideShow.speed,
              ),
            (n.timer = setTimeout(function () {
              i.current.opts.loop || i.current.index != i.group.length - 1
                ? i.next()
                : i.jumpTo(0);
            }, o.opts.slideShow.speed)))
          : (n.stop(), (i.idleSecondsCounter = 0), i.showControls());
      },
      clear: function () {
        var t = this;
        (clearTimeout(t.timer),
          (t.timer = null),
          t.$progress && t.$progress.removeAttr("style").hide());
      },
      start: function () {
        var t = this,
          e = t.instance.current;
        e &&
          (t.$button
            .attr(
              "title",
              (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP,
            )
            .removeClass("fancybox-button--play")
            .addClass("fancybox-button--pause"),
          (t.isActive = !0),
          e.isComplete && t.set(!0),
          t.instance.trigger("onSlideShowChange", !0));
      },
      stop: function () {
        var t = this,
          e = t.instance.current;
        (t.clear(),
          t.$button
            .attr(
              "title",
              (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START,
            )
            .removeClass("fancybox-button--pause")
            .addClass("fancybox-button--play"),
          (t.isActive = !1),
          t.instance.trigger("onSlideShowChange", !1),
          t.$progress && t.$progress.removeAttr("style").hide());
      },
      toggle: function () {
        var t = this;
        t.isActive ? t.stop() : t.start();
      },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          e && !e.SlideShow && (e.SlideShow = new n(e));
        },
        "beforeShow.fb": function (t, e, n, i) {
          var o = e && e.SlideShow;
          i
            ? o && n.opts.slideShow.autoStart && o.start()
            : o && o.isActive && o.clear();
        },
        "afterShow.fb": function (t, e, n) {
          var i = e && e.SlideShow;
          i && i.isActive && i.set();
        },
        "afterKeydown.fb": function (n, i, o, r, s) {
          var a = i && i.SlideShow;
          !a ||
            !o.opts.slideShow ||
            (80 !== s && 32 !== s) ||
            e(t.activeElement).is("button,a,input") ||
            (r.preventDefault(), a.toggle());
        },
        "beforeClose.fb onDeactivate.fb": function (t, e) {
          var n = e && e.SlideShow;
          n && n.stop();
        },
      }),
      e(t).on("visibilitychange", function () {
        var n = e.fancybox.getInstance(),
          i = n && n.SlideShow;
        i && i.isActive && (t.hidden ? i.clear() : i.set());
      }));
  })(document, jQuery),
  (function (t, e) {
    var n = (function () {
      for (
        var e = [
            [
              "requestFullscreen",
              "exitFullscreen",
              "fullscreenElement",
              "fullscreenEnabled",
              "fullscreenchange",
              "fullscreenerror",
            ],
            [
              "webkitRequestFullscreen",
              "webkitExitFullscreen",
              "webkitFullscreenElement",
              "webkitFullscreenEnabled",
              "webkitfullscreenchange",
              "webkitfullscreenerror",
            ],
            [
              "webkitRequestFullScreen",
              "webkitCancelFullScreen",
              "webkitCurrentFullScreenElement",
              "webkitCancelFullScreen",
              "webkitfullscreenchange",
              "webkitfullscreenerror",
            ],
            [
              "mozRequestFullScreen",
              "mozCancelFullScreen",
              "mozFullScreenElement",
              "mozFullScreenEnabled",
              "mozfullscreenchange",
              "mozfullscreenerror",
            ],
            [
              "msRequestFullscreen",
              "msExitFullscreen",
              "msFullscreenElement",
              "msFullscreenEnabled",
              "MSFullscreenChange",
              "MSFullscreenError",
            ],
          ],
          n = {},
          i = 0;
        i < e.length;
        i++
      ) {
        var o = e[i];
        if (o && o[1] in t) {
          for (var r = 0; r < o.length; r++) n[e[0][r]] = o[r];
          return n;
        }
      }
      return !1;
    })();
    if (n) {
      var i = {
        request: function (e) {
          (e = e || t.documentElement)[n.requestFullscreen](
            e.ALLOW_KEYBOARD_INPUT,
          );
        },
        exit: function () {
          t[n.exitFullscreen]();
        },
        toggle: function (e) {
          ((e = e || t.documentElement),
            this.isFullscreen() ? this.exit() : this.request(e));
        },
        isFullscreen: function () {
          return Boolean(t[n.fullscreenElement]);
        },
        enabled: function () {
          return Boolean(t[n.fullscreenEnabled]);
        },
      };
      (e.extend(!0, e.fancybox.defaults, {
        btnTpl: {
          fullScreen:
            '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>',
        },
        fullScreen: { autoStart: !1 },
      }),
        e(t).on(n.fullscreenchange, function () {
          var t = i.isFullscreen(),
            n = e.fancybox.getInstance();
          n &&
            (n.current &&
              "image" === n.current.type &&
              n.isAnimating &&
              ((n.isAnimating = !1),
              n.update(!0, !0, 0),
              n.isComplete || n.complete()),
            n.trigger("onFullscreenChange", t),
            n.$refs.container.toggleClass("fancybox-is-fullscreen", t),
            n.$refs.toolbar
              .find("[data-fancybox-fullscreen]")
              .toggleClass("fancybox-button--fsenter", !t)
              .toggleClass("fancybox-button--fsexit", t));
        }));
    }
    e(t).on({
      "onInit.fb": function (t, e) {
        n
          ? e && e.group[e.currIndex].opts.fullScreen
            ? (e.$refs.container.on(
                "click.fb-fullscreen",
                "[data-fancybox-fullscreen]",
                function (t) {
                  (t.stopPropagation(), t.preventDefault(), i.toggle());
                },
              ),
              e.opts.fullScreen &&
                !0 === e.opts.fullScreen.autoStart &&
                i.request(),
              (e.FullScreen = i))
            : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide()
          : e.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();
      },
      "afterKeydown.fb": function (t, e, n, i, o) {
        e &&
          e.FullScreen &&
          70 === o &&
          (i.preventDefault(), e.FullScreen.toggle());
      },
      "beforeClose.fb": function (t, e) {
        e &&
          e.FullScreen &&
          e.$refs.container.hasClass("fancybox-is-fullscreen") &&
          i.exit();
      },
    });
  })(document, jQuery),
  (function (t, e) {
    var n = "fancybox-thumbs";
    e.fancybox.defaults = e.extend(
      !0,
      {
        btnTpl: {
          thumbs:
            '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>',
        },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
      },
      e.fancybox.defaults,
    );
    var i = function (t) {
      this.init(t);
    };
    (e.extend(i.prototype, {
      $button: null,
      $grid: null,
      $list: null,
      isVisible: !1,
      isActive: !1,
      init: function (t) {
        var e = this,
          n = t.group,
          i = 0;
        ((e.instance = t),
          (e.opts = n[t.currIndex].opts.thumbs),
          (t.Thumbs = e),
          (e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]")));
        for (
          var o = 0, r = n.length;
          o < r && (n[o].thumb && i++, !(i > 1));
          o++
        );
        i > 1 && e.opts
          ? (e.$button.removeAttr("style").on("click", function () {
              e.toggle();
            }),
            (e.isActive = !0))
          : e.$button.hide();
      },
      create: function () {
        var t,
          i = this,
          o = i.instance,
          r = i.opts.parentEl,
          s = [];
        (i.$grid ||
          ((i.$grid = e(
            '<div class="' + n + " " + n + "-" + i.opts.axis + '"></div>',
          ).appendTo(o.$refs.container.find(r).addBack().filter(r))),
          i.$grid.on("click", "a", function () {
            o.jumpTo(e(this).attr("data-index"));
          })),
          i.$list ||
            (i.$list = e('<div class="' + n + '__list">').appendTo(i.$grid)),
          e.each(o.group, function (e, n) {
            ((t = n.thumb) || "image" !== n.type || (t = n.src),
              s.push(
                '<a href="javascript:;" tabindex="0" data-index="' +
                  e +
                  '"' +
                  (t && t.length
                    ? ' style="background-image:url(' + t + ')"'
                    : 'class="fancybox-thumbs-missing"') +
                  "></a>",
              ));
          }),
          (i.$list[0].innerHTML = s.join("")),
          "x" === i.opts.axis &&
            i.$list.width(
              parseInt(i.$grid.css("padding-right"), 10) +
                o.group.length * i.$list.children().eq(0).outerWidth(!0),
            ));
      },
      focus: function (t) {
        var e,
          n,
          i = this,
          o = i.$list,
          r = i.$grid;
        i.instance.current &&
          ((n = (e = o
            .children()
            .removeClass("fancybox-thumbs-active")
            .filter('[data-index="' + i.instance.current.index + '"]')
            .addClass("fancybox-thumbs-active")).position()),
          "y" === i.opts.axis &&
          (n.top < 0 || n.top > o.height() - e.outerHeight())
            ? o.stop().animate({ scrollTop: o.scrollTop() + n.top }, t)
            : "x" === i.opts.axis &&
              (n.left < r.scrollLeft() ||
                n.left > r.scrollLeft() + (r.width() - e.outerWidth())) &&
              o.parent().stop().animate({ scrollLeft: n.left }, t));
      },
      update: function () {
        var t = this;
        (t.instance.$refs.container.toggleClass(
          "fancybox-show-thumbs",
          this.isVisible,
        ),
          t.isVisible
            ? (t.$grid || t.create(),
              t.instance.trigger("onThumbsShow"),
              t.focus(0))
            : t.$grid && t.instance.trigger("onThumbsHide"),
          t.instance.update());
      },
      hide: function () {
        ((this.isVisible = !1), this.update());
      },
      show: function () {
        ((this.isVisible = !0), this.update());
      },
      toggle: function () {
        ((this.isVisible = !this.isVisible), this.update());
      },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          var n;
          e &&
            !e.Thumbs &&
            (n = new i(e)).isActive &&
            !0 === n.opts.autoStart &&
            n.show();
        },
        "beforeShow.fb": function (t, e, n, i) {
          var o = e && e.Thumbs;
          o && o.isVisible && o.focus(i ? 0 : 250);
        },
        "afterKeydown.fb": function (t, e, n, i, o) {
          var r = e && e.Thumbs;
          r && r.isActive && 71 === o && (i.preventDefault(), r.toggle());
        },
        "beforeClose.fb": function (t, e) {
          var n = e && e.Thumbs;
          n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide();
        },
      }));
  })(document, jQuery),
  (function (t, e) {
    (e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        share:
          '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>',
      },
      share: {
        url: function (t, e) {
          return (
            (!t.currentHash &&
              "inline" !== e.type &&
              "html" !== e.type &&
              (e.origSrc || e.src)) ||
            window.location
          );
        },
        tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>',
      },
    }),
      e(t).on("click", "[data-fancybox-share]", function () {
        var t,
          n,
          i = e.fancybox.getInstance(),
          o = i.current || null;
        o &&
          ("function" === e.type(o.opts.share.url) &&
            (t = o.opts.share.url.apply(o, [i, o])),
          (n = o.opts.share.tpl
            .replace(
              /\{\{media\}\}/g,
              "image" === o.type ? encodeURIComponent(o.src) : "",
            )
            .replace(/\{\{url\}\}/g, encodeURIComponent(t))
            .replace(
              /\{\{url_raw\}\}/g,
              (function (t) {
                var e = {
                  "&": "&amp;",
                  "<": "&lt;",
                  ">": "&gt;",
                  '"': "&quot;",
                  "'": "&#39;",
                  "/": "&#x2F;",
                  "`": "&#x60;",
                  "=": "&#x3D;",
                };
                return String(t).replace(/[&<>"'`=\/]/g, function (t) {
                  return e[t];
                });
              })(t),
            )
            .replace(
              /\{\{descr\}\}/g,
              i.$caption ? encodeURIComponent(i.$caption.text()) : "",
            )),
          e.fancybox.open({
            src: i.translate(i, n),
            type: "html",
            opts: {
              touch: !1,
              animationEffect: !1,
              afterLoad: function (t, e) {
                (i.$refs.container.one("beforeClose.fb", function () {
                  t.close(null, 0);
                }),
                  e.$content.find(".fancybox-share__button").click(function () {
                    return (
                      window.open(this.href, "Share", "width=550, height=450"),
                      !1
                    );
                  }));
              },
              mobile: { autoFocus: !1 },
            },
          }));
      }));
  })(document, jQuery),
  (function (t, e, n) {
    function i() {
      var e = t.location.hash.substr(1),
        n = e.split("-"),
        i =
          (n.length > 1 &&
            /^\+?\d+$/.test(n[n.length - 1]) &&
            parseInt(n.pop(-1), 10)) ||
          1;
      return { hash: e, index: i < 1 ? 1 : i, gallery: n.join("-") };
    }
    function o(t) {
      "" !== t.gallery &&
        n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']")
          .eq(t.index - 1)
          .focus()
          .trigger("click.fb-start");
    }
    function r(t) {
      var e, n;
      return (
        !!t &&
        "" !==
          (n =
            (e = t.current ? t.current.opts : t.opts).hash ||
            (e.$orig
              ? e.$orig.data("fancybox") || e.$orig.data("fancybox-trigger")
              : "")) &&
        n
      );
    }
    (n.escapeSelector ||
      (n.escapeSelector = function (t) {
        return (t + "").replace(
          /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
          function (t, e) {
            return e
              ? "\0" === t
                ? "�"
                : t.slice(0, -1) +
                  "\\" +
                  t.charCodeAt(t.length - 1).toString(16) +
                  " "
              : "\\" + t;
          },
        );
      }),
      n(function () {
        !1 !== n.fancybox.defaults.hash &&
          (n(e).on({
            "onInit.fb": function (t, e) {
              var n, o;
              !1 !== e.group[e.currIndex].opts.hash &&
                ((n = i()),
                (o = r(e)) &&
                  n.gallery &&
                  o == n.gallery &&
                  (e.currIndex = n.index - 1));
            },
            "beforeShow.fb": function (n, i, o, s) {
              var a;
              o &&
                !1 !== o.opts.hash &&
                (a = r(i)) &&
                ((i.currentHash =
                  a + (i.group.length > 1 ? "-" + (o.index + 1) : "")),
                t.location.hash !== "#" + i.currentHash &&
                  (s && !i.origHash && (i.origHash = t.location.hash),
                  i.hashTimer && clearTimeout(i.hashTimer),
                  (i.hashTimer = setTimeout(function () {
                    ("replaceState" in t.history
                      ? (t.history[s ? "pushState" : "replaceState"](
                          {},
                          e.title,
                          t.location.pathname +
                            t.location.search +
                            "#" +
                            i.currentHash,
                        ),
                        s && (i.hasCreatedHistory = !0))
                      : (t.location.hash = i.currentHash),
                      (i.hashTimer = null));
                  }, 300))));
            },
            "beforeClose.fb": function (n, i, o) {
              o &&
                !1 !== o.opts.hash &&
                (clearTimeout(i.hashTimer),
                i.currentHash && i.hasCreatedHistory
                  ? t.history.back()
                  : i.currentHash &&
                    ("replaceState" in t.history
                      ? t.history.replaceState(
                          {},
                          e.title,
                          t.location.pathname +
                            t.location.search +
                            (i.origHash || ""),
                        )
                      : (t.location.hash = i.origHash)),
                (i.currentHash = null));
            },
          }),
          n(t).on("hashchange.fb", function () {
            var t = i(),
              e = null;
            (n.each(n(".fancybox-container").get().reverse(), function (t, i) {
              var o = n(i).data("FancyBox");
              if (o && o.currentHash) return ((e = o), !1);
            }),
              e
                ? e.currentHash === t.gallery + "-" + t.index ||
                  (1 === t.index && e.currentHash == t.gallery) ||
                  ((e.currentHash = null), e.close())
                : "" !== t.gallery && o(t));
          }),
          setTimeout(function () {
            n.fancybox.getInstance() || o(i());
          }, 50));
      }));
  })(window, document, jQuery),
  (function (t, e) {
    var n = new Date().getTime();
    e(t).on({
      "onInit.fb": function (t, e, i) {
        e.$refs.stage.on(
          "mousewheel DOMMouseScroll wheel MozMousePixelScroll",
          function (t) {
            var i = e.current,
              o = new Date().getTime();
            e.group.length < 2 ||
              !1 === i.opts.wheel ||
              ("auto" === i.opts.wheel && "image" !== i.type) ||
              (t.preventDefault(),
              t.stopPropagation(),
              i.$slide.hasClass("fancybox-animated") ||
                ((t = t.originalEvent || t),
                o - n < 250 ||
                  ((n = o),
                  e[
                    (-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0
                      ? "next"
                      : "previous"
                  ]())));
          },
        );
      },
    });
  })(document, jQuery),
  (function () {
    var t = (function () {
      function t(t) {
        return decodeURIComponent(t.replace(/\+/g, " "));
      }
      function e(t, e) {
        var n = t.charAt(0),
          i = e.split(n);
        return n === t
          ? i
          : i[(t = parseInt(t.substring(1), 10)) < 0 ? i.length + t : t - 1];
      }
      function n(e, n) {
        for (
          var i = e.charAt(0),
            o = n.split("&"),
            r = [],
            s = {},
            a = [],
            l = e.substring(1),
            c = 0,
            u = o.length;
          c < u;
          c++
        )
          if (
            ((r = o[c].match(/(.*?)=(.*)/)) || (r = [o[c], o[c], ""]),
            "" !== r[1].replace(/\s/g, ""))
          ) {
            if (((r[2] = t(r[2] || "")), l === r[1])) return r[2];
            (a = r[1].match(/(.*)\[([0-9]+)\]/))
              ? ((s[a[1]] = s[a[1]] || []), (s[a[1]][a[2]] = r[2]))
              : (s[r[1]] = r[2]);
          }
        return i === e ? s : s[l];
      }
      return function (t, i) {
        var o,
          r = {};
        if ("tld?" !== t) {
          if (((i = i || window.location.toString()), !t)) return i;
          if (((t = t.toString()), (o = i.match(/^mailto:([^\/].+)/))))
            ((r.protocol = "mailto"), (r.email = o[1]));
          else {
            if (
              ((o = i.match(/(.*?)\/#\!(.*)/)) && (i = o[1] + o[2]),
              (o = i.match(/(.*?)#(.*)/)) && ((r.hash = o[2]), (i = o[1])),
              r.hash && t.match(/^#/))
            )
              return n(t, r.hash);
            if (
              ((o = i.match(/(.*?)\?(.*)/)) && ((r.query = o[2]), (i = o[1])),
              r.query && t.match(/^\?/))
            )
              return n(t, r.query);
            if (
              ((o = i.match(/(.*?)\:?\/\/(.*)/)) &&
                ((r.protocol = o[1].toLowerCase()), (i = o[2])),
              (o = i.match(/(.*?)(\/.*)/)) && ((r.path = o[2]), (i = o[1])),
              (r.path = (r.path || "").replace(/^([^\/])/, "/$1")),
              t.match(/^[\-0-9]+$/) && (t = t.replace(/^([^\/])/, "/$1")),
              t.match(/^\//))
            )
              return e(t, r.path.substring(1));
            if (
              ((o = e("/-1", r.path.substring(1))) &&
                (o = o.match(/(.*?)\.(.*)/)) &&
                ((r.file = o[0]), (r.filename = o[1]), (r.fileext = o[2])),
              (o = i.match(/(.*)\:([0-9]+)$/)) && ((r.port = o[2]), (i = o[1])),
              (o = i.match(/(.*?)@(.*)/)) && ((r.auth = o[1]), (i = o[2])),
              r.auth &&
                ((o = r.auth.match(/(.*)\:(.*)/)),
                (r.user = o ? o[1] : r.auth),
                (r.pass = o ? o[2] : void 0)),
              (r.hostname = i.toLowerCase()),
              "." === t.charAt(0))
            )
              return e(t, r.hostname);
            ((r.port = r.port || ("https" === r.protocol ? "443" : "80")),
              (r.protocol =
                r.protocol || ("443" === r.port ? "https" : "http")));
          }
          return t in r ? r[t] : "{}" === t ? r : void 0;
        }
      };
    })();
    "function" == typeof window.define && window.define.amd
      ? window.define("js-url", [], function () {
          return t;
        })
      : (void 0 !== window.jQuery &&
          window.jQuery.extend({
            url: function (t, e) {
              return window.url(t, e);
            },
          }),
        (window.url = t));
  })(),
  function () {
    var t, e;
    ((t = window.jQuery),
      (e = t(window)),
      (t.fn.stick_in_parent = function (n) {
        var i, o, r, s, a, l, c, u, h, d, f, p;
        for (
          null == n && (n = {}),
            p = n.sticky_class,
            a = n.inner_scrolling,
            f = n.recalc_every,
            d = n.parent,
            u = n.offset_top,
            c = n.spacer,
            o = n.bottoming,
            null == u && (u = 0),
            null == d && (d = void 0),
            null == a && (a = !0),
            null == p && (p = "is_stuck"),
            i = t(document),
            null == o && (o = !0),
            h = function (t) {
              var e;
              return window.getComputedStyle
                ? ((t = window.getComputedStyle(t[0])),
                  (e =
                    parseFloat(t.getPropertyValue("width")) +
                    parseFloat(t.getPropertyValue("margin-left")) +
                    parseFloat(t.getPropertyValue("margin-right"))),
                  "border-box" !== t.getPropertyValue("box-sizing") &&
                    (e +=
                      parseFloat(t.getPropertyValue("border-left-width")) +
                      parseFloat(t.getPropertyValue("border-right-width")) +
                      parseFloat(t.getPropertyValue("padding-left")) +
                      parseFloat(t.getPropertyValue("padding-right"))),
                  e)
                : t.outerWidth(!0);
            },
            r = function (n, r, s, l, m, g, v, y) {
              var b, w, x, S, k, E, C, T, P, A, I, _;
              if (!n.data("sticky_kit")) {
                if (
                  (n.data("sticky_kit", !0),
                  (k = i.height()),
                  (C = n.parent()),
                  null != d && (C = C.closest(d)),
                  !C.length)
                )
                  throw "failed to find stick parent";
                if (
                  ((b = x = !1),
                  (I = null != c ? c && n.closest(c) : t("<div />")) &&
                    I.css("position", n.css("position")),
                  (T = function () {
                    var t, e, o;
                    if (
                      !y &&
                      ((k = i.height()),
                      (t = parseInt(C.css("border-top-width"), 10)),
                      (e = parseInt(C.css("padding-top"), 10)),
                      (r = parseInt(C.css("padding-bottom"), 10)),
                      (s = C.offset().top + t + e),
                      (l = C.height()),
                      x &&
                        ((b = x = !1),
                        null == c && (n.insertAfter(I), I.detach()),
                        n
                          .css({ position: "", top: "", width: "", bottom: "" })
                          .removeClass(p),
                        (o = !0)),
                      (m =
                        n.offset().top -
                        (parseInt(n.css("margin-top"), 10) || 0) -
                        u),
                      (g = n.outerHeight(!0)),
                      (v = n.css("float")),
                      I &&
                        I.css({
                          width: h(n),
                          height: g,
                          display: n.css("display"),
                          "vertical-align": n.css("vertical-align"),
                          float: v,
                        }),
                      o)
                    )
                      return _();
                  }),
                  T(),
                  g !== l)
                )
                  return (
                    (S = void 0),
                    (E = u),
                    (A = f),
                    (_ = function () {
                      var t, h, d, w;
                      if (
                        !y &&
                        ((d = !1),
                        null != A && 0 >= --A && ((A = f), T(), (d = !0)),
                        d || i.height() === k || T(),
                        (d = e.scrollTop()),
                        null != S && (h = d - S),
                        (S = d),
                        x
                          ? (o &&
                              ((w = d + g + E > l + s),
                              b &&
                                !w &&
                                ((b = !1),
                                n
                                  .css({
                                    position: "fixed",
                                    bottom: "",
                                    top: E,
                                  })
                                  .trigger("sticky_kit:unbottom"))),
                            d < m &&
                              ((x = !1),
                              (E = u),
                              null == c &&
                                (("left" !== v && "right" !== v) ||
                                  n.insertAfter(I),
                                I.detach()),
                              (t = { position: "", width: "", top: "" }),
                              n
                                .css(t)
                                .removeClass(p)
                                .trigger("sticky_kit:unstick")),
                            a &&
                              ((t = e.height()),
                              g + u > t &&
                                !b &&
                                ((E -= h),
                                (E = Math.max(t - g, E)),
                                (E = Math.min(u, E)),
                                x && n.css({ top: E + "px" }))))
                          : d > m &&
                            ((x = !0),
                            ((t = { position: "fixed", top: E }).width =
                              "border-box" === n.css("box-sizing")
                                ? n.outerWidth() + "px"
                                : n.width() + "px"),
                            n.css(t).addClass(p),
                            null == c &&
                              (n.after(I),
                              ("left" !== v && "right" !== v) || I.append(n)),
                            n.trigger("sticky_kit:stick")),
                        x &&
                          o &&
                          (null == w && (w = d + g + E > l + s), !b && w))
                      )
                        return (
                          (b = !0),
                          "static" === C.css("position") &&
                            C.css({ position: "relative" }),
                          n
                            .css({
                              position: "absolute",
                              bottom: r,
                              top: "auto",
                            })
                            .trigger("sticky_kit:bottom")
                        );
                    }),
                    (P = function () {
                      return (T(), _());
                    }),
                    (w = function () {
                      if (
                        ((y = !0),
                        e.off("touchmove", _),
                        e.off("scroll", _),
                        e.off("resize", P),
                        t(document.body).off("sticky_kit:recalc", P),
                        n.off("sticky_kit:detach", w),
                        n.removeData("sticky_kit"),
                        n.css({ position: "", bottom: "", top: "", width: "" }),
                        C.position("position", ""),
                        x)
                      )
                        return (
                          null == c &&
                            (("left" !== v && "right" !== v) ||
                              n.insertAfter(I),
                            I.remove()),
                          n.removeClass(p)
                        );
                    }),
                    e.on("touchmove", _),
                    e.on("scroll", _),
                    e.on("resize", P),
                    t(document.body).on("sticky_kit:recalc", P),
                    n.on("sticky_kit:detach", w),
                    setTimeout(_, 0)
                  );
              }
            },
            s = 0,
            l = this.length;
          s < l;
          s++
        )
          ((n = this[s]), r(t(n)));
        return this;
      }));
  }.call(this),
  /*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
  (function (t) {
    var e = {
      url: !1,
      callback: !1,
      target: !1,
      duration: 120,
      on: "mouseover",
      touch: !0,
      onZoomIn: !1,
      onZoomOut: !1,
      magnify: 1,
    };
    ((t.zoom = function (e, n, i, o) {
      var r,
        s,
        a,
        l,
        c,
        u,
        h,
        d = t(e),
        f = d.css("position"),
        p = t(n);
      return (
        (e.style.position = /(absolute|fixed)/.test(f) ? f : "relative"),
        (e.style.overflow = "hidden"),
        (i.style.width = i.style.height = ""),
        t(i)
          .addClass("zoomImg")
          .css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: i.width * o,
            height: i.height * o,
            border: "none",
            maxWidth: "none",
            maxHeight: "none",
          })
          .appendTo(e),
        {
          init: function () {
            ((s = d.outerWidth()),
              (r = d.outerHeight()),
              n === e
                ? ((l = s), (a = r))
                : ((l = p.outerWidth()), (a = p.outerHeight())),
              (c = (i.width - s) / l),
              (u = (i.height - r) / a),
              (h = p.offset()));
          },
          move: function (t) {
            var e = t.pageX - h.left,
              n = t.pageY - h.top;
            ((n = Math.max(Math.min(n, a), 0)),
              (e = Math.max(Math.min(e, l), 0)),
              (i.style.left = e * -c + "px"),
              (i.style.top = n * -u + "px"));
          },
        }
      );
    }),
      (t.fn.zoom = function (n) {
        return this.each(function () {
          var i = t.extend({}, e, n || {}),
            o = (i.target && t(i.target)[0]) || this,
            r = this,
            s = t(r),
            a = document.createElement("img"),
            l = t(a),
            c = "mousemove.zoom",
            u = !1,
            h = !1;
          if (!i.url) {
            var d = r.querySelector("img");
            if (
              (d &&
                (i.url = d.getAttribute("data-src") || d.currentSrc || d.src),
              !i.url)
            )
              return;
          }
          (s.one(
            "zoom.destroy",
            function (t, e) {
              (s.off(".zoom"),
                (o.style.position = t),
                (o.style.overflow = e),
                (a.onload = null),
                l.remove());
            }.bind(this, o.style.position, o.style.overflow),
          ),
            (a.onload = function () {
              function e(e) {
                (d.init(),
                  d.move(e),
                  l
                    .stop()
                    .fadeTo(
                      t.support.opacity ? i.duration : 0,
                      1,
                      !!t.isFunction(i.onZoomIn) && i.onZoomIn.call(a),
                    ));
              }
              function n() {
                l.stop().fadeTo(
                  i.duration,
                  0,
                  !!t.isFunction(i.onZoomOut) && i.onZoomOut.call(a),
                );
              }
              var d = t.zoom(o, r, a, i.magnify);
              ("grab" === i.on
                ? s.on("mousedown.zoom", function (i) {
                    1 === i.which &&
                      (t(document).one("mouseup.zoom", function () {
                        (n(), t(document).off(c, d.move));
                      }),
                      e(i),
                      t(document).on(c, d.move),
                      i.preventDefault());
                  })
                : "click" === i.on
                  ? s.on("click.zoom", function (i) {
                      return u
                        ? void 0
                        : ((u = !0),
                          e(i),
                          t(document).on(c, d.move),
                          t(document).one("click.zoom", function () {
                            (n(), (u = !1), t(document).off(c, d.move));
                          }),
                          !1);
                    })
                  : "toggle" === i.on
                    ? s.on("click.zoom", function (t) {
                        (u ? n() : e(t), (u = !u));
                      })
                    : "mouseover" === i.on &&
                      (d.init(),
                      s
                        .on("mouseenter.zoom", e)
                        .on("mouseleave.zoom", n)
                        .on(c, d.move)),
                i.touch &&
                  s
                    .on("touchstart.zoom", function (t) {
                      (t.preventDefault(),
                        h
                          ? ((h = !1), n())
                          : ((h = !0),
                            e(
                              t.originalEvent.touches[0] ||
                                t.originalEvent.changedTouches[0],
                            )));
                    })
                    .on("touchmove.zoom", function (t) {
                      (t.preventDefault(),
                        d.move(
                          t.originalEvent.touches[0] ||
                            t.originalEvent.changedTouches[0],
                        ));
                    })
                    .on("touchend.zoom", function (t) {
                      (t.preventDefault(), h && ((h = !1), n()));
                    }),
                t.isFunction(i.callback) && i.callback.call(a));
            }),
            a.setAttribute("role", "presentation"),
            (a.alt = ""),
            (a.src = i.url));
        });
      }),
      (t.fn.zoom.defaults = e));
  })(window.jQuery),
  (function () {
    function t(i) {
      if (!i) throw new Error("No options passed to Waypoint constructor");
      if (!i.element)
        throw new Error("No element option passed to Waypoint constructor");
      if (!i.handler)
        throw new Error("No handler option passed to Waypoint constructor");
      ((this.key = "waypoint-" + e),
        (this.options = t.Adapter.extend({}, t.defaults, i)),
        (this.element = this.options.element),
        (this.adapter = new t.Adapter(this.element)),
        (this.callback = i.handler),
        (this.axis = this.options.horizontal ? "horizontal" : "vertical"),
        (this.enabled = this.options.enabled),
        (this.triggerPoint = null),
        (this.group = t.Group.findOrCreate({
          name: this.options.group,
          axis: this.axis,
        })),
        (this.context = t.Context.findOrCreateByElement(this.options.context)),
        t.offsetAliases[this.options.offset] &&
          (this.options.offset = t.offsetAliases[this.options.offset]),
        this.group.add(this),
        this.context.add(this),
        (n[this.key] = this),
        (e += 1));
    }
    var e = 0,
      n = {};
    ((t.prototype.queueTrigger = function (t) {
      this.group.queueTrigger(this, t);
    }),
      (t.prototype.trigger = function (t) {
        this.enabled && this.callback && this.callback.apply(this, t);
      }),
      (t.prototype.destroy = function () {
        (this.context.remove(this),
          this.group.remove(this),
          delete n[this.key]);
      }),
      (t.prototype.disable = function () {
        return ((this.enabled = !1), this);
      }),
      (t.prototype.enable = function () {
        return (this.context.refresh(), (this.enabled = !0), this);
      }),
      (t.prototype.next = function () {
        return this.group.next(this);
      }),
      (t.prototype.previous = function () {
        return this.group.previous(this);
      }),
      (t.invokeAll = function (t) {
        var e = [];
        for (var i in n) e.push(n[i]);
        for (var o = 0, r = e.length; r > o; o++) e[o][t]();
      }),
      (t.destroyAll = function () {
        t.invokeAll("destroy");
      }),
      (t.disableAll = function () {
        t.invokeAll("disable");
      }),
      (t.enableAll = function () {
        t.invokeAll("enable");
      }),
      (t.refreshAll = function () {
        t.Context.refreshAll();
      }),
      (t.viewportHeight = function () {
        return window.innerHeight || document.documentElement.clientHeight;
      }),
      (t.viewportWidth = function () {
        return document.documentElement.clientWidth;
      }),
      (t.adapters = []),
      (t.defaults = {
        context: window,
        continuous: !0,
        enabled: !0,
        group: "default",
        horizontal: !1,
        offset: 0,
      }),
      (t.offsetAliases = {
        "bottom-in-view": function () {
          return this.context.innerHeight() - this.adapter.outerHeight();
        },
        "right-in-view": function () {
          return this.context.innerWidth() - this.adapter.outerWidth();
        },
      }),
      (window.Waypoint = t));
  })(),
  (function () {
    function t(t) {
      window.setTimeout(t, 1e3 / 60);
    }
    function e(t) {
      ((this.element = t),
        (this.Adapter = o.Adapter),
        (this.adapter = new this.Adapter(t)),
        (this.key = "waypoint-context-" + n),
        (this.didScroll = !1),
        (this.didResize = !1),
        (this.oldScroll = {
          x: this.adapter.scrollLeft(),
          y: this.adapter.scrollTop(),
        }),
        (this.waypoints = { vertical: {}, horizontal: {} }),
        (t.waypointContextKey = this.key),
        (i[t.waypointContextKey] = this),
        (n += 1),
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler());
    }
    var n = 0,
      i = {},
      o = window.Waypoint,
      r = window.onload;
    ((e.prototype.add = function (t) {
      var e = t.options.horizontal ? "horizontal" : "vertical";
      ((this.waypoints[e][t.key] = t), this.refresh());
    }),
      (e.prototype.checkEmpty = function () {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
          e = this.Adapter.isEmptyObject(this.waypoints.vertical);
        t && e && (this.adapter.off(".waypoints"), delete i[this.key]);
      }),
      (e.prototype.createThrottledResizeHandler = function () {
        function t() {
          (e.handleResize(), (e.didResize = !1));
        }
        var e = this;
        this.adapter.on("resize.waypoints", function () {
          e.didResize || ((e.didResize = !0), o.requestAnimationFrame(t));
        });
      }),
      (e.prototype.createThrottledScrollHandler = function () {
        function t() {
          (e.handleScroll(), (e.didScroll = !1));
        }
        var e = this;
        this.adapter.on("scroll.waypoints", function () {
          (!e.didScroll || o.isTouch) &&
            ((e.didScroll = !0), o.requestAnimationFrame(t));
        });
      }),
      (e.prototype.handleResize = function () {
        o.Context.refreshAll();
      }),
      (e.prototype.handleScroll = function () {
        var t = {},
          e = {
            horizontal: {
              newScroll: this.adapter.scrollLeft(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left",
            },
            vertical: {
              newScroll: this.adapter.scrollTop(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up",
            },
          };
        for (var n in e) {
          var i = e[n],
            o = i.newScroll > i.oldScroll ? i.forward : i.backward;
          for (var r in this.waypoints[n]) {
            var s = this.waypoints[n][r],
              a = i.oldScroll < s.triggerPoint,
              l = i.newScroll >= s.triggerPoint;
            ((a && l) || (!a && !l)) &&
              (s.queueTrigger(o), (t[s.group.id] = s.group));
          }
        }
        for (var c in t) t[c].flushTriggers();
        this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll };
      }),
      (e.prototype.innerHeight = function () {
        return this.element == this.element.window
          ? o.viewportHeight()
          : this.adapter.innerHeight();
      }),
      (e.prototype.remove = function (t) {
        (delete this.waypoints[t.axis][t.key], this.checkEmpty());
      }),
      (e.prototype.innerWidth = function () {
        return this.element == this.element.window
          ? o.viewportWidth()
          : this.adapter.innerWidth();
      }),
      (e.prototype.destroy = function () {
        var t = [];
        for (var e in this.waypoints)
          for (var n in this.waypoints[e]) t.push(this.waypoints[e][n]);
        for (var i = 0, o = t.length; o > i; i++) t[i].destroy();
      }),
      (e.prototype.refresh = function () {
        var t,
          e = this.element == this.element.window,
          n = e ? void 0 : this.adapter.offset(),
          i = {};
        for (var r in (this.handleScroll(),
        (t = {
          horizontal: {
            contextOffset: e ? 0 : n.left,
            contextScroll: e ? 0 : this.oldScroll.x,
            contextDimension: this.innerWidth(),
            oldScroll: this.oldScroll.x,
            forward: "right",
            backward: "left",
            offsetProp: "left",
          },
          vertical: {
            contextOffset: e ? 0 : n.top,
            contextScroll: e ? 0 : this.oldScroll.y,
            contextDimension: this.innerHeight(),
            oldScroll: this.oldScroll.y,
            forward: "down",
            backward: "up",
            offsetProp: "top",
          },
        }))) {
          var s = t[r];
          for (var a in this.waypoints[r]) {
            var l,
              c,
              u,
              h,
              d = this.waypoints[r][a],
              f = d.options.offset,
              p = d.triggerPoint,
              m = 0,
              g = null == p;
            (d.element !== d.element.window &&
              (m = d.adapter.offset()[s.offsetProp]),
              "function" == typeof f
                ? (f = f.apply(d))
                : "string" == typeof f &&
                  ((f = parseFloat(f)),
                  d.options.offset.indexOf("%") > -1 &&
                    (f = Math.ceil((s.contextDimension * f) / 100))),
              (l = s.contextScroll - s.contextOffset),
              (d.triggerPoint = m + l - f),
              (c = p < s.oldScroll),
              (u = d.triggerPoint >= s.oldScroll),
              (h = !c && !u),
              !g && c && u
                ? (d.queueTrigger(s.backward), (i[d.group.id] = d.group))
                : ((!g && h) || (g && s.oldScroll >= d.triggerPoint)) &&
                  (d.queueTrigger(s.forward), (i[d.group.id] = d.group)));
          }
        }
        return (
          o.requestAnimationFrame(function () {
            for (var t in i) i[t].flushTriggers();
          }),
          this
        );
      }),
      (e.findOrCreateByElement = function (t) {
        return e.findByElement(t) || new e(t);
      }),
      (e.refreshAll = function () {
        for (var t in i) i[t].refresh();
      }),
      (e.findByElement = function (t) {
        return i[t.waypointContextKey];
      }),
      (window.onload = function () {
        (r && r(), e.refreshAll());
      }),
      (o.requestAnimationFrame = function (e) {
        (
          window.requestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          t
        ).call(window, e);
      }),
      (o.Context = e));
  })(),
  (function () {
    function t(t, e) {
      return t.triggerPoint - e.triggerPoint;
    }
    function e(t, e) {
      return e.triggerPoint - t.triggerPoint;
    }
    function n(t) {
      ((this.name = t.name),
        (this.axis = t.axis),
        (this.id = this.name + "-" + this.axis),
        (this.waypoints = []),
        this.clearTriggerQueues(),
        (i[this.axis][this.name] = this));
    }
    var i = { vertical: {}, horizontal: {} },
      o = window.Waypoint;
    ((n.prototype.add = function (t) {
      this.waypoints.push(t);
    }),
      (n.prototype.clearTriggerQueues = function () {
        this.triggerQueues = { up: [], down: [], left: [], right: [] };
      }),
      (n.prototype.flushTriggers = function () {
        for (var n in this.triggerQueues) {
          var i = this.triggerQueues[n],
            o = "up" === n || "left" === n;
          i.sort(o ? e : t);
          for (var r = 0, s = i.length; s > r; r += 1) {
            var a = i[r];
            (a.options.continuous || r === i.length - 1) && a.trigger([n]);
          }
        }
        this.clearTriggerQueues();
      }),
      (n.prototype.next = function (e) {
        this.waypoints.sort(t);
        var n = o.Adapter.inArray(e, this.waypoints);
        return n === this.waypoints.length - 1 ? null : this.waypoints[n + 1];
      }),
      (n.prototype.previous = function (e) {
        this.waypoints.sort(t);
        var n = o.Adapter.inArray(e, this.waypoints);
        return n ? this.waypoints[n - 1] : null;
      }),
      (n.prototype.queueTrigger = function (t, e) {
        this.triggerQueues[e].push(t);
      }),
      (n.prototype.remove = function (t) {
        var e = o.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1);
      }),
      (n.prototype.first = function () {
        return this.waypoints[0];
      }),
      (n.prototype.last = function () {
        return this.waypoints[this.waypoints.length - 1];
      }),
      (n.findOrCreate = function (t) {
        return i[t.axis][t.name] || new n(t);
      }),
      (o.Group = n));
  })(),
  (function () {
    function t(t) {
      this.$element = e(t);
    }
    var e = window.jQuery,
      n = window.Waypoint;
    (e.each(
      [
        "innerHeight",
        "innerWidth",
        "off",
        "offset",
        "on",
        "outerHeight",
        "outerWidth",
        "scrollLeft",
        "scrollTop",
      ],
      function (e, n) {
        t.prototype[n] = function () {
          var t = Array.prototype.slice.call(arguments);
          return this.$element[n].apply(this.$element, t);
        };
      },
    ),
      e.each(["extend", "inArray", "isEmptyObject"], function (n, i) {
        t[i] = e[i];
      }),
      n.adapters.push({ name: "jquery", Adapter: t }),
      (n.Adapter = t));
  })(),
  (function () {
    function t(t) {
      return function () {
        var n = [],
          i = arguments[0];
        return (
          t.isFunction(arguments[0]) &&
            ((i = t.extend({}, arguments[1])).handler = arguments[0]),
          this.each(function () {
            var o = t.extend({}, i, { element: this });
            ("string" == typeof o.context &&
              (o.context = t(this).closest(o.context)[0]),
              n.push(new e(o)));
          }),
          n
        );
      };
    }
    var e = window.Waypoint;
    (window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
      window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto)));
  })(),
  (function () {
    function t(i) {
      ((this.options = e.extend({}, t.defaults, i)),
        (this.container = this.options.element),
        "auto" !== this.options.container &&
          (this.container = this.options.container),
        (this.$container = e(this.container)),
        (this.$more = e(this.options.more)),
        this.$more.length &&
          (this.setupHandler(), (this.waypoint = new n(this.options))));
    }
    var e = window.jQuery,
      n = window.Waypoint;
    ((t.prototype.setupHandler = function () {
      this.options.handler = e.proxy(function () {
        (this.options.onBeforePageLoad(),
          this.destroy(),
          this.$container.addClass(this.options.loadingClass),
          e.get(
            e(this.options.more).attr("href"),
            e.proxy(function (t) {
              var i = e(e.parseHTML(t)),
                o = i.find(this.options.more),
                r = i.find(this.options.items);
              (r.length || (r = i.filter(this.options.items)),
                this.$container.append(r),
                this.$container.removeClass(this.options.loadingClass),
                o.length || (o = i.filter(this.options.more)),
                o.length
                  ? (this.$more.replaceWith(o),
                    (this.$more = o),
                    (this.waypoint = new n(this.options)))
                  : this.$more.remove(),
                this.options.onAfterPageLoad(r));
            }, this),
          ));
      }, this);
    }),
      (t.prototype.destroy = function () {
        this.waypoint && this.waypoint.destroy();
      }),
      (t.defaults = {
        container: "auto",
        items: ".infinite-item",
        more: ".infinite-more-link",
        offset: "bottom-in-view",
        loadingClass: "infinite-loading",
        onBeforePageLoad: e.noop,
        onAfterPageLoad: e.noop,
      }),
      (n.Infinite = t));
  })(),
  (function (t) {
    "function" == typeof define && define.amd
      ? define(["jquery"], t)
      : "object" == typeof module && module.exports
        ? (module.exports = t(require("jquery")))
        : t(jQuery);
  })(function (t) {
    var e = Array.prototype.slice,
      n = Array.prototype.splice,
      i = {
        topSpacing: 0,
        bottomSpacing: 0,
        className: "is-sticky",
        wrapperClassName: "sticky-wrapper",
        center: !1,
        getWidthFrom: "",
        widthFromWrapper: !0,
        responsiveWidth: !1,
        zIndex: "inherit",
      },
      o = t(window),
      r = t(document),
      s = [],
      a = o.height(),
      l = function () {
        for (
          var e = o.scrollTop(),
            n = r.height(),
            i = n - a,
            l = e > i ? i - e : 0,
            c = 0,
            u = s.length;
          c < u;
          c++
        ) {
          var h = s[c],
            d = h.stickyWrapper.offset().top - h.topSpacing - l;
          if (
            (h.stickyWrapper.css("height", h.stickyElement.outerHeight()),
            e <= d)
          )
            null !== h.currentTop &&
              (h.stickyElement.css({
                width: "",
                position: "",
                top: "",
                "z-index": "",
              }),
              h.stickyElement.parent().removeClass(h.className),
              h.stickyElement.trigger("sticky-end", [h]),
              (h.currentTop = null));
          else {
            var f,
              p =
                n -
                h.stickyElement.outerHeight() -
                h.topSpacing -
                h.bottomSpacing -
                e -
                l;
            (p < 0 ? (p += h.topSpacing) : (p = h.topSpacing),
              h.currentTop !== p &&
                (h.getWidthFrom
                  ? ((padding =
                      h.stickyElement.innerWidth() - h.stickyElement.width()),
                    (f = t(h.getWidthFrom).width() - padding || null))
                  : h.widthFromWrapper && (f = h.stickyWrapper.width()),
                null == f && (f = h.stickyElement.width()),
                h.stickyElement
                  .css("width", f)
                  .css("position", "fixed")
                  .css("top", p)
                  .css("z-index", h.zIndex),
                h.stickyElement.parent().addClass(h.className),
                null === h.currentTop
                  ? h.stickyElement.trigger("sticky-start", [h])
                  : h.stickyElement.trigger("sticky-update", [h]),
                (h.currentTop === h.topSpacing && h.currentTop > p) ||
                (null === h.currentTop && p < h.topSpacing)
                  ? h.stickyElement.trigger("sticky-bottom-reached", [h])
                  : null !== h.currentTop &&
                    p === h.topSpacing &&
                    h.currentTop < p &&
                    h.stickyElement.trigger("sticky-bottom-unreached", [h]),
                (h.currentTop = p)));
            var m = h.stickyWrapper.parent();
            h.stickyElement.offset().top + h.stickyElement.outerHeight() >=
              m.offset().top + m.outerHeight() &&
            h.stickyElement.offset().top <= h.topSpacing
              ? h.stickyElement
                  .css("position", "absolute")
                  .css("top", "")
                  .css("bottom", 0)
                  .css("z-index", "")
              : h.stickyElement
                  .css("position", "fixed")
                  .css("top", p)
                  .css("bottom", "")
                  .css("z-index", h.zIndex);
          }
        }
      },
      c = function () {
        a = o.height();
        for (var e = 0, n = s.length; e < n; e++) {
          var i = s[e],
            r = null;
          (i.getWidthFrom
            ? i.responsiveWidth && (r = t(i.getWidthFrom).width())
            : i.widthFromWrapper && (r = i.stickyWrapper.width()),
            null != r && i.stickyElement.css("width", r));
        }
      },
      u = {
        init: function (e) {
          return this.each(function () {
            var n = t.extend({}, i, e),
              o = t(this),
              r = o.attr("id"),
              a = r ? r + "-" + i.wrapperClassName : i.wrapperClassName,
              l = t("<div></div>").attr("id", a).addClass(n.wrapperClassName);
            o.wrapAll(function () {
              if (0 == t(this).parent("#" + a).length) return l;
            });
            var c = o.parent();
            (n.center &&
              c.css({
                width: o.outerWidth(),
                marginLeft: "auto",
                marginRight: "auto",
              }),
              "right" === o.css("float") &&
                o.css({ float: "none" }).parent().css({ float: "right" }),
              (n.stickyElement = o),
              (n.stickyWrapper = c),
              (n.currentTop = null),
              s.push(n),
              u.setWrapperHeight(this),
              u.setupChangeListeners(this));
          });
        },
        setWrapperHeight: function (e) {
          var n = t(e),
            i = n.parent();
          i && i.css("height", n.outerHeight());
        },
        setupChangeListeners: function (t) {
          window.MutationObserver
            ? new window.MutationObserver(function (e) {
                (e[0].addedNodes.length || e[0].removedNodes.length) &&
                  u.setWrapperHeight(t);
              }).observe(t, { subtree: !0, childList: !0 })
            : window.addEventListener
              ? (t.addEventListener(
                  "DOMNodeInserted",
                  function () {
                    u.setWrapperHeight(t);
                  },
                  !1,
                ),
                t.addEventListener(
                  "DOMNodeRemoved",
                  function () {
                    u.setWrapperHeight(t);
                  },
                  !1,
                ))
              : window.attachEvent &&
                (t.attachEvent("onDOMNodeInserted", function () {
                  u.setWrapperHeight(t);
                }),
                t.attachEvent("onDOMNodeRemoved", function () {
                  u.setWrapperHeight(t);
                }));
        },
        update: l,
        unstick: function (e) {
          return this.each(function () {
            for (var e = t(this), i = -1, o = s.length; o-- > 0; )
              s[o].stickyElement.get(0) === this && (n.call(s, o, 1), (i = o));
            -1 !== i &&
              (e.unwrap(),
              e.css({
                width: "",
                position: "",
                top: "",
                float: "",
                "z-index": "",
              }));
          });
        },
      };
    (window.addEventListener
      ? (window.addEventListener("scroll", l, !1),
        window.addEventListener("resize", c, !1))
      : window.attachEvent &&
        (window.attachEvent("onscroll", l), window.attachEvent("onresize", c)),
      (t.fn.sticky = function (n) {
        return u[n]
          ? u[n].apply(this, e.call(arguments, 1))
          : "object" != typeof n && n
            ? void t.error("Method " + n + " does not exist on jQuery.sticky")
            : u.init.apply(this, arguments);
      }),
      (t.fn.unstick = function (n) {
        return u[n]
          ? u[n].apply(this, e.call(arguments, 1))
          : "object" != typeof n && n
            ? void t.error("Method " + n + " does not exist on jQuery.sticky")
            : u.unstick.apply(this, arguments);
      }),
      t(function () {
        setTimeout(l, 0);
      }));
  }),
  (this.Shopify = this.Shopify || {}),
  (this.Shopify.theme = this.Shopify.theme || {}),
  (this.Shopify.theme.ajaxCart = (function (t) {
    function e() {
      return JSON.parse(
        JSON.stringify({
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;",
          },
        }),
      );
    }
    function n(t, e) {
      return fetch(t, e).then(function (t) {
        if (!t.ok) throw t;
        return t.json();
      });
    }
    function i() {
      return n("/cart.js", e());
    }
    function o(t, i) {
      var o = e();
      return (
        (i = i || {}),
        (o.method = "POST"),
        (o.body = JSON.stringify({
          line: t,
          quantity: i.quantity,
          properties: i.properties,
        })),
        n("/cart/change.js", o)
      );
    }
    function r(t) {
      var i = e();
      return (
        (i.method = "POST"),
        (i.body = JSON.stringify(t)),
        n("/cart/update.js", i)
      );
    }
    function s(t) {
      if ("string" != typeof t || 2 !== t.split(":").length)
        throw new TypeError(
          "Theme Cart: Provided key value is not a string with the format xxx:xxx",
        );
    }
    function a(t) {
      return (
        s(t),
        i().then(function (e) {
          var n = -1;
          return (
            e.items.forEach(function (e, i) {
              n = e.key === t ? i + 1 : n;
            }),
            -1 === n
              ? Promise.reject(
                  new Error(
                    "Theme Cart: Unable to match line item with provided key",
                  ),
                )
              : n
          );
        })
      );
    }
    function l() {
      return i().then(function (t) {
        return t.attributes;
      });
    }
    function c(t) {
      return r({ attributes: t });
    }
    return (
      (t.getState = function () {
        return i();
      }),
      (t.getItemIndex = a),
      (t.getItem = function (t) {
        return (
          s(t),
          i().then(function (e) {
            var n = null;
            return (
              e.items.forEach(function (e) {
                n = e.key === t ? e : n;
              }),
              null === n
                ? Promise.reject(
                    new Error(
                      "Theme Cart: Unable to match line item with provided key",
                    ),
                  )
                : n
            );
          })
        );
      }),
      (t.addItem = function (t, i) {
        return (
          (i = i || {}),
          (function (t) {
            if ("number" != typeof t)
              throw new TypeError("Theme Cart: Variant ID must be a number");
          })(t),
          (o = t),
          (r = i.quantity),
          (s = i.properties),
          ((a = e()).method = "POST"),
          (a.body = JSON.stringify({ id: o, quantity: r, properties: s })),
          n("/cart/add.js", a)
        );
        var o, r, s, a;
      }),
      (t.updateItem = function (t, e) {
        return (
          s(t),
          (function (t) {
            if ("object" != typeof t)
              throw new TypeError("Theme Cart: Options must be an object");
            if (void 0 === t.quantity && void 0 === t.properties)
              throw new Error(
                "Theme Cart: You muse define a value for quantity or properties",
              );
            (void 0 !== t.quantity &&
              (function (t) {
                if ("number" != typeof t)
                  throw new TypeError(
                    "Theme Cart: An object which specifies a quantity or properties value is required",
                  );
              })(t.quantity),
              void 0 !== t.properties &&
                (function (t) {
                  if ("object" != typeof t)
                    throw new TypeError(
                      "Theme Cart: Properties must be an object",
                    );
                })(t.properties));
          })(e),
          a(t).then(function (t) {
            return o(t, e);
          })
        );
      }),
      (t.removeItem = function (t) {
        return (
          s(t),
          a(t).then(function (t) {
            return o(t, { quantity: 0 });
          })
        );
      }),
      (t.clearItems = function () {
        return (((t = e()).method = "POST"), n("/cart/clear.js", t));
        var t;
      }),
      (t.getAttributes = l),
      (t.updateAttributes = c),
      (t.clearAttributes = function () {
        return l().then(function (t) {
          for (var e in t) t[e] = "";
          return c(t);
        });
      }),
      (t.getNote = function () {
        return i().then(function (t) {
          return t.note;
        });
      }),
      (t.updateNote = function (t) {
        return r({ note: t });
      }),
      (t.clearNote = function () {
        return r({ note: "" });
      }),
      (t.getShippingRates = function () {
        return n("/cart/shipping_rates.json", e());
      }),
      t
    );
  })({})),
  (function (t) {
    var e;
    if (
      ("function" == typeof define && define.amd && (define(t), (e = !0)),
      "object" == typeof exports && ((module.exports = t()), (e = !0)),
      !e)
    ) {
      var n = window.Cookies,
        i = (window.Cookies = t());
      i.noConflict = function () {
        return ((window.Cookies = n), i);
      };
    }
  })(function () {
    function t() {
      for (var t = 0, e = {}; t < arguments.length; t++) {
        var n = arguments[t];
        for (var i in n) e[i] = n[i];
      }
      return e;
    }
    function e(t) {
      return t.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    return (function n(i) {
      function o() {}
      function r(e, n, r) {
        if ("undefined" != typeof document) {
          ("number" == typeof (r = t({ path: "/" }, o.defaults, r)).expires &&
            (r.expires = new Date(1 * new Date() + 864e5 * r.expires)),
            (r.expires = r.expires ? r.expires.toUTCString() : ""));
          try {
            var s = JSON.stringify(n);
            /^[\{\[]/.test(s) && (n = s);
          } catch (t) {}
          ((n = i.write
            ? i.write(n, e)
            : encodeURIComponent(String(n)).replace(
                /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                decodeURIComponent,
              )),
            (e = encodeURIComponent(String(e))
              .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
              .replace(/[\(\)]/g, escape)));
          var a = "";
          for (var l in r)
            r[l] &&
              ((a += "; " + l), !0 !== r[l] && (a += "=" + r[l].split(";")[0]));
          return (document.cookie = e + "=" + n + a);
        }
      }
      function s(t, n) {
        if ("undefined" != typeof document) {
          for (
            var o = {},
              r = document.cookie ? document.cookie.split("; ") : [],
              s = 0;
            s < r.length;
            s++
          ) {
            var a = r[s].split("="),
              l = a.slice(1).join("=");
            n || '"' !== l.charAt(0) || (l = l.slice(1, -1));
            try {
              var c = e(a[0]);
              if (((l = (i.read || i)(l, c) || e(l)), n))
                try {
                  l = JSON.parse(l);
                } catch (t) {}
              if (((o[c] = l), t === c)) break;
            } catch (t) {}
          }
          return t ? o[t] : o;
        }
      }
      return (
        (o.set = r),
        (o.get = function (t) {
          return s(t, !1);
        }),
        (o.getJSON = function (t) {
          return s(t, !0);
        }),
        (o.remove = function (e, n) {
          r(e, "", t(n, { expires: -1 }));
        }),
        (o.defaults = {}),
        (o.withConverter = n),
        o
      );
    })(function () {});
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("jquery-bridget/jquery-bridget", ["jquery"], function (n) {
          return e(t, n);
        })
      : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("jquery")))
        : (t.jQueryBridget = e(t, t.jQuery));
  })(window, function (t, e) {
    function n(n, r, a) {
      (a = a || e || t.jQuery) &&
        (r.prototype.option ||
          (r.prototype.option = function (t) {
            a.isPlainObject(t) &&
              (this.options = a.extend(!0, this.options, t));
          }),
        (a.fn[n] = function (t) {
          return "string" == typeof t
            ? (function (t, e, i) {
                var o,
                  r = "$()." + n + '("' + e + '")';
                return (
                  t.each(function (t, l) {
                    var c = a.data(l, n);
                    if (c) {
                      var u = c[e];
                      if (u && "_" != e.charAt(0)) {
                        var h = u.apply(c, i);
                        o = void 0 === o ? h : o;
                      } else s(r + " is not a valid method");
                    } else
                      s(n + " not initialized. Cannot call methods, i.e. " + r);
                  }),
                  void 0 !== o ? o : t
                );
              })(this, t, o.call(arguments, 1))
            : ((function (t, e) {
                t.each(function (t, i) {
                  var o = a.data(i, n);
                  o
                    ? (o.option(e), o._init())
                    : ((o = new r(i, e)), a.data(i, n, o));
                });
              })(this, t),
              this);
        }),
        i(a));
    }
    function i(t) {
      !t || (t && t.bridget) || (t.bridget = n);
    }
    var o = Array.prototype.slice,
      r = t.console,
      s =
        void 0 === r
          ? function () {}
          : function (t) {
              r.error(t);
            };
    return (i(e || t.jQuery), n);
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", e)
      : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.EvEmitter = e());
  })("undefined" != typeof window ? window : this, function () {
    function t() {}
    var e = t.prototype;
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var n = (this._events = this._events || {}),
            i = (n[t] = n[t] || []);
          return (-1 == i.indexOf(e) && i.push(e), this);
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var n = (this._onceEvents = this._onceEvents || {});
          return (((n[t] = n[t] || {})[e] = !0), this);
        }
      }),
      (e.off = function (t, e) {
        var n = this._events && this._events[t];
        if (n && n.length) {
          var i = n.indexOf(e);
          return (-1 != i && n.splice(i, 1), this);
        }
      }),
      (e.emitEvent = function (t, e) {
        var n = this._events && this._events[t];
        if (n && n.length) {
          ((n = n.slice(0)), (e = e || []));
          for (
            var i = this._onceEvents && this._onceEvents[t], o = 0;
            o < n.length;
            o++
          ) {
            var r = n[o];
            (i && i[r] && (this.off(t, r), delete i[r]), r.apply(this, e));
          }
          return this;
        }
      }),
      (e.allOff = function () {
        (delete this._events, delete this._onceEvents);
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("get-size/get-size", e)
      : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.getSize = e());
  })(window, function () {
    function t(t) {
      var e = parseFloat(t);
      return -1 == t.indexOf("%") && !isNaN(e) && e;
    }
    function e(t) {
      var e = getComputedStyle(t);
      return (
        e ||
          r(
            "Style returned " +
              e +
              ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1",
          ),
        e
      );
    }
    function n() {
      if (!l) {
        l = !0;
        var n = document.createElement("div");
        ((n.style.width = "200px"),
          (n.style.padding = "1px 2px 3px 4px"),
          (n.style.borderStyle = "solid"),
          (n.style.borderWidth = "1px 2px 3px 4px"),
          (n.style.boxSizing = "border-box"));
        var r = document.body || document.documentElement;
        r.appendChild(n);
        var s = e(n);
        ((o = 200 == Math.round(t(s.width))),
          (i.isBoxSizeOuter = o),
          r.removeChild(n));
      }
    }
    function i(i) {
      if (
        (n(),
        "string" == typeof i && (i = document.querySelector(i)),
        i && "object" == typeof i && i.nodeType)
      ) {
        var r = e(i);
        if ("none" == r.display)
          return (function () {
            for (
              var t = {
                  width: 0,
                  height: 0,
                  innerWidth: 0,
                  innerHeight: 0,
                  outerWidth: 0,
                  outerHeight: 0,
                },
                e = 0;
              e < a;
              e++
            )
              t[s[e]] = 0;
            return t;
          })();
        var l = {};
        ((l.width = i.offsetWidth), (l.height = i.offsetHeight));
        for (
          var c = (l.isBorderBox = "border-box" == r.boxSizing), u = 0;
          u < a;
          u++
        ) {
          var h = s[u],
            d = r[h],
            f = parseFloat(d);
          l[h] = isNaN(f) ? 0 : f;
        }
        var p = l.paddingLeft + l.paddingRight,
          m = l.paddingTop + l.paddingBottom,
          g = l.marginLeft + l.marginRight,
          v = l.marginTop + l.marginBottom,
          y = l.borderLeftWidth + l.borderRightWidth,
          b = l.borderTopWidth + l.borderBottomWidth,
          w = c && o,
          x = t(r.width);
        !1 !== x && (l.width = x + (w ? 0 : p + y));
        var S = t(r.height);
        return (
          !1 !== S && (l.height = S + (w ? 0 : m + b)),
          (l.innerWidth = l.width - (p + y)),
          (l.innerHeight = l.height - (m + b)),
          (l.outerWidth = l.width + g),
          (l.outerHeight = l.height + v),
          l
        );
      }
    }
    var o,
      r =
        "undefined" == typeof console
          ? function () {}
          : function (t) {
              console.error(t);
            },
      s = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth",
      ],
      a = s.length,
      l = !1;
    return i;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("desandro-matches-selector/matches-selector", e)
      : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.matchesSelector = e());
  })(window, function () {
    var t = (function () {
      var t = window.Element.prototype;
      if (t.matches) return "matches";
      if (t.matchesSelector) return "matchesSelector";
      for (var e = ["webkit", "moz", "ms", "o"], n = 0; n < e.length; n++) {
        var i = e[n] + "MatchesSelector";
        if (t[i]) return i;
      }
    })();
    return function (e, n) {
      return e[t](n);
    };
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "fizzy-ui-utils/utils",
          ["desandro-matches-selector/matches-selector"],
          function (n) {
            return e(t, n);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("desandro-matches-selector")))
        : (t.fizzyUIUtils = e(t, t.matchesSelector));
  })(window, function (t, e) {
    var n = {
        extend: function (t, e) {
          for (var n in e) t[n] = e[n];
          return t;
        },
        modulo: function (t, e) {
          return ((t % e) + e) % e;
        },
      },
      i = Array.prototype.slice;
    ((n.makeArray = function (t) {
      return Array.isArray(t)
        ? t
        : null == t
          ? []
          : "object" == typeof t && "number" == typeof t.length
            ? i.call(t)
            : [t];
    }),
      (n.removeFrom = function (t, e) {
        var n = t.indexOf(e);
        -1 != n && t.splice(n, 1);
      }),
      (n.getParent = function (t, n) {
        for (; t.parentNode && t != document.body; )
          if (((t = t.parentNode), e(t, n))) return t;
      }),
      (n.getQueryElement = function (t) {
        return "string" == typeof t ? document.querySelector(t) : t;
      }),
      (n.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (n.filterFindElements = function (t, i) {
        t = n.makeArray(t);
        var o = [];
        return (
          t.forEach(function (t) {
            if (t instanceof HTMLElement) {
              if (!i) return void o.push(t);
              e(t, i) && o.push(t);
              for (var n = t.querySelectorAll(i), r = 0; r < n.length; r++)
                o.push(n[r]);
            }
          }),
          o
        );
      }),
      (n.debounceMethod = function (t, e, n) {
        n = n || 100;
        var i = t.prototype[e],
          o = e + "Timeout";
        t.prototype[e] = function () {
          var t = this[o];
          clearTimeout(t);
          var e = arguments,
            r = this;
          this[o] = setTimeout(function () {
            (i.apply(r, e), delete r[o]);
          }, n);
        };
      }),
      (n.docReady = function (t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e
          ? setTimeout(t)
          : document.addEventListener("DOMContentLoaded", t);
      }),
      (n.toDashed = function (t) {
        return t
          .replace(/(.)([A-Z])/g, function (t, e, n) {
            return e + "-" + n;
          })
          .toLowerCase();
      }));
    var o = t.console;
    return (
      (n.htmlInit = function (e, i) {
        n.docReady(function () {
          var r = n.toDashed(i),
            s = "data-" + r,
            a = document.querySelectorAll("[" + s + "]"),
            l = document.querySelectorAll(".js-" + r),
            c = n.makeArray(a).concat(n.makeArray(l)),
            u = s + "-options",
            h = t.jQuery;
          c.forEach(function (t) {
            var n,
              r = t.getAttribute(s) || t.getAttribute(u);
            try {
              n = r && JSON.parse(r);
            } catch (e) {
              return void (
                o &&
                o.error("Error parsing " + s + " on " + t.className + ": " + e)
              );
            }
            var a = new e(t, n);
            h && h.data(t, i, a);
          });
        });
      }),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "outlayer/item",
          ["ev-emitter/ev-emitter", "get-size/get-size"],
          e,
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(require("ev-emitter"), require("get-size")))
        : ((t.Outlayer = {}), (t.Outlayer.Item = e(t.EvEmitter, t.getSize)));
  })(window, function (t, e) {
    function n(t, e) {
      t &&
        ((this.element = t),
        (this.layout = e),
        (this.position = { x: 0, y: 0 }),
        this._create());
    }
    var i = document.documentElement.style,
      o = "string" == typeof i.transition ? "transition" : "WebkitTransition",
      r = "string" == typeof i.transform ? "transform" : "WebkitTransform",
      s = {
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend",
      }[o],
      a = {
        transform: r,
        transition: o,
        transitionDuration: o + "Duration",
        transitionProperty: o + "Property",
        transitionDelay: o + "Delay",
      },
      l = (n.prototype = Object.create(t.prototype));
    ((l.constructor = n),
      (l._create = function () {
        ((this._transn = { ingProperties: {}, clean: {}, onEnd: {} }),
          this.css({ position: "absolute" }));
      }),
      (l.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (l.getSize = function () {
        this.size = e(this.element);
      }),
      (l.css = function (t) {
        var e = this.element.style;
        for (var n in t) {
          e[a[n] || n] = t[n];
        }
      }),
      (l.getPosition = function () {
        var t = getComputedStyle(this.element),
          e = this.layout._getOption("originLeft"),
          n = this.layout._getOption("originTop"),
          i = t[e ? "left" : "right"],
          o = t[n ? "top" : "bottom"],
          r = parseFloat(i),
          s = parseFloat(o),
          a = this.layout.size;
        (-1 != i.indexOf("%") && (r = (r / 100) * a.width),
          -1 != o.indexOf("%") && (s = (s / 100) * a.height),
          (r = isNaN(r) ? 0 : r),
          (s = isNaN(s) ? 0 : s),
          (r -= e ? a.paddingLeft : a.paddingRight),
          (s -= n ? a.paddingTop : a.paddingBottom),
          (this.position.x = r),
          (this.position.y = s));
      }),
      (l.layoutPosition = function () {
        var t = this.layout.size,
          e = {},
          n = this.layout._getOption("originLeft"),
          i = this.layout._getOption("originTop"),
          o = n ? "paddingLeft" : "paddingRight",
          r = n ? "left" : "right",
          s = n ? "right" : "left",
          a = this.position.x + t[o];
        ((e[r] = this.getXValue(a)), (e[s] = ""));
        var l = i ? "paddingTop" : "paddingBottom",
          c = i ? "top" : "bottom",
          u = i ? "bottom" : "top",
          h = this.position.y + t[l];
        ((e[c] = this.getYValue(h)),
          (e[u] = ""),
          this.css(e),
          this.emitEvent("layout", [this]));
      }),
      (l.getXValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e
          ? (t / this.layout.size.width) * 100 + "%"
          : t + "px";
      }),
      (l.getYValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e
          ? (t / this.layout.size.height) * 100 + "%"
          : t + "px";
      }),
      (l._transitionTo = function (t, e) {
        this.getPosition();
        var n = this.position.x,
          i = this.position.y,
          o = t == this.position.x && e == this.position.y;
        if ((this.setPosition(t, e), !o || this.isTransitioning)) {
          var r = t - n,
            s = e - i,
            a = {};
          ((a.transform = this.getTranslate(r, s)),
            this.transition({
              to: a,
              onTransitionEnd: { transform: this.layoutPosition },
              isCleaning: !0,
            }));
        } else this.layoutPosition();
      }),
      (l.getTranslate = function (t, e) {
        return (
          "translate3d(" +
          (t = this.layout._getOption("originLeft") ? t : -t) +
          "px, " +
          (e = this.layout._getOption("originTop") ? e : -e) +
          "px, 0)"
        );
      }),
      (l.goTo = function (t, e) {
        (this.setPosition(t, e), this.layoutPosition());
      }),
      (l.moveTo = l._transitionTo),
      (l.setPosition = function (t, e) {
        ((this.position.x = parseFloat(t)), (this.position.y = parseFloat(e)));
      }),
      (l._nonTransition = function (t) {
        for (var e in (this.css(t.to),
        t.isCleaning && this._removeStyles(t.to),
        t.onTransitionEnd))
          t.onTransitionEnd[e].call(this);
      }),
      (l.transition = function (t) {
        if (parseFloat(this.layout.options.transitionDuration)) {
          var e = this._transn;
          for (var n in t.onTransitionEnd) e.onEnd[n] = t.onTransitionEnd[n];
          for (n in t.to)
            ((e.ingProperties[n] = !0), t.isCleaning && (e.clean[n] = !0));
          if (t.from) {
            this.css(t.from);
            this.element.offsetHeight;
            null;
          }
          (this.enableTransition(t.to),
            this.css(t.to),
            (this.isTransitioning = !0));
        } else this._nonTransition(t);
      }));
    var c =
      "opacity," +
      (function (t) {
        return t.replace(/([A-Z])/g, function (t) {
          return "-" + t.toLowerCase();
        });
      })(r);
    ((l.enableTransition = function () {
      if (!this.isTransitioning) {
        var t = this.layout.options.transitionDuration;
        ((t = "number" == typeof t ? t + "ms" : t),
          this.css({
            transitionProperty: c,
            transitionDuration: t,
            transitionDelay: this.staggerDelay || 0,
          }),
          this.element.addEventListener(s, this, !1));
      }
    }),
      (l.onwebkitTransitionEnd = function (t) {
        this.ontransitionend(t);
      }),
      (l.onotransitionend = function (t) {
        this.ontransitionend(t);
      }));
    var u = { "-webkit-transform": "transform" };
    ((l.ontransitionend = function (t) {
      if (t.target === this.element) {
        var e = this._transn,
          n = u[t.propertyName] || t.propertyName;
        if (
          (delete e.ingProperties[n],
          (function (t) {
            for (var e in t) return !1;
            return !0;
          })(e.ingProperties) && this.disableTransition(),
          n in e.clean &&
            ((this.element.style[t.propertyName] = ""), delete e.clean[n]),
          n in e.onEnd)
        )
          (e.onEnd[n].call(this), delete e.onEnd[n]);
        this.emitEvent("transitionEnd", [this]);
      }
    }),
      (l.disableTransition = function () {
        (this.removeTransitionStyles(),
          this.element.removeEventListener(s, this, !1),
          (this.isTransitioning = !1));
      }),
      (l._removeStyles = function (t) {
        var e = {};
        for (var n in t) e[n] = "";
        this.css(e);
      }));
    var h = {
      transitionProperty: "",
      transitionDuration: "",
      transitionDelay: "",
    };
    return (
      (l.removeTransitionStyles = function () {
        this.css(h);
      }),
      (l.stagger = function (t) {
        ((t = isNaN(t) ? 0 : t), (this.staggerDelay = t + "ms"));
      }),
      (l.removeElem = function () {
        (this.element.parentNode.removeChild(this.element),
          this.css({ display: "" }),
          this.emitEvent("remove", [this]));
      }),
      (l.remove = function () {
        return o && parseFloat(this.layout.options.transitionDuration)
          ? (this.once("transitionEnd", function () {
              this.removeElem();
            }),
            void this.hide())
          : void this.removeElem();
      }),
      (l.reveal = function () {
        (delete this.isHidden, this.css({ display: "" }));
        var t = this.layout.options,
          e = {};
        ((e[this.getHideRevealTransitionEndProperty("visibleStyle")] =
          this.onRevealTransitionEnd),
          this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e,
          }));
      }),
      (l.onRevealTransitionEnd = function () {
        this.isHidden || this.emitEvent("reveal");
      }),
      (l.getHideRevealTransitionEndProperty = function (t) {
        var e = this.layout.options[t];
        if (e.opacity) return "opacity";
        for (var n in e) return n;
      }),
      (l.hide = function () {
        ((this.isHidden = !0), this.css({ display: "" }));
        var t = this.layout.options,
          e = {};
        ((e[this.getHideRevealTransitionEndProperty("hiddenStyle")] =
          this.onHideTransitionEnd),
          this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e,
          }));
      }),
      (l.onHideTransitionEnd = function () {
        this.isHidden &&
          (this.css({ display: "none" }), this.emitEvent("hide"));
      }),
      (l.destroy = function () {
        this.css({
          position: "",
          left: "",
          right: "",
          top: "",
          bottom: "",
          transition: "",
          transform: "",
        });
      }),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "outlayer/outlayer",
          [
            "ev-emitter/ev-emitter",
            "get-size/get-size",
            "fizzy-ui-utils/utils",
            "./item",
          ],
          function (n, i, o, r) {
            return e(t, n, i, o, r);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(
            t,
            require("ev-emitter"),
            require("get-size"),
            require("fizzy-ui-utils"),
            require("./item"),
          ))
        : (t.Outlayer = e(
            t,
            t.EvEmitter,
            t.getSize,
            t.fizzyUIUtils,
            t.Outlayer.Item,
          ));
  })(window, function (t, e, n, i, o) {
    function r(t, e) {
      var n = i.getQueryElement(t);
      if (n) {
        ((this.element = n),
          l && (this.$element = l(this.element)),
          (this.options = i.extend({}, this.constructor.defaults)),
          this.option(e));
        var o = ++u;
        ((this.element.outlayerGUID = o),
          (h[o] = this),
          this._create(),
          this._getOption("initLayout") && this.layout());
      } else
        a &&
          a.error(
            "Bad element for " + this.constructor.namespace + ": " + (n || t),
          );
    }
    function s(t) {
      function e() {
        t.apply(this, arguments);
      }
      return (
        (e.prototype = Object.create(t.prototype)),
        (e.prototype.constructor = e),
        e
      );
    }
    var a = t.console,
      l = t.jQuery,
      c = function () {},
      u = 0,
      h = {};
    ((r.namespace = "outlayer"),
      (r.Item = o),
      (r.defaults = {
        containerStyle: { position: "relative" },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
        visibleStyle: { opacity: 1, transform: "scale(1)" },
      }));
    var d = r.prototype;
    (i.extend(d, e.prototype),
      (d.option = function (t) {
        i.extend(this.options, t);
      }),
      (d._getOption = function (t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e]
          ? this.options[e]
          : this.options[t];
      }),
      (r.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer",
      }),
      (d._create = function () {
        (this.reloadItems(),
          (this.stamps = []),
          this.stamp(this.options.stamp),
          i.extend(this.element.style, this.options.containerStyle),
          this._getOption("resize") && this.bindResize());
      }),
      (d.reloadItems = function () {
        this.items = this._itemize(this.element.children);
      }),
      (d._itemize = function (t) {
        for (
          var e = this._filterFindItemElements(t),
            n = this.constructor.Item,
            i = [],
            o = 0;
          o < e.length;
          o++
        ) {
          var r = new n(e[o], this);
          i.push(r);
        }
        return i;
      }),
      (d._filterFindItemElements = function (t) {
        return i.filterFindElements(t, this.options.itemSelector);
      }),
      (d.getItemElements = function () {
        return this.items.map(function (t) {
          return t.element;
        });
      }),
      (d.layout = function () {
        (this._resetLayout(), this._manageStamps());
        var t = this._getOption("layoutInstant"),
          e = void 0 !== t ? t : !this._isLayoutInited;
        (this.layoutItems(this.items, e), (this._isLayoutInited = !0));
      }),
      (d._init = d.layout),
      (d._resetLayout = function () {
        this.getSize();
      }),
      (d.getSize = function () {
        this.size = n(this.element);
      }),
      (d._getMeasurement = function (t, e) {
        var i,
          o = this.options[t];
        o
          ? ("string" == typeof o
              ? (i = this.element.querySelector(o))
              : o instanceof HTMLElement && (i = o),
            (this[t] = i ? n(i)[e] : o))
          : (this[t] = 0);
      }),
      (d.layoutItems = function (t, e) {
        ((t = this._getItemsForLayout(t)),
          this._layoutItems(t, e),
          this._postLayout());
      }),
      (d._getItemsForLayout = function (t) {
        return t.filter(function (t) {
          return !t.isIgnored;
        });
      }),
      (d._layoutItems = function (t, e) {
        if ((this._emitCompleteOnItems("layout", t), t && t.length)) {
          var n = [];
          (t.forEach(function (t) {
            var i = this._getItemLayoutPosition(t);
            ((i.item = t), (i.isInstant = e || t.isLayoutInstant), n.push(i));
          }, this),
            this._processLayoutQueue(n));
        }
      }),
      (d._getItemLayoutPosition = function () {
        return { x: 0, y: 0 };
      }),
      (d._processLayoutQueue = function (t) {
        (this.updateStagger(),
          t.forEach(function (t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e);
          }, this));
      }),
      (d.updateStagger = function () {
        var t = this.options.stagger;
        return null == t
          ? void (this.stagger = 0)
          : ((this.stagger = (function (t) {
              if ("number" == typeof t) return t;
              var e = t.match(/(^\d*\.?\d*)(\w*)/),
                n = e && e[1],
                i = e && e[2];
              return n.length ? (n = parseFloat(n)) * (f[i] || 1) : 0;
            })(t)),
            this.stagger);
      }),
      (d._positionItem = function (t, e, n, i, o) {
        i ? t.goTo(e, n) : (t.stagger(o * this.stagger), t.moveTo(e, n));
      }),
      (d._postLayout = function () {
        this.resizeContainer();
      }),
      (d.resizeContainer = function () {
        if (this._getOption("resizeContainer")) {
          var t = this._getContainerSize();
          t &&
            (this._setContainerMeasure(t.width, !0),
            this._setContainerMeasure(t.height, !1));
        }
      }),
      (d._getContainerSize = c),
      (d._setContainerMeasure = function (t, e) {
        if (void 0 !== t) {
          var n = this.size;
          (n.isBorderBox &&
            (t += e
              ? n.paddingLeft +
                n.paddingRight +
                n.borderLeftWidth +
                n.borderRightWidth
              : n.paddingBottom +
                n.paddingTop +
                n.borderTopWidth +
                n.borderBottomWidth),
            (t = Math.max(t, 0)),
            (this.element.style[e ? "width" : "height"] = t + "px"));
        }
      }),
      (d._emitCompleteOnItems = function (t, e) {
        function n() {
          o.dispatchEvent(t + "Complete", null, [e]);
        }
        function i() {
          ++s == r && n();
        }
        var o = this,
          r = e.length;
        if (e && r) {
          var s = 0;
          e.forEach(function (e) {
            e.once(t, i);
          });
        } else n();
      }),
      (d.dispatchEvent = function (t, e, n) {
        var i = e ? [e].concat(n) : n;
        if ((this.emitEvent(t, i), l))
          if (((this.$element = this.$element || l(this.element)), e)) {
            var o = l.Event(e);
            ((o.type = t), this.$element.trigger(o, n));
          } else this.$element.trigger(t, n);
      }),
      (d.ignore = function (t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0);
      }),
      (d.unignore = function (t) {
        var e = this.getItem(t);
        e && delete e.isIgnored;
      }),
      (d.stamp = function (t) {
        (t = this._find(t)) &&
          ((this.stamps = this.stamps.concat(t)), t.forEach(this.ignore, this));
      }),
      (d.unstamp = function (t) {
        (t = this._find(t)) &&
          t.forEach(function (t) {
            (i.removeFrom(this.stamps, t), this.unignore(t));
          }, this);
      }),
      (d._find = function (t) {
        if (t)
          return (
            "string" == typeof t && (t = this.element.querySelectorAll(t)),
            i.makeArray(t)
          );
      }),
      (d._manageStamps = function () {
        this.stamps &&
          this.stamps.length &&
          (this._getBoundingRect(),
          this.stamps.forEach(this._manageStamp, this));
      }),
      (d._getBoundingRect = function () {
        var t = this.element.getBoundingClientRect(),
          e = this.size;
        this._boundingRect = {
          left: t.left + e.paddingLeft + e.borderLeftWidth,
          top: t.top + e.paddingTop + e.borderTopWidth,
          right: t.right - (e.paddingRight + e.borderRightWidth),
          bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth),
        };
      }),
      (d._manageStamp = c),
      (d._getElementOffset = function (t) {
        var e = t.getBoundingClientRect(),
          i = this._boundingRect,
          o = n(t);
        return {
          left: e.left - i.left - o.marginLeft,
          top: e.top - i.top - o.marginTop,
          right: i.right - e.right - o.marginRight,
          bottom: i.bottom - e.bottom - o.marginBottom,
        };
      }),
      (d.handleEvent = i.handleEvent),
      (d.bindResize = function () {
        (t.addEventListener("resize", this), (this.isResizeBound = !0));
      }),
      (d.unbindResize = function () {
        (t.removeEventListener("resize", this), (this.isResizeBound = !1));
      }),
      (d.onresize = function () {
        this.resize();
      }),
      i.debounceMethod(r, "onresize", 100),
      (d.resize = function () {
        this.isResizeBound && this.needsResizeLayout() && this.layout();
      }),
      (d.needsResizeLayout = function () {
        var t = n(this.element);
        return this.size && t && t.innerWidth !== this.size.innerWidth;
      }),
      (d.addItems = function (t) {
        var e = this._itemize(t);
        return (e.length && (this.items = this.items.concat(e)), e);
      }),
      (d.appended = function (t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0), this.reveal(e));
      }),
      (d.prepended = function (t) {
        var e = this._itemize(t);
        if (e.length) {
          var n = this.items.slice(0);
          ((this.items = e.concat(n)),
            this._resetLayout(),
            this._manageStamps(),
            this.layoutItems(e, !0),
            this.reveal(e),
            this.layoutItems(n));
        }
      }),
      (d.reveal = function (t) {
        if ((this._emitCompleteOnItems("reveal", t), t && t.length)) {
          var e = this.updateStagger();
          t.forEach(function (t, n) {
            (t.stagger(n * e), t.reveal());
          });
        }
      }),
      (d.hide = function (t) {
        if ((this._emitCompleteOnItems("hide", t), t && t.length)) {
          var e = this.updateStagger();
          t.forEach(function (t, n) {
            (t.stagger(n * e), t.hide());
          });
        }
      }),
      (d.revealItemElements = function (t) {
        var e = this.getItems(t);
        this.reveal(e);
      }),
      (d.hideItemElements = function (t) {
        var e = this.getItems(t);
        this.hide(e);
      }),
      (d.getItem = function (t) {
        for (var e = 0; e < this.items.length; e++) {
          var n = this.items[e];
          if (n.element == t) return n;
        }
      }),
      (d.getItems = function (t) {
        t = i.makeArray(t);
        var e = [];
        return (
          t.forEach(function (t) {
            var n = this.getItem(t);
            n && e.push(n);
          }, this),
          e
        );
      }),
      (d.remove = function (t) {
        var e = this.getItems(t);
        (this._emitCompleteOnItems("remove", e),
          e &&
            e.length &&
            e.forEach(function (t) {
              (t.remove(), i.removeFrom(this.items, t));
            }, this));
      }),
      (d.destroy = function () {
        var t = this.element.style;
        ((t.height = ""),
          (t.position = ""),
          (t.width = ""),
          this.items.forEach(function (t) {
            t.destroy();
          }),
          this.unbindResize());
        var e = this.element.outlayerGUID;
        (delete h[e],
          delete this.element.outlayerGUID,
          l && l.removeData(this.element, this.constructor.namespace));
      }),
      (r.data = function (t) {
        var e = (t = i.getQueryElement(t)) && t.outlayerGUID;
        return e && h[e];
      }),
      (r.create = function (t, e) {
        var n = s(r);
        return (
          (n.defaults = i.extend({}, r.defaults)),
          i.extend(n.defaults, e),
          (n.compatOptions = i.extend({}, r.compatOptions)),
          (n.namespace = t),
          (n.data = r.data),
          (n.Item = s(o)),
          i.htmlInit(n, t),
          l && l.bridget && l.bridget(t, n),
          n
        );
      }));
    var f = { ms: 1, s: 1e3 };
    return ((r.Item = o), r);
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("isotope-layout/js/item", ["outlayer/outlayer"], e)
      : "object" == typeof module && module.exports
        ? (module.exports = e(require("outlayer")))
        : ((t.Isotope = t.Isotope || {}), (t.Isotope.Item = e(t.Outlayer)));
  })(window, function (t) {
    function e() {
      t.Item.apply(this, arguments);
    }
    var n = (e.prototype = Object.create(t.Item.prototype)),
      i = n._create;
    ((n._create = function () {
      ((this.id = this.layout.itemGUID++), i.call(this), (this.sortData = {}));
    }),
      (n.updateSortData = function () {
        if (!this.isIgnored) {
          ((this.sortData.id = this.id),
            (this.sortData["original-order"] = this.id),
            (this.sortData.random = Math.random()));
          var t = this.layout.options.getSortData,
            e = this.layout._sorters;
          for (var n in t) {
            var i = e[n];
            this.sortData[n] = i(this.element, this);
          }
        }
      }));
    var o = n.destroy;
    return (
      (n.destroy = function () {
        (o.apply(this, arguments), this.css({ display: "" }));
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "isotope-layout/js/layout-mode",
          ["get-size/get-size", "outlayer/outlayer"],
          e,
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(require("get-size"), require("outlayer")))
        : ((t.Isotope = t.Isotope || {}),
          (t.Isotope.LayoutMode = e(t.getSize, t.Outlayer)));
  })(window, function (t, e) {
    function n(t) {
      ((this.isotope = t),
        t &&
          ((this.options = t.options[this.namespace]),
          (this.element = t.element),
          (this.items = t.filteredItems),
          (this.size = t.size)));
    }
    var i = n.prototype;
    return (
      [
        "_resetLayout",
        "_getItemLayoutPosition",
        "_manageStamp",
        "_getContainerSize",
        "_getElementOffset",
        "needsResizeLayout",
        "_getOption",
      ].forEach(function (t) {
        i[t] = function () {
          return e.prototype[t].apply(this.isotope, arguments);
        };
      }),
      (i.needsVerticalResizeLayout = function () {
        var e = t(this.isotope.element);
        return (
          this.isotope.size &&
          e &&
          e.innerHeight != this.isotope.size.innerHeight
        );
      }),
      (i._getMeasurement = function () {
        this.isotope._getMeasurement.apply(this, arguments);
      }),
      (i.getColumnWidth = function () {
        this.getSegmentSize("column", "Width");
      }),
      (i.getRowHeight = function () {
        this.getSegmentSize("row", "Height");
      }),
      (i.getSegmentSize = function (t, e) {
        var n = t + e,
          i = "outer" + e;
        if ((this._getMeasurement(n, i), !this[n])) {
          var o = this.getFirstItemSize();
          this[n] = (o && o[i]) || this.isotope.size["inner" + e];
        }
      }),
      (i.getFirstItemSize = function () {
        var e = this.isotope.filteredItems[0];
        return e && e.element && t(e.element);
      }),
      (i.layout = function () {
        this.isotope.layout.apply(this.isotope, arguments);
      }),
      (i.getSize = function () {
        (this.isotope.getSize(), (this.size = this.isotope.size));
      }),
      (n.modes = {}),
      (n.create = function (t, e) {
        function o() {
          n.apply(this, arguments);
        }
        return (
          (o.prototype = Object.create(i)),
          (o.prototype.constructor = o),
          e && (o.options = e),
          (o.prototype.namespace = t),
          (n.modes[t] = o),
          o
        );
      }),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "masonry-layout/masonry",
          ["outlayer/outlayer", "get-size/get-size"],
          e,
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(require("outlayer"), require("get-size")))
        : (t.Masonry = e(t.Outlayer, t.getSize));
  })(window, function (t, e) {
    var n = t.create("masonry");
    n.compatOptions.fitWidth = "isFitWidth";
    var i = n.prototype;
    return (
      (i._resetLayout = function () {
        (this.getSize(),
          this._getMeasurement("columnWidth", "outerWidth"),
          this._getMeasurement("gutter", "outerWidth"),
          this.measureColumns(),
          (this.colYs = []));
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        ((this.maxY = 0), (this.horizontalColIndex = 0));
      }),
      (i.measureColumns = function () {
        if ((this.getContainerWidth(), !this.columnWidth)) {
          var t = this.items[0],
            n = t && t.element;
          this.columnWidth = (n && e(n).outerWidth) || this.containerWidth;
        }
        var i = (this.columnWidth += this.gutter),
          o = this.containerWidth + this.gutter,
          r = o / i,
          s = i - (o % i);
        ((r = Math[s && s < 1 ? "round" : "floor"](r)),
          (this.cols = Math.max(r, 1)));
      }),
      (i.getContainerWidth = function () {
        var t = this._getOption("fitWidth")
            ? this.element.parentNode
            : this.element,
          n = e(t);
        this.containerWidth = n && n.innerWidth;
      }),
      (i._getItemLayoutPosition = function (t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth,
          n = Math[e && e < 1 ? "round" : "ceil"](
            t.size.outerWidth / this.columnWidth,
          );
        n = Math.min(n, this.cols);
        for (
          var i = this[
              this.options.horizontalOrder
                ? "_getHorizontalColPosition"
                : "_getTopColPosition"
            ](n, t),
            o = { x: this.columnWidth * i.col, y: i.y },
            r = i.y + t.size.outerHeight,
            s = n + i.col,
            a = i.col;
          a < s;
          a++
        )
          this.colYs[a] = r;
        return o;
      }),
      (i._getTopColPosition = function (t) {
        var e = this._getTopColGroup(t),
          n = Math.min.apply(Math, e);
        return { col: e.indexOf(n), y: n };
      }),
      (i._getTopColGroup = function (t) {
        if (t < 2) return this.colYs;
        for (var e = [], n = this.cols + 1 - t, i = 0; i < n; i++)
          e[i] = this._getColGroupY(i, t);
        return e;
      }),
      (i._getColGroupY = function (t, e) {
        if (e < 2) return this.colYs[t];
        var n = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, n);
      }),
      (i._getHorizontalColPosition = function (t, e) {
        var n = this.horizontalColIndex % this.cols;
        n = t > 1 && n + t > this.cols ? 0 : n;
        var i = e.size.outerWidth && e.size.outerHeight;
        return (
          (this.horizontalColIndex = i ? n + t : this.horizontalColIndex),
          { col: n, y: this._getColGroupY(n, t) }
        );
      }),
      (i._manageStamp = function (t) {
        var n = e(t),
          i = this._getElementOffset(t),
          o = this._getOption("originLeft") ? i.left : i.right,
          r = o + n.outerWidth,
          s = Math.floor(o / this.columnWidth);
        s = Math.max(0, s);
        var a = Math.floor(r / this.columnWidth);
        ((a -= r % this.columnWidth ? 0 : 1), (a = Math.min(this.cols - 1, a)));
        for (
          var l =
              (this._getOption("originTop") ? i.top : i.bottom) + n.outerHeight,
            c = s;
          c <= a;
          c++
        )
          this.colYs[c] = Math.max(l, this.colYs[c]);
      }),
      (i._getContainerSize = function () {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = { height: this.maxY };
        return (
          this._getOption("fitWidth") &&
            (t.width = this._getContainerFitWidth()),
          t
        );
      }),
      (i._getContainerFitWidth = function () {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; ) t++;
        return (this.cols - t) * this.columnWidth - this.gutter;
      }),
      (i.needsResizeLayout = function () {
        var t = this.containerWidth;
        return (this.getContainerWidth(), t != this.containerWidth);
      }),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "isotope-layout/js/layout-modes/masonry",
          ["../layout-mode", "masonry-layout/masonry"],
          e,
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(
            require("../layout-mode"),
            require("masonry-layout"),
          ))
        : e(t.Isotope.LayoutMode, t.Masonry);
  })(window, function (t, e) {
    var n = t.create("masonry"),
      i = n.prototype,
      o = { _getElementOffset: !0, layout: !0, _getMeasurement: !0 };
    for (var r in e.prototype) o[r] || (i[r] = e.prototype[r]);
    var s = i.measureColumns;
    i.measureColumns = function () {
      ((this.items = this.isotope.filteredItems), s.call(this));
    };
    var a = i._getOption;
    return (
      (i._getOption = function (t) {
        return "fitWidth" == t
          ? void 0 !== this.options.isFitWidth
            ? this.options.isFitWidth
            : this.options.fitWidth
          : a.apply(this.isotope, arguments);
      }),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("isotope-layout/js/layout-modes/fit-rows", ["../layout-mode"], e)
      : "object" == typeof exports
        ? (module.exports = e(require("../layout-mode")))
        : e(t.Isotope.LayoutMode);
  })(window, function (t) {
    var e = t.create("fitRows"),
      n = e.prototype;
    return (
      (n._resetLayout = function () {
        ((this.x = 0),
          (this.y = 0),
          (this.maxY = 0),
          this._getMeasurement("gutter", "outerWidth"));
      }),
      (n._getItemLayoutPosition = function (t) {
        t.getSize();
        var e = t.size.outerWidth + this.gutter,
          n = this.isotope.size.innerWidth + this.gutter;
        0 !== this.x && e + this.x > n && ((this.x = 0), (this.y = this.maxY));
        var i = { x: this.x, y: this.y };
        return (
          (this.maxY = Math.max(this.maxY, this.y + t.size.outerHeight)),
          (this.x += e),
          i
        );
      }),
      (n._getContainerSize = function () {
        return { height: this.maxY };
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("isotope-layout/js/layout-modes/vertical", ["../layout-mode"], e)
      : "object" == typeof module && module.exports
        ? (module.exports = e(require("../layout-mode")))
        : e(t.Isotope.LayoutMode);
  })(window, function (t) {
    var e = t.create("vertical", { horizontalAlignment: 0 }),
      n = e.prototype;
    return (
      (n._resetLayout = function () {
        this.y = 0;
      }),
      (n._getItemLayoutPosition = function (t) {
        t.getSize();
        var e =
            (this.isotope.size.innerWidth - t.size.outerWidth) *
            this.options.horizontalAlignment,
          n = this.y;
        return ((this.y += t.size.outerHeight), { x: e, y: n });
      }),
      (n._getContainerSize = function () {
        return { height: this.y };
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          [
            "outlayer/outlayer",
            "get-size/get-size",
            "desandro-matches-selector/matches-selector",
            "fizzy-ui-utils/utils",
            "isotope-layout/js/item",
            "isotope-layout/js/layout-mode",
            "isotope-layout/js/layout-modes/masonry",
            "isotope-layout/js/layout-modes/fit-rows",
            "isotope-layout/js/layout-modes/vertical",
          ],
          function (n, i, o, r, s, a) {
            return e(t, n, i, o, r, s, a);
          },
        )
      : "object" == typeof module && module.exports
        ? (module.exports = e(
            t,
            require("outlayer"),
            require("get-size"),
            require("desandro-matches-selector"),
            require("fizzy-ui-utils"),
            require("isotope-layout/js/item"),
            require("isotope-layout/js/layout-mode"),
            require("isotope-layout/js/layout-modes/masonry"),
            require("isotope-layout/js/layout-modes/fit-rows"),
            require("isotope-layout/js/layout-modes/vertical"),
          ))
        : (t.Isotope = e(
            t,
            t.Outlayer,
            t.getSize,
            t.matchesSelector,
            t.fizzyUIUtils,
            t.Isotope.Item,
            t.Isotope.LayoutMode,
          ));
  })(window, function (t, e, n, i, o, r, s) {
    var a = t.jQuery,
      l = String.prototype.trim
        ? function (t) {
            return t.trim();
          }
        : function (t) {
            return t.replace(/^\s+|\s+$/g, "");
          },
      c = e.create("isotope", {
        layoutMode: "masonry",
        isJQueryFiltering: !0,
        sortAscending: !0,
      });
    ((c.Item = r), (c.LayoutMode = s));
    var u = c.prototype;
    ((u._create = function () {
      for (var t in ((this.itemGUID = 0),
      (this._sorters = {}),
      this._getSorters(),
      e.prototype._create.call(this),
      (this.modes = {}),
      (this.filteredItems = this.items),
      (this.sortHistory = ["original-order"]),
      s.modes))
        this._initLayoutMode(t);
    }),
      (u.reloadItems = function () {
        ((this.itemGUID = 0), e.prototype.reloadItems.call(this));
      }),
      (u._itemize = function () {
        for (
          var t = e.prototype._itemize.apply(this, arguments), n = 0;
          n < t.length;
          n++
        ) {
          t[n].id = this.itemGUID++;
        }
        return (this._updateItemsSortData(t), t);
      }),
      (u._initLayoutMode = function (t) {
        var e = s.modes[t],
          n = this.options[t] || {};
        ((this.options[t] = e.options ? o.extend(e.options, n) : n),
          (this.modes[t] = new e(this)));
      }),
      (u.layout = function () {
        return !this._isLayoutInited && this._getOption("initLayout")
          ? void this.arrange()
          : void this._layout();
      }),
      (u._layout = function () {
        var t = this._getIsInstant();
        (this._resetLayout(),
          this._manageStamps(),
          this.layoutItems(this.filteredItems, t),
          (this._isLayoutInited = !0));
      }),
      (u.arrange = function (t) {
        (this.option(t), this._getIsInstant());
        var e = this._filter(this.items);
        ((this.filteredItems = e.matches),
          this._bindArrangeComplete(),
          this._isInstant
            ? this._noTransition(this._hideReveal, [e])
            : this._hideReveal(e),
          this._sort(),
          this._layout());
      }),
      (u._init = u.arrange),
      (u._hideReveal = function (t) {
        (this.reveal(t.needReveal), this.hide(t.needHide));
      }),
      (u._getIsInstant = function () {
        var t = this._getOption("layoutInstant"),
          e = void 0 !== t ? t : !this._isLayoutInited;
        return ((this._isInstant = e), e);
      }),
      (u._bindArrangeComplete = function () {
        function t() {
          e &&
            n &&
            i &&
            o.dispatchEvent("arrangeComplete", null, [o.filteredItems]);
        }
        var e,
          n,
          i,
          o = this;
        (this.once("layoutComplete", function () {
          ((e = !0), t());
        }),
          this.once("hideComplete", function () {
            ((n = !0), t());
          }),
          this.once("revealComplete", function () {
            ((i = !0), t());
          }));
      }),
      (u._filter = function (t) {
        var e = this.options.filter;
        e = e || "*";
        for (
          var n = [], i = [], o = [], r = this._getFilterTest(e), s = 0;
          s < t.length;
          s++
        ) {
          var a = t[s];
          if (!a.isIgnored) {
            var l = r(a);
            (l && n.push(a),
              l && a.isHidden ? i.push(a) : l || a.isHidden || o.push(a));
          }
        }
        return { matches: n, needReveal: i, needHide: o };
      }),
      (u._getFilterTest = function (t) {
        return a && this.options.isJQueryFiltering
          ? function (e) {
              return a(e.element).is(t);
            }
          : "function" == typeof t
            ? function (e) {
                return t(e.element);
              }
            : function (e) {
                return i(e.element, t);
              };
      }),
      (u.updateSortData = function (t) {
        var e;
        (t ? ((t = o.makeArray(t)), (e = this.getItems(t))) : (e = this.items),
          this._getSorters(),
          this._updateItemsSortData(e));
      }),
      (u._getSorters = function () {
        var t = this.options.getSortData;
        for (var e in t) {
          var n = t[e];
          this._sorters[e] = h(n);
        }
      }),
      (u._updateItemsSortData = function (t) {
        for (var e = t && t.length, n = 0; e && n < e; n++) {
          t[n].updateSortData();
        }
      }));
    var h = function (t) {
      if ("string" != typeof t) return t;
      var e = l(t).split(" "),
        n = e[0],
        i = n.match(/^\[(.+)\]$/),
        o = (function (t, e) {
          return t
            ? function (e) {
                return e.getAttribute(t);
              }
            : function (t) {
                var n = t.querySelector(e);
                return n && n.textContent;
              };
        })(i && i[1], n),
        r = c.sortDataParsers[e[1]];
      return r
        ? function (t) {
            return t && r(o(t));
          }
        : function (t) {
            return t && o(t);
          };
    };
    ((c.sortDataParsers = {
      parseInt: function (t) {
        return parseInt(t, 10);
      },
      parseFloat: function (t) {
        return parseFloat(t);
      },
    }),
      (u._sort = function () {
        if (this.options.sortBy) {
          var t = o.makeArray(this.options.sortBy);
          this._getIsSameSortBy(t) ||
            (this.sortHistory = t.concat(this.sortHistory));
          var e = (function (t, e) {
            return function (n, i) {
              for (var o = 0; o < t.length; o++) {
                var r = t[o],
                  s = n.sortData[r],
                  a = i.sortData[r];
                if (s > a || s < a)
                  return (
                    (s > a ? 1 : -1) * ((void 0 !== e[r] ? e[r] : e) ? 1 : -1)
                  );
              }
              return 0;
            };
          })(this.sortHistory, this.options.sortAscending);
          this.filteredItems.sort(e);
        }
      }),
      (u._getIsSameSortBy = function (t) {
        for (var e = 0; e < t.length; e++)
          if (t[e] != this.sortHistory[e]) return !1;
        return !0;
      }),
      (u._mode = function () {
        var t = this.options.layoutMode,
          e = this.modes[t];
        if (!e) throw new Error("No layout mode: " + t);
        return ((e.options = this.options[t]), e);
      }),
      (u._resetLayout = function () {
        (e.prototype._resetLayout.call(this), this._mode()._resetLayout());
      }),
      (u._getItemLayoutPosition = function (t) {
        return this._mode()._getItemLayoutPosition(t);
      }),
      (u._manageStamp = function (t) {
        this._mode()._manageStamp(t);
      }),
      (u._getContainerSize = function () {
        return this._mode()._getContainerSize();
      }),
      (u.needsResizeLayout = function () {
        return this._mode().needsResizeLayout();
      }),
      (u.appended = function (t) {
        var e = this.addItems(t);
        if (e.length) {
          var n = this._filterRevealAdded(e);
          this.filteredItems = this.filteredItems.concat(n);
        }
      }),
      (u.prepended = function (t) {
        var e = this._itemize(t);
        if (e.length) {
          (this._resetLayout(), this._manageStamps());
          var n = this._filterRevealAdded(e);
          (this.layoutItems(this.filteredItems),
            (this.filteredItems = n.concat(this.filteredItems)),
            (this.items = e.concat(this.items)));
        }
      }),
      (u._filterRevealAdded = function (t) {
        var e = this._filter(t);
        return (
          this.hide(e.needHide),
          this.reveal(e.matches),
          this.layoutItems(e.matches, !0),
          e.matches
        );
      }),
      (u.insert = function (t) {
        var e = this.addItems(t);
        if (e.length) {
          var n,
            i,
            o = e.length;
          for (n = 0; n < o; n++)
            ((i = e[n]), this.element.appendChild(i.element));
          var r = this._filter(e).matches;
          for (n = 0; n < o; n++) e[n].isLayoutInstant = !0;
          for (this.arrange(), n = 0; n < o; n++) delete e[n].isLayoutInstant;
          this.reveal(r);
        }
      }));
    var d = u.remove;
    return (
      (u.remove = function (t) {
        t = o.makeArray(t);
        var e = this.getItems(t);
        d.call(this, t);
        for (var n = e && e.length, i = 0; n && i < n; i++) {
          var r = e[i];
          o.removeFrom(this.filteredItems, r);
        }
      }),
      (u.shuffle = function () {
        for (var t = 0; t < this.items.length; t++) {
          this.items[t].sortData.random = Math.random();
        }
        ((this.options.sortBy = "random"), this._sort(), this._layout());
      }),
      (u._noTransition = function (t, e) {
        var n = this.options.transitionDuration;
        this.options.transitionDuration = 0;
        var i = t.apply(this, e);
        return ((this.options.transitionDuration = n), i);
      }),
      (u.getFilteredItemElements = function () {
        return this.filteredItems.map(function (t) {
          return t.element;
        });
      }),
      c
    );
  }),
  (function (t, e, n) {
    function i(t, e) {
      return typeof t === e;
    }
    function o() {
      return "function" != typeof e.createElement
        ? e.createElement(arguments[0])
        : d
          ? e.createElementNS.call(
              e,
              "http://www.w3.org/2000/svg",
              arguments[0],
            )
          : e.createElement.apply(e, arguments);
    }
    function r() {
      var t = e.body;
      return (t || ((t = o(d ? "svg" : "body")).fake = !0), t);
    }
    function s(t, n, i, s) {
      var a,
        l,
        c,
        u,
        d = "modernizr",
        f = o("div"),
        p = r();
      if (parseInt(i, 10))
        for (; i--; )
          (((c = o("div")).id = s ? s[i] : d + (i + 1)), f.appendChild(c));
      return (
        ((a = o("style")).type = "text/css"),
        (a.id = "s" + d),
        (p.fake ? p : f).appendChild(a),
        p.appendChild(f),
        a.styleSheet
          ? (a.styleSheet.cssText = t)
          : a.appendChild(e.createTextNode(t)),
        (f.id = d),
        p.fake &&
          ((p.style.background = ""),
          (p.style.overflow = "hidden"),
          (u = h.style.overflow),
          (h.style.overflow = "hidden"),
          h.appendChild(p)),
        (l = n(f, t)),
        p.fake
          ? (p.parentNode.removeChild(p),
            (h.style.overflow = u),
            h.offsetHeight)
          : f.parentNode.removeChild(f),
        !!l
      );
    }
    var a = [],
      l = [],
      c = {
        _version: "3.5.0",
        _config: {
          classPrefix: "",
          enableClasses: !0,
          enableJSClass: !0,
          usePrefixes: !0,
        },
        _q: [],
        on: function (t, e) {
          var n = this;
          setTimeout(function () {
            e(n[t]);
          }, 0);
        },
        addTest: function (t, e, n) {
          l.push({ name: t, fn: e, options: n });
        },
        addAsyncTest: function (t) {
          l.push({ name: null, fn: t });
        },
      },
      u = function () {};
    ((u.prototype = c), (u = new u()));
    var h = e.documentElement,
      d = "svg" === h.nodeName.toLowerCase(),
      f = (function () {
        var e = t.matchMedia || t.msMatchMedia;
        return e
          ? function (t) {
              var n = e(t);
              return (n && n.matches) || !1;
            }
          : function (e) {
              var n = !1;
              return (
                s(
                  "@media " + e + " { #modernizr { position: absolute; } }",
                  function (e) {
                    n =
                      "absolute" ==
                      (t.getComputedStyle
                        ? t.getComputedStyle(e, null)
                        : e.currentStyle
                      ).position;
                  },
                ),
                n
              );
            };
      })();
    ((c.mq = f), u.addTest("mediaqueries", f("only all")));
    var p = c._config.usePrefixes
      ? " -webkit- -moz- -o- -ms- ".split(" ")
      : ["", ""];
    c._prefixes = p;
    var m = (c.testStyles = s);
    (u.addTest("touchevents", function () {
      var n;
      if (
        "ontouchstart" in t ||
        (t.DocumentTouch && e instanceof DocumentTouch)
      )
        n = !0;
      else {
        var i = [
          "@media (",
          p.join("touch-enabled),("),
          "heartz",
          ")",
          "{#modernizr{top:9px;position:absolute}}",
        ].join("");
        m(i, function (t) {
          n = 9 === t.offsetTop;
        });
      }
      return n;
    }),
      (function () {
        var t, e, n, o, r, s;
        for (var c in l)
          if (l.hasOwnProperty(c)) {
            if (
              ((t = []),
              (e = l[c]).name &&
                (t.push(e.name.toLowerCase()),
                e.options && e.options.aliases && e.options.aliases.length))
            )
              for (n = 0; n < e.options.aliases.length; n++)
                t.push(e.options.aliases[n].toLowerCase());
            for (
              o = i(e.fn, "function") ? e.fn() : e.fn, r = 0;
              r < t.length;
              r++
            )
              (1 === (s = t[r].split(".")).length
                ? (u[s[0]] = o)
                : (!u[s[0]] ||
                    u[s[0]] instanceof Boolean ||
                    (u[s[0]] = new Boolean(u[s[0]])),
                  (u[s[0]][s[1]] = o)),
                a.push((o ? "" : "no-") + s.join("-")));
          }
      })(),
      (function (t) {
        var e = h.className,
          n = u._config.classPrefix || "";
        if ((d && (e = e.baseVal), u._config.enableJSClass)) {
          var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
          e = e.replace(i, "$1" + n + "js$2");
        }
        u._config.enableClasses &&
          ((e += " " + n + t.join(" " + n)),
          d ? (h.className.baseVal = e) : (h.className = e));
      })(a),
      delete c.addTest,
      delete c.addAsyncTest);
    for (var g = 0; g < u._q.length; g++) u._q[g]();
    t.Modernizr = u;
  })(window, document),
  /*
   * jQuery offscreen plugin
   *
   * Copyright Cory LaViska for A Beautiful Site, LLC
   *
   * @license: http://opensource.org/licenses/MIT
   *
   */
  (function (t) {
    t.extend(t.expr[":"], {
      "off-top": function (e) {
        return t(e).offset().top < t(window).scrollTop();
      },
      "off-right": function (e) {
        return (
          t(e).offset().left + t(e).outerWidth() - t(window).scrollLeft() >
          t(window).width()
        );
      },
      "off-bottom": function (e) {
        return (
          t(e).offset().top + t(e).outerHeight() - t(window).scrollTop() >
          t(window).height()
        );
      },
      "off-left": function (e) {
        return t(e).offset().left < t(window).scrollLeft();
      },
      "off-screen": function (e) {
        return t(e).is(":off-top, :off-right, :off-bottom, :off-left");
      },
    });
  })(jQuery),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
        ? define(e)
        : (t.lazyframe = e());
  })(this, function () {
    var t =
      Object.assign ||
      function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var i in n)
            Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
        }
        return t;
      };
    return (function () {
      function e(t) {
        var e = this;
        if (
          t instanceof HTMLElement != 0 &&
          !t.classList.contains("lazyframe--loaded")
        ) {
          var i = { el: t, settings: n(t) };
          (i.el.addEventListener("click", function () {
            i.el.appendChild(i.iframe);
            var n = t.querySelectorAll("iframe");
            i.settings.onAppend.call(e, n[0]);
          }),
            s.lazyload ? r(i) : o(i, i.settings.thumbnail));
        }
      }
      function n(e) {
        var n = Array.prototype.slice
            .apply(e.attributes)
            .filter(function (t) {
              return "" !== t.value;
            })
            .reduce(function (t, e) {
              return (
                (t[
                  0 === e.name.indexOf("data-")
                    ? e.name.split("data-")[1]
                    : e.name
                ] = e.value),
                t
              );
            }, {}),
          o = t({}, s, n, { y: e.offsetTop, parameters: i(n.src) });
        if (o.vendor) {
          var r = o.src.match(c.regex[o.vendor]);
          o.id = c.condition[o.vendor](r);
        }
        return o;
      }
      function i(t) {
        var e = t.split("?");
        return e[1]
          ? -1 !== (e = e[1]).indexOf("autoplay")
            ? e
            : e + "&autoplay=1"
          : "autoplay=1";
      }
      function o(t) {
        var e = this;
        !(function (t) {
          return !(
            !t.vendor ||
            (t.title && t.thumbnail) ||
            (("youtube" === t.vendor || "youtube_nocookie" === t.vendor) &&
              !t.apikey)
          );
        })(t.settings)
          ? r(t, !0)
          : (function (t, e) {
              var n = c.endpoints[t.settings.vendor](t.settings),
                i = new XMLHttpRequest();
              (i.open("GET", n, !0),
                (i.onload = function () {
                  if (i.status >= 200 && i.status < 400) {
                    var n = JSON.parse(i.responseText);
                    e(null, [n, t]);
                  } else e(!0);
                }),
                (i.onerror = function () {
                  e(!0);
                }),
                i.send());
            })(t, function (n, i) {
              if (!n) {
                var o = i[0],
                  s = i[1];
                if (
                  (s.settings.title ||
                    (s.settings.title = c.response[s.settings.vendor].title(o)),
                  !s.settings.thumbnail)
                ) {
                  var a = c.response[s.settings.vendor].thumbnail(o);
                  ((s.settings.thumbnail = a),
                    t.settings.onThumbnailLoad.call(e, a));
                }
                r(s, !0);
              }
            });
      }
      function r(t, e) {
        if (
          ((t.iframe = (function (t) {
            var e = document.createDocumentFragment(),
              n = document.createElement("iframe");
            if (
              (t.vendor && (t.src = c.src[t.vendor](t)),
              n.setAttribute("id", "lazyframe-" + t.id),
              n.setAttribute("src", t.src),
              n.setAttribute("frameborder", 0),
              n.setAttribute("allowfullscreen", ""),
              "vine" === t.vendor)
            ) {
              var i = document.createElement("script");
              (i.setAttribute(
                "src",
                "https://platform.vine.co/static/scripts/embed.js",
              ),
                e.appendChild(i));
            }
            return (e.appendChild(n), e);
          })(t.settings)),
          t.settings.thumbnail &&
            e &&
            (t.el.style.backgroundImage = "url(" + t.settings.thumbnail + ")"),
          t.settings.title && 0 === t.el.children.length)
        ) {
          var n = document.createDocumentFragment(),
            i = document.createElement("span");
          ((i.className = "lazyframe__title"),
            (i.innerHTML = t.settings.title),
            n.appendChild(i),
            t.el.appendChild(n));
        }
        (s.lazyload ||
          (t.el.classList.add("lazyframe--loaded"),
          t.settings.onLoad.call(this, t),
          a.push(t)),
          t.settings.initialized || a.push(t));
      }
      var s = void 0,
        a = [],
        l = {
          vendor: void 0,
          id: void 0,
          src: void 0,
          thumbnail: void 0,
          title: void 0,
          apikey: void 0,
          initialized: !1,
          parameters: void 0,
          y: void 0,
          debounce: 250,
          lazyload: !0,
          initinview: !1,
          onLoad: function (t) {},
          onAppend: function (t) {},
          onThumbnailLoad: function (t) {},
        },
        c = {
          regex: {
            youtube_nocookie:
              /(?:youtube-nocookie\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=)))([a-zA-Z0-9_-]{6,11})/,
            youtube:
              /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/,
            vimeo: /vimeo\.com\/(?:video\/)?([0-9]*)(?:\?|)/,
            vine: /vine.co\/v\/(.*)/,
          },
          condition: {
            youtube: function (t) {
              return !(!t || 11 != t[1].length) && t[1];
            },
            youtube_nocookie: function (t) {
              return !(!t || 11 != t[1].length) && t[1];
            },
            vimeo: function (t) {
              return !!((t && 9 === t[1].length) || 8 === t[1].length) && t[1];
            },
            vine: function (t) {
              return !(!t || 11 !== t[1].length) && t[1];
            },
          },
          src: {
            youtube: function (t) {
              return (
                "https://www.youtube.com/embed/" + t.id + "/?" + t.parameters
              );
            },
            youtube_nocookie: function (t) {
              return (
                "https://www.youtube-nocookie.com/embed/" +
                t.id +
                "/?" +
                t.parameters
              );
            },
            vimeo: function (t) {
              return (
                "https://player.vimeo.com/video/" + t.id + "/?" + t.parameters
              );
            },
            vine: function (t) {
              return "https://vine.co/v/" + t.id + "/embed/simple";
            },
          },
          endpoints: {
            youtube: function (t) {
              return (
                "https://www.googleapis.com/youtube/v3/videos?id=" +
                t.id +
                "&key=" +
                t.apikey +
                "&fields=items(snippet(title,thumbnails))&part=snippet"
              );
            },
            youtube_nocookie: function (t) {
              return (
                "https://www.googleapis.com/youtube/v3/videos?id=" +
                t.id +
                "&key=" +
                t.apikey +
                "&fields=items(snippet(title,thumbnails))&part=snippet"
              );
            },
            vimeo: function (t) {
              return (
                "https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/" +
                t.id
              );
            },
            vine: function (t) {
              return (
                "https://vine.co/oembed.json?url=https%3A%2F%2Fvine.co%2Fv%2F" +
                t.id
              );
            },
          },
          response: {
            youtube: {
              title: function (t) {
                return t.items[0].snippet.title;
              },
              thumbnail: function (t) {
                var e = t.items[0].snippet.thumbnails;
                return (
                  e.maxres ||
                  e.standard ||
                  e.high ||
                  e.medium ||
                  e.default
                ).url;
              },
            },
            youtube_nocookie: {
              title: function (t) {
                return t.items[0].snippet.title;
              },
              thumbnail: function (t) {
                var e = t.items[0].snippet.thumbnails;
                return (
                  e.maxres ||
                  e.standard ||
                  e.high ||
                  e.medium ||
                  e.default
                ).url;
              },
            },
            vimeo: {
              title: function (t) {
                return t.title;
              },
              thumbnail: function (t) {
                return t.thumbnail_url;
              },
            },
            vine: {
              title: function (t) {
                return t.title;
              },
              thumbnail: function (t) {
                return t.thumbnail_url;
              },
            },
          },
        };
      return function (n) {
        if (
          ((s = t({}, l, arguments.length <= 1 ? void 0 : arguments[1])),
          "string" == typeof n)
        )
          for (var i = document.querySelectorAll(n), r = 0; r < i.length; r++)
            e(i[r]);
        else if (void 0 === n.length) e(n);
        else if (n.length > 1) for (var c = 0; c < n.length; c++) e(n[c]);
        else e(n[0]);
        s.lazyload &&
          (function () {
            var t = this,
              e = window.innerHeight,
              n = a.length,
              i = function (e, i) {
                ((e.settings.initialized = !0),
                  e.el.classList.add("lazyframe--loaded"),
                  n--,
                  o(e),
                  e.settings.initinview && e.el.click(),
                  e.settings.onLoad.call(t, e));
              };
            a.filter(function (t) {
              return t.settings.y < e;
            }).forEach(i);
            var r = (function (t, e, n) {
                var i = void 0;
                return function () {
                  var o = this,
                    r = arguments,
                    s = function () {
                      ((i = null), n || t.apply(o, r));
                    },
                    a = n && !i;
                  (clearTimeout(i), (i = setTimeout(s, e)), a && t.apply(o, r));
                };
              })(function () {
                ((c = l < window.pageYOffset),
                  (l = window.pageYOffset),
                  c &&
                    a
                      .filter(function (t) {
                        return (
                          t.settings.y < e + l && !1 === t.settings.initialized
                        );
                      })
                      .forEach(i),
                  0 === n && window.removeEventListener("scroll", r, !1));
              }, s.debounce),
              l = 0,
              c = !1;
            window.addEventListener("scroll", r, !1);
          })();
      };
    })();
  }),
  (this.Shopify = this.Shopify || {}),
  (this.Shopify.theme = this.Shopify.theme || {}),
  (this.Shopify.theme.addresses = (function (t) {
    function e(t) {
      if ("string" != typeof t) throw new TypeError(t + " is not a string.");
      this.countryOptions = t;
    }
    function n(t, e) {
      return t.querySelector('option[value="' + e + '"]');
    }
    function i(t, e, i) {
      var o,
        r,
        s,
        a = n(t, i),
        l = JSON.parse(a.getAttribute("data-provinces"));
      return (
        (e.options.length = 0),
        l.length &&
          ((r = l),
          (s = (o = e).getAttribute("data-default")),
          r.forEach(function (t) {
            var e = document.createElement("option");
            ((e.value = t[0]), (e.textContent = t[1]), o.appendChild(e));
          }),
          s && n(o, s) && (o.value = s)),
        l
      );
    }
    return (
      (e.prototype.build = function (t, e, o) {
        if ("object" != typeof t) throw new TypeError(t + " is not a object.");
        if ("object" != typeof e) throw new TypeError(e + " is not a object.");
        var r = t.getAttribute("data-default");
        if (
          ((o = o || {}),
          (t.innerHTML = this.countryOptions),
          (t.value = r) && n(t, r))
        ) {
          var s = i(t, e, r);
          o.onCountryChange && o.onCountryChange(s, e, t);
        }
        (t.addEventListener("change", function (n) {
          var r = n.target,
            s = r.value,
            a = i(r, e, s);
          o.onCountryChange && o.onCountryChange(a, e, t);
        }),
          o.onProvinceChange &&
            e.addEventListener("change", o.onProvinceChange));
      }),
      (t.CountryProvinceSelector = e),
      t
    );
  })({})),
  "object" == typeof navigator &&
    (function (t, e) {
      "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = e())
        : "function" == typeof define && define.amd
          ? define("Plyr", e)
          : ((t = t || self).Plyr = e());
    })(this, function () {
      !(function () {
        if ("undefined" != typeof window)
          try {
            var t = new window.CustomEvent("test", { cancelable: !0 });
            if ((t.preventDefault(), !0 !== t.defaultPrevented))
              throw new Error("Could not prevent default");
          } catch (t) {
            var e = function (t, e) {
              var n, i;
              return (
                ((e = e || {}).bubbles = !!e.bubbles),
                (e.cancelable = !!e.cancelable),
                (n = document.createEvent("CustomEvent")).initCustomEvent(
                  t,
                  e.bubbles,
                  e.cancelable,
                  e.detail,
                ),
                (i = n.preventDefault),
                (n.preventDefault = function () {
                  i.call(this);
                  try {
                    Object.defineProperty(this, "defaultPrevented", {
                      get: function () {
                        return !0;
                      },
                    });
                  } catch (t) {
                    this.defaultPrevented = !0;
                  }
                }),
                n
              );
            };
            ((e.prototype = window.Event.prototype), (window.CustomEvent = e));
          }
      })();
      var t =
        "undefined" != typeof globalThis
          ? globalThis
          : "undefined" != typeof window
            ? window
            : "undefined" != typeof global
              ? global
              : "undefined" != typeof self
                ? self
                : {};
      function e(t, e) {
        return (t((e = { exports: {} }), e.exports), e.exports);
      }
      var n,
        i,
        o,
        r = "object",
        s = function (t) {
          return t && t.Math == Math && t;
        },
        a =
          s(typeof globalThis == r && globalThis) ||
          s(typeof window == r && window) ||
          s(typeof self == r && self) ||
          s(typeof t == r && t) ||
          Function("return this")(),
        l = function (t) {
          try {
            return !!t();
          } catch (t) {
            return !0;
          }
        },
        c = !l(function () {
          return (
            7 !=
            Object.defineProperty({}, "a", {
              get: function () {
                return 7;
              },
            }).a
          );
        }),
        u = {}.propertyIsEnumerable,
        h = Object.getOwnPropertyDescriptor,
        d = {
          f:
            h && !u.call({ 1: 2 }, 1)
              ? function (t) {
                  var e = h(this, t);
                  return !!e && e.enumerable;
                }
              : u,
        },
        f = function (t, e) {
          return {
            enumerable: !(1 & t),
            configurable: !(2 & t),
            writable: !(4 & t),
            value: e,
          };
        },
        p = {}.toString,
        m = function (t) {
          return p.call(t).slice(8, -1);
        },
        g = "".split,
        v = l(function () {
          return !Object("z").propertyIsEnumerable(0);
        })
          ? function (t) {
              return "String" == m(t) ? g.call(t, "") : Object(t);
            }
          : Object,
        y = function (t) {
          if (null == t) throw TypeError("Can't call method on " + t);
          return t;
        },
        b = function (t) {
          return v(y(t));
        },
        w = function (t) {
          return "object" == typeof t ? null !== t : "function" == typeof t;
        },
        x = function (t, e) {
          if (!w(t)) return t;
          var n, i;
          if (e && "function" == typeof (n = t.toString) && !w((i = n.call(t))))
            return i;
          if ("function" == typeof (n = t.valueOf) && !w((i = n.call(t))))
            return i;
          if (
            !e &&
            "function" == typeof (n = t.toString) &&
            !w((i = n.call(t)))
          )
            return i;
          throw TypeError("Can't convert object to primitive value");
        },
        S = {}.hasOwnProperty,
        k = function (t, e) {
          return S.call(t, e);
        },
        E = a.document,
        C = w(E) && w(E.createElement),
        T = function (t) {
          return C ? E.createElement(t) : {};
        },
        P =
          !c &&
          !l(function () {
            return (
              7 !=
              Object.defineProperty(T("div"), "a", {
                get: function () {
                  return 7;
                },
              }).a
            );
          }),
        A = Object.getOwnPropertyDescriptor,
        I = {
          f: c
            ? A
            : function (t, e) {
                if (((t = b(t)), (e = x(e, !0)), P))
                  try {
                    return A(t, e);
                  } catch (t) {}
                if (k(t, e)) return f(!d.f.call(t, e), t[e]);
              },
        },
        _ = function (t) {
          if (!w(t)) throw TypeError(String(t) + " is not an object");
          return t;
        },
        L = Object.defineProperty,
        z = {
          f: c
            ? L
            : function (t, e, n) {
                if ((_(t), (e = x(e, !0)), _(n), P))
                  try {
                    return L(t, e, n);
                  } catch (t) {}
                if ("get" in n || "set" in n)
                  throw TypeError("Accessors not supported");
                return ("value" in n && (t[e] = n.value), t);
              },
        },
        M = c
          ? function (t, e, n) {
              return z.f(t, e, f(1, n));
            }
          : function (t, e, n) {
              return ((t[e] = n), t);
            },
        j = function (t, e) {
          try {
            M(a, t, e);
          } catch (n) {
            a[t] = e;
          }
          return e;
        },
        O = e(function (t) {
          var e = a["__core-js_shared__"] || j("__core-js_shared__", {});
          (t.exports = function (t, n) {
            return e[t] || (e[t] = void 0 !== n ? n : {});
          })("versions", []).push({
            version: "3.1.3",
            mode: "global",
            copyright: "© 2019 Denis Pushkarev (zloirock.ru)",
          });
        }),
        D = O("native-function-to-string", Function.toString),
        F = a.WeakMap,
        R = "function" == typeof F && /native code/.test(D.call(F)),
        N = 0,
        $ = Math.random(),
        q = function (t) {
          return (
            "Symbol(" +
            String(void 0 === t ? "" : t) +
            ")_" +
            (++N + $).toString(36)
          );
        },
        H = O("keys"),
        W = function (t) {
          return H[t] || (H[t] = q(t));
        },
        B = {},
        U = a.WeakMap;
      if (R) {
        var V = new U(),
          Y = V.get,
          X = V.has,
          Q = V.set;
        ((n = function (t, e) {
          return (Q.call(V, t, e), e);
        }),
          (i = function (t) {
            return Y.call(V, t) || {};
          }),
          (o = function (t) {
            return X.call(V, t);
          }));
      } else {
        var G = W("state");
        ((B[G] = !0),
          (n = function (t, e) {
            return (M(t, G, e), e);
          }),
          (i = function (t) {
            return k(t, G) ? t[G] : {};
          }),
          (o = function (t) {
            return k(t, G);
          }));
      }
      var K = {
          set: n,
          get: i,
          has: o,
          enforce: function (t) {
            return o(t) ? i(t) : n(t, {});
          },
          getterFor: function (t) {
            return function (e) {
              var n;
              if (!w(e) || (n = i(e)).type !== t)
                throw TypeError("Incompatible receiver, " + t + " required");
              return n;
            };
          },
        },
        Z = e(function (t) {
          var e = K.get,
            n = K.enforce,
            i = String(D).split("toString");
          (O("inspectSource", function (t) {
            return D.call(t);
          }),
            (t.exports = function (t, e, o, r) {
              var s = !!r && !!r.unsafe,
                l = !!r && !!r.enumerable,
                c = !!r && !!r.noTargetGet;
              ("function" == typeof o &&
                ("string" != typeof e || k(o, "name") || M(o, "name", e),
                (n(o).source = i.join("string" == typeof e ? e : ""))),
                t !== a
                  ? (s ? !c && t[e] && (l = !0) : delete t[e],
                    l ? (t[e] = o) : M(t, e, o))
                  : l
                    ? (t[e] = o)
                    : j(e, o));
            })(Function.prototype, "toString", function () {
              return (
                ("function" == typeof this && e(this).source) || D.call(this)
              );
            }));
        }),
        J = a,
        tt = function (t) {
          return "function" == typeof t ? t : void 0;
        },
        et = function (t, e) {
          return arguments.length < 2
            ? tt(J[t]) || tt(a[t])
            : (J[t] && J[t][e]) || (a[t] && a[t][e]);
        },
        nt = Math.ceil,
        it = Math.floor,
        ot = function (t) {
          return isNaN((t = +t)) ? 0 : (t > 0 ? it : nt)(t);
        },
        rt = Math.min,
        st = function (t) {
          return t > 0 ? rt(ot(t), 9007199254740991) : 0;
        },
        at = Math.max,
        lt = Math.min,
        ct = function (t, e) {
          var n = ot(t);
          return n < 0 ? at(n + e, 0) : lt(n, e);
        },
        ut = function (t) {
          return function (e, n, i) {
            var o,
              r = b(e),
              s = st(r.length),
              a = ct(i, s);
            if (t && n != n) {
              for (; s > a; ) if ((o = r[a++]) != o) return !0;
            } else
              for (; s > a; a++)
                if ((t || a in r) && r[a] === n) return t || a || 0;
            return !t && -1;
          };
        },
        ht = { includes: ut(!0), indexOf: ut(!1) },
        dt = ht.indexOf,
        ft = function (t, e) {
          var n,
            i = b(t),
            o = 0,
            r = [];
          for (n in i) !k(B, n) && k(i, n) && r.push(n);
          for (; e.length > o; ) k(i, (n = e[o++])) && (~dt(r, n) || r.push(n));
          return r;
        },
        pt = [
          "constructor",
          "hasOwnProperty",
          "isPrototypeOf",
          "propertyIsEnumerable",
          "toLocaleString",
          "toString",
          "valueOf",
        ],
        mt = pt.concat("length", "prototype"),
        gt = {
          f:
            Object.getOwnPropertyNames ||
            function (t) {
              return ft(t, mt);
            },
        },
        vt = { f: Object.getOwnPropertySymbols },
        yt =
          et("Reflect", "ownKeys") ||
          function (t) {
            var e = gt.f(_(t)),
              n = vt.f;
            return n ? e.concat(n(t)) : e;
          },
        bt = function (t, e) {
          for (var n = yt(e), i = z.f, o = I.f, r = 0; r < n.length; r++) {
            var s = n[r];
            k(t, s) || i(t, s, o(e, s));
          }
        },
        wt = /#|\.prototype\./,
        xt = function (t, e) {
          var n = kt[St(t)];
          return n == Ct || (n != Et && ("function" == typeof e ? l(e) : !!e));
        },
        St = (xt.normalize = function (t) {
          return String(t).replace(wt, ".").toLowerCase();
        }),
        kt = (xt.data = {}),
        Et = (xt.NATIVE = "N"),
        Ct = (xt.POLYFILL = "P"),
        Tt = xt,
        Pt = I.f,
        At = function (t, e) {
          var n,
            i,
            o,
            r,
            s,
            l = t.target,
            c = t.global,
            u = t.stat;
          if ((n = c ? a : u ? a[l] || j(l, {}) : (a[l] || {}).prototype))
            for (i in e) {
              if (
                ((r = e[i]),
                (o = t.noTargetGet ? (s = Pt(n, i)) && s.value : n[i]),
                !Tt(c ? i : l + (u ? "." : "#") + i, t.forced) && void 0 !== o)
              ) {
                if (typeof r == typeof o) continue;
                bt(r, o);
              }
              ((t.sham || (o && o.sham)) && M(r, "sham", !0), Z(n, i, r, t));
            }
        },
        It =
          !!Object.getOwnPropertySymbols &&
          !l(function () {
            return !String(Symbol());
          }),
        _t =
          Array.isArray ||
          function (t) {
            return "Array" == m(t);
          },
        Lt = function (t) {
          return Object(y(t));
        },
        zt =
          Object.keys ||
          function (t) {
            return ft(t, pt);
          },
        Mt = c
          ? Object.defineProperties
          : function (t, e) {
              _(t);
              for (var n, i = zt(e), o = i.length, r = 0; o > r; )
                z.f(t, (n = i[r++]), e[n]);
              return t;
            },
        jt = et("document", "documentElement"),
        Ot = W("IE_PROTO"),
        Dt = function () {},
        Ft = function () {
          var t,
            e = T("iframe"),
            n = pt.length;
          for (
            e.style.display = "none",
              jt.appendChild(e),
              e.src = String("javascript:"),
              (t = e.contentWindow.document).open(),
              t.write("<script>document.F=Object<\/script>"),
              t.close(),
              Ft = t.F;
            n--;
          )
            delete Ft.prototype[pt[n]];
          return Ft();
        },
        Rt =
          Object.create ||
          function (t, e) {
            var n;
            return (
              null !== t
                ? ((Dt.prototype = _(t)),
                  (n = new Dt()),
                  (Dt.prototype = null),
                  (n[Ot] = t))
                : (n = Ft()),
              void 0 === e ? n : Mt(n, e)
            );
          };
      B[Ot] = !0;
      var Nt = gt.f,
        $t = {}.toString,
        qt =
          "object" == typeof window && window && Object.getOwnPropertyNames
            ? Object.getOwnPropertyNames(window)
            : [],
        Ht = {
          f: function (t) {
            return qt && "[object Window]" == $t.call(t)
              ? (function (t) {
                  try {
                    return Nt(t);
                  } catch (t) {
                    return qt.slice();
                  }
                })(t)
              : Nt(b(t));
          },
        },
        Wt = a.Symbol,
        Bt = O("wks"),
        Ut = function (t) {
          return (
            Bt[t] || (Bt[t] = (It && Wt[t]) || (It ? Wt : q)("Symbol." + t))
          );
        },
        Vt = { f: Ut },
        Yt = z.f,
        Xt = function (t) {
          var e = J.Symbol || (J.Symbol = {});
          k(e, t) || Yt(e, t, { value: Vt.f(t) });
        },
        Qt = z.f,
        Gt = Ut("toStringTag"),
        Kt = function (t, e, n) {
          t &&
            !k((t = n ? t : t.prototype), Gt) &&
            Qt(t, Gt, { configurable: !0, value: e });
        },
        Zt = function (t) {
          if ("function" != typeof t)
            throw TypeError(String(t) + " is not a function");
          return t;
        },
        Jt = function (t, e, n) {
          if ((Zt(t), void 0 === e)) return t;
          switch (n) {
            case 0:
              return function () {
                return t.call(e);
              };
            case 1:
              return function (n) {
                return t.call(e, n);
              };
            case 2:
              return function (n, i) {
                return t.call(e, n, i);
              };
            case 3:
              return function (n, i, o) {
                return t.call(e, n, i, o);
              };
          }
          return function () {
            return t.apply(e, arguments);
          };
        },
        te = Ut("species"),
        ee = function (t, e) {
          var n;
          return (
            _t(t) &&
              ("function" != typeof (n = t.constructor) ||
              (n !== Array && !_t(n.prototype))
                ? w(n) && null === (n = n[te]) && (n = void 0)
                : (n = void 0)),
            new (void 0 === n ? Array : n)(0 === e ? 0 : e)
          );
        },
        ne = [].push,
        ie = function (t) {
          var e = 1 == t,
            n = 2 == t,
            i = 3 == t,
            o = 4 == t,
            r = 6 == t,
            s = 5 == t || r;
          return function (a, l, c, u) {
            for (
              var h,
                d,
                f = Lt(a),
                p = v(f),
                m = Jt(l, c, 3),
                g = st(p.length),
                y = 0,
                b = u || ee,
                w = e ? b(a, g) : n ? b(a, 0) : void 0;
              g > y;
              y++
            )
              if ((s || y in p) && ((d = m((h = p[y]), y, f)), t))
                if (e) w[y] = d;
                else if (d)
                  switch (t) {
                    case 3:
                      return !0;
                    case 5:
                      return h;
                    case 6:
                      return y;
                    case 2:
                      ne.call(w, h);
                  }
                else if (o) return !1;
            return r ? -1 : i || o ? o : w;
          };
        },
        oe = {
          forEach: ie(0),
          map: ie(1),
          filter: ie(2),
          some: ie(3),
          every: ie(4),
          find: ie(5),
          findIndex: ie(6),
        },
        re = oe.forEach,
        se = W("hidden"),
        ae = Ut("toPrimitive"),
        le = K.set,
        ce = K.getterFor("Symbol"),
        ue = Object.prototype,
        he = a.Symbol,
        de = a.JSON,
        fe = de && de.stringify,
        pe = I.f,
        me = z.f,
        ge = Ht.f,
        ve = d.f,
        ye = O("symbols"),
        be = O("op-symbols"),
        we = O("string-to-symbol-registry"),
        xe = O("symbol-to-string-registry"),
        Se = O("wks"),
        ke = a.QObject,
        Ee = !ke || !ke.prototype || !ke.prototype.findChild,
        Ce =
          c &&
          l(function () {
            return (
              7 !=
              Rt(
                me({}, "a", {
                  get: function () {
                    return me(this, "a", { value: 7 }).a;
                  },
                }),
              ).a
            );
          })
            ? function (t, e, n) {
                var i = pe(ue, e);
                (i && delete ue[e], me(t, e, n), i && t !== ue && me(ue, e, i));
              }
            : me,
        Te = function (t, e) {
          var n = (ye[t] = Rt(he.prototype));
          return (
            le(n, { type: "Symbol", tag: t, description: e }),
            c || (n.description = e),
            n
          );
        },
        Pe =
          It && "symbol" == typeof he.iterator
            ? function (t) {
                return "symbol" == typeof t;
              }
            : function (t) {
                return Object(t) instanceof he;
              },
        Ae = function (t, e, n) {
          (t === ue && Ae(be, e, n), _(t));
          var i = x(e, !0);
          return (
            _(n),
            k(ye, i)
              ? (n.enumerable
                  ? (k(t, se) && t[se][i] && (t[se][i] = !1),
                    (n = Rt(n, { enumerable: f(0, !1) })))
                  : (k(t, se) || me(t, se, f(1, {})), (t[se][i] = !0)),
                Ce(t, i, n))
              : me(t, i, n)
          );
        },
        Ie = function (t, e) {
          _(t);
          var n = b(e),
            i = zt(n).concat(Me(n));
          return (
            re(i, function (e) {
              (c && !_e.call(n, e)) || Ae(t, e, n[e]);
            }),
            t
          );
        },
        _e = function (t) {
          var e = x(t, !0),
            n = ve.call(this, e);
          return (
            !(this === ue && k(ye, e) && !k(be, e)) &&
            (!(n || !k(this, e) || !k(ye, e) || (k(this, se) && this[se][e])) ||
              n)
          );
        },
        Le = function (t, e) {
          var n = b(t),
            i = x(e, !0);
          if (n !== ue || !k(ye, i) || k(be, i)) {
            var o = pe(n, i);
            return (
              !o || !k(ye, i) || (k(n, se) && n[se][i]) || (o.enumerable = !0),
              o
            );
          }
        },
        ze = function (t) {
          var e = ge(b(t)),
            n = [];
          return (
            re(e, function (t) {
              k(ye, t) || k(B, t) || n.push(t);
            }),
            n
          );
        },
        Me = function (t) {
          var e = t === ue,
            n = ge(e ? be : b(t)),
            i = [];
          return (
            re(n, function (t) {
              !k(ye, t) || (e && !k(ue, t)) || i.push(ye[t]);
            }),
            i
          );
        };
      (It ||
        (Z(
          (he = function () {
            if (this instanceof he)
              throw TypeError("Symbol is not a constructor");
            var t =
                arguments.length && void 0 !== arguments[0]
                  ? String(arguments[0])
                  : void 0,
              e = q(t),
              n = function (t) {
                (this === ue && n.call(be, t),
                  k(this, se) && k(this[se], e) && (this[se][e] = !1),
                  Ce(this, e, f(1, t)));
              };
            return (
              c && Ee && Ce(ue, e, { configurable: !0, set: n }),
              Te(e, t)
            );
          }).prototype,
          "toString",
          function () {
            return ce(this).tag;
          },
        ),
        (d.f = _e),
        (z.f = Ae),
        (I.f = Le),
        (gt.f = Ht.f = ze),
        (vt.f = Me),
        c &&
          (me(he.prototype, "description", {
            configurable: !0,
            get: function () {
              return ce(this).description;
            },
          }),
          Z(ue, "propertyIsEnumerable", _e, { unsafe: !0 })),
        (Vt.f = function (t) {
          return Te(Ut(t), t);
        })),
        At({ global: !0, wrap: !0, forced: !It, sham: !It }, { Symbol: he }),
        re(zt(Se), function (t) {
          Xt(t);
        }),
        At(
          { target: "Symbol", stat: !0, forced: !It },
          {
            for: function (t) {
              var e = String(t);
              if (k(we, e)) return we[e];
              var n = he(e);
              return ((we[e] = n), (xe[n] = e), n);
            },
            keyFor: function (t) {
              if (!Pe(t)) throw TypeError(t + " is not a symbol");
              if (k(xe, t)) return xe[t];
            },
            useSetter: function () {
              Ee = !0;
            },
            useSimple: function () {
              Ee = !1;
            },
          },
        ),
        At(
          { target: "Object", stat: !0, forced: !It, sham: !c },
          {
            create: function (t, e) {
              return void 0 === e ? Rt(t) : Ie(Rt(t), e);
            },
            defineProperty: Ae,
            defineProperties: Ie,
            getOwnPropertyDescriptor: Le,
          },
        ),
        At(
          { target: "Object", stat: !0, forced: !It },
          { getOwnPropertyNames: ze, getOwnPropertySymbols: Me },
        ),
        At(
          {
            target: "Object",
            stat: !0,
            forced: l(function () {
              vt.f(1);
            }),
          },
          {
            getOwnPropertySymbols: function (t) {
              return vt.f(Lt(t));
            },
          },
        ),
        de &&
          At(
            {
              target: "JSON",
              stat: !0,
              forced:
                !It ||
                l(function () {
                  var t = he();
                  return (
                    "[null]" != fe([t]) ||
                    "{}" != fe({ a: t }) ||
                    "{}" != fe(Object(t))
                  );
                }),
            },
            {
              stringify: function (t) {
                for (var e, n, i = [t], o = 1; arguments.length > o; )
                  i.push(arguments[o++]);
                if (((n = e = i[1]), (w(e) || void 0 !== t) && !Pe(t)))
                  return (
                    _t(e) ||
                      (e = function (t, e) {
                        if (
                          ("function" == typeof n && (e = n.call(this, t, e)),
                          !Pe(e))
                        )
                          return e;
                      }),
                    (i[1] = e),
                    fe.apply(de, i)
                  );
              },
            },
          ),
        he.prototype[ae] || M(he.prototype, ae, he.prototype.valueOf),
        Kt(he, "Symbol"),
        (B[se] = !0));
      var je = z.f,
        Oe = a.Symbol;
      if (
        c &&
        "function" == typeof Oe &&
        (!("description" in Oe.prototype) || void 0 !== Oe().description)
      ) {
        var De = {},
          Fe = function () {
            var t =
                arguments.length < 1 || void 0 === arguments[0]
                  ? void 0
                  : String(arguments[0]),
              e = this instanceof Fe ? new Oe(t) : void 0 === t ? Oe() : Oe(t);
            return ("" === t && (De[e] = !0), e);
          };
        bt(Fe, Oe);
        var Re = (Fe.prototype = Oe.prototype);
        Re.constructor = Fe;
        var Ne = Re.toString,
          $e = "Symbol(test)" == String(Oe("test")),
          qe = /^Symbol\((.*)\)[^)]+$/;
        (je(Re, "description", {
          configurable: !0,
          get: function () {
            var t = w(this) ? this.valueOf() : this,
              e = Ne.call(t);
            if (k(De, t)) return "";
            var n = $e ? e.slice(7, -1) : e.replace(qe, "$1");
            return "" === n ? void 0 : n;
          },
        }),
          At({ global: !0, forced: !0 }, { Symbol: Fe }));
      }
      Xt("iterator");
      var He = Ut("unscopables"),
        We = Array.prototype;
      null == We[He] && M(We, He, Rt(null));
      var Be,
        Ue,
        Ve,
        Ye = function (t) {
          We[He][t] = !0;
        },
        Xe = {},
        Qe = !l(function () {
          function t() {}
          return (
            (t.prototype.constructor = null),
            Object.getPrototypeOf(new t()) !== t.prototype
          );
        }),
        Ge = W("IE_PROTO"),
        Ke = Object.prototype,
        Ze = Qe
          ? Object.getPrototypeOf
          : function (t) {
              return (
                (t = Lt(t)),
                k(t, Ge)
                  ? t[Ge]
                  : "function" == typeof t.constructor &&
                      t instanceof t.constructor
                    ? t.constructor.prototype
                    : t instanceof Object
                      ? Ke
                      : null
              );
            },
        Je = Ut("iterator"),
        tn = !1;
      ([].keys &&
        ("next" in (Ve = [].keys())
          ? (Ue = Ze(Ze(Ve))) !== Object.prototype && (Be = Ue)
          : (tn = !0)),
        null == Be && (Be = {}),
        k(Be, Je) ||
          M(Be, Je, function () {
            return this;
          }));
      var en = { IteratorPrototype: Be, BUGGY_SAFARI_ITERATORS: tn },
        nn = en.IteratorPrototype,
        on = function () {
          return this;
        },
        rn = function (t, e, n) {
          var i = e + " Iterator";
          return (
            (t.prototype = Rt(nn, { next: f(1, n) })),
            Kt(t, i, !1),
            (Xe[i] = on),
            t
          );
        },
        sn =
          Object.setPrototypeOf ||
          ("__proto__" in {}
            ? (function () {
                var t,
                  e = !1,
                  n = {};
                try {
                  ((t = Object.getOwnPropertyDescriptor(
                    Object.prototype,
                    "__proto__",
                  ).set).call(n, []),
                    (e = n instanceof Array));
                } catch (t) {}
                return function (n, i) {
                  return (
                    _(n),
                    (function (t) {
                      if (!w(t) && null !== t)
                        throw TypeError(
                          "Can't set " + String(t) + " as a prototype",
                        );
                    })(i),
                    e ? t.call(n, i) : (n.__proto__ = i),
                    n
                  );
                };
              })()
            : void 0),
        an = en.IteratorPrototype,
        ln = en.BUGGY_SAFARI_ITERATORS,
        cn = Ut("iterator"),
        un = function () {
          return this;
        },
        hn = function (t, e, n, i, o, r, s) {
          rn(n, e, i);
          var a,
            l,
            c,
            u = function (t) {
              if (t === o && m) return m;
              if (!ln && t in f) return f[t];
              switch (t) {
                case "keys":
                case "values":
                case "entries":
                  return function () {
                    return new n(this, t);
                  };
              }
              return function () {
                return new n(this);
              };
            },
            h = e + " Iterator",
            d = !1,
            f = t.prototype,
            p = f[cn] || f["@@iterator"] || (o && f[o]),
            m = (!ln && p) || u(o),
            g = ("Array" == e && f.entries) || p;
          if (
            (g &&
              ((a = Ze(g.call(new t()))),
              an !== Object.prototype &&
                a.next &&
                (Ze(a) !== an &&
                  (sn ? sn(a, an) : "function" != typeof a[cn] && M(a, cn, un)),
                Kt(a, h, !0))),
            "values" == o &&
              p &&
              "values" !== p.name &&
              ((d = !0),
              (m = function () {
                return p.call(this);
              })),
            f[cn] !== m && M(f, cn, m),
            (Xe[e] = m),
            o)
          )
            if (
              ((l = {
                values: u("values"),
                keys: r ? m : u("keys"),
                entries: u("entries"),
              }),
              s)
            )
              for (c in l) (!ln && !d && c in f) || Z(f, c, l[c]);
            else At({ target: e, proto: !0, forced: ln || d }, l);
          return l;
        },
        dn = K.set,
        fn = K.getterFor("Array Iterator"),
        pn = hn(
          Array,
          "Array",
          function (t, e) {
            dn(this, {
              type: "Array Iterator",
              target: b(t),
              index: 0,
              kind: e,
            });
          },
          function () {
            var t = fn(this),
              e = t.target,
              n = t.kind,
              i = t.index++;
            return !e || i >= e.length
              ? ((t.target = void 0), { value: void 0, done: !0 })
              : "keys" == n
                ? { value: i, done: !1 }
                : "values" == n
                  ? { value: e[i], done: !1 }
                  : { value: [i, e[i]], done: !1 };
          },
          "values",
        );
      ((Xe.Arguments = Xe.Array), Ye("keys"), Ye("values"), Ye("entries"));
      var mn = function (t, e) {
          var n = [][t];
          return (
            !n ||
            !l(function () {
              n.call(
                null,
                e ||
                  function () {
                    throw 1;
                  },
                1,
              );
            })
          );
        },
        gn = [].join,
        vn = v != Object,
        yn = mn("join", ",");
      At(
        { target: "Array", proto: !0, forced: vn || yn },
        {
          join: function (t) {
            return gn.call(b(this), void 0 === t ? "," : t);
          },
        },
      );
      var bn = function (t, e, n) {
          var i = x(e);
          i in t ? z.f(t, i, f(0, n)) : (t[i] = n);
        },
        wn = Ut("species"),
        xn = function (t) {
          return !l(function () {
            var e = [];
            return (
              ((e.constructor = {})[wn] = function () {
                return { foo: 1 };
              }),
              1 !== e[t](Boolean).foo
            );
          });
        },
        Sn = Ut("species"),
        kn = [].slice,
        En = Math.max;
      At(
        { target: "Array", proto: !0, forced: !xn("slice") },
        {
          slice: function (t, e) {
            var n,
              i,
              o,
              r = b(this),
              s = st(r.length),
              a = ct(t, s),
              l = ct(void 0 === e ? s : e, s);
            if (
              _t(r) &&
              ("function" != typeof (n = r.constructor) ||
              (n !== Array && !_t(n.prototype))
                ? w(n) && null === (n = n[Sn]) && (n = void 0)
                : (n = void 0),
              n === Array || void 0 === n)
            )
              return kn.call(r, a, l);
            for (
              i = new (void 0 === n ? Array : n)(En(l - a, 0)), o = 0;
              a < l;
              a++, o++
            )
              a in r && bn(i, o, r[a]);
            return ((i.length = o), i);
          },
        },
      );
      var Cn = Ut("toStringTag"),
        Tn =
          "Arguments" ==
          m(
            (function () {
              return arguments;
            })(),
          ),
        Pn = function (t) {
          var e, n, i;
          return void 0 === t
            ? "Undefined"
            : null === t
              ? "Null"
              : "string" ==
                  typeof (n = (function (t, e) {
                    try {
                      return t[e];
                    } catch (t) {}
                  })((e = Object(t)), Cn))
                ? n
                : Tn
                  ? m(e)
                  : "Object" == (i = m(e)) && "function" == typeof e.callee
                    ? "Arguments"
                    : i;
        },
        An = {};
      An[Ut("toStringTag")] = "z";
      var In =
          "[object z]" !== String(An)
            ? function () {
                return "[object " + Pn(this) + "]";
              }
            : An.toString,
        _n = Object.prototype;
      In !== _n.toString && Z(_n, "toString", In, { unsafe: !0 });
      var Ln = function () {
          var t = _(this),
            e = "";
          return (
            t.global && (e += "g"),
            t.ignoreCase && (e += "i"),
            t.multiline && (e += "m"),
            t.dotAll && (e += "s"),
            t.unicode && (e += "u"),
            t.sticky && (e += "y"),
            e
          );
        },
        zn = RegExp.prototype,
        Mn = zn.toString,
        jn = l(function () {
          return "/a/b" != Mn.call({ source: "a", flags: "b" });
        }),
        On = "toString" != Mn.name;
      (jn || On) &&
        Z(
          RegExp.prototype,
          "toString",
          function () {
            var t = _(this),
              e = String(t.source),
              n = t.flags;
            return (
              "/" +
              e +
              "/" +
              String(
                void 0 === n && t instanceof RegExp && !("flags" in zn)
                  ? Ln.call(t)
                  : n,
              )
            );
          },
          { unsafe: !0 },
        );
      var Dn = function (t) {
          return function (e, n) {
            var i,
              o,
              r = String(y(e)),
              s = ot(n),
              a = r.length;
            return s < 0 || s >= a
              ? t
                ? ""
                : void 0
              : (i = r.charCodeAt(s)) < 55296 ||
                  i > 56319 ||
                  s + 1 === a ||
                  (o = r.charCodeAt(s + 1)) < 56320 ||
                  o > 57343
                ? t
                  ? r.charAt(s)
                  : i
                : t
                  ? r.slice(s, s + 2)
                  : o - 56320 + ((i - 55296) << 10) + 65536;
          };
        },
        Fn = { codeAt: Dn(!1), charAt: Dn(!0) },
        Rn = Fn.charAt,
        Nn = K.set,
        $n = K.getterFor("String Iterator");
      hn(
        String,
        "String",
        function (t) {
          Nn(this, { type: "String Iterator", string: String(t), index: 0 });
        },
        function () {
          var t,
            e = $n(this),
            n = e.string,
            i = e.index;
          return i >= n.length
            ? { value: void 0, done: !0 }
            : ((t = Rn(n, i)), (e.index += t.length), { value: t, done: !1 });
        },
      );
      var qn = RegExp.prototype.exec,
        Hn = String.prototype.replace,
        Wn = qn,
        Bn = (function () {
          var t = /a/,
            e = /b*/g;
          return (
            qn.call(t, "a"),
            qn.call(e, "a"),
            0 !== t.lastIndex || 0 !== e.lastIndex
          );
        })(),
        Un = void 0 !== /()??/.exec("")[1];
      (Bn || Un) &&
        (Wn = function (t) {
          var e,
            n,
            i,
            o,
            r = this;
          return (
            Un && (n = new RegExp("^" + r.source + "$(?!\\s)", Ln.call(r))),
            Bn && (e = r.lastIndex),
            (i = qn.call(r, t)),
            Bn && i && (r.lastIndex = r.global ? i.index + i[0].length : e),
            Un &&
              i &&
              i.length > 1 &&
              Hn.call(i[0], n, function () {
                for (o = 1; o < arguments.length - 2; o++)
                  void 0 === arguments[o] && (i[o] = void 0);
              }),
            i
          );
        });
      var Vn = Wn,
        Yn = Ut("species"),
        Xn = !l(function () {
          var t = /./;
          return (
            (t.exec = function () {
              var t = [];
              return ((t.groups = { a: "7" }), t);
            }),
            "7" !== "".replace(t, "$<a>")
          );
        }),
        Qn = !l(function () {
          var t = /(?:)/,
            e = t.exec;
          t.exec = function () {
            return e.apply(this, arguments);
          };
          var n = "ab".split(t);
          return 2 !== n.length || "a" !== n[0] || "b" !== n[1];
        }),
        Gn = function (t, e, n, i) {
          var o = Ut(t),
            r = !l(function () {
              var e = {};
              return (
                (e[o] = function () {
                  return 7;
                }),
                7 != ""[t](e)
              );
            }),
            s =
              r &&
              !l(function () {
                var e = !1,
                  n = /a/;
                return (
                  (n.exec = function () {
                    return ((e = !0), null);
                  }),
                  "split" === t &&
                    ((n.constructor = {}),
                    (n.constructor[Yn] = function () {
                      return n;
                    })),
                  n[o](""),
                  !e
                );
              });
          if (!r || !s || ("replace" === t && !Xn) || ("split" === t && !Qn)) {
            var a = /./[o],
              c = n(o, ""[t], function (t, e, n, i, o) {
                return e.exec === Vn
                  ? r && !o
                    ? { done: !0, value: a.call(e, n, i) }
                    : { done: !0, value: t.call(n, e, i) }
                  : { done: !1 };
              }),
              u = c[0],
              h = c[1];
            (Z(String.prototype, t, u),
              Z(
                RegExp.prototype,
                o,
                2 == e
                  ? function (t, e) {
                      return h.call(t, this, e);
                    }
                  : function (t) {
                      return h.call(t, this);
                    },
              ),
              i && M(RegExp.prototype[o], "sham", !0));
          }
        },
        Kn = Fn.charAt,
        Zn = function (t, e, n) {
          return e + (n ? Kn(t, e).length : 1);
        },
        Jn = function (t, e) {
          var n = t.exec;
          if ("function" == typeof n) {
            var i = n.call(t, e);
            if ("object" != typeof i)
              throw TypeError(
                "RegExp exec method returned something other than an Object or null",
              );
            return i;
          }
          if ("RegExp" !== m(t))
            throw TypeError("RegExp#exec called on incompatible receiver");
          return Vn.call(t, e);
        },
        ti = Math.max,
        ei = Math.min,
        ni = Math.floor,
        ii = /\$([$&'`]|\d\d?|<[^>]*>)/g,
        oi = /\$([$&'`]|\d\d?)/g;
      Gn("replace", 2, function (t, e, n) {
        return [
          function (n, i) {
            var o = y(this),
              r = null == n ? void 0 : n[t];
            return void 0 !== r ? r.call(n, o, i) : e.call(String(o), n, i);
          },
          function (t, o) {
            var r = n(e, t, this, o);
            if (r.done) return r.value;
            var s = _(t),
              a = String(this),
              l = "function" == typeof o;
            l || (o = String(o));
            var c = s.global;
            if (c) {
              var u = s.unicode;
              s.lastIndex = 0;
            }
            for (var h = []; ; ) {
              var d = Jn(s, a);
              if (null === d) break;
              if ((h.push(d), !c)) break;
              "" === String(d[0]) && (s.lastIndex = Zn(a, st(s.lastIndex), u));
            }
            for (var f, p = "", m = 0, g = 0; g < h.length; g++) {
              d = h[g];
              for (
                var v = String(d[0]),
                  y = ti(ei(ot(d.index), a.length), 0),
                  b = [],
                  w = 1;
                w < d.length;
                w++
              )
                b.push(void 0 === (f = d[w]) ? f : String(f));
              var x = d.groups;
              if (l) {
                var S = [v].concat(b, y, a);
                void 0 !== x && S.push(x);
                var k = String(o.apply(void 0, S));
              } else k = i(v, a, y, b, x, o);
              y >= m && ((p += a.slice(m, y) + k), (m = y + v.length));
            }
            return p + a.slice(m);
          },
        ];
        function i(t, n, i, o, r, s) {
          var a = i + t.length,
            l = o.length,
            c = oi;
          return (
            void 0 !== r && ((r = Lt(r)), (c = ii)),
            e.call(s, c, function (e, s) {
              var c;
              switch (s.charAt(0)) {
                case "$":
                  return "$";
                case "&":
                  return t;
                case "`":
                  return n.slice(0, i);
                case "'":
                  return n.slice(a);
                case "<":
                  c = r[s.slice(1, -1)];
                  break;
                default:
                  var u = +s;
                  if (0 === u) return e;
                  if (u > l) {
                    var h = ni(u / 10);
                    return 0 === h
                      ? e
                      : h <= l
                        ? void 0 === o[h - 1]
                          ? s.charAt(1)
                          : o[h - 1] + s.charAt(1)
                        : e;
                  }
                  c = o[u - 1];
              }
              return void 0 === c ? "" : c;
            })
          );
        }
      });
      var ri =
        Object.is ||
        function (t, e) {
          return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
        };
      Gn("search", 1, function (t, e, n) {
        return [
          function (e) {
            var n = y(this),
              i = null == e ? void 0 : e[t];
            return void 0 !== i ? i.call(e, n) : new RegExp(e)[t](String(n));
          },
          function (t) {
            var i = n(e, t, this);
            if (i.done) return i.value;
            var o = _(t),
              r = String(this),
              s = o.lastIndex;
            ri(s, 0) || (o.lastIndex = 0);
            var a = Jn(o, r);
            return (
              ri(o.lastIndex, s) || (o.lastIndex = s),
              null === a ? -1 : a.index
            );
          },
        ];
      });
      var si = Ut("match"),
        ai = function (t) {
          var e;
          return w(t) && (void 0 !== (e = t[si]) ? !!e : "RegExp" == m(t));
        },
        li = Ut("species"),
        ci = function (t, e) {
          var n,
            i = _(t).constructor;
          return void 0 === i || null == (n = _(i)[li]) ? e : Zt(n);
        },
        ui = [].push,
        hi = Math.min,
        di = !l(function () {
          return !RegExp(4294967295, "y");
        });
      Gn(
        "split",
        2,
        function (t, e, n) {
          var i;
          return (
            (i =
              "c" == "abbc".split(/(b)*/)[1] ||
              4 != "test".split(/(?:)/, -1).length ||
              2 != "ab".split(/(?:ab)*/).length ||
              4 != ".".split(/(.?)(.?)/).length ||
              ".".split(/()()/).length > 1 ||
              "".split(/.?/).length
                ? function (t, n) {
                    var i = String(y(this)),
                      o = void 0 === n ? 4294967295 : n >>> 0;
                    if (0 === o) return [];
                    if (void 0 === t) return [i];
                    if (!ai(t)) return e.call(i, t, o);
                    for (
                      var r,
                        s,
                        a,
                        l = [],
                        c =
                          (t.ignoreCase ? "i" : "") +
                          (t.multiline ? "m" : "") +
                          (t.unicode ? "u" : "") +
                          (t.sticky ? "y" : ""),
                        u = 0,
                        h = new RegExp(t.source, c + "g");
                      (r = Vn.call(h, i)) &&
                      !(
                        (s = h.lastIndex) > u &&
                        (l.push(i.slice(u, r.index)),
                        r.length > 1 &&
                          r.index < i.length &&
                          ui.apply(l, r.slice(1)),
                        (a = r[0].length),
                        (u = s),
                        l.length >= o)
                      );
                    )
                      h.lastIndex === r.index && h.lastIndex++;
                    return (
                      u === i.length
                        ? (!a && h.test("")) || l.push("")
                        : l.push(i.slice(u)),
                      l.length > o ? l.slice(0, o) : l
                    );
                  }
                : "0".split(void 0, 0).length
                  ? function (t, n) {
                      return void 0 === t && 0 === n ? [] : e.call(this, t, n);
                    }
                  : e),
            [
              function (e, n) {
                var o = y(this),
                  r = null == e ? void 0 : e[t];
                return void 0 !== r ? r.call(e, o, n) : i.call(String(o), e, n);
              },
              function (t, o) {
                var r = n(i, t, this, o, i !== e);
                if (r.done) return r.value;
                var s = _(t),
                  a = String(this),
                  l = ci(s, RegExp),
                  c = s.unicode,
                  u =
                    (s.ignoreCase ? "i" : "") +
                    (s.multiline ? "m" : "") +
                    (s.unicode ? "u" : "") +
                    (di ? "y" : "g"),
                  h = new l(di ? s : "^(?:" + s.source + ")", u),
                  d = void 0 === o ? 4294967295 : o >>> 0;
                if (0 === d) return [];
                if (0 === a.length) return null === Jn(h, a) ? [a] : [];
                for (var f = 0, p = 0, m = []; p < a.length; ) {
                  h.lastIndex = di ? p : 0;
                  var g,
                    v = Jn(h, di ? a : a.slice(p));
                  if (
                    null === v ||
                    (g = hi(st(h.lastIndex + (di ? 0 : p)), a.length)) === f
                  )
                    p = Zn(a, p, c);
                  else {
                    if ((m.push(a.slice(f, p)), m.length === d)) return m;
                    for (var y = 1; y <= v.length - 1; y++)
                      if ((m.push(v[y]), m.length === d)) return m;
                    p = f = g;
                  }
                }
                return (m.push(a.slice(f)), m);
              },
            ]
          );
        },
        !di,
      );
      var fi = {
          CSSRuleList: 0,
          CSSStyleDeclaration: 0,
          CSSValueList: 0,
          ClientRectList: 0,
          DOMRectList: 0,
          DOMStringList: 0,
          DOMTokenList: 1,
          DataTransferItemList: 0,
          FileList: 0,
          HTMLAllCollection: 0,
          HTMLCollection: 0,
          HTMLFormElement: 0,
          HTMLSelectElement: 0,
          MediaList: 0,
          MimeTypeArray: 0,
          NamedNodeMap: 0,
          NodeList: 1,
          PaintRequestList: 0,
          Plugin: 0,
          PluginArray: 0,
          SVGLengthList: 0,
          SVGNumberList: 0,
          SVGPathSegList: 0,
          SVGPointList: 0,
          SVGStringList: 0,
          SVGTransformList: 0,
          SourceBufferList: 0,
          StyleSheetList: 0,
          TextTrackCueList: 0,
          TextTrackList: 0,
          TouchList: 0,
        },
        pi = oe.forEach,
        mi = mn("forEach")
          ? function (t) {
              return pi(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
          : [].forEach;
      for (var gi in fi) {
        var vi = a[gi],
          yi = vi && vi.prototype;
        if (yi && yi.forEach !== mi)
          try {
            M(yi, "forEach", mi);
          } catch (t) {
            yi.forEach = mi;
          }
      }
      var bi = Ut("iterator"),
        wi = Ut("toStringTag"),
        xi = pn.values;
      for (var Si in fi) {
        var ki = a[Si],
          Ei = ki && ki.prototype;
        if (Ei) {
          if (Ei[bi] !== xi)
            try {
              M(Ei, bi, xi);
            } catch (t) {
              Ei[bi] = xi;
            }
          if ((Ei[wi] || M(Ei, wi, Si), fi[Si]))
            for (var Ci in pn)
              if (Ei[Ci] !== pn[Ci])
                try {
                  M(Ei, Ci, pn[Ci]);
                } catch (t) {
                  Ei[Ci] = pn[Ci];
                }
        }
      }
      var Ti = Ut("iterator"),
        Pi = !l(function () {
          var t = new URL("b?e=1", "http://a"),
            e = t.searchParams;
          return (
            (t.pathname = "c%20d"),
            !e.sort ||
              "http://a/c%20d?e=1" !== t.href ||
              "1" !== e.get("e") ||
              "a=1" !== String(new URLSearchParams("?a=1")) ||
              !e[Ti] ||
              "a" !== new URL("https://a@b").username ||
              "b" !==
                new URLSearchParams(new URLSearchParams("a=b")).get("a") ||
              "xn--e1aybc" !== new URL("http://тест").host ||
              "#%D0%B1" !== new URL("http://a#б").hash
          );
        }),
        Ai = function (t, e, n) {
          if (!(t instanceof e))
            throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
          return t;
        },
        Ii = Object.assign,
        _i =
          !Ii ||
          l(function () {
            var t = {},
              e = {},
              n = Symbol();
            return (
              (t[n] = 7),
              "abcdefghijklmnopqrst".split("").forEach(function (t) {
                e[t] = t;
              }),
              7 != Ii({}, t)[n] ||
                "abcdefghijklmnopqrst" != zt(Ii({}, e)).join("")
            );
          })
            ? function (t, e) {
                for (
                  var n = Lt(t), i = arguments.length, o = 1, r = vt.f, s = d.f;
                  i > o;
                )
                  for (
                    var a,
                      l = v(arguments[o++]),
                      u = r ? zt(l).concat(r(l)) : zt(l),
                      h = u.length,
                      f = 0;
                    h > f;
                  )
                    ((a = u[f++]), (c && !s.call(l, a)) || (n[a] = l[a]));
                return n;
              }
            : Ii,
        Li = function (t, e, n, i) {
          try {
            return i ? e(_(n)[0], n[1]) : e(n);
          } catch (e) {
            var o = t.return;
            throw (void 0 !== o && _(o.call(t)), e);
          }
        },
        zi = Ut("iterator"),
        Mi = Array.prototype,
        ji = function (t) {
          return void 0 !== t && (Xe.Array === t || Mi[zi] === t);
        },
        Oi = Ut("iterator"),
        Di = function (t) {
          if (null != t) return t[Oi] || t["@@iterator"] || Xe[Pn(t)];
        },
        Fi = function (t) {
          var e,
            n,
            i,
            o,
            r = Lt(t),
            s = "function" == typeof this ? this : Array,
            a = arguments.length,
            l = a > 1 ? arguments[1] : void 0,
            c = void 0 !== l,
            u = 0,
            h = Di(r);
          if (
            (c && (l = Jt(l, a > 2 ? arguments[2] : void 0, 2)),
            null == h || (s == Array && ji(h)))
          )
            for (n = new s((e = st(r.length))); e > u; u++)
              bn(n, u, c ? l(r[u], u) : r[u]);
          else
            for (o = h.call(r), n = new s(); !(i = o.next()).done; u++)
              bn(n, u, c ? Li(o, l, [i.value, u], !0) : i.value);
          return ((n.length = u), n);
        },
        Ri = /[^\0-\u007E]/,
        Ni = /[.\u3002\uFF0E\uFF61]/g,
        $i = "Overflow: input needs wider integers to process",
        qi = Math.floor,
        Hi = String.fromCharCode,
        Wi = function (t) {
          return t + 22 + 75 * (t < 26);
        },
        Bi = function (t, e, n) {
          var i = 0;
          for (t = n ? qi(t / 700) : t >> 1, t += qi(t / e); t > 455; i += 36)
            t = qi(t / 35);
          return qi(i + (36 * t) / (t + 38));
        },
        Ui = function (t) {
          var e,
            n,
            i = [],
            o = (t = (function (t) {
              for (var e = [], n = 0, i = t.length; n < i; ) {
                var o = t.charCodeAt(n++);
                if (o >= 55296 && o <= 56319 && n < i) {
                  var r = t.charCodeAt(n++);
                  56320 == (64512 & r)
                    ? e.push(((1023 & o) << 10) + (1023 & r) + 65536)
                    : (e.push(o), n--);
                } else e.push(o);
              }
              return e;
            })(t)).length,
            r = 128,
            s = 0,
            a = 72;
          for (e = 0; e < t.length; e++) (n = t[e]) < 128 && i.push(Hi(n));
          var l = i.length,
            c = l;
          for (l && i.push("-"); c < o; ) {
            var u = 2147483647;
            for (e = 0; e < t.length; e++) (n = t[e]) >= r && n < u && (u = n);
            var h = c + 1;
            if (u - r > qi((2147483647 - s) / h)) throw RangeError($i);
            for (s += (u - r) * h, r = u, e = 0; e < t.length; e++) {
              if ((n = t[e]) < r && ++s > 2147483647) throw RangeError($i);
              if (n == r) {
                for (var d = s, f = 36; ; f += 36) {
                  var p = f <= a ? 1 : f >= a + 26 ? 26 : f - a;
                  if (d < p) break;
                  var m = d - p,
                    g = 36 - p;
                  (i.push(Hi(Wi(p + (m % g)))), (d = qi(m / g)));
                }
                (i.push(Hi(Wi(d))), (a = Bi(s, h, c == l)), (s = 0), ++c);
              }
            }
            (++s, ++r);
          }
          return i.join("");
        },
        Vi = function (t, e, n) {
          for (var i in e) Z(t, i, e[i], n);
          return t;
        },
        Yi = function (t) {
          var e = Di(t);
          if ("function" != typeof e)
            throw TypeError(String(t) + " is not iterable");
          return _(e.call(t));
        },
        Xi = Ut("iterator"),
        Qi = K.set,
        Gi = K.getterFor("URLSearchParams"),
        Ki = K.getterFor("URLSearchParamsIterator"),
        Zi = /\+/g,
        Ji = Array(4),
        to = function (t) {
          return (
            Ji[t - 1] ||
            (Ji[t - 1] = RegExp("((?:%[\\da-f]{2}){" + t + "})", "gi"))
          );
        },
        eo = function (t) {
          try {
            return decodeURIComponent(t);
          } catch (e) {
            return t;
          }
        },
        no = function (t) {
          var e = t.replace(Zi, " "),
            n = 4;
          try {
            return decodeURIComponent(e);
          } catch (t) {
            for (; n; ) e = e.replace(to(n--), eo);
            return e;
          }
        },
        io = /[!'()~]|%20/g,
        oo = {
          "!": "%21",
          "'": "%27",
          "(": "%28",
          ")": "%29",
          "~": "%7E",
          "%20": "+",
        },
        ro = function (t) {
          return oo[t];
        },
        so = function (t) {
          return encodeURIComponent(t).replace(io, ro);
        },
        ao = function (t, e) {
          if (e)
            for (var n, i, o = e.split("&"), r = 0; r < o.length; )
              (n = o[r++]).length &&
                ((i = n.split("=")),
                t.push({ key: no(i.shift()), value: no(i.join("=")) }));
        },
        lo = function (t) {
          ((this.entries.length = 0), ao(this.entries, t));
        },
        co = function (t, e) {
          if (t < e) throw TypeError("Not enough arguments");
        },
        uo = rn(
          function (t, e) {
            Qi(this, {
              type: "URLSearchParamsIterator",
              iterator: Yi(Gi(t).entries),
              kind: e,
            });
          },
          "Iterator",
          function () {
            var t = Ki(this),
              e = t.kind,
              n = t.iterator.next(),
              i = n.value;
            return (
              n.done ||
                (n.value =
                  "keys" === e
                    ? i.key
                    : "values" === e
                      ? i.value
                      : [i.key, i.value]),
              n
            );
          },
        ),
        ho = function () {
          Ai(this, ho, "URLSearchParams");
          var t,
            e,
            n,
            i,
            o,
            r,
            s,
            a = arguments.length > 0 ? arguments[0] : void 0,
            l = [];
          if (
            (Qi(this, {
              type: "URLSearchParams",
              entries: l,
              updateURL: function () {},
              updateSearchParams: lo,
            }),
            void 0 !== a)
          )
            if (w(a))
              if ("function" == typeof (t = Di(a)))
                for (e = t.call(a); !(n = e.next()).done; ) {
                  if (
                    (o = (i = Yi(_(n.value))).next()).done ||
                    (r = i.next()).done ||
                    !i.next().done
                  )
                    throw TypeError("Expected sequence with length 2");
                  l.push({ key: o.value + "", value: r.value + "" });
                }
              else for (s in a) k(a, s) && l.push({ key: s, value: a[s] + "" });
            else
              ao(
                l,
                "string" == typeof a
                  ? "?" === a.charAt(0)
                    ? a.slice(1)
                    : a
                  : a + "",
              );
        },
        fo = ho.prototype;
      (Vi(
        fo,
        {
          append: function (t, e) {
            co(arguments.length, 2);
            var n = Gi(this);
            (n.entries.push({ key: t + "", value: e + "" }), n.updateURL());
          },
          delete: function (t) {
            co(arguments.length, 1);
            for (
              var e = Gi(this), n = e.entries, i = t + "", o = 0;
              o < n.length;
            )
              n[o].key === i ? n.splice(o, 1) : o++;
            e.updateURL();
          },
          get: function (t) {
            co(arguments.length, 1);
            for (var e = Gi(this).entries, n = t + "", i = 0; i < e.length; i++)
              if (e[i].key === n) return e[i].value;
            return null;
          },
          getAll: function (t) {
            co(arguments.length, 1);
            for (
              var e = Gi(this).entries, n = t + "", i = [], o = 0;
              o < e.length;
              o++
            )
              e[o].key === n && i.push(e[o].value);
            return i;
          },
          has: function (t) {
            co(arguments.length, 1);
            for (var e = Gi(this).entries, n = t + "", i = 0; i < e.length; )
              if (e[i++].key === n) return !0;
            return !1;
          },
          set: function (t, e) {
            co(arguments.length, 1);
            for (
              var n,
                i = Gi(this),
                o = i.entries,
                r = !1,
                s = t + "",
                a = e + "",
                l = 0;
              l < o.length;
              l++
            )
              (n = o[l]).key === s &&
                (r ? o.splice(l--, 1) : ((r = !0), (n.value = a)));
            (r || o.push({ key: s, value: a }), i.updateURL());
          },
          sort: function () {
            var t,
              e,
              n,
              i = Gi(this),
              o = i.entries,
              r = o.slice();
            for (o.length = 0, n = 0; n < r.length; n++) {
              for (t = r[n], e = 0; e < n; e++)
                if (o[e].key > t.key) {
                  o.splice(e, 0, t);
                  break;
                }
              e === n && o.push(t);
            }
            i.updateURL();
          },
          forEach: function (t) {
            for (
              var e,
                n = Gi(this).entries,
                i = Jt(t, arguments.length > 1 ? arguments[1] : void 0, 3),
                o = 0;
              o < n.length;
            )
              i((e = n[o++]).value, e.key, this);
          },
          keys: function () {
            return new uo(this, "keys");
          },
          values: function () {
            return new uo(this, "values");
          },
          entries: function () {
            return new uo(this, "entries");
          },
        },
        { enumerable: !0 },
      ),
        Z(fo, Xi, fo.entries),
        Z(
          fo,
          "toString",
          function () {
            for (var t, e = Gi(this).entries, n = [], i = 0; i < e.length; )
              ((t = e[i++]), n.push(so(t.key) + "=" + so(t.value)));
            return n.join("&");
          },
          { enumerable: !0 },
        ),
        Kt(ho, "URLSearchParams"),
        At({ global: !0, forced: !Pi }, { URLSearchParams: ho }));
      var po,
        mo = { URLSearchParams: ho, getState: Gi },
        go = Fn.codeAt,
        vo = a.URL,
        yo = mo.URLSearchParams,
        bo = mo.getState,
        wo = K.set,
        xo = K.getterFor("URL"),
        So = Math.floor,
        ko = Math.pow,
        Eo = /[A-Za-z]/,
        Co = /[\d+\-.A-Za-z]/,
        To = /\d/,
        Po = /^(0x|0X)/,
        Ao = /^[0-7]+$/,
        Io = /^\d+$/,
        _o = /^[\dA-Fa-f]+$/,
        Lo = /[\u0000\u0009\u000A\u000D #%\/:?@[\\]]/,
        zo = /[\u0000\u0009\u000A\u000D #\/:?@[\\]]/,
        Mo = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
        jo = /[\u0009\u000A\u000D]/g,
        Oo = function (t, e) {
          var n, i, o;
          if ("[" == e.charAt(0)) {
            if ("]" != e.charAt(e.length - 1)) return "Invalid host";
            if (!(n = Fo(e.slice(1, -1)))) return "Invalid host";
            t.host = n;
          } else if (Uo(t)) {
            if (
              ((e = (function (t) {
                var e,
                  n,
                  i = [],
                  o = t.toLowerCase().replace(Ni, ".").split(".");
                for (e = 0; e < o.length; e++)
                  ((n = o[e]), i.push(Ri.test(n) ? "xn--" + Ui(n) : n));
                return i.join(".");
              })(e)),
              Lo.test(e))
            )
              return "Invalid host";
            if (null === (n = Do(e))) return "Invalid host";
            t.host = n;
          } else {
            if (zo.test(e)) return "Invalid host";
            for (n = "", i = Fi(e), o = 0; o < i.length; o++) n += Wo(i[o], No);
            t.host = n;
          }
        },
        Do = function (t) {
          var e,
            n,
            i,
            o,
            r,
            s,
            a,
            l = t.split(".");
          if (
            (l.length && "" == l[l.length - 1] && l.pop(), (e = l.length) > 4)
          )
            return t;
          for (n = [], i = 0; i < e; i++) {
            if ("" == (o = l[i])) return t;
            if (
              ((r = 10),
              o.length > 1 &&
                "0" == o.charAt(0) &&
                ((r = Po.test(o) ? 16 : 8), (o = o.slice(8 == r ? 1 : 2))),
              "" === o)
            )
              s = 0;
            else {
              if (!(10 == r ? Io : 8 == r ? Ao : _o).test(o)) return t;
              s = parseInt(o, r);
            }
            n.push(s);
          }
          for (i = 0; i < e; i++)
            if (((s = n[i]), i == e - 1)) {
              if (s >= ko(256, 5 - e)) return null;
            } else if (s > 255) return null;
          for (a = n.pop(), i = 0; i < n.length; i++)
            a += n[i] * ko(256, 3 - i);
          return a;
        },
        Fo = function (t) {
          var e,
            n,
            i,
            o,
            r,
            s,
            a,
            l = [0, 0, 0, 0, 0, 0, 0, 0],
            c = 0,
            u = null,
            h = 0,
            d = function () {
              return t.charAt(h);
            };
          if (":" == d()) {
            if (":" != t.charAt(1)) return;
            ((h += 2), (u = ++c));
          }
          for (; d(); ) {
            if (8 == c) return;
            if (":" != d()) {
              for (e = n = 0; n < 4 && _o.test(d()); )
                ((e = 16 * e + parseInt(d(), 16)), h++, n++);
              if ("." == d()) {
                if (0 == n) return;
                if (((h -= n), c > 6)) return;
                for (i = 0; d(); ) {
                  if (((o = null), i > 0)) {
                    if (!("." == d() && i < 4)) return;
                    h++;
                  }
                  if (!To.test(d())) return;
                  for (; To.test(d()); ) {
                    if (((r = parseInt(d(), 10)), null === o)) o = r;
                    else {
                      if (0 == o) return;
                      o = 10 * o + r;
                    }
                    if (o > 255) return;
                    h++;
                  }
                  ((l[c] = 256 * l[c] + o), (2 != ++i && 4 != i) || c++);
                }
                if (4 != i) return;
                break;
              }
              if (":" == d()) {
                if ((h++, !d())) return;
              } else if (d()) return;
              l[c++] = e;
            } else {
              if (null !== u) return;
              (h++, (u = ++c));
            }
          }
          if (null !== u)
            for (s = c - u, c = 7; 0 != c && s > 0; )
              ((a = l[c]), (l[c--] = l[u + s - 1]), (l[u + --s] = a));
          else if (8 != c) return;
          return l;
        },
        Ro = function (t) {
          var e, n, i, o;
          if ("number" == typeof t) {
            for (e = [], n = 0; n < 4; n++)
              (e.unshift(t % 256), (t = So(t / 256)));
            return e.join(".");
          }
          if ("object" == typeof t) {
            for (
              e = "",
                i = (function (t) {
                  for (var e = null, n = 1, i = null, o = 0, r = 0; r < 8; r++)
                    0 !== t[r]
                      ? (o > n && ((e = i), (n = o)), (i = null), (o = 0))
                      : (null === i && (i = r), ++o);
                  return (o > n && ((e = i), (n = o)), e);
                })(t),
                n = 0;
              n < 8;
              n++
            )
              (o && 0 === t[n]) ||
                (o && (o = !1),
                i === n
                  ? ((e += n ? ":" : "::"), (o = !0))
                  : ((e += t[n].toString(16)), n < 7 && (e += ":")));
            return "[" + e + "]";
          }
          return t;
        },
        No = {},
        $o = _i({}, No, { " ": 1, '"': 1, "<": 1, ">": 1, "`": 1 }),
        qo = _i({}, $o, { "#": 1, "?": 1, "{": 1, "}": 1 }),
        Ho = _i({}, qo, {
          "/": 1,
          ":": 1,
          ";": 1,
          "=": 1,
          "@": 1,
          "[": 1,
          "\\": 1,
          "]": 1,
          "^": 1,
          "|": 1,
        }),
        Wo = function (t, e) {
          var n = go(t, 0);
          return n > 32 && n < 127 && !k(e, t) ? t : encodeURIComponent(t);
        },
        Bo = {
          ftp: 21,
          file: null,
          gopher: 70,
          http: 80,
          https: 443,
          ws: 80,
          wss: 443,
        },
        Uo = function (t) {
          return k(Bo, t.scheme);
        },
        Vo = function (t) {
          return "" != t.username || "" != t.password;
        },
        Yo = function (t) {
          return !t.host || t.cannotBeABaseURL || "file" == t.scheme;
        },
        Xo = function (t, e) {
          var n;
          return (
            2 == t.length &&
            Eo.test(t.charAt(0)) &&
            (":" == (n = t.charAt(1)) || (!e && "|" == n))
          );
        },
        Qo = function (t) {
          var e;
          return (
            t.length > 1 &&
            Xo(t.slice(0, 2)) &&
            (2 == t.length ||
              "/" === (e = t.charAt(2)) ||
              "\\" === e ||
              "?" === e ||
              "#" === e)
          );
        },
        Go = function (t) {
          var e = t.path,
            n = e.length;
          !n || ("file" == t.scheme && 1 == n && Xo(e[0], !0)) || e.pop();
        },
        Ko = function (t) {
          return "." === t || "%2e" === t.toLowerCase();
        },
        Zo = {},
        Jo = {},
        tr = {},
        er = {},
        nr = {},
        ir = {},
        or = {},
        rr = {},
        sr = {},
        ar = {},
        lr = {},
        cr = {},
        ur = {},
        hr = {},
        dr = {},
        fr = {},
        pr = {},
        mr = {},
        gr = {},
        vr = {},
        yr = {},
        br = function (t, e, n, i) {
          var o,
            r,
            s,
            a,
            l,
            c = n || Zo,
            u = 0,
            h = "",
            d = !1,
            f = !1,
            p = !1;
          for (
            n ||
              ((t.scheme = ""),
              (t.username = ""),
              (t.password = ""),
              (t.host = null),
              (t.port = null),
              (t.path = []),
              (t.query = null),
              (t.fragment = null),
              (t.cannotBeABaseURL = !1),
              (e = e.replace(Mo, ""))),
              e = e.replace(jo, ""),
              o = Fi(e);
            u <= o.length;
          ) {
            switch (((r = o[u]), c)) {
              case Zo:
                if (!r || !Eo.test(r)) {
                  if (n) return "Invalid scheme";
                  c = tr;
                  continue;
                }
                ((h += r.toLowerCase()), (c = Jo));
                break;
              case Jo:
                if (r && (Co.test(r) || "+" == r || "-" == r || "." == r))
                  h += r.toLowerCase();
                else {
                  if (":" != r) {
                    if (n) return "Invalid scheme";
                    ((h = ""), (c = tr), (u = 0));
                    continue;
                  }
                  if (
                    n &&
                    (Uo(t) != k(Bo, h) ||
                      ("file" == h && (Vo(t) || null !== t.port)) ||
                      ("file" == t.scheme && !t.host))
                  )
                    return;
                  if (((t.scheme = h), n))
                    return void (
                      Uo(t) &&
                      Bo[t.scheme] == t.port &&
                      (t.port = null)
                    );
                  ((h = ""),
                    "file" == t.scheme
                      ? (c = hr)
                      : Uo(t) && i && i.scheme == t.scheme
                        ? (c = er)
                        : Uo(t)
                          ? (c = rr)
                          : "/" == o[u + 1]
                            ? ((c = nr), u++)
                            : ((t.cannotBeABaseURL = !0),
                              t.path.push(""),
                              (c = gr)));
                }
                break;
              case tr:
                if (!i || (i.cannotBeABaseURL && "#" != r))
                  return "Invalid scheme";
                if (i.cannotBeABaseURL && "#" == r) {
                  ((t.scheme = i.scheme),
                    (t.path = i.path.slice()),
                    (t.query = i.query),
                    (t.fragment = ""),
                    (t.cannotBeABaseURL = !0),
                    (c = yr));
                  break;
                }
                c = "file" == i.scheme ? hr : ir;
                continue;
              case er:
                if ("/" != r || "/" != o[u + 1]) {
                  c = ir;
                  continue;
                }
                ((c = sr), u++);
                break;
              case nr:
                if ("/" == r) {
                  c = ar;
                  break;
                }
                c = mr;
                continue;
              case ir:
                if (((t.scheme = i.scheme), r == po))
                  ((t.username = i.username),
                    (t.password = i.password),
                    (t.host = i.host),
                    (t.port = i.port),
                    (t.path = i.path.slice()),
                    (t.query = i.query));
                else if ("/" == r || ("\\" == r && Uo(t))) c = or;
                else if ("?" == r)
                  ((t.username = i.username),
                    (t.password = i.password),
                    (t.host = i.host),
                    (t.port = i.port),
                    (t.path = i.path.slice()),
                    (t.query = ""),
                    (c = vr));
                else {
                  if ("#" != r) {
                    ((t.username = i.username),
                      (t.password = i.password),
                      (t.host = i.host),
                      (t.port = i.port),
                      (t.path = i.path.slice()),
                      t.path.pop(),
                      (c = mr));
                    continue;
                  }
                  ((t.username = i.username),
                    (t.password = i.password),
                    (t.host = i.host),
                    (t.port = i.port),
                    (t.path = i.path.slice()),
                    (t.query = i.query),
                    (t.fragment = ""),
                    (c = yr));
                }
                break;
              case or:
                if (!Uo(t) || ("/" != r && "\\" != r)) {
                  if ("/" != r) {
                    ((t.username = i.username),
                      (t.password = i.password),
                      (t.host = i.host),
                      (t.port = i.port),
                      (c = mr));
                    continue;
                  }
                  c = ar;
                } else c = sr;
                break;
              case rr:
                if (((c = sr), "/" != r || "/" != h.charAt(u + 1))) continue;
                u++;
                break;
              case sr:
                if ("/" != r && "\\" != r) {
                  c = ar;
                  continue;
                }
                break;
              case ar:
                if ("@" == r) {
                  (d && (h = "%40" + h), (d = !0), (s = Fi(h)));
                  for (var m = 0; m < s.length; m++) {
                    var g = s[m];
                    if (":" != g || p) {
                      var v = Wo(g, Ho);
                      p ? (t.password += v) : (t.username += v);
                    } else p = !0;
                  }
                  h = "";
                } else if (
                  r == po ||
                  "/" == r ||
                  "?" == r ||
                  "#" == r ||
                  ("\\" == r && Uo(t))
                ) {
                  if (d && "" == h) return "Invalid authority";
                  ((u -= Fi(h).length + 1), (h = ""), (c = lr));
                } else h += r;
                break;
              case lr:
              case cr:
                if (n && "file" == t.scheme) {
                  c = fr;
                  continue;
                }
                if (":" != r || f) {
                  if (
                    r == po ||
                    "/" == r ||
                    "?" == r ||
                    "#" == r ||
                    ("\\" == r && Uo(t))
                  ) {
                    if (Uo(t) && "" == h) return "Invalid host";
                    if (n && "" == h && (Vo(t) || null !== t.port)) return;
                    if ((a = Oo(t, h))) return a;
                    if (((h = ""), (c = pr), n)) return;
                    continue;
                  }
                  ("[" == r ? (f = !0) : "]" == r && (f = !1), (h += r));
                } else {
                  if ("" == h) return "Invalid host";
                  if ((a = Oo(t, h))) return a;
                  if (((h = ""), (c = ur), n == cr)) return;
                }
                break;
              case ur:
                if (!To.test(r)) {
                  if (
                    r == po ||
                    "/" == r ||
                    "?" == r ||
                    "#" == r ||
                    ("\\" == r && Uo(t)) ||
                    n
                  ) {
                    if ("" != h) {
                      var y = parseInt(h, 10);
                      if (y > 65535) return "Invalid port";
                      ((t.port = Uo(t) && y === Bo[t.scheme] ? null : y),
                        (h = ""));
                    }
                    if (n) return;
                    c = pr;
                    continue;
                  }
                  return "Invalid port";
                }
                h += r;
                break;
              case hr:
                if (((t.scheme = "file"), "/" == r || "\\" == r)) c = dr;
                else {
                  if (!i || "file" != i.scheme) {
                    c = mr;
                    continue;
                  }
                  if (r == po)
                    ((t.host = i.host),
                      (t.path = i.path.slice()),
                      (t.query = i.query));
                  else if ("?" == r)
                    ((t.host = i.host),
                      (t.path = i.path.slice()),
                      (t.query = ""),
                      (c = vr));
                  else {
                    if ("#" != r) {
                      (Qo(o.slice(u).join("")) ||
                        ((t.host = i.host), (t.path = i.path.slice()), Go(t)),
                        (c = mr));
                      continue;
                    }
                    ((t.host = i.host),
                      (t.path = i.path.slice()),
                      (t.query = i.query),
                      (t.fragment = ""),
                      (c = yr));
                  }
                }
                break;
              case dr:
                if ("/" == r || "\\" == r) {
                  c = fr;
                  break;
                }
                (i &&
                  "file" == i.scheme &&
                  !Qo(o.slice(u).join("")) &&
                  (Xo(i.path[0], !0)
                    ? t.path.push(i.path[0])
                    : (t.host = i.host)),
                  (c = mr));
                continue;
              case fr:
                if (r == po || "/" == r || "\\" == r || "?" == r || "#" == r) {
                  if (!n && Xo(h)) c = mr;
                  else if ("" == h) {
                    if (((t.host = ""), n)) return;
                    c = pr;
                  } else {
                    if ((a = Oo(t, h))) return a;
                    if (("localhost" == t.host && (t.host = ""), n)) return;
                    ((h = ""), (c = pr));
                  }
                  continue;
                }
                h += r;
                break;
              case pr:
                if (Uo(t)) {
                  if (((c = mr), "/" != r && "\\" != r)) continue;
                } else if (n || "?" != r)
                  if (n || "#" != r) {
                    if (r != po && ((c = mr), "/" != r)) continue;
                  } else ((t.fragment = ""), (c = yr));
                else ((t.query = ""), (c = vr));
                break;
              case mr:
                if (
                  r == po ||
                  "/" == r ||
                  ("\\" == r && Uo(t)) ||
                  (!n && ("?" == r || "#" == r))
                ) {
                  if (
                    (".." === (l = (l = h).toLowerCase()) ||
                    "%2e." === l ||
                    ".%2e" === l ||
                    "%2e%2e" === l
                      ? (Go(t),
                        "/" == r || ("\\" == r && Uo(t)) || t.path.push(""))
                      : Ko(h)
                        ? "/" == r || ("\\" == r && Uo(t)) || t.path.push("")
                        : ("file" == t.scheme &&
                            !t.path.length &&
                            Xo(h) &&
                            (t.host && (t.host = ""), (h = h.charAt(0) + ":")),
                          t.path.push(h)),
                    (h = ""),
                    "file" == t.scheme && (r == po || "?" == r || "#" == r))
                  )
                    for (; t.path.length > 1 && "" === t.path[0]; )
                      t.path.shift();
                  "?" == r
                    ? ((t.query = ""), (c = vr))
                    : "#" == r && ((t.fragment = ""), (c = yr));
                } else h += Wo(r, qo);
                break;
              case gr:
                "?" == r
                  ? ((t.query = ""), (c = vr))
                  : "#" == r
                    ? ((t.fragment = ""), (c = yr))
                    : r != po && (t.path[0] += Wo(r, No));
                break;
              case vr:
                n || "#" != r
                  ? r != po &&
                    ("'" == r && Uo(t)
                      ? (t.query += "%27")
                      : (t.query += "#" == r ? "%23" : Wo(r, No)))
                  : ((t.fragment = ""), (c = yr));
                break;
              case yr:
                r != po && (t.fragment += Wo(r, $o));
            }
            u++;
          }
        },
        wr = function (t) {
          var e,
            n,
            i = Ai(this, wr, "URL"),
            o = arguments.length > 1 ? arguments[1] : void 0,
            r = String(t),
            s = wo(i, { type: "URL" });
          if (void 0 !== o)
            if (o instanceof wr) e = xo(o);
            else if ((n = br((e = {}), String(o)))) throw TypeError(n);
          if ((n = br(s, r, null, e))) throw TypeError(n);
          var a = (s.searchParams = new yo()),
            l = bo(a);
          (l.updateSearchParams(s.query),
            (l.updateURL = function () {
              s.query = String(a) || null;
            }),
            c ||
              ((i.href = Sr.call(i)),
              (i.origin = kr.call(i)),
              (i.protocol = Er.call(i)),
              (i.username = Cr.call(i)),
              (i.password = Tr.call(i)),
              (i.host = Pr.call(i)),
              (i.hostname = Ar.call(i)),
              (i.port = Ir.call(i)),
              (i.pathname = _r.call(i)),
              (i.search = Lr.call(i)),
              (i.searchParams = zr.call(i)),
              (i.hash = Mr.call(i))));
        },
        xr = wr.prototype,
        Sr = function () {
          var t = xo(this),
            e = t.scheme,
            n = t.username,
            i = t.password,
            o = t.host,
            r = t.port,
            s = t.path,
            a = t.query,
            l = t.fragment,
            c = e + ":";
          return (
            null !== o
              ? ((c += "//"),
                Vo(t) && (c += n + (i ? ":" + i : "") + "@"),
                (c += Ro(o)),
                null !== r && (c += ":" + r))
              : "file" == e && (c += "//"),
            (c += t.cannotBeABaseURL
              ? s[0]
              : s.length
                ? "/" + s.join("/")
                : ""),
            null !== a && (c += "?" + a),
            null !== l && (c += "#" + l),
            c
          );
        },
        kr = function () {
          var t = xo(this),
            e = t.scheme,
            n = t.port;
          if ("blob" == e)
            try {
              return new URL(e.path[0]).origin;
            } catch (t) {
              return "null";
            }
          return "file" != e && Uo(t)
            ? e + "://" + Ro(t.host) + (null !== n ? ":" + n : "")
            : "null";
        },
        Er = function () {
          return xo(this).scheme + ":";
        },
        Cr = function () {
          return xo(this).username;
        },
        Tr = function () {
          return xo(this).password;
        },
        Pr = function () {
          var t = xo(this),
            e = t.host,
            n = t.port;
          return null === e ? "" : null === n ? Ro(e) : Ro(e) + ":" + n;
        },
        Ar = function () {
          var t = xo(this).host;
          return null === t ? "" : Ro(t);
        },
        Ir = function () {
          var t = xo(this).port;
          return null === t ? "" : String(t);
        },
        _r = function () {
          var t = xo(this),
            e = t.path;
          return t.cannotBeABaseURL ? e[0] : e.length ? "/" + e.join("/") : "";
        },
        Lr = function () {
          var t = xo(this).query;
          return t ? "?" + t : "";
        },
        zr = function () {
          return xo(this).searchParams;
        },
        Mr = function () {
          var t = xo(this).fragment;
          return t ? "#" + t : "";
        },
        jr = function (t, e) {
          return { get: t, set: e, configurable: !0, enumerable: !0 };
        };
      if (
        (c &&
          Mt(xr, {
            href: jr(Sr, function (t) {
              var e = xo(this),
                n = String(t),
                i = br(e, n);
              if (i) throw TypeError(i);
              bo(e.searchParams).updateSearchParams(e.query);
            }),
            origin: jr(kr),
            protocol: jr(Er, function (t) {
              var e = xo(this);
              br(e, String(t) + ":", Zo);
            }),
            username: jr(Cr, function (t) {
              var e = xo(this),
                n = Fi(String(t));
              if (!Yo(e)) {
                e.username = "";
                for (var i = 0; i < n.length; i++) e.username += Wo(n[i], Ho);
              }
            }),
            password: jr(Tr, function (t) {
              var e = xo(this),
                n = Fi(String(t));
              if (!Yo(e)) {
                e.password = "";
                for (var i = 0; i < n.length; i++) e.password += Wo(n[i], Ho);
              }
            }),
            host: jr(Pr, function (t) {
              var e = xo(this);
              e.cannotBeABaseURL || br(e, String(t), lr);
            }),
            hostname: jr(Ar, function (t) {
              var e = xo(this);
              e.cannotBeABaseURL || br(e, String(t), cr);
            }),
            port: jr(Ir, function (t) {
              var e = xo(this);
              Yo(e) || ("" == (t = String(t)) ? (e.port = null) : br(e, t, ur));
            }),
            pathname: jr(_r, function (t) {
              var e = xo(this);
              e.cannotBeABaseURL || ((e.path = []), br(e, t + "", pr));
            }),
            search: jr(Lr, function (t) {
              var e = xo(this);
              ("" == (t = String(t))
                ? (e.query = null)
                : ("?" == t.charAt(0) && (t = t.slice(1)),
                  (e.query = ""),
                  br(e, t, vr)),
                bo(e.searchParams).updateSearchParams(e.query));
            }),
            searchParams: jr(zr),
            hash: jr(Mr, function (t) {
              var e = xo(this);
              "" != (t = String(t))
                ? ("#" == t.charAt(0) && (t = t.slice(1)),
                  (e.fragment = ""),
                  br(e, t, yr))
                : (e.fragment = null);
            }),
          }),
        Z(
          xr,
          "toJSON",
          function () {
            return Sr.call(this);
          },
          { enumerable: !0 },
        ),
        Z(
          xr,
          "toString",
          function () {
            return Sr.call(this);
          },
          { enumerable: !0 },
        ),
        vo)
      ) {
        var Or = vo.createObjectURL,
          Dr = vo.revokeObjectURL;
        (Or &&
          Z(wr, "createObjectURL", function (t) {
            return Or.apply(vo, arguments);
          }),
          Dr &&
            Z(wr, "revokeObjectURL", function (t) {
              return Dr.apply(vo, arguments);
            }));
      }
      function Fr(t) {
        return (Fr =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function Rr(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function Nr(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          ((i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i));
        }
      }
      function $r(t, e, n) {
        return (e && Nr(t.prototype, e), n && Nr(t, n), t);
      }
      function qr(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }
      function Hr(t, e) {
        return (
          (function (t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function (t, e) {
            var n = [],
              i = !0,
              o = !1,
              r = void 0;
            try {
              for (
                var s, a = t[Symbol.iterator]();
                !(i = (s = a.next()).done) &&
                (n.push(s.value), !e || n.length !== e);
                i = !0
              );
            } catch (t) {
              ((o = !0), (r = t));
            } finally {
              try {
                i || null == a.return || a.return();
              } finally {
                if (o) throw r;
              }
            }
            return n;
          })(t, e) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance",
            );
          })()
        );
      }
      function Wr(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) {
              for (var e = 0, n = new Array(t.length); e < t.length; e++)
                n[e] = t[e];
              return n;
            }
          })(t) ||
          (function (t) {
            if (
              Symbol.iterator in Object(t) ||
              "[object Arguments]" === Object.prototype.toString.call(t)
            )
              return Array.from(t);
          })(t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance",
            );
          })()
        );
      }
      (Kt(wr, "URL"),
        At({ global: !0, forced: !Pi, sham: !c }, { URL: wr }),
        (function (t) {
          var e = (function () {
              try {
                return !!Symbol.iterator;
              } catch (t) {
                return !1;
              }
            })(),
            n = function (t) {
              var n = {
                next: function () {
                  var e = t.shift();
                  return { done: void 0 === e, value: e };
                },
              };
              return (
                e &&
                  (n[Symbol.iterator] = function () {
                    return n;
                  }),
                n
              );
            },
            i = function (t) {
              return encodeURIComponent(t).replace(/%20/g, "+");
            },
            o = function (t) {
              return decodeURIComponent(String(t).replace(/\+/g, " "));
            };
          ("URLSearchParams" in t &&
            "a=1" === new t.URLSearchParams("?a=1").toString()) ||
            (function () {
              var o = function t(e) {
                  Object.defineProperty(this, "_entries", {
                    writable: !0,
                    value: {},
                  });
                  var n = Fr(e);
                  if ("undefined" === n);
                  else if ("string" === n) "" !== e && this._fromString(e);
                  else if (e instanceof t) {
                    var i = this;
                    e.forEach(function (t, e) {
                      i.append(e, t);
                    });
                  } else {
                    if (null === e || "object" !== n)
                      throw new TypeError(
                        "Unsupported input's type for URLSearchParams",
                      );
                    if ("[object Array]" === Object.prototype.toString.call(e))
                      for (var o = 0; o < e.length; o++) {
                        var r = e[o];
                        if (
                          "[object Array]" !==
                            Object.prototype.toString.call(r) &&
                          2 === r.length
                        )
                          throw new TypeError(
                            "Expected [string, any] as entry at index " +
                              o +
                              " of URLSearchParams's input",
                          );
                        this.append(r[0], r[1]);
                      }
                    else
                      for (var s in e)
                        e.hasOwnProperty(s) && this.append(s, e[s]);
                  }
                },
                r = o.prototype;
              ((r.append = function (t, e) {
                t in this._entries
                  ? this._entries[t].push(String(e))
                  : (this._entries[t] = [String(e)]);
              }),
                (r.delete = function (t) {
                  delete this._entries[t];
                }),
                (r.get = function (t) {
                  return t in this._entries ? this._entries[t][0] : null;
                }),
                (r.getAll = function (t) {
                  return t in this._entries ? this._entries[t].slice(0) : [];
                }),
                (r.has = function (t) {
                  return t in this._entries;
                }),
                (r.set = function (t, e) {
                  this._entries[t] = [String(e)];
                }),
                (r.forEach = function (t, e) {
                  var n;
                  for (var i in this._entries)
                    if (this._entries.hasOwnProperty(i)) {
                      n = this._entries[i];
                      for (var o = 0; o < n.length; o++)
                        t.call(e, n[o], i, this);
                    }
                }),
                (r.keys = function () {
                  var t = [];
                  return (
                    this.forEach(function (e, n) {
                      t.push(n);
                    }),
                    n(t)
                  );
                }),
                (r.values = function () {
                  var t = [];
                  return (
                    this.forEach(function (e) {
                      t.push(e);
                    }),
                    n(t)
                  );
                }),
                (r.entries = function () {
                  var t = [];
                  return (
                    this.forEach(function (e, n) {
                      t.push([n, e]);
                    }),
                    n(t)
                  );
                }),
                e && (r[Symbol.iterator] = r.entries),
                (r.toString = function () {
                  var t = [];
                  return (
                    this.forEach(function (e, n) {
                      t.push(i(n) + "=" + i(e));
                    }),
                    t.join("&")
                  );
                }),
                (t.URLSearchParams = o));
            })();
          var r = t.URLSearchParams.prototype;
          ("function" != typeof r.sort &&
            (r.sort = function () {
              var t = this,
                e = [];
              (this.forEach(function (n, i) {
                (e.push([i, n]), t._entries || t.delete(i));
              }),
                e.sort(function (t, e) {
                  return t[0] < e[0] ? -1 : t[0] > e[0] ? 1 : 0;
                }),
                t._entries && (t._entries = {}));
              for (var n = 0; n < e.length; n++) this.append(e[n][0], e[n][1]);
            }),
            "function" != typeof r._fromString &&
              Object.defineProperty(r, "_fromString", {
                enumerable: !1,
                configurable: !1,
                writable: !1,
                value: function (t) {
                  if (this._entries) this._entries = {};
                  else {
                    var e = [];
                    this.forEach(function (t, n) {
                      e.push(n);
                    });
                    for (var n = 0; n < e.length; n++) this.delete(e[n]);
                  }
                  var i,
                    r = (t = t.replace(/^\?/, "")).split("&");
                  for (n = 0; n < r.length; n++)
                    ((i = r[n].split("=")),
                      this.append(o(i[0]), i.length > 1 ? o(i[1]) : ""));
                },
              }));
        })(
          void 0 !== t
            ? t
            : "undefined" != typeof window
              ? window
              : "undefined" != typeof self
                ? self
                : t,
        ),
        (function (t) {
          if (
            ((function () {
              try {
                var e = new t.URL("b", "http://a");
                return (
                  (e.pathname = "c%20d"),
                  "http://a/c%20d" === e.href && e.searchParams
                );
              } catch (t) {
                return !1;
              }
            })() ||
              (function () {
                var e = t.URL,
                  n = function (e, n) {
                    "string" != typeof e && (e = String(e));
                    var i,
                      o = document;
                    if (n && (void 0 === t.location || n !== t.location.href)) {
                      (((i = (o =
                        document.implementation.createHTMLDocument(
                          "",
                        )).createElement("base")).href = n),
                        o.head.appendChild(i));
                      try {
                        if (0 !== i.href.indexOf(n)) throw new Error(i.href);
                      } catch (t) {
                        throw new Error(
                          "URL unable to set base " + n + " due to " + t,
                        );
                      }
                    }
                    var r = o.createElement("a");
                    if (
                      ((r.href = e),
                      i && (o.body.appendChild(r), (r.href = r.href)),
                      ":" === r.protocol || !/:/.test(r.href))
                    )
                      throw new TypeError("Invalid URL");
                    Object.defineProperty(this, "_anchorElement", { value: r });
                    var s = new t.URLSearchParams(this.search),
                      a = !0,
                      l = !0,
                      c = this;
                    (["append", "delete", "set"].forEach(function (t) {
                      var e = s[t];
                      s[t] = function () {
                        (e.apply(s, arguments),
                          a && ((l = !1), (c.search = s.toString()), (l = !0)));
                      };
                    }),
                      Object.defineProperty(this, "searchParams", {
                        value: s,
                        enumerable: !0,
                      }));
                    var u = void 0;
                    Object.defineProperty(this, "_updateSearchParams", {
                      enumerable: !1,
                      configurable: !1,
                      writable: !1,
                      value: function () {
                        this.search !== u &&
                          ((u = this.search),
                          l &&
                            ((a = !1),
                            this.searchParams._fromString(this.search),
                            (a = !0)));
                      },
                    });
                  },
                  i = n.prototype;
                (["hash", "host", "hostname", "port", "protocol"].forEach(
                  function (t) {
                    !(function (t) {
                      Object.defineProperty(i, t, {
                        get: function () {
                          return this._anchorElement[t];
                        },
                        set: function (e) {
                          this._anchorElement[t] = e;
                        },
                        enumerable: !0,
                      });
                    })(t);
                  },
                ),
                  Object.defineProperty(i, "search", {
                    get: function () {
                      return this._anchorElement.search;
                    },
                    set: function (t) {
                      ((this._anchorElement.search = t),
                        this._updateSearchParams());
                    },
                    enumerable: !0,
                  }),
                  Object.defineProperties(i, {
                    toString: {
                      get: function () {
                        var t = this;
                        return function () {
                          return t.href;
                        };
                      },
                    },
                    href: {
                      get: function () {
                        return this._anchorElement.href.replace(/\?$/, "");
                      },
                      set: function (t) {
                        ((this._anchorElement.href = t),
                          this._updateSearchParams());
                      },
                      enumerable: !0,
                    },
                    pathname: {
                      get: function () {
                        return this._anchorElement.pathname.replace(
                          /(^\/?)/,
                          "/",
                        );
                      },
                      set: function (t) {
                        this._anchorElement.pathname = t;
                      },
                      enumerable: !0,
                    },
                    origin: {
                      get: function () {
                        var t = { "http:": 80, "https:": 443, "ftp:": 21 }[
                            this._anchorElement.protocol
                          ],
                          e =
                            this._anchorElement.port != t &&
                            "" !== this._anchorElement.port;
                        return (
                          this._anchorElement.protocol +
                          "//" +
                          this._anchorElement.hostname +
                          (e ? ":" + this._anchorElement.port : "")
                        );
                      },
                      enumerable: !0,
                    },
                    password: {
                      get: function () {
                        return "";
                      },
                      set: function (t) {},
                      enumerable: !0,
                    },
                    username: {
                      get: function () {
                        return "";
                      },
                      set: function (t) {},
                      enumerable: !0,
                    },
                  }),
                  (n.createObjectURL = function (t) {
                    return e.createObjectURL.apply(e, arguments);
                  }),
                  (n.revokeObjectURL = function (t) {
                    return e.revokeObjectURL.apply(e, arguments);
                  }),
                  (t.URL = n));
              })(),
            void 0 !== t.location && !("origin" in t.location))
          ) {
            var e = function () {
              return (
                t.location.protocol +
                "//" +
                t.location.hostname +
                (t.location.port ? ":" + t.location.port : "")
              );
            };
            try {
              Object.defineProperty(t.location, "origin", {
                get: e,
                enumerable: !0,
              });
            } catch (n) {
              setInterval(function () {
                t.location.origin = e();
              }, 100);
            }
          }
        })(
          void 0 !== t
            ? t
            : "undefined" != typeof window
              ? window
              : "undefined" != typeof self
                ? self
                : t,
        ));
      var Br = Ut("isConcatSpreadable"),
        Ur = !l(function () {
          var t = [];
          return ((t[Br] = !1), t.concat()[0] !== t);
        }),
        Vr = xn("concat"),
        Yr = function (t) {
          if (!w(t)) return !1;
          var e = t[Br];
          return void 0 !== e ? !!e : _t(t);
        };
      At(
        { target: "Array", proto: !0, forced: !Ur || !Vr },
        {
          concat: function (t) {
            var e,
              n,
              i,
              o,
              r,
              s = Lt(this),
              a = ee(s, 0),
              l = 0;
            for (e = -1, i = arguments.length; e < i; e++)
              if (Yr((r = -1 === e ? s : arguments[e]))) {
                if (l + (o = st(r.length)) > 9007199254740991)
                  throw TypeError("Maximum allowed index exceeded");
                for (n = 0; n < o; n++, l++) n in r && bn(a, l, r[n]);
              } else {
                if (l >= 9007199254740991)
                  throw TypeError("Maximum allowed index exceeded");
                bn(a, l++, r);
              }
            return ((a.length = l), a);
          },
        },
      );
      var Xr = oe.filter;
      At(
        { target: "Array", proto: !0, forced: !xn("filter") },
        {
          filter: function (t) {
            return Xr(this, t, arguments.length > 1 ? arguments[1] : void 0);
          },
        },
      );
      var Qr = oe.find,
        Gr = !0;
      ("find" in [] &&
        Array(1).find(function () {
          Gr = !1;
        }),
        At(
          { target: "Array", proto: !0, forced: Gr },
          {
            find: function (t) {
              return Qr(this, t, arguments.length > 1 ? arguments[1] : void 0);
            },
          },
        ),
        Ye("find"));
      var Kr = Ut("iterator"),
        Zr = !1;
      try {
        var Jr = 0,
          ts = {
            next: function () {
              return { done: !!Jr++ };
            },
            return: function () {
              Zr = !0;
            },
          };
        ((ts[Kr] = function () {
          return this;
        }),
          Array.from(ts, function () {
            throw 2;
          }));
      } catch (t) {}
      var es = function (t, e) {
          if (!e && !Zr) return !1;
          var n = !1;
          try {
            var i = {};
            ((i[Kr] = function () {
              return {
                next: function () {
                  return { done: (n = !0) };
                },
              };
            }),
              t(i));
          } catch (t) {}
          return n;
        },
        ns = !es(function (t) {
          Array.from(t);
        });
      At({ target: "Array", stat: !0, forced: ns }, { from: Fi });
      var is = ht.includes;
      (At(
        { target: "Array", proto: !0 },
        {
          includes: function (t) {
            return is(this, t, arguments.length > 1 ? arguments[1] : void 0);
          },
        },
      ),
        Ye("includes"));
      var os = oe.map;
      At(
        { target: "Array", proto: !0, forced: !xn("map") },
        {
          map: function (t) {
            return os(this, t, arguments.length > 1 ? arguments[1] : void 0);
          },
        },
      );
      var rs = function (t, e, n) {
          var i, o;
          return (
            sn &&
              "function" == typeof (i = e.constructor) &&
              i !== n &&
              w((o = i.prototype)) &&
              o !== n.prototype &&
              sn(t, o),
            t
          );
        },
        ss = "\t\n\v\f\r                　\u2028\u2029\ufeff",
        as = "[" + ss + "]",
        ls = RegExp("^" + as + as + "*"),
        cs = RegExp(as + as + "*$"),
        us = function (t) {
          return function (e) {
            var n = String(y(e));
            return (
              1 & t && (n = n.replace(ls, "")),
              2 & t && (n = n.replace(cs, "")),
              n
            );
          };
        },
        hs = { start: us(1), end: us(2), trim: us(3) },
        ds = gt.f,
        fs = I.f,
        ps = z.f,
        ms = hs.trim,
        gs = a.Number,
        vs = gs.prototype,
        ys = "Number" == m(Rt(vs)),
        bs = function (t) {
          var e,
            n,
            i,
            o,
            r,
            s,
            a,
            l,
            c = x(t, !1);
          if ("string" == typeof c && c.length > 2)
            if (43 === (e = (c = ms(c)).charCodeAt(0)) || 45 === e) {
              if (88 === (n = c.charCodeAt(2)) || 120 === n) return NaN;
            } else if (48 === e) {
              switch (c.charCodeAt(1)) {
                case 66:
                case 98:
                  ((i = 2), (o = 49));
                  break;
                case 79:
                case 111:
                  ((i = 8), (o = 55));
                  break;
                default:
                  return +c;
              }
              for (s = (r = c.slice(2)).length, a = 0; a < s; a++)
                if ((l = r.charCodeAt(a)) < 48 || l > o) return NaN;
              return parseInt(r, i);
            }
          return +c;
        };
      if (Tt("Number", !gs(" 0o1") || !gs("0b1") || gs("+0x1"))) {
        for (
          var ws,
            xs = function (t) {
              var e = arguments.length < 1 ? 0 : t,
                n = this;
              return n instanceof xs &&
                (ys
                  ? l(function () {
                      vs.valueOf.call(n);
                    })
                  : "Number" != m(n))
                ? rs(new gs(bs(e)), n, xs)
                : bs(e);
            },
            Ss = c
              ? ds(gs)
              : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(
                  ",",
                ),
            ks = 0;
          Ss.length > ks;
          ks++
        )
          k(gs, (ws = Ss[ks])) && !k(xs, ws) && ps(xs, ws, fs(gs, ws));
        ((xs.prototype = vs), (vs.constructor = xs), Z(a, "Number", xs));
      }
      var Es = l(function () {
        zt(1);
      });
      At(
        { target: "Object", stat: !0, forced: Es },
        {
          keys: function (t) {
            return zt(Lt(t));
          },
        },
      );
      var Cs = function (t) {
          if (ai(t))
            throw TypeError("The method doesn't accept regular expressions");
          return t;
        },
        Ts = Ut("match"),
        Ps = function (t) {
          var e = /./;
          try {
            "/./"[t](e);
          } catch (n) {
            try {
              return ((e[Ts] = !1), "/./"[t](e));
            } catch (t) {}
          }
          return !1;
        };
      At(
        { target: "String", proto: !0, forced: !Ps("includes") },
        {
          includes: function (t) {
            return !!~String(y(this)).indexOf(
              Cs(t),
              arguments.length > 1 ? arguments[1] : void 0,
            );
          },
        },
      );
      var As = !l(function () {
          return Object.isExtensible(Object.preventExtensions({}));
        }),
        Is = e(function (t) {
          var e = z.f,
            n = q("meta"),
            i = 0,
            o =
              Object.isExtensible ||
              function () {
                return !0;
              },
            r = function (t) {
              e(t, n, { value: { objectID: "O" + ++i, weakData: {} } });
            },
            s = (t.exports = {
              REQUIRED: !1,
              fastKey: function (t, e) {
                if (!w(t))
                  return "symbol" == typeof t
                    ? t
                    : ("string" == typeof t ? "S" : "P") + t;
                if (!k(t, n)) {
                  if (!o(t)) return "F";
                  if (!e) return "E";
                  r(t);
                }
                return t[n].objectID;
              },
              getWeakData: function (t, e) {
                if (!k(t, n)) {
                  if (!o(t)) return !0;
                  if (!e) return !1;
                  r(t);
                }
                return t[n].weakData;
              },
              onFreeze: function (t) {
                return (As && s.REQUIRED && o(t) && !k(t, n) && r(t), t);
              },
            });
          B[n] = !0;
        }),
        _s =
          (Is.REQUIRED,
          Is.fastKey,
          Is.getWeakData,
          Is.onFreeze,
          e(function (t) {
            var e = function (t, e) {
              ((this.stopped = t), (this.result = e));
            };
            (t.exports = function (t, n, i, o, r) {
              var s,
                a,
                l,
                c,
                u,
                h,
                d = Jt(n, i, o ? 2 : 1);
              if (r) s = t;
              else {
                if ("function" != typeof (a = Di(t)))
                  throw TypeError("Target is not iterable");
                if (ji(a)) {
                  for (l = 0, c = st(t.length); c > l; l++)
                    if (
                      (u = o ? d(_((h = t[l]))[0], h[1]) : d(t[l])) &&
                      u instanceof e
                    )
                      return u;
                  return new e(!1);
                }
                s = a.call(t);
              }
              for (; !(h = s.next()).done; )
                if ((u = Li(s, d, h.value, o)) && u instanceof e) return u;
              return new e(!1);
            }).stop = function (t) {
              return new e(!0, t);
            };
          })),
        Ls = Is.getWeakData,
        zs = K.set,
        Ms = K.getterFor,
        js = oe.find,
        Os = oe.findIndex,
        Ds = 0,
        Fs = function (t) {
          return t.frozen || (t.frozen = new Rs());
        },
        Rs = function () {
          this.entries = [];
        },
        Ns = function (t, e) {
          return js(t.entries, function (t) {
            return t[0] === e;
          });
        };
      Rs.prototype = {
        get: function (t) {
          var e = Ns(this, t);
          if (e) return e[1];
        },
        has: function (t) {
          return !!Ns(this, t);
        },
        set: function (t, e) {
          var n = Ns(this, t);
          n ? (n[1] = e) : this.entries.push([t, e]);
        },
        delete: function (t) {
          var e = Os(this.entries, function (e) {
            return e[0] === t;
          });
          return (~e && this.entries.splice(e, 1), !!~e);
        },
      };
      var $s = {
        getConstructor: function (t, e, n, i) {
          var o = t(function (t, r) {
              (Ai(t, o, e),
                zs(t, { type: e, id: Ds++, frozen: void 0 }),
                null != r && _s(r, t[i], t, n));
            }),
            r = Ms(e),
            s = function (t, e, n) {
              var i = r(t),
                o = Ls(_(e), !0);
              return (!0 === o ? Fs(i).set(e, n) : (o[i.id] = n), t);
            };
          return (
            Vi(o.prototype, {
              delete: function (t) {
                var e = r(this);
                if (!w(t)) return !1;
                var n = Ls(t);
                return !0 === n
                  ? Fs(e).delete(t)
                  : n && k(n, e.id) && delete n[e.id];
              },
              has: function (t) {
                var e = r(this);
                if (!w(t)) return !1;
                var n = Ls(t);
                return !0 === n ? Fs(e).has(t) : n && k(n, e.id);
              },
            }),
            Vi(
              o.prototype,
              n
                ? {
                    get: function (t) {
                      var e = r(this);
                      if (w(t)) {
                        var n = Ls(t);
                        return !0 === n ? Fs(e).get(t) : n ? n[e.id] : void 0;
                      }
                    },
                    set: function (t, e) {
                      return s(this, t, e);
                    },
                  }
                : {
                    add: function (t) {
                      return s(this, t, !0);
                    },
                  },
            ),
            o
          );
        },
      };
      (e(function (t) {
        var e,
          n = K.enforce,
          i = !a.ActiveXObject && "ActiveXObject" in a,
          o = Object.isExtensible,
          r = function (t) {
            return function () {
              return t(this, arguments.length ? arguments[0] : void 0);
            };
          },
          s = (t.exports = (function (t, e, n, i, o) {
            var r = a[t],
              s = r && r.prototype,
              c = r,
              u = "set",
              h = {},
              d = function (t) {
                var e = s[t];
                Z(
                  s,
                  t,
                  "add" == t
                    ? function (t) {
                        return (e.call(this, 0 === t ? 0 : t), this);
                      }
                    : "delete" == t
                      ? function (t) {
                          return !!w(t) && e.call(this, 0 === t ? 0 : t);
                        }
                      : "get" == t
                        ? function (t) {
                            return w(t)
                              ? e.call(this, 0 === t ? 0 : t)
                              : void 0;
                          }
                        : "has" == t
                          ? function (t) {
                              return !!w(t) && e.call(this, 0 === t ? 0 : t);
                            }
                          : function (t, n) {
                              return (e.call(this, 0 === t ? 0 : t, n), this);
                            },
                );
              };
            if (Tt(t, "function" != typeof r || !1))
              ((c = n.getConstructor(e, t, i, u)), (Is.REQUIRED = !0));
            else if (Tt(t, !0)) {
              var f = new c(),
                p = f[u]({}, 1) != f,
                m = l(function () {
                  f.has(1);
                }),
                g = es(function (t) {
                  new r(t);
                });
              (g ||
                (((c = e(function (e, n) {
                  Ai(e, c, t);
                  var o = rs(new r(), e, c);
                  return (null != n && _s(n, o[u], o, i), o);
                })).prototype = s),
                (s.constructor = c)),
                !!m && (d("delete"), d("has"), d("get")),
                p && d(u),
                s.clear && delete s.clear);
            }
            return (
              (h[t] = c),
              At({ global: !0, forced: c != r }, h),
              Kt(c, t),
              c
            );
          })("WeakMap", r, $s, !0));
        if (R && i) {
          ((e = $s.getConstructor(r, "WeakMap", !0)), (Is.REQUIRED = !0));
          var c = s.prototype,
            u = c.delete,
            h = c.has,
            d = c.get,
            f = c.set;
          Vi(c, {
            delete: function (t) {
              if (w(t) && !o(t)) {
                var i = n(this);
                return (
                  i.frozen || (i.frozen = new e()),
                  u.call(this, t) || i.frozen.delete(t)
                );
              }
              return u.call(this, t);
            },
            has: function (t) {
              if (w(t) && !o(t)) {
                var i = n(this);
                return (
                  i.frozen || (i.frozen = new e()),
                  h.call(this, t) || i.frozen.has(t)
                );
              }
              return h.call(this, t);
            },
            get: function (t) {
              if (w(t) && !o(t)) {
                var i = n(this);
                return (
                  i.frozen || (i.frozen = new e()),
                  h.call(this, t) ? d.call(this, t) : i.frozen.get(t)
                );
              }
              return d.call(this, t);
            },
            set: function (t, i) {
              if (w(t) && !o(t)) {
                var r = n(this);
                (r.frozen || (r.frozen = new e()),
                  h.call(this, t) ? f.call(this, t, i) : r.frozen.set(t, i));
              } else f.call(this, t, i);
              return this;
            },
          });
        }
      }),
        At(
          { target: "Object", stat: !0, forced: Object.assign !== _i },
          { assign: _i },
        ));
      var qs = hs.trim;
      At(
        {
          target: "String",
          proto: !0,
          forced: (function (t) {
            return l(function () {
              return !!ss[t]() || "​᠎" != "​᠎"[t]() || ss[t].name !== t;
            });
          })("trim"),
        },
        {
          trim: function () {
            return qs(this);
          },
        },
      );
      var Hs =
          "".repeat ||
          function (t) {
            var e = String(y(this)),
              n = "",
              i = ot(t);
            if (i < 0 || i == 1 / 0)
              throw RangeError("Wrong number of repetitions");
            for (; i > 0; (i >>>= 1) && (e += e)) 1 & i && (n += e);
            return n;
          },
        Ws = (1).toFixed,
        Bs = Math.floor,
        Us = function (t, e, n) {
          return 0 === e
            ? n
            : e % 2 == 1
              ? Us(t, e - 1, n * t)
              : Us(t * t, e / 2, n);
        },
        Vs =
          (Ws &&
            ("0.000" !== (8e-5).toFixed(3) ||
              "1" !== (0.9).toFixed(0) ||
              "1.25" !== (1.255).toFixed(2) ||
              "1000000000000000128" !== (0xde0b6b3a7640080).toFixed(0))) ||
          !l(function () {
            Ws.call({});
          });
      At(
        { target: "Number", proto: !0, forced: Vs },
        {
          toFixed: function (t) {
            var e,
              n,
              i,
              o,
              r = (function (t) {
                if ("number" != typeof t && "Number" != m(t))
                  throw TypeError("Incorrect invocation");
                return +t;
              })(this),
              s = ot(t),
              a = [0, 0, 0, 0, 0, 0],
              l = "",
              c = "0",
              u = function (t, e) {
                for (var n = -1, i = e; ++n < 6; )
                  ((i += t * a[n]), (a[n] = i % 1e7), (i = Bs(i / 1e7)));
              },
              h = function (t) {
                for (var e = 6, n = 0; --e >= 0; )
                  ((n += a[e]), (a[e] = Bs(n / t)), (n = (n % t) * 1e7));
              },
              d = function () {
                for (var t = 6, e = ""; --t >= 0; )
                  if ("" !== e || 0 === t || 0 !== a[t]) {
                    var n = String(a[t]);
                    e = "" === e ? n : e + Hs.call("0", 7 - n.length) + n;
                  }
                return e;
              };
            if (s < 0 || s > 20) throw RangeError("Incorrect fraction digits");
            if (r != r) return "NaN";
            if (r <= -1e21 || r >= 1e21) return String(r);
            if ((r < 0 && ((l = "-"), (r = -r)), r > 1e-21))
              if (
                ((n =
                  (e =
                    (function (t) {
                      for (var e = 0, n = t; n >= 4096; )
                        ((e += 12), (n /= 4096));
                      for (; n >= 2; ) ((e += 1), (n /= 2));
                      return e;
                    })(r * Us(2, 69, 1)) - 69) < 0
                    ? r * Us(2, -e, 1)
                    : r / Us(2, e, 1)),
                (n *= 4503599627370496),
                (e = 52 - e) > 0)
              ) {
                for (u(0, n), i = s; i >= 7; ) (u(1e7, 0), (i -= 7));
                for (u(Us(10, i, 1), 0), i = e - 1; i >= 23; )
                  (h(1 << 23), (i -= 23));
                (h(1 << i), u(1, 1), h(2), (c = d()));
              } else (u(0, n), u(1 << -e, 0), (c = d() + Hs.call("0", s)));
            return s > 0
              ? l +
                  ((o = c.length) <= s
                    ? "0." + Hs.call("0", s - o) + c
                    : c.slice(0, o - s) + "." + c.slice(o - s))
              : l + c;
          },
        },
      );
      var Ys = d.f,
        Xs = function (t) {
          return function (e) {
            for (
              var n, i = b(e), o = zt(i), r = o.length, s = 0, a = [];
              r > s;
            )
              ((n = o[s++]),
                (c && !Ys.call(i, n)) || a.push(t ? [n, i[n]] : i[n]));
            return a;
          };
        },
        Qs = { entries: Xs(!0), values: Xs(!1) },
        Gs = Qs.entries;
      At(
        { target: "Object", stat: !0 },
        {
          entries: function (t) {
            return Gs(t);
          },
        },
      );
      var Ks = Qs.values;
      At(
        { target: "Object", stat: !0 },
        {
          values: function (t) {
            return Ks(t);
          },
        },
      );
      var Zs = { addCSS: !0, thumbWidth: 15, watch: !0 };
      At(
        { target: "Number", stat: !0 },
        {
          isNaN: function (t) {
            return t != t;
          },
        },
      );
      var Js = function (t) {
          return null != t ? t.constructor : null;
        },
        ta = function (t, e) {
          return Boolean(t && e && t instanceof e);
        },
        ea = function (t) {
          return null == t;
        },
        na = function (t) {
          return Js(t) === Object;
        },
        ia = function (t) {
          return Js(t) === String;
        },
        oa = function (t) {
          return Array.isArray(t);
        },
        ra = function (t) {
          return ta(t, NodeList);
        },
        sa = ia,
        aa = oa,
        la = ra,
        ca = function (t) {
          return ta(t, Element);
        },
        ua = function (t) {
          return ta(t, Event);
        },
        ha = function (t) {
          return (
            ea(t) ||
            ((ia(t) || oa(t) || ra(t)) && !t.length) ||
            (na(t) && !Object.keys(t).length)
          );
        };
      Gn("match", 1, function (t, e, n) {
        return [
          function (e) {
            var n = y(this),
              i = null == e ? void 0 : e[t];
            return void 0 !== i ? i.call(e, n) : new RegExp(e)[t](String(n));
          },
          function (t) {
            var i = n(e, t, this);
            if (i.done) return i.value;
            var o = _(t),
              r = String(this);
            if (!o.global) return Jn(o, r);
            var s = o.unicode;
            o.lastIndex = 0;
            for (var a, l = [], c = 0; null !== (a = Jn(o, r)); ) {
              var u = String(a[0]);
              ((l[c] = u),
                "" === u && (o.lastIndex = Zn(r, st(o.lastIndex), s)),
                c++);
            }
            return 0 === c ? null : l;
          },
        ];
      });
      var da,
        fa,
        pa,
        ma = (function () {
          function t(e, n) {
            (Rr(this, t),
              ca(e)
                ? (this.element = e)
                : sa(e) && (this.element = document.querySelector(e)),
              ca(this.element) &&
                ha(this.element.rangeTouch) &&
                ((this.config = Object.assign({}, Zs, n)), this.init()));
          }
          return (
            $r(
              t,
              [
                {
                  key: "init",
                  value: function () {
                    t.enabled &&
                      (this.config.addCSS &&
                        ((this.element.style.userSelect = "none"),
                        (this.element.style.webKitUserSelect = "none"),
                        (this.element.style.touchAction = "manipulation")),
                      this.listeners(!0),
                      (this.element.rangeTouch = this));
                  },
                },
                {
                  key: "destroy",
                  value: function () {
                    t.enabled &&
                      (this.listeners(!1), (this.element.rangeTouch = null));
                  },
                },
                {
                  key: "listeners",
                  value: function (t) {
                    var e = this,
                      n = t ? "addEventListener" : "removeEventListener";
                    ["touchstart", "touchmove", "touchend"].forEach(
                      function (t) {
                        e.element[n](
                          t,
                          function (t) {
                            return e.set(t);
                          },
                          !1,
                        );
                      },
                    );
                  },
                },
                {
                  key: "get",
                  value: function (e) {
                    if (!t.enabled || !ua(e)) return null;
                    var n,
                      i = e.target,
                      o = e.changedTouches[0],
                      r = parseFloat(i.getAttribute("min")) || 0,
                      s = parseFloat(i.getAttribute("max")) || 100,
                      a = parseFloat(i.getAttribute("step")) || 1,
                      l = s - r,
                      c = i.getBoundingClientRect(),
                      u =
                        ((100 / c.width) * (this.config.thumbWidth / 2)) / 100;
                    return (
                      (n = (100 / c.width) * (o.clientX - c.left)) < 0
                        ? (n = 0)
                        : n > 100 && (n = 100),
                      n < 50
                        ? (n -= (100 - 2 * n) * u)
                        : n > 50 && (n += 2 * (n - 50) * u),
                      r +
                        (function (t, e) {
                          if (e < 1) {
                            var n = (i = ""
                              .concat(e)
                              .match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/))
                              ? Math.max(
                                  0,
                                  (i[1] ? i[1].length : 0) - (i[2] ? +i[2] : 0),
                                )
                              : 0;
                            return parseFloat(t.toFixed(n));
                          }
                          var i;
                          return Math.round(t / e) * e;
                        })(l * (n / 100), a)
                    );
                  },
                },
                {
                  key: "set",
                  value: function (e) {
                    t.enabled &&
                      ua(e) &&
                      !e.target.disabled &&
                      (e.preventDefault(),
                      (e.target.value = this.get(e)),
                      (function (t, e) {
                        if (t && e) {
                          var n = new Event(e);
                          t.dispatchEvent(n);
                        }
                      })(e.target, "touchend" === e.type ? "change" : "input"));
                  },
                },
              ],
              [
                {
                  key: "setup",
                  value: function (e) {
                    var n =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : {},
                      i = null;
                    if (
                      (ha(e) || sa(e)
                        ? (i = Array.from(
                            document.querySelectorAll(
                              sa(e) ? e : 'input[type="range"]',
                            ),
                          ))
                        : ca(e)
                          ? (i = [e])
                          : la(e)
                            ? (i = Array.from(e))
                            : aa(e) && (i = e.filter(ca)),
                      ha(i))
                    )
                      return null;
                    var o = Object.assign({}, Zs, n);
                    return (
                      sa(e) &&
                        o.watch &&
                        new MutationObserver(function (n) {
                          Array.from(n).forEach(function (n) {
                            Array.from(n.addedNodes).forEach(function (n) {
                              var i;
                              ca(n) &&
                                function () {
                                  return Array.from(
                                    document.querySelectorAll(i),
                                  ).includes(this);
                                }.call(n, (i = e)) &&
                                new t(n, o);
                            });
                          });
                        }).observe(document.body, {
                          childList: !0,
                          subtree: !0,
                        }),
                      i.map(function (e) {
                        return new t(e, n);
                      })
                    );
                  },
                },
                {
                  key: "enabled",
                  get: function () {
                    return "ontouchstart" in document.documentElement;
                  },
                },
              ],
            ),
            t
          );
        })(),
        ga = Ut("species"),
        va = function (t) {
          var e = et(t),
            n = z.f;
          c &&
            e &&
            !e[ga] &&
            n(e, ga, {
              configurable: !0,
              get: function () {
                return this;
              },
            });
        },
        ya = a.location,
        ba = a.setImmediate,
        wa = a.clearImmediate,
        xa = a.process,
        Sa = a.MessageChannel,
        ka = a.Dispatch,
        Ea = 0,
        Ca = {},
        Ta = function (t) {
          if (Ca.hasOwnProperty(t)) {
            var e = Ca[t];
            (delete Ca[t], e());
          }
        },
        Pa = function (t) {
          return function () {
            Ta(t);
          };
        },
        Aa = function (t) {
          Ta(t.data);
        },
        Ia = function (t) {
          a.postMessage(t + "", ya.protocol + "//" + ya.host);
        };
      (ba && wa) ||
        ((ba = function (t) {
          for (var e = [], n = 1; arguments.length > n; )
            e.push(arguments[n++]);
          return (
            (Ca[++Ea] = function () {
              ("function" == typeof t ? t : Function(t)).apply(void 0, e);
            }),
            da(Ea),
            Ea
          );
        }),
        (wa = function (t) {
          delete Ca[t];
        }),
        "process" == m(xa)
          ? (da = function (t) {
              xa.nextTick(Pa(t));
            })
          : ka && ka.now
            ? (da = function (t) {
                ka.now(Pa(t));
              })
            : Sa
              ? ((pa = (fa = new Sa()).port2),
                (fa.port1.onmessage = Aa),
                (da = Jt(pa.postMessage, pa, 1)))
              : !a.addEventListener ||
                  "function" != typeof postMessage ||
                  a.importScripts ||
                  l(Ia)
                ? (da =
                    "onreadystatechange" in T("script")
                      ? function (t) {
                          jt.appendChild(T("script")).onreadystatechange =
                            function () {
                              (jt.removeChild(this), Ta(t));
                            };
                        }
                      : function (t) {
                          setTimeout(Pa(t), 0);
                        })
                : ((da = Ia), a.addEventListener("message", Aa, !1)));
      var _a,
        La,
        za,
        Ma,
        ja,
        Oa,
        Da,
        Fa = { set: ba, clear: wa },
        Ra = et("navigator", "userAgent") || "",
        Na = I.f,
        $a = Fa.set,
        qa = a.MutationObserver || a.WebKitMutationObserver,
        Ha = a.process,
        Wa = a.Promise,
        Ba = "process" == m(Ha),
        Ua = Na(a, "queueMicrotask"),
        Va = Ua && Ua.value;
      Va ||
        ((_a = function () {
          var t, e;
          for (Ba && (t = Ha.domain) && t.exit(); La; ) {
            ((e = La.fn), (La = La.next));
            try {
              e();
            } catch (t) {
              throw (La ? Ma() : (za = void 0), t);
            }
          }
          ((za = void 0), t && t.enter());
        }),
        Ba
          ? (Ma = function () {
              Ha.nextTick(_a);
            })
          : qa && !/(iphone|ipod|ipad).*applewebkit/i.test(Ra)
            ? ((ja = !0),
              (Oa = document.createTextNode("")),
              new qa(_a).observe(Oa, { characterData: !0 }),
              (Ma = function () {
                Oa.data = ja = !ja;
              }))
            : Wa && Wa.resolve
              ? ((Da = Wa.resolve(void 0)),
                (Ma = function () {
                  Da.then(_a);
                }))
              : (Ma = function () {
                  $a.call(a, _a);
                }));
      var Ya,
        Xa,
        Qa,
        Ga =
          Va ||
          function (t) {
            var e = { fn: t, next: void 0 };
            (za && (za.next = e), La || ((La = e), Ma()), (za = e));
          },
        Ka = function (t) {
          var e, n;
          ((this.promise = new t(function (t, i) {
            if (void 0 !== e || void 0 !== n)
              throw TypeError("Bad Promise constructor");
            ((e = t), (n = i));
          })),
            (this.resolve = Zt(e)),
            (this.reject = Zt(n)));
        },
        Za = {
          f: function (t) {
            return new Ka(t);
          },
        },
        Ja = function (t, e) {
          if ((_(t), w(e) && e.constructor === t)) return e;
          var n = Za.f(t);
          return ((0, n.resolve)(e), n.promise);
        },
        tl = function (t) {
          try {
            return { error: !1, value: t() };
          } catch (t) {
            return { error: !0, value: t };
          }
        },
        el = Fa.set,
        nl = Ut("species"),
        il = "Promise",
        ol = K.get,
        rl = K.set,
        sl = K.getterFor(il),
        al = a.Promise,
        ll = a.TypeError,
        cl = a.document,
        ul = a.process,
        hl = a.fetch,
        dl = ul && ul.versions,
        fl = (dl && dl.v8) || "",
        pl = Za.f,
        ml = pl,
        gl = "process" == m(ul),
        vl = !!(cl && cl.createEvent && a.dispatchEvent),
        yl = Tt(il, function () {
          var t = al.resolve(1),
            e = function () {},
            n = ((t.constructor = {})[nl] = function (t) {
              t(e, e);
            });
          return !(
            (gl || "function" == typeof PromiseRejectionEvent) &&
            t.then(e) instanceof n &&
            0 !== fl.indexOf("6.6") &&
            -1 === Ra.indexOf("Chrome/66")
          );
        }),
        bl =
          yl ||
          !es(function (t) {
            al.all(t).catch(function () {});
          }),
        wl = function (t) {
          var e;
          return !(!w(t) || "function" != typeof (e = t.then)) && e;
        },
        xl = function (t, e, n) {
          if (!e.notified) {
            e.notified = !0;
            var i = e.reactions;
            Ga(function () {
              for (var o = e.value, r = 1 == e.state, s = 0; i.length > s; ) {
                var a,
                  l,
                  c,
                  u = i[s++],
                  h = r ? u.ok : u.fail,
                  d = u.resolve,
                  f = u.reject,
                  p = u.domain;
                try {
                  h
                    ? (r || (2 === e.rejection && Cl(t, e), (e.rejection = 1)),
                      !0 === h
                        ? (a = o)
                        : (p && p.enter(),
                          (a = h(o)),
                          p && (p.exit(), (c = !0))),
                      a === u.promise
                        ? f(ll("Promise-chain cycle"))
                        : (l = wl(a))
                          ? l.call(a, d, f)
                          : d(a))
                    : f(o);
                } catch (t) {
                  (p && !c && p.exit(), f(t));
                }
              }
              ((e.reactions = []),
                (e.notified = !1),
                n && !e.rejection && kl(t, e));
            });
          }
        },
        Sl = function (t, e, n) {
          var i, o;
          (vl
            ? (((i = cl.createEvent("Event")).promise = e),
              (i.reason = n),
              i.initEvent(t, !1, !0),
              a.dispatchEvent(i))
            : (i = { promise: e, reason: n }),
            (o = a["on" + t])
              ? o(i)
              : "unhandledrejection" === t &&
                (function (t, e) {
                  var n = a.console;
                  n &&
                    n.error &&
                    (1 === arguments.length ? n.error(t) : n.error(t, e));
                })("Unhandled promise rejection", n));
        },
        kl = function (t, e) {
          el.call(a, function () {
            var n,
              i = e.value;
            if (
              El(e) &&
              ((n = tl(function () {
                gl
                  ? ul.emit("unhandledRejection", i, t)
                  : Sl("unhandledrejection", t, i);
              })),
              (e.rejection = gl || El(e) ? 2 : 1),
              n.error)
            )
              throw n.value;
          });
        },
        El = function (t) {
          return 1 !== t.rejection && !t.parent;
        },
        Cl = function (t, e) {
          el.call(a, function () {
            gl
              ? ul.emit("rejectionHandled", t)
              : Sl("rejectionhandled", t, e.value);
          });
        },
        Tl = function (t, e, n, i) {
          return function (o) {
            t(e, n, o, i);
          };
        },
        Pl = function (t, e, n, i) {
          e.done ||
            ((e.done = !0),
            i && (e = i),
            (e.value = n),
            (e.state = 2),
            xl(t, e, !0));
        },
        Al = function (t, e, n, i) {
          if (!e.done) {
            ((e.done = !0), i && (e = i));
            try {
              if (t === n) throw ll("Promise can't be resolved itself");
              var o = wl(n);
              o
                ? Ga(function () {
                    var i = { done: !1 };
                    try {
                      o.call(n, Tl(Al, t, i, e), Tl(Pl, t, i, e));
                    } catch (n) {
                      Pl(t, i, n, e);
                    }
                  })
                : ((e.value = n), (e.state = 1), xl(t, e, !1));
            } catch (n) {
              Pl(t, { done: !1 }, n, e);
            }
          }
        };
      (yl &&
        ((al = function (t) {
          (Ai(this, al, il), Zt(t), Ya.call(this));
          var e = ol(this);
          try {
            t(Tl(Al, this, e), Tl(Pl, this, e));
          } catch (t) {
            Pl(this, e, t);
          }
        }),
        ((Ya = function (t) {
          rl(this, {
            type: il,
            done: !1,
            notified: !1,
            parent: !1,
            reactions: [],
            rejection: !1,
            state: 0,
            value: void 0,
          });
        }).prototype = Vi(al.prototype, {
          then: function (t, e) {
            var n = sl(this),
              i = pl(ci(this, al));
            return (
              (i.ok = "function" != typeof t || t),
              (i.fail = "function" == typeof e && e),
              (i.domain = gl ? ul.domain : void 0),
              (n.parent = !0),
              n.reactions.push(i),
              0 != n.state && xl(this, n, !1),
              i.promise
            );
          },
          catch: function (t) {
            return this.then(void 0, t);
          },
        })),
        (Xa = function () {
          var t = new Ya(),
            e = ol(t);
          ((this.promise = t),
            (this.resolve = Tl(Al, t, e)),
            (this.reject = Tl(Pl, t, e)));
        }),
        (Za.f = pl =
          function (t) {
            return t === al || t === Qa ? new Xa(t) : ml(t);
          }),
        "function" == typeof hl &&
          At(
            { global: !0, enumerable: !0, forced: !0 },
            {
              fetch: function (t) {
                return Ja(al, hl.apply(a, arguments));
              },
            },
          )),
        At({ global: !0, wrap: !0, forced: yl }, { Promise: al }),
        Kt(al, il, !1),
        va(il),
        (Qa = J.Promise),
        At(
          { target: il, stat: !0, forced: yl },
          {
            reject: function (t) {
              var e = pl(this);
              return (e.reject.call(void 0, t), e.promise);
            },
          },
        ),
        At(
          { target: il, stat: !0, forced: yl },
          {
            resolve: function (t) {
              return Ja(this, t);
            },
          },
        ),
        At(
          { target: il, stat: !0, forced: bl },
          {
            all: function (t) {
              var e = this,
                n = pl(e),
                i = n.resolve,
                o = n.reject,
                r = tl(function () {
                  var n = Zt(e.resolve),
                    r = [],
                    s = 0,
                    a = 1;
                  (_s(t, function (t) {
                    var l = s++,
                      c = !1;
                    (r.push(void 0),
                      a++,
                      n.call(e, t).then(function (t) {
                        c || ((c = !0), (r[l] = t), --a || i(r));
                      }, o));
                  }),
                    --a || i(r));
                });
              return (r.error && o(r.value), n.promise);
            },
            race: function (t) {
              var e = this,
                n = pl(e),
                i = n.reject,
                o = tl(function () {
                  var o = Zt(e.resolve);
                  _s(t, function (t) {
                    o.call(e, t).then(n.resolve, i);
                  });
                });
              return (o.error && i(o.value), n.promise);
            },
          },
        ));
      var Il = "".startsWith,
        _l = Math.min;
      At(
        { target: "String", proto: !0, forced: !Ps("startsWith") },
        {
          startsWith: function (t) {
            var e = String(y(this));
            Cs(t);
            var n = st(
                _l(arguments.length > 1 ? arguments[1] : void 0, e.length),
              ),
              i = String(t);
            return Il ? Il.call(e, i, n) : e.slice(n, n + i.length) === i;
          },
        },
      );
      var Ll,
        zl,
        Ml,
        jl = function (t) {
          return null != t ? t.constructor : null;
        },
        Ol = function (t, e) {
          return Boolean(t && e && t instanceof e);
        },
        Dl = function (t) {
          return null == t;
        },
        Fl = function (t) {
          return jl(t) === Object;
        },
        Rl = function (t) {
          return jl(t) === String;
        },
        Nl = function (t) {
          return Array.isArray(t);
        },
        $l = function (t) {
          return Ol(t, NodeList);
        },
        ql = function (t) {
          return (
            Dl(t) ||
            ((Rl(t) || Nl(t) || $l(t)) && !t.length) ||
            (Fl(t) && !Object.keys(t).length)
          );
        },
        Hl = {
          nullOrUndefined: Dl,
          object: Fl,
          number: function (t) {
            return jl(t) === Number && !Number.isNaN(t);
          },
          string: Rl,
          boolean: function (t) {
            return jl(t) === Boolean;
          },
          function: function (t) {
            return jl(t) === Function;
          },
          array: Nl,
          weakMap: function (t) {
            return Ol(t, WeakMap);
          },
          nodeList: $l,
          element: function (t) {
            return Ol(t, Element);
          },
          textNode: function (t) {
            return jl(t) === Text;
          },
          event: function (t) {
            return Ol(t, Event);
          },
          keyboardEvent: function (t) {
            return Ol(t, KeyboardEvent);
          },
          cue: function (t) {
            return Ol(t, window.TextTrackCue) || Ol(t, window.VTTCue);
          },
          track: function (t) {
            return Ol(t, TextTrack) || (!Dl(t) && Rl(t.kind));
          },
          promise: function (t) {
            return Ol(t, Promise);
          },
          url: function (t) {
            if (Ol(t, window.URL)) return !0;
            if (!Rl(t)) return !1;
            var e = t;
            (t.startsWith("http://") && t.startsWith("https://")) ||
              (e = "http://".concat(t));
            try {
              return !ql(new URL(e).hostname);
            } catch (t) {
              return !1;
            }
          },
          empty: ql,
        },
        Wl =
          ((Ll = document.createElement("span")),
          (zl = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend",
          }),
          (Ml = Object.keys(zl).find(function (t) {
            return void 0 !== Ll.style[t];
          })),
          !!Hl.string(Ml) && zl[Ml]);
      function Bl(t, e) {
        setTimeout(function () {
          try {
            ((t.hidden = !0), t.offsetHeight, (t.hidden = !1));
          } catch (t) {}
        }, e);
      }
      var Ul = {
          isIE: !!document.documentMode,
          isEdge: window.navigator.userAgent.includes("Edge"),
          isWebkit:
            "WebkitAppearance" in document.documentElement.style &&
            !/Edge/.test(navigator.userAgent),
          isIPhone: /(iPhone|iPod)/gi.test(navigator.platform),
          isIos: /(iPad|iPhone|iPod)/gi.test(navigator.platform),
        },
        Vl = (function () {
          var t = !1;
          try {
            var e = Object.defineProperty({}, "passive", {
              get: function () {
                return ((t = !0), null);
              },
            });
            (window.addEventListener("test", null, e),
              window.removeEventListener("test", null, e));
          } catch (t) {}
          return t;
        })();
      function Yl(t, e, n) {
        var i = this,
          o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          r =
            !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
          s = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
        if (t && "addEventListener" in t && !Hl.empty(e) && Hl.function(n)) {
          var a = e.split(" "),
            l = s;
          (Vl && (l = { passive: r, capture: s }),
            a.forEach(function (e) {
              (i &&
                i.eventListeners &&
                o &&
                i.eventListeners.push({
                  element: t,
                  type: e,
                  callback: n,
                  options: l,
                }),
                t[o ? "addEventListener" : "removeEventListener"](e, n, l));
            }));
        }
      }
      function Xl(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 ? arguments[2] : void 0,
          i =
            !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
          o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
        Yl.call(this, t, e, n, !0, i, o);
      }
      function Ql(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 ? arguments[2] : void 0,
          i =
            !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
          o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
        Yl.call(this, t, e, n, !1, i, o);
      }
      function Gl(t) {
        var e = this,
          n =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          i = arguments.length > 2 ? arguments[2] : void 0,
          o =
            !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
          r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
        Yl.call(
          this,
          t,
          n,
          function s() {
            Ql(t, n, s, o, r);
            for (var a = arguments.length, l = new Array(a), c = 0; c < a; c++)
              l[c] = arguments[c];
            i.apply(e, l);
          },
          !0,
          o,
          r,
        );
      }
      function Kl(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          i =
            arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        if (Hl.element(t) && !Hl.empty(e)) {
          var o = new CustomEvent(e, {
            bubbles: n,
            detail: Object.assign({}, i, { plyr: this }),
          });
          t.dispatchEvent(o);
        }
      }
      function Zl(t, e) {
        return e.split(".").reduce(function (t, e) {
          return t && t[e];
        }, t);
      }
      function Jl() {
        for (
          var t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : {},
            e = arguments.length,
            n = new Array(e > 1 ? e - 1 : 0),
            i = 1;
          i < e;
          i++
        )
          n[i - 1] = arguments[i];
        if (!n.length) return t;
        var o = n.shift();
        return Hl.object(o)
          ? (Object.keys(o).forEach(function (e) {
              Hl.object(o[e])
                ? (Object.keys(t).includes(e) ||
                    Object.assign(t, qr({}, e, {})),
                  Jl(t[e], o[e]))
                : Object.assign(t, qr({}, e, o[e]));
            }),
            Jl.apply(void 0, [t].concat(n)))
          : t;
      }
      function tc(t, e) {
        var n = t.length ? t : [t];
        Array.from(n)
          .reverse()
          .forEach(function (t, n) {
            var i = n > 0 ? e.cloneNode(!0) : e,
              o = t.parentNode,
              r = t.nextSibling;
            (i.appendChild(t), r ? o.insertBefore(i, r) : o.appendChild(i));
          });
      }
      function ec(t, e) {
        Hl.element(t) &&
          !Hl.empty(e) &&
          Object.entries(e)
            .filter(function (t) {
              var e = Hr(t, 2)[1];
              return !Hl.nullOrUndefined(e);
            })
            .forEach(function (e) {
              var n = Hr(e, 2),
                i = n[0],
                o = n[1];
              return t.setAttribute(i, o);
            });
      }
      function nc(t, e, n) {
        var i = document.createElement(t);
        return (Hl.object(e) && ec(i, e), Hl.string(n) && (i.innerText = n), i);
      }
      function ic(t, e, n, i) {
        Hl.element(e) && e.appendChild(nc(t, n, i));
      }
      function oc(t) {
        Hl.nodeList(t) || Hl.array(t)
          ? Array.from(t).forEach(oc)
          : Hl.element(t) &&
            Hl.element(t.parentNode) &&
            t.parentNode.removeChild(t);
      }
      function rc(t) {
        if (Hl.element(t))
          for (var e = t.childNodes.length; e > 0; )
            (t.removeChild(t.lastChild), (e -= 1));
      }
      function sc(t, e) {
        return Hl.element(e) && Hl.element(e.parentNode) && Hl.element(t)
          ? (e.parentNode.replaceChild(t, e), t)
          : null;
      }
      function ac(t, e) {
        if (!Hl.string(t) || Hl.empty(t)) return {};
        var n = {},
          i = Jl({}, e);
        return (
          t.split(",").forEach(function (t) {
            var e = t.trim(),
              o = e.replace(".", ""),
              r = e.replace(/[[\]]/g, "").split("="),
              s = Hr(r, 1)[0],
              a = r.length > 1 ? r[1].replace(/["']/g, "") : "";
            switch (e.charAt(0)) {
              case ".":
                Hl.string(i.class)
                  ? (n.class = "".concat(i.class, " ").concat(o))
                  : (n.class = o);
                break;
              case "#":
                n.id = e.replace("#", "");
                break;
              case "[":
                n[s] = a;
            }
          }),
          Jl(i, n)
        );
      }
      function lc(t, e) {
        if (Hl.element(t)) {
          var n = e;
          (Hl.boolean(n) || (n = !t.hidden), (t.hidden = n));
        }
      }
      function cc(t, e, n) {
        if (Hl.nodeList(t))
          return Array.from(t).map(function (t) {
            return cc(t, e, n);
          });
        if (Hl.element(t)) {
          var i = "toggle";
          return (
            void 0 !== n && (i = n ? "add" : "remove"),
            t.classList[i](e),
            t.classList.contains(e)
          );
        }
        return !1;
      }
      function uc(t, e) {
        return Hl.element(t) && t.classList.contains(e);
      }
      function hc(t, e) {
        return function () {
          return Array.from(document.querySelectorAll(e)).includes(this);
        }.call(t, e);
      }
      function dc(t) {
        return this.elements.container.querySelectorAll(t);
      }
      function fc(t) {
        return this.elements.container.querySelector(t);
      }
      function pc() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : null,
          e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        Hl.element(t) &&
          (t.focus({ preventScroll: !0 }),
          e && cc(t, this.config.classNames.tabFocus));
      }
      var mc,
        gc = {
          "audio/ogg": "vorbis",
          "audio/wav": "1",
          "video/webm": "vp8, vorbis",
          "video/mp4": "avc1.42E01E, mp4a.40.2",
          "video/ogg": "theora",
        },
        vc = {
          audio: "canPlayType" in document.createElement("audio"),
          video: "canPlayType" in document.createElement("video"),
          check: function (t, e, n) {
            var i = Ul.isIPhone && n && vc.playsinline,
              o = vc[t] || "html5" !== e;
            return {
              api: o,
              ui: o && vc.rangeInput && ("video" !== t || !Ul.isIPhone || i),
            };
          },
          pip: !(
            Ul.isIPhone ||
            (!Hl.function(nc("video").webkitSetPresentationMode) &&
              (!document.pictureInPictureEnabled ||
                nc("video").disablePictureInPicture))
          ),
          airplay: Hl.function(window.WebKitPlaybackTargetAvailabilityEvent),
          playsinline: "playsInline" in document.createElement("video"),
          mime: function (t) {
            if (Hl.empty(t)) return !1;
            var e = Hr(t.split("/"), 1)[0],
              n = t;
            if (!this.isHTML5 || e !== this.type) return !1;
            Object.keys(gc).includes(n) &&
              (n += '; codecs="'.concat(gc[t], '"'));
            try {
              return Boolean(n && this.media.canPlayType(n).replace(/no/, ""));
            } catch (t) {
              return !1;
            }
          },
          textTracks: "textTracks" in document.createElement("video"),
          rangeInput:
            ((mc = document.createElement("input")),
            (mc.type = "range"),
            "range" === mc.type),
          touch: "ontouchstart" in document.documentElement,
          transitions: !1 !== Wl,
          reducedMotion:
            "matchMedia" in window &&
            window.matchMedia("(prefers-reduced-motion)").matches,
        };
      function yc(t) {
        return (
          !!(Hl.array(t) || (Hl.string(t) && t.includes(":"))) &&
          (Hl.array(t) ? t : t.split(":")).map(Number).every(Hl.number)
        );
      }
      function bc(t) {
        if (!Hl.array(t) || !t.every(Hl.number)) return null;
        var e = Hr(t, 2),
          n = e[0],
          i = e[1],
          o = (function t(e, n) {
            return 0 === n ? e : t(n, e % n);
          })(n, i);
        return [n / o, i / o];
      }
      function wc(t) {
        var e = function (t) {
            return yc(t) ? t.split(":").map(Number) : null;
          },
          n = e(t);
        if (
          (null === n && (n = e(this.config.ratio)),
          null === n &&
            !Hl.empty(this.embed) &&
            Hl.array(this.embed.ratio) &&
            (n = this.embed.ratio),
          null === n && this.isHTML5)
        ) {
          var i = this.media;
          n = bc([i.videoWidth, i.videoHeight]);
        }
        return n;
      }
      function xc(t) {
        if (!this.isVideo) return {};
        var e = wc.call(this, t),
          n = Hr(Hl.array(e) ? e : [0, 0], 2),
          i = (100 / n[0]) * n[1];
        if (
          ((this.elements.wrapper.style.paddingBottom = "".concat(i, "%")),
          this.isVimeo && this.supported.ui)
        ) {
          var o = (240 - i) / 4.8;
          this.media.style.transform = "translateY(-".concat(o, "%)");
        } else
          this.isHTML5 &&
            this.elements.wrapper.classList.toggle(
              this.config.classNames.videoFixedRatio,
              null !== e,
            );
        return { padding: i, ratio: e };
      }
      var Sc = {
        getSources: function () {
          var t = this;
          return this.isHTML5
            ? Array.from(this.media.querySelectorAll("source")).filter(
                function (e) {
                  var n = e.getAttribute("type");
                  return !!Hl.empty(n) || vc.mime.call(t, n);
                },
              )
            : [];
        },
        getQualityOptions: function () {
          return Sc.getSources
            .call(this)
            .map(function (t) {
              return Number(t.getAttribute("size"));
            })
            .filter(Boolean);
        },
        extend: function () {
          if (this.isHTML5) {
            var t = this;
            (Hl.empty(this.config.ratio) || xc.call(t),
              Object.defineProperty(t.media, "quality", {
                get: function () {
                  var e = Sc.getSources.call(t).find(function (e) {
                    return e.getAttribute("src") === t.source;
                  });
                  return e && Number(e.getAttribute("size"));
                },
                set: function (e) {
                  var n = Sc.getSources.call(t).find(function (t) {
                    return Number(t.getAttribute("size")) === e;
                  });
                  if (n) {
                    var i = t.media,
                      o = i.currentTime,
                      r = i.paused,
                      s = i.preload,
                      a = i.readyState;
                    ((t.media.src = n.getAttribute("src")),
                      ("none" !== s || a) &&
                        (t.once("loadedmetadata", function () {
                          ((t.currentTime = o), r || t.play());
                        }),
                        t.media.load()),
                      Kl.call(t, t.media, "qualitychange", !1, { quality: e }));
                  }
                },
              }));
          }
        },
        cancelRequests: function () {
          this.isHTML5 &&
            (oc(Sc.getSources.call(this)),
            this.media.setAttribute("src", this.config.blankVideo),
            this.media.load(),
            this.debug.log("Cancelled network requests"));
        },
      };
      function kc(t) {
        return Hl.array(t)
          ? t.filter(function (e, n) {
              return t.indexOf(e) === n;
            })
          : t;
      }
      var Ec = z.f,
        Cc = gt.f,
        Tc = Ut("match"),
        Pc = a.RegExp,
        Ac = Pc.prototype,
        Ic = /a/g,
        _c = /a/g,
        Lc = new Pc(Ic) !== Ic;
      if (
        c &&
        Tt(
          "RegExp",
          !Lc ||
            l(function () {
              return (
                (_c[Tc] = !1),
                Pc(Ic) != Ic || Pc(_c) == _c || "/a/i" != Pc(Ic, "i")
              );
            }),
        )
      ) {
        for (
          var zc = function (t, e) {
              var n = this instanceof zc,
                i = ai(t),
                o = void 0 === e;
              return !n && i && t.constructor === zc && o
                ? t
                : rs(
                    Lc
                      ? new Pc(i && !o ? t.source : t, e)
                      : Pc(
                          (i = t instanceof zc) ? t.source : t,
                          i && o ? Ln.call(t) : e,
                        ),
                    n ? this : Ac,
                    zc,
                  );
            },
            Mc = function (t) {
              (t in zc) ||
                Ec(zc, t, {
                  configurable: !0,
                  get: function () {
                    return Pc[t];
                  },
                  set: function (e) {
                    Pc[t] = e;
                  },
                });
            },
            jc = Cc(Pc),
            Oc = 0;
          jc.length > Oc;
        )
          Mc(jc[Oc++]);
        ((Ac.constructor = zc), (zc.prototype = Ac), Z(a, "RegExp", zc));
      }
      function Dc(t) {
        for (
          var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1;
          i < e;
          i++
        )
          n[i - 1] = arguments[i];
        return Hl.empty(t)
          ? t
          : t.toString().replace(/{(\d+)}/g, function (t, e) {
              return n[e].toString();
            });
      }
      function Fc() {
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          e =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
        return (
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""
        ).replace(
          new RegExp(
            t.toString().replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1"),
            "g",
          ),
          e.toString(),
        );
      }
      function Rc() {
        return (
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""
        )
          .toString()
          .replace(/\w\S*/g, function (t) {
            return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
          });
      }
      function Nc(t) {
        var e = document.createElement("div");
        return (e.appendChild(t), e.innerHTML);
      }
      va("RegExp");
      var $c = {
          pip: "PIP",
          airplay: "AirPlay",
          html5: "HTML5",
          vimeo: "Vimeo",
          youtube: "YouTube",
        },
        qc = function () {
          var t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : "",
            e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
          if (Hl.empty(t) || Hl.empty(e)) return "";
          var n = Zl(e.i18n, t);
          if (Hl.empty(n)) return Object.keys($c).includes(t) ? $c[t] : "";
          var i = { "{seektime}": e.seekTime, "{title}": e.title };
          return (
            Object.entries(i).forEach(function (t) {
              var e = Hr(t, 2),
                i = e[0],
                o = e[1];
              n = Fc(n, i, o);
            }),
            n
          );
        },
        Hc = (function () {
          function t(e) {
            (Rr(this, t),
              (this.enabled = e.config.storage.enabled),
              (this.key = e.config.storage.key));
          }
          return (
            $r(
              t,
              [
                {
                  key: "get",
                  value: function (e) {
                    if (!t.supported || !this.enabled) return null;
                    var n = window.localStorage.getItem(this.key);
                    if (Hl.empty(n)) return null;
                    var i = JSON.parse(n);
                    return Hl.string(e) && e.length ? i[e] : i;
                  },
                },
                {
                  key: "set",
                  value: function (e) {
                    if (t.supported && this.enabled && Hl.object(e)) {
                      var n = this.get();
                      (Hl.empty(n) && (n = {}),
                        Jl(n, e),
                        window.localStorage.setItem(
                          this.key,
                          JSON.stringify(n),
                        ));
                    }
                  },
                },
              ],
              [
                {
                  key: "supported",
                  get: function () {
                    try {
                      return (
                        "localStorage" in window &&
                        (window.localStorage.setItem("___test", "___test"),
                        window.localStorage.removeItem("___test"),
                        !0)
                      );
                    } catch (t) {
                      return !1;
                    }
                  },
                },
              ],
            ),
            t
          );
        })();
      function Wc(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : "text";
        return new Promise(function (n, i) {
          try {
            var o = new XMLHttpRequest();
            if (!("withCredentials" in o)) return;
            (o.addEventListener("load", function () {
              if ("text" === e)
                try {
                  n(JSON.parse(o.responseText));
                } catch (t) {
                  n(o.responseText);
                }
              else n(o.response);
            }),
              o.addEventListener("error", function () {
                throw new Error(o.status);
              }),
              o.open("GET", t, !0),
              (o.responseType = e),
              o.send());
          } catch (t) {
            i(t);
          }
        });
      }
      function Bc(t, e) {
        if (Hl.string(t)) {
          var n = Hl.string(e),
            i = function () {
              return null !== document.getElementById(e);
            },
            o = function (t, e) {
              ((t.innerHTML = e),
                (n && i()) ||
                  document.body.insertAdjacentElement("afterbegin", t));
            };
          if (!n || !i()) {
            var r = Hc.supported,
              s = document.createElement("div");
            if (
              (s.setAttribute("hidden", ""), n && s.setAttribute("id", e), r)
            ) {
              var a = window.localStorage.getItem(
                "".concat("cache", "-").concat(e),
              );
              if (null !== a) {
                var l = JSON.parse(a);
                o(s, l.content);
              }
            }
            Wc(t)
              .then(function (t) {
                Hl.empty(t) ||
                  (r &&
                    window.localStorage.setItem(
                      "".concat("cache", "-").concat(e),
                      JSON.stringify({ content: t }),
                    ),
                  o(s, t));
              })
              .catch(function () {});
          }
        }
      }
      var Uc = Math.ceil,
        Vc = Math.floor;
      At(
        { target: "Math", stat: !0 },
        {
          trunc: function (t) {
            return (t > 0 ? Vc : Uc)(t);
          },
        },
      );
      var Yc = function (t) {
        return Math.trunc((t / 60 / 60) % 60, 10);
      };
      function Xc() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (!Hl.number(t)) return Xc(null, e, n);
        var i = function (t) {
            return "0".concat(t).slice(-2);
          },
          o = Yc(t),
          r = (function (t) {
            return Math.trunc((t / 60) % 60, 10);
          })(t),
          s = (function (t) {
            return Math.trunc(t % 60, 10);
          })(t);
        return (
          (o = e || o > 0 ? "".concat(o, ":") : ""),
          ""
            .concat(n && t > 0 ? "-" : "")
            .concat(o)
            .concat(i(r), ":")
            .concat(i(s))
        );
      }
      var Qc = {
        getIconUrl: function () {
          var t =
            new URL(this.config.iconUrl, window.location).host !==
              window.location.host ||
            (Ul.isIE && !window.svg4everybody);
          return { url: this.config.iconUrl, cors: t };
        },
        findElements: function () {
          try {
            return (
              (this.elements.controls = fc.call(
                this,
                this.config.selectors.controls.wrapper,
              )),
              (this.elements.buttons = {
                play: dc.call(this, this.config.selectors.buttons.play),
                pause: fc.call(this, this.config.selectors.buttons.pause),
                restart: fc.call(this, this.config.selectors.buttons.restart),
                rewind: fc.call(this, this.config.selectors.buttons.rewind),
                fastForward: fc.call(
                  this,
                  this.config.selectors.buttons.fastForward,
                ),
                mute: fc.call(this, this.config.selectors.buttons.mute),
                pip: fc.call(this, this.config.selectors.buttons.pip),
                airplay: fc.call(this, this.config.selectors.buttons.airplay),
                settings: fc.call(this, this.config.selectors.buttons.settings),
                captions: fc.call(this, this.config.selectors.buttons.captions),
                fullscreen: fc.call(
                  this,
                  this.config.selectors.buttons.fullscreen,
                ),
              }),
              (this.elements.progress = fc.call(
                this,
                this.config.selectors.progress,
              )),
              (this.elements.inputs = {
                seek: fc.call(this, this.config.selectors.inputs.seek),
                volume: fc.call(this, this.config.selectors.inputs.volume),
              }),
              (this.elements.display = {
                buffer: fc.call(this, this.config.selectors.display.buffer),
                currentTime: fc.call(
                  this,
                  this.config.selectors.display.currentTime,
                ),
                duration: fc.call(this, this.config.selectors.display.duration),
              }),
              Hl.element(this.elements.progress) &&
                (this.elements.display.seekTooltip =
                  this.elements.progress.querySelector(
                    ".".concat(this.config.classNames.tooltip),
                  )),
              !0
            );
          } catch (t) {
            return (
              this.debug.warn(
                "It looks like there is a problem with your custom controls HTML",
                t,
              ),
              this.toggleNativeControls(!0),
              !1
            );
          }
        },
        createIcon: function (t, e) {
          var n = Qc.getIconUrl.call(this),
            i = ""
              .concat(n.cors ? "" : n.url, "#")
              .concat(this.config.iconPrefix),
            o = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          ec(o, Jl(e, { role: "presentation", focusable: "false" }));
          var r = document.createElementNS("http://www.w3.org/2000/svg", "use"),
            s = "".concat(i, "-").concat(t);
          return (
            "href" in r &&
              r.setAttributeNS("http://www.w3.org/1999/xlink", "href", s),
            r.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", s),
            o.appendChild(r),
            o
          );
        },
        createLabel: function (t) {
          var e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            n = qc(t, this.config);
          return nc(
            "span",
            Object.assign({}, e, {
              class: [e.class, this.config.classNames.hidden]
                .filter(Boolean)
                .join(" "),
            }),
            n,
          );
        },
        createBadge: function (t) {
          if (Hl.empty(t)) return null;
          var e = nc("span", { class: this.config.classNames.menu.value });
          return (
            e.appendChild(
              nc("span", { class: this.config.classNames.menu.badge }, t),
            ),
            e
          );
        },
        createButton: function (t, e) {
          var n = this,
            i = Jl({}, e),
            o = (function () {
              var t = (
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : ""
              ).toString();
              return (
                (t = (function () {
                  var t = (
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : ""
                  ).toString();
                  return (
                    (t = Fc(t, "-", " ")),
                    (t = Fc(t, "_", " ")),
                    Fc((t = Rc(t)), " ", "")
                  );
                })(t))
                  .charAt(0)
                  .toLowerCase() + t.slice(1)
              );
            })(t),
            r = {
              element: "button",
              toggle: !1,
              label: null,
              icon: null,
              labelPressed: null,
              iconPressed: null,
            };
          switch (
            (["element", "icon", "label"].forEach(function (t) {
              Object.keys(i).includes(t) && ((r[t] = i[t]), delete i[t]);
            }),
            "button" !== r.element ||
              Object.keys(i).includes("type") ||
              (i.type = "button"),
            Object.keys(i).includes("class")
              ? i.class.split(" ").some(function (t) {
                  return t === n.config.classNames.control;
                }) ||
                Jl(i, {
                  class: ""
                    .concat(i.class, " ")
                    .concat(this.config.classNames.control),
                })
              : (i.class = this.config.classNames.control),
            t)
          ) {
            case "play":
              ((r.toggle = !0),
                (r.label = "play"),
                (r.labelPressed = "pause"),
                (r.icon = "play"),
                (r.iconPressed = "pause"));
              break;
            case "mute":
              ((r.toggle = !0),
                (r.label = "mute"),
                (r.labelPressed = "unmute"),
                (r.icon = "volume"),
                (r.iconPressed = "muted"));
              break;
            case "captions":
              ((r.toggle = !0),
                (r.label = "enableCaptions"),
                (r.labelPressed = "disableCaptions"),
                (r.icon = "captions-off"),
                (r.iconPressed = "captions-on"));
              break;
            case "fullscreen":
              ((r.toggle = !0),
                (r.label = "enterFullscreen"),
                (r.labelPressed = "exitFullscreen"),
                (r.icon = "enter-fullscreen"),
                (r.iconPressed = "exit-fullscreen"));
              break;
            case "play-large":
              ((i.class += " ".concat(
                this.config.classNames.control,
                "--overlaid",
              )),
                (o = "play"),
                (r.label = "play"),
                (r.icon = "play"));
              break;
            default:
              (Hl.empty(r.label) && (r.label = o),
                Hl.empty(r.icon) && (r.icon = t));
          }
          var s = nc(r.element);
          return (
            r.toggle
              ? (s.appendChild(
                  Qc.createIcon.call(this, r.iconPressed, {
                    class: "icon--pressed",
                  }),
                ),
                s.appendChild(
                  Qc.createIcon.call(this, r.icon, {
                    class: "icon--not-pressed",
                  }),
                ),
                s.appendChild(
                  Qc.createLabel.call(this, r.labelPressed, {
                    class: "label--pressed",
                  }),
                ),
                s.appendChild(
                  Qc.createLabel.call(this, r.label, {
                    class: "label--not-pressed",
                  }),
                ))
              : (s.appendChild(Qc.createIcon.call(this, r.icon)),
                s.appendChild(Qc.createLabel.call(this, r.label))),
            Jl(i, ac(this.config.selectors.buttons[o], i)),
            ec(s, i),
            "play" === o
              ? (Hl.array(this.elements.buttons[o]) ||
                  (this.elements.buttons[o] = []),
                this.elements.buttons[o].push(s))
              : (this.elements.buttons[o] = s),
            s
          );
        },
        createRange: function (t, e) {
          var n = nc(
            "input",
            Jl(
              ac(this.config.selectors.inputs[t]),
              {
                type: "range",
                min: 0,
                max: 100,
                step: 0.01,
                value: 0,
                autocomplete: "off",
                role: "slider",
                "aria-label": qc(t, this.config),
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": 0,
              },
              e,
            ),
          );
          return (
            (this.elements.inputs[t] = n),
            Qc.updateRangeFill.call(this, n),
            ma.setup(n),
            n
          );
        },
        createProgress: function (t, e) {
          var n = nc(
            "progress",
            Jl(
              ac(this.config.selectors.display[t]),
              {
                min: 0,
                max: 100,
                value: 0,
                role: "progressbar",
                "aria-hidden": !0,
              },
              e,
            ),
          );
          if ("volume" !== t) {
            n.appendChild(nc("span", null, "0"));
            var i = { played: "played", buffer: "buffered" }[t],
              o = i ? qc(i, this.config) : "";
            n.innerText = "% ".concat(o.toLowerCase());
          }
          return ((this.elements.display[t] = n), n);
        },
        createTime: function (t, e) {
          var n = ac(this.config.selectors.display[t], e),
            i = nc(
              "div",
              Jl(n, {
                class: ""
                  .concat(n.class ? n.class : "", " ")
                  .concat(this.config.classNames.display.time, " ")
                  .trim(),
                "aria-label": qc(t, this.config),
              }),
              "00:00",
            );
          return ((this.elements.display[t] = i), i);
        },
        bindMenuItemShortcuts: function (t, e) {
          var n = this;
          (Xl(
            t,
            "keydown keyup",
            function (i) {
              if (
                [32, 38, 39, 40].includes(i.which) &&
                (i.preventDefault(), i.stopPropagation(), "keydown" !== i.type)
              ) {
                var o,
                  r = hc(t, '[role="menuitemradio"]');
                !r && [32, 39].includes(i.which)
                  ? Qc.showMenuPanel.call(n, e, !0)
                  : 32 !== i.which &&
                    (40 === i.which || (r && 39 === i.which)
                      ? ((o = t.nextElementSibling),
                        Hl.element(o) || (o = t.parentNode.firstElementChild))
                      : ((o = t.previousElementSibling),
                        Hl.element(o) || (o = t.parentNode.lastElementChild)),
                    pc.call(n, o, !0));
              }
            },
            !1,
          ),
            Xl(t, "keyup", function (t) {
              13 === t.which && Qc.focusFirstMenuItem.call(n, null, !0);
            }));
        },
        createMenuItem: function (t) {
          var e = this,
            n = t.value,
            i = t.list,
            o = t.type,
            r = t.title,
            s = t.badge,
            a = void 0 === s ? null : s,
            l = t.checked,
            c = void 0 !== l && l,
            u = ac(this.config.selectors.inputs[o]),
            h = nc(
              "button",
              Jl(u, {
                type: "button",
                role: "menuitemradio",
                class: ""
                  .concat(this.config.classNames.control, " ")
                  .concat(u.class ? u.class : "")
                  .trim(),
                "aria-checked": c,
                value: n,
              }),
            ),
            d = nc("span");
          ((d.innerHTML = r),
            Hl.element(a) && d.appendChild(a),
            h.appendChild(d),
            Object.defineProperty(h, "checked", {
              enumerable: !0,
              get: function () {
                return "true" === h.getAttribute("aria-checked");
              },
              set: function (t) {
                (t &&
                  Array.from(h.parentNode.children)
                    .filter(function (t) {
                      return hc(t, '[role="menuitemradio"]');
                    })
                    .forEach(function (t) {
                      return t.setAttribute("aria-checked", "false");
                    }),
                  h.setAttribute("aria-checked", t ? "true" : "false"));
              },
            }),
            this.listeners.bind(
              h,
              "click keyup",
              function (t) {
                if (!Hl.keyboardEvent(t) || 32 === t.which) {
                  switch (
                    (t.preventDefault(),
                    t.stopPropagation(),
                    (h.checked = !0),
                    o)
                  ) {
                    case "language":
                      e.currentTrack = Number(n);
                      break;
                    case "quality":
                      e.quality = n;
                      break;
                    case "speed":
                      e.speed = parseFloat(n);
                  }
                  Qc.showMenuPanel.call(e, "home", Hl.keyboardEvent(t));
                }
              },
              o,
              !1,
            ),
            Qc.bindMenuItemShortcuts.call(this, h, o),
            i.appendChild(h));
        },
        formatTime: function () {
          var t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : 0,
            e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          return Hl.number(t) ? Xc(t, Yc(this.duration) > 0, e) : t;
        },
        updateTimeDisplay: function () {
          var t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : null,
            e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : 0,
            n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          Hl.element(t) && Hl.number(e) && (t.innerText = Qc.formatTime(e, n));
        },
        updateVolume: function () {
          this.supported.ui &&
            (Hl.element(this.elements.inputs.volume) &&
              Qc.setRange.call(
                this,
                this.elements.inputs.volume,
                this.muted ? 0 : this.volume,
              ),
            Hl.element(this.elements.buttons.mute) &&
              (this.elements.buttons.mute.pressed =
                this.muted || 0 === this.volume));
        },
        setRange: function (t) {
          var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          Hl.element(t) && ((t.value = e), Qc.updateRangeFill.call(this, t));
        },
        updateProgress: function (t) {
          var e = this;
          if (this.supported.ui && Hl.event(t)) {
            var n = 0;
            if (t)
              switch (t.type) {
                case "timeupdate":
                case "seeking":
                case "seeked":
                  ((n = (function (t, e) {
                    return 0 === t ||
                      0 === e ||
                      Number.isNaN(t) ||
                      Number.isNaN(e)
                      ? 0
                      : ((t / e) * 100).toFixed(2);
                  })(this.currentTime, this.duration)),
                    "timeupdate" === t.type &&
                      Qc.setRange.call(this, this.elements.inputs.seek, n));
                  break;
                case "playing":
                case "progress":
                  !(function (t, n) {
                    var i = Hl.number(n) ? n : 0,
                      o = Hl.element(t) ? t : e.elements.display.buffer;
                    if (Hl.element(o)) {
                      o.value = i;
                      var r = o.getElementsByTagName("span")[0];
                      Hl.element(r) && (r.childNodes[0].nodeValue = i);
                    }
                  })(this.elements.display.buffer, 100 * this.buffered);
              }
          }
        },
        updateRangeFill: function (t) {
          var e = Hl.event(t) ? t.target : t;
          if (Hl.element(e) && "range" === e.getAttribute("type")) {
            if (hc(e, this.config.selectors.inputs.seek)) {
              e.setAttribute("aria-valuenow", this.currentTime);
              var n = Qc.formatTime(this.currentTime),
                i = Qc.formatTime(this.duration),
                o = qc("seekLabel", this.config);
              e.setAttribute(
                "aria-valuetext",
                o.replace("{currentTime}", n).replace("{duration}", i),
              );
            } else if (hc(e, this.config.selectors.inputs.volume)) {
              var r = 100 * e.value;
              (e.setAttribute("aria-valuenow", r),
                e.setAttribute("aria-valuetext", "".concat(r.toFixed(1), "%")));
            } else e.setAttribute("aria-valuenow", e.value);
            Ul.isWebkit &&
              e.style.setProperty(
                "--value",
                "".concat((e.value / e.max) * 100, "%"),
              );
          }
        },
        updateSeekTooltip: function (t) {
          var e = this;
          if (
            this.config.tooltips.seek &&
            Hl.element(this.elements.inputs.seek) &&
            Hl.element(this.elements.display.seekTooltip) &&
            0 !== this.duration
          ) {
            var n = "".concat(this.config.classNames.tooltip, "--visible"),
              i = function (t) {
                return cc(e.elements.display.seekTooltip, n, t);
              };
            if (this.touch) i(!1);
            else {
              var o = 0,
                r = this.elements.progress.getBoundingClientRect();
              if (Hl.event(t)) o = (100 / r.width) * (t.pageX - r.left);
              else {
                if (!uc(this.elements.display.seekTooltip, n)) return;
                o = parseFloat(
                  this.elements.display.seekTooltip.style.left,
                  10,
                );
              }
              (o < 0 ? (o = 0) : o > 100 && (o = 100),
                Qc.updateTimeDisplay.call(
                  this,
                  this.elements.display.seekTooltip,
                  (this.duration / 100) * o,
                ),
                (this.elements.display.seekTooltip.style.left = "".concat(
                  o,
                  "%",
                )),
                Hl.event(t) &&
                  ["mouseenter", "mouseleave"].includes(t.type) &&
                  i("mouseenter" === t.type));
            }
          }
        },
        timeUpdate: function (t) {
          var e =
            !Hl.element(this.elements.display.duration) &&
            this.config.invertTime;
          (Qc.updateTimeDisplay.call(
            this,
            this.elements.display.currentTime,
            e ? this.duration - this.currentTime : this.currentTime,
            e,
          ),
            (t && "timeupdate" === t.type && this.media.seeking) ||
              Qc.updateProgress.call(this, t));
        },
        durationUpdate: function () {
          if (
            this.supported.ui &&
            (this.config.invertTime || !this.currentTime)
          ) {
            if (this.duration >= Math.pow(2, 32))
              return (
                lc(this.elements.display.currentTime, !0),
                void lc(this.elements.progress, !0)
              );
            Hl.element(this.elements.inputs.seek) &&
              this.elements.inputs.seek.setAttribute(
                "aria-valuemax",
                this.duration,
              );
            var t = Hl.element(this.elements.display.duration);
            (!t &&
              this.config.displayDuration &&
              this.paused &&
              Qc.updateTimeDisplay.call(
                this,
                this.elements.display.currentTime,
                this.duration,
              ),
              t &&
                Qc.updateTimeDisplay.call(
                  this,
                  this.elements.display.duration,
                  this.duration,
                ),
              Qc.updateSeekTooltip.call(this));
          }
        },
        toggleMenuButton: function (t, e) {
          lc(this.elements.settings.buttons[t], !e);
        },
        updateSetting: function (t, e, n) {
          var i = this.elements.settings.panels[t],
            o = null,
            r = e;
          if ("captions" === t) o = this.currentTrack;
          else {
            if (
              ((o = Hl.empty(n) ? this[t] : n),
              Hl.empty(o) && (o = this.config[t].default),
              !Hl.empty(this.options[t]) && !this.options[t].includes(o))
            )
              return void this.debug.warn(
                "Unsupported value of '".concat(o, "' for ").concat(t),
              );
            if (!this.config[t].options.includes(o))
              return void this.debug.warn(
                "Disabled value of '".concat(o, "' for ").concat(t),
              );
          }
          if (
            (Hl.element(r) || (r = i && i.querySelector('[role="menu"]')),
            Hl.element(r))
          ) {
            this.elements.settings.buttons[t].querySelector(
              ".".concat(this.config.classNames.menu.value),
            ).innerHTML = Qc.getLabel.call(this, t, o);
            var s = r && r.querySelector('[value="'.concat(o, '"]'));
            Hl.element(s) && (s.checked = !0);
          }
        },
        getLabel: function (t, e) {
          switch (t) {
            case "speed":
              return 1 === e
                ? qc("normal", this.config)
                : "".concat(e, "&times;");
            case "quality":
              if (Hl.number(e)) {
                var n = qc("qualityLabel.".concat(e), this.config);
                return n.length ? n : "".concat(e, "p");
              }
              return Rc(e);
            case "captions":
              return Zc.getLabel.call(this);
            default:
              return null;
          }
        },
        setQualityMenu: function (t) {
          var e = this;
          if (Hl.element(this.elements.settings.panels.quality)) {
            var n =
              this.elements.settings.panels.quality.querySelector(
                '[role="menu"]',
              );
            Hl.array(t) &&
              (this.options.quality = kc(t).filter(function (t) {
                return e.config.quality.options.includes(t);
              }));
            var i =
              !Hl.empty(this.options.quality) &&
              this.options.quality.length > 1;
            if (
              (Qc.toggleMenuButton.call(this, "quality", i),
              rc(n),
              Qc.checkMenu.call(this),
              i)
            ) {
              var o = function (t) {
                var n = qc("qualityBadge.".concat(t), e.config);
                return n.length ? Qc.createBadge.call(e, n) : null;
              };
              (this.options.quality
                .sort(function (t, n) {
                  var i = e.config.quality.options;
                  return i.indexOf(t) > i.indexOf(n) ? 1 : -1;
                })
                .forEach(function (t) {
                  Qc.createMenuItem.call(e, {
                    value: t,
                    list: n,
                    type: "quality",
                    title: Qc.getLabel.call(e, "quality", t),
                    badge: o(t),
                  });
                }),
                Qc.updateSetting.call(this, "quality", n));
            }
          }
        },
        setCaptionsMenu: function () {
          var t = this;
          if (Hl.element(this.elements.settings.panels.captions)) {
            var e =
                this.elements.settings.panels.captions.querySelector(
                  '[role="menu"]',
                ),
              n = Zc.getTracks.call(this),
              i = Boolean(n.length);
            if (
              (Qc.toggleMenuButton.call(this, "captions", i),
              rc(e),
              Qc.checkMenu.call(this),
              i)
            ) {
              var o = n.map(function (n, i) {
                return {
                  value: i,
                  checked: t.captions.toggled && t.currentTrack === i,
                  title: Zc.getLabel.call(t, n),
                  badge:
                    n.language &&
                    Qc.createBadge.call(t, n.language.toUpperCase()),
                  list: e,
                  type: "language",
                };
              });
              (o.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: qc("disabled", this.config),
                list: e,
                type: "language",
              }),
                o.forEach(Qc.createMenuItem.bind(this)),
                Qc.updateSetting.call(this, "captions", e));
            }
          }
        },
        setSpeedMenu: function (t) {
          var e = this;
          if (Hl.element(this.elements.settings.panels.speed)) {
            var n =
              this.elements.settings.panels.speed.querySelector(
                '[role="menu"]',
              );
            (Hl.array(t)
              ? (this.options.speed = t)
              : (this.isHTML5 || this.isVimeo) &&
                (this.options.speed = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]),
              (this.options.speed = this.options.speed.filter(function (t) {
                return e.config.speed.options.includes(t);
              })));
            var i =
              !Hl.empty(this.options.speed) && this.options.speed.length > 1;
            (Qc.toggleMenuButton.call(this, "speed", i),
              rc(n),
              Qc.checkMenu.call(this),
              i &&
                (this.options.speed.forEach(function (t) {
                  Qc.createMenuItem.call(e, {
                    value: t,
                    list: n,
                    type: "speed",
                    title: Qc.getLabel.call(e, "speed", t),
                  });
                }),
                Qc.updateSetting.call(this, "speed", n)));
          }
        },
        checkMenu: function () {
          var t = this.elements.settings.buttons,
            e =
              !Hl.empty(t) &&
              Object.values(t).some(function (t) {
                return !t.hidden;
              });
          lc(this.elements.settings.menu, !e);
        },
        focusFirstMenuItem: function (t) {
          var e =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          if (!this.elements.settings.popup.hidden) {
            var n = t;
            Hl.element(n) ||
              (n = Object.values(this.elements.settings.panels).find(
                function (t) {
                  return !t.hidden;
                },
              ));
            var i = n.querySelector('[role^="menuitem"]');
            pc.call(this, i, e);
          }
        },
        toggleMenu: function (t) {
          var e = this.elements.settings.popup,
            n = this.elements.buttons.settings;
          if (Hl.element(e) && Hl.element(n)) {
            var i = e.hidden,
              o = i;
            if (Hl.boolean(t)) o = t;
            else if (Hl.keyboardEvent(t) && 27 === t.which) o = !1;
            else if (Hl.event(t)) {
              var r = Hl.function(t.composedPath)
                  ? t.composedPath()[0]
                  : t.target,
                s = e.contains(r);
              if (s || (!s && t.target !== n && o)) return;
            }
            (n.setAttribute("aria-expanded", o),
              lc(e, !o),
              cc(this.elements.container, this.config.classNames.menu.open, o),
              o && Hl.keyboardEvent(t)
                ? Qc.focusFirstMenuItem.call(this, null, !0)
                : o || i || pc.call(this, n, Hl.keyboardEvent(t)));
          }
        },
        getMenuSize: function (t) {
          var e = t.cloneNode(!0);
          ((e.style.position = "absolute"),
            (e.style.opacity = 0),
            e.removeAttribute("hidden"),
            t.parentNode.appendChild(e));
          var n = e.scrollWidth,
            i = e.scrollHeight;
          return (oc(e), { width: n, height: i });
        },
        showMenuPanel: function () {
          var t = this,
            e =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : "",
            n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            i = this.elements.container.querySelector(
              "#plyr-settings-".concat(this.id, "-").concat(e),
            );
          if (Hl.element(i)) {
            var o = i.parentNode,
              r = Array.from(o.children).find(function (t) {
                return !t.hidden;
              });
            if (vc.transitions && !vc.reducedMotion) {
              ((o.style.width = "".concat(r.scrollWidth, "px")),
                (o.style.height = "".concat(r.scrollHeight, "px")));
              var s = Qc.getMenuSize.call(this, i);
              (Xl.call(this, o, Wl, function e(n) {
                n.target === o &&
                  ["width", "height"].includes(n.propertyName) &&
                  ((o.style.width = ""),
                  (o.style.height = ""),
                  Ql.call(t, o, Wl, e));
              }),
                (o.style.width = "".concat(s.width, "px")),
                (o.style.height = "".concat(s.height, "px")));
            }
            (lc(r, !0), lc(i, !1), Qc.focusFirstMenuItem.call(this, i, n));
          }
        },
        setDownloadUrl: function () {
          var t = this.elements.buttons.download;
          Hl.element(t) && t.setAttribute("href", this.download);
        },
        create: function (t) {
          var e = this,
            n = Qc.bindMenuItemShortcuts,
            i = Qc.createButton,
            o = Qc.createProgress,
            r = Qc.createRange,
            s = Qc.createTime,
            a = Qc.setQualityMenu,
            l = Qc.setSpeedMenu,
            c = Qc.showMenuPanel;
          ((this.elements.controls = null),
            this.config.controls.includes("play-large") &&
              this.elements.container.appendChild(i.call(this, "play-large")));
          var u = nc("div", ac(this.config.selectors.controls.wrapper));
          this.elements.controls = u;
          var h = { class: "plyr__controls__item" };
          return (
            kc(this.config.controls).forEach(function (a) {
              if (
                ("restart" === a && u.appendChild(i.call(e, "restart", h)),
                "rewind" === a && u.appendChild(i.call(e, "rewind", h)),
                "play" === a && u.appendChild(i.call(e, "play", h)),
                "fast-forward" === a &&
                  u.appendChild(i.call(e, "fast-forward", h)),
                "progress" === a)
              ) {
                var l = nc("div", {
                    class: "".concat(h.class, " plyr__progress__container"),
                  }),
                  d = nc("div", ac(e.config.selectors.progress));
                if (
                  (d.appendChild(
                    r.call(e, "seek", { id: "plyr-seek-".concat(t.id) }),
                  ),
                  d.appendChild(o.call(e, "buffer")),
                  e.config.tooltips.seek)
                ) {
                  var f = nc(
                    "span",
                    { class: e.config.classNames.tooltip },
                    "00:00",
                  );
                  (d.appendChild(f), (e.elements.display.seekTooltip = f));
                }
                ((e.elements.progress = d),
                  l.appendChild(e.elements.progress),
                  u.appendChild(l));
              }
              if (
                ("current-time" === a &&
                  u.appendChild(s.call(e, "currentTime", h)),
                "duration" === a && u.appendChild(s.call(e, "duration", h)),
                "mute" === a || "volume" === a)
              ) {
                var p = e.elements.volume;
                if (
                  ((Hl.element(p) && u.contains(p)) ||
                    ((p = nc(
                      "div",
                      Jl({}, h, {
                        class: "".concat(h.class, " plyr__volume").trim(),
                      }),
                    )),
                    (e.elements.volume = p),
                    u.appendChild(p)),
                  "mute" === a && p.appendChild(i.call(e, "mute")),
                  "volume" === a)
                ) {
                  var m = { max: 1, step: 0.05, value: e.config.volume };
                  p.appendChild(
                    r.call(
                      e,
                      "volume",
                      Jl(m, { id: "plyr-volume-".concat(t.id) }),
                    ),
                  );
                }
              }
              if (
                ("captions" === a && u.appendChild(i.call(e, "captions", h)),
                "settings" === a && !Hl.empty(e.config.settings))
              ) {
                var g = nc(
                  "div",
                  Jl({}, h, {
                    class: "".concat(h.class, " plyr__menu").trim(),
                    hidden: "",
                  }),
                );
                g.appendChild(
                  i.call(e, "settings", {
                    "aria-haspopup": !0,
                    "aria-controls": "plyr-settings-".concat(t.id),
                    "aria-expanded": !1,
                  }),
                );
                var v = nc("div", {
                    class: "plyr__menu__container",
                    id: "plyr-settings-".concat(t.id),
                    hidden: "",
                  }),
                  y = nc("div"),
                  b = nc("div", { id: "plyr-settings-".concat(t.id, "-home") }),
                  w = nc("div", { role: "menu" });
                (b.appendChild(w),
                  y.appendChild(b),
                  (e.elements.settings.panels.home = b),
                  e.config.settings.forEach(function (i) {
                    var o = nc(
                      "button",
                      Jl(ac(e.config.selectors.buttons.settings), {
                        type: "button",
                        class: ""
                          .concat(e.config.classNames.control, " ")
                          .concat(e.config.classNames.control, "--forward"),
                        role: "menuitem",
                        "aria-haspopup": !0,
                        hidden: "",
                      }),
                    );
                    (n.call(e, o, i),
                      Xl(o, "click", function () {
                        c.call(e, i, !1);
                      }));
                    var r = nc("span", null, qc(i, e.config)),
                      s = nc("span", { class: e.config.classNames.menu.value });
                    ((s.innerHTML = t[i]),
                      r.appendChild(s),
                      o.appendChild(r),
                      w.appendChild(o));
                    var a = nc("div", {
                        id: "plyr-settings-".concat(t.id, "-").concat(i),
                        hidden: "",
                      }),
                      l = nc("button", {
                        type: "button",
                        class: ""
                          .concat(e.config.classNames.control, " ")
                          .concat(e.config.classNames.control, "--back"),
                      });
                    (l.appendChild(
                      nc("span", { "aria-hidden": !0 }, qc(i, e.config)),
                    ),
                      l.appendChild(
                        nc(
                          "span",
                          { class: e.config.classNames.hidden },
                          qc("menuBack", e.config),
                        ),
                      ),
                      Xl(
                        a,
                        "keydown",
                        function (t) {
                          37 === t.which &&
                            (t.preventDefault(),
                            t.stopPropagation(),
                            c.call(e, "home", !0));
                        },
                        !1,
                      ),
                      Xl(l, "click", function () {
                        c.call(e, "home", !1);
                      }),
                      a.appendChild(l),
                      a.appendChild(nc("div", { role: "menu" })),
                      y.appendChild(a),
                      (e.elements.settings.buttons[i] = o),
                      (e.elements.settings.panels[i] = a));
                  }),
                  v.appendChild(y),
                  g.appendChild(v),
                  u.appendChild(g),
                  (e.elements.settings.popup = v),
                  (e.elements.settings.menu = g));
              }
              if (
                ("pip" === a && vc.pip && u.appendChild(i.call(e, "pip", h)),
                "airplay" === a &&
                  vc.airplay &&
                  u.appendChild(i.call(e, "airplay", h)),
                "download" === a)
              ) {
                var x = Jl({}, h, {
                    element: "a",
                    href: e.download,
                    target: "_blank",
                  }),
                  S = e.config.urls.download;
                (!Hl.url(S) &&
                  e.isEmbed &&
                  Jl(x, {
                    icon: "logo-".concat(e.provider),
                    label: e.provider,
                  }),
                  u.appendChild(i.call(e, "download", x)));
              }
              "fullscreen" === a && u.appendChild(i.call(e, "fullscreen", h));
            }),
            this.isHTML5 && a.call(this, Sc.getQualityOptions.call(this)),
            l.call(this),
            u
          );
        },
        inject: function () {
          var t = this;
          if (this.config.loadSprite) {
            var e = Qc.getIconUrl.call(this);
            e.cors && Bc(e.url, "sprite-plyr");
          }
          this.id = Math.floor(1e4 * Math.random());
          var n = null;
          this.elements.controls = null;
          var i = {
              id: this.id,
              seektime: this.config.seekTime,
              title: this.config.title,
            },
            o = !0;
          (Hl.function(this.config.controls) &&
            (this.config.controls = this.config.controls.call(this, i)),
            this.config.controls || (this.config.controls = []),
            Hl.element(this.config.controls) || Hl.string(this.config.controls)
              ? (n = this.config.controls)
              : ((n = Qc.create.call(this, {
                  id: this.id,
                  seektime: this.config.seekTime,
                  speed: this.speed,
                  quality: this.quality,
                  captions: Zc.getLabel.call(this),
                })),
                (o = !1)));
          var r,
            s = function (t) {
              var e = t;
              return (
                Object.entries(i).forEach(function (t) {
                  var n = Hr(t, 2),
                    i = n[0],
                    o = n[1];
                  e = Fc(e, "{".concat(i, "}"), o);
                }),
                e
              );
            };
          if (
            (o &&
              (Hl.string(this.config.controls)
                ? (n = s(n))
                : Hl.element(n) && (n.innerHTML = s(n.innerHTML))),
            Hl.string(this.config.selectors.controls.container) &&
              (r = document.querySelector(
                this.config.selectors.controls.container,
              )),
            Hl.element(r) || (r = this.elements.container),
            r[Hl.element(n) ? "insertAdjacentElement" : "insertAdjacentHTML"](
              "afterbegin",
              n,
            ),
            Hl.element(this.elements.controls) || Qc.findElements.call(this),
            !Hl.empty(this.elements.buttons))
          ) {
            var a = function (e) {
              var n = t.config.classNames.controlPressed;
              Object.defineProperty(e, "pressed", {
                enumerable: !0,
                get: function () {
                  return uc(e, n);
                },
                set: function () {
                  cc(
                    e,
                    n,
                    arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0],
                  );
                },
              });
            };
            Object.values(this.elements.buttons)
              .filter(Boolean)
              .forEach(function (t) {
                Hl.array(t) || Hl.nodeList(t)
                  ? Array.from(t).filter(Boolean).forEach(a)
                  : a(t);
              });
          }
          if ((Ul.isEdge && Bl(r), this.config.tooltips.controls)) {
            var l = this.config,
              c = l.classNames,
              u = l.selectors,
              h = ""
                .concat(u.controls.wrapper, " ")
                .concat(u.labels, " .")
                .concat(c.hidden),
              d = dc.call(this, h);
            Array.from(d).forEach(function (e) {
              (cc(e, t.config.classNames.hidden, !1),
                cc(e, t.config.classNames.tooltip, !0));
            });
          }
        },
      };
      function Gc(t) {
        var e = t;
        if (
          !(arguments.length > 1 && void 0 !== arguments[1]) ||
          arguments[1]
        ) {
          var n = document.createElement("a");
          ((n.href = e), (e = n.href));
        }
        try {
          return new URL(e);
        } catch (t) {
          return null;
        }
      }
      function Kc(t) {
        var e = new URLSearchParams();
        return (
          Hl.object(t) &&
            Object.entries(t).forEach(function (t) {
              var n = Hr(t, 2),
                i = n[0],
                o = n[1];
              e.set(i, o);
            }),
          e
        );
      }
      var Zc = {
          setup: function () {
            if (this.supported.ui)
              if (
                !this.isVideo ||
                this.isYouTube ||
                (this.isHTML5 && !vc.textTracks)
              )
                Hl.array(this.config.controls) &&
                  this.config.controls.includes("settings") &&
                  this.config.settings.includes("captions") &&
                  Qc.setCaptionsMenu.call(this);
              else {
                if (
                  (Hl.element(this.elements.captions) ||
                    ((this.elements.captions = nc(
                      "div",
                      ac(this.config.selectors.captions),
                    )),
                    (function (t, e) {
                      Hl.element(t) &&
                        Hl.element(e) &&
                        e.parentNode.insertBefore(t, e.nextSibling);
                    })(this.elements.captions, this.elements.wrapper)),
                  Ul.isIE && window.URL)
                ) {
                  var t = this.media.querySelectorAll("track");
                  Array.from(t).forEach(function (t) {
                    var e = t.getAttribute("src"),
                      n = Gc(e);
                    null !== n &&
                      n.hostname !== window.location.href.hostname &&
                      ["http:", "https:"].includes(n.protocol) &&
                      Wc(e, "blob")
                        .then(function (e) {
                          t.setAttribute("src", window.URL.createObjectURL(e));
                        })
                        .catch(function () {
                          oc(t);
                        });
                  });
                }
                var e = kc(
                    (
                      navigator.languages || [
                        navigator.language || navigator.userLanguage || "en",
                      ]
                    ).map(function (t) {
                      return t.split("-")[0];
                    }),
                  ),
                  n = (
                    this.storage.get("language") ||
                    this.config.captions.language ||
                    "auto"
                  ).toLowerCase();
                "auto" === n && (n = Hr(e, 1)[0]);
                var i = this.storage.get("captions");
                if (
                  (Hl.boolean(i) || (i = this.config.captions.active),
                  Object.assign(this.captions, {
                    toggled: !1,
                    active: i,
                    language: n,
                    languages: e,
                  }),
                  this.isHTML5)
                ) {
                  var o = this.config.captions.update
                    ? "addtrack removetrack"
                    : "removetrack";
                  Xl.call(this, this.media.textTracks, o, Zc.update.bind(this));
                }
                setTimeout(Zc.update.bind(this), 0);
              }
          },
          update: function () {
            var t = this,
              e = Zc.getTracks.call(this, !0),
              n = this.captions,
              i = n.active,
              o = n.language,
              r = n.meta,
              s = n.currentTrackNode,
              a = Boolean(
                e.find(function (t) {
                  return t.language === o;
                }),
              );
            (this.isHTML5 &&
              this.isVideo &&
              e
                .filter(function (t) {
                  return !r.get(t);
                })
                .forEach(function (e) {
                  (t.debug.log("Track added", e),
                    r.set(e, { default: "showing" === e.mode }),
                    (e.mode = "hidden"),
                    Xl.call(t, e, "cuechange", function () {
                      return Zc.updateCues.call(t);
                    }));
                }),
              ((a && this.language !== o) || !e.includes(s)) &&
                (Zc.setLanguage.call(this, o), Zc.toggle.call(this, i && a)),
              cc(
                this.elements.container,
                this.config.classNames.captions.enabled,
                !Hl.empty(e),
              ),
              (this.config.controls || []).includes("settings") &&
                this.config.settings.includes("captions") &&
                Qc.setCaptionsMenu.call(this));
          },
          toggle: function (t) {
            var e =
              !(arguments.length > 1 && void 0 !== arguments[1]) ||
              arguments[1];
            if (this.supported.ui) {
              var n = this.captions.toggled,
                i = this.config.classNames.captions.active,
                o = Hl.nullOrUndefined(t) ? !n : t;
              if (o !== n) {
                if (
                  (e ||
                    ((this.captions.active = o),
                    this.storage.set({ captions: o })),
                  !this.language && o && !e)
                ) {
                  var r = Zc.getTracks.call(this),
                    s = Zc.findTrack.call(
                      this,
                      [this.captions.language].concat(
                        Wr(this.captions.languages),
                      ),
                      !0,
                    );
                  return (
                    (this.captions.language = s.language),
                    void Zc.set.call(this, r.indexOf(s))
                  );
                }
                (this.elements.buttons.captions &&
                  (this.elements.buttons.captions.pressed = o),
                  cc(this.elements.container, i, o),
                  (this.captions.toggled = o),
                  Qc.updateSetting.call(this, "captions"),
                  Kl.call(
                    this,
                    this.media,
                    o ? "captionsenabled" : "captionsdisabled",
                  ));
              }
            }
          },
          set: function (t) {
            var e =
                !(arguments.length > 1 && void 0 !== arguments[1]) ||
                arguments[1],
              n = Zc.getTracks.call(this);
            if (-1 !== t)
              if (Hl.number(t))
                if (t in n) {
                  if (this.captions.currentTrack !== t) {
                    this.captions.currentTrack = t;
                    var i = n[t],
                      o = (i || {}).language;
                    ((this.captions.currentTrackNode = i),
                      Qc.updateSetting.call(this, "captions"),
                      e ||
                        ((this.captions.language = o),
                        this.storage.set({ language: o })),
                      this.isVimeo && this.embed.enableTextTrack(o),
                      Kl.call(this, this.media, "languagechange"));
                  }
                  (Zc.toggle.call(this, !0, e),
                    this.isHTML5 && this.isVideo && Zc.updateCues.call(this));
                } else this.debug.warn("Track not found", t);
              else this.debug.warn("Invalid caption argument", t);
            else Zc.toggle.call(this, !1, e);
          },
          setLanguage: function (t) {
            var e =
              !(arguments.length > 1 && void 0 !== arguments[1]) ||
              arguments[1];
            if (Hl.string(t)) {
              var n = t.toLowerCase();
              this.captions.language = n;
              var i = Zc.getTracks.call(this),
                o = Zc.findTrack.call(this, [n]);
              Zc.set.call(this, i.indexOf(o), e);
            } else this.debug.warn("Invalid language argument", t);
          },
          getTracks: function () {
            var t = this,
              e =
                arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return Array.from((this.media || {}).textTracks || [])
              .filter(function (n) {
                return !t.isHTML5 || e || t.captions.meta.has(n);
              })
              .filter(function (t) {
                return ["captions", "subtitles"].includes(t.kind);
              });
          },
          findTrack: function (t) {
            var e,
              n = this,
              i =
                arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              o = Zc.getTracks.call(this),
              r = function (t) {
                return Number((n.captions.meta.get(t) || {}).default);
              },
              s = Array.from(o).sort(function (t, e) {
                return r(e) - r(t);
              });
            return (
              t.every(function (t) {
                return !(e = s.find(function (e) {
                  return e.language === t;
                }));
              }),
              e || (i ? s[0] : void 0)
            );
          },
          getCurrentTrack: function () {
            return Zc.getTracks.call(this)[this.currentTrack];
          },
          getLabel: function (t) {
            var e = t;
            return (
              !Hl.track(e) &&
                vc.textTracks &&
                this.captions.toggled &&
                (e = Zc.getCurrentTrack.call(this)),
              Hl.track(e)
                ? Hl.empty(e.label)
                  ? Hl.empty(e.language)
                    ? qc("enabled", this.config)
                    : t.language.toUpperCase()
                  : e.label
                : qc("disabled", this.config)
            );
          },
          updateCues: function (t) {
            if (this.supported.ui)
              if (Hl.element(this.elements.captions))
                if (Hl.nullOrUndefined(t) || Array.isArray(t)) {
                  var e = t;
                  if (!e) {
                    var n = Zc.getCurrentTrack.call(this);
                    e = Array.from((n || {}).activeCues || [])
                      .map(function (t) {
                        return t.getCueAsHTML();
                      })
                      .map(Nc);
                  }
                  var i = e
                    .map(function (t) {
                      return t.trim();
                    })
                    .join("\n");
                  if (i !== this.elements.captions.innerHTML) {
                    rc(this.elements.captions);
                    var o = nc("span", ac(this.config.selectors.caption));
                    ((o.innerHTML = i),
                      this.elements.captions.appendChild(o),
                      Kl.call(this, this.media, "cuechange"));
                  }
                } else this.debug.warn("updateCues: Invalid input", t);
              else this.debug.warn("No captions element to render to");
          },
        },
        Jc = {
          enabled: !0,
          title: "",
          debug: !1,
          autoplay: !1,
          autopause: !0,
          playsinline: !0,
          seekTime: 10,
          volume: 1,
          muted: !1,
          duration: null,
          displayDuration: !0,
          invertTime: !0,
          toggleInvert: !0,
          ratio: null,
          clickToPlay: !0,
          hideControls: !0,
          resetOnEnd: !1,
          disableContextMenu: !0,
          loadSprite: !0,
          iconPrefix: "plyr",
          iconUrl: "https://cdn.plyr.io/3.5.6/plyr.svg",
          blankVideo: "https://cdn.plyr.io/static/blank.mp4",
          quality: {
            default: 576,
            options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240],
          },
          loop: { active: !1 },
          speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] },
          keyboard: { focused: !0, global: !1 },
          tooltips: { controls: !1, seek: !0 },
          captions: { active: !1, language: "auto", update: !1 },
          fullscreen: { enabled: !0, fallback: !0, iosNative: !1 },
          storage: { enabled: !0, key: "plyr" },
          controls: [
            "play-large",
            "play",
            "progress",
            "current-time",
            "mute",
            "volume",
            "captions",
            "settings",
            "pip",
            "airplay",
            "fullscreen",
          ],
          settings: ["captions", "quality", "speed"],
          i18n: {
            restart: "Restart",
            rewind: "Rewind {seektime}s",
            play: "Play",
            pause: "Pause",
            fastForward: "Forward {seektime}s",
            seek: "Seek",
            seekLabel: "{currentTime} of {duration}",
            played: "Played",
            buffered: "Buffered",
            currentTime: "Current time",
            duration: "Duration",
            volume: "Volume",
            mute: "Mute",
            unmute: "Unmute",
            enableCaptions: "Enable captions",
            disableCaptions: "Disable captions",
            download: "Download",
            enterFullscreen: "Enter fullscreen",
            exitFullscreen: "Exit fullscreen",
            frameTitle: "Player for {title}",
            captions: "Captions",
            settings: "Settings",
            menuBack: "Go back to previous menu",
            speed: "Speed",
            normal: "Normal",
            quality: "Quality",
            loop: "Loop",
            start: "Start",
            end: "End",
            all: "All",
            reset: "Reset",
            disabled: "Disabled",
            enabled: "Enabled",
            advertisement: "Ad",
            qualityBadge: {
              2160: "4K",
              1440: "HD",
              1080: "HD",
              720: "HD",
              576: "SD",
              480: "SD",
            },
          },
          urls: {
            download: null,
            vimeo: {
              sdk: "https://player.vimeo.com/api/player.js",
              iframe: "https://player.vimeo.com/video/{0}?{1}",
              api: "https://vimeo.com/api/v2/video/{0}.json",
            },
            youtube: {
              sdk: "https://www.youtube.com/iframe_api",
              api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}",
            },
            googleIMA: {
              sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
            },
          },
          listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null,
          },
          events: [
            "ended",
            "progress",
            "stalled",
            "playing",
            "waiting",
            "canplay",
            "canplaythrough",
            "loadstart",
            "loadeddata",
            "loadedmetadata",
            "timeupdate",
            "volumechange",
            "play",
            "pause",
            "error",
            "seeking",
            "seeked",
            "emptied",
            "ratechange",
            "cuechange",
            "download",
            "enterfullscreen",
            "exitfullscreen",
            "captionsenabled",
            "captionsdisabled",
            "languagechange",
            "controlshidden",
            "controlsshown",
            "ready",
            "statechange",
            "qualitychange",
            "adsloaded",
            "adscontentpause",
            "adscontentresume",
            "adstarted",
            "adsmidpoint",
            "adscomplete",
            "adsallcomplete",
            "adsimpression",
            "adsclick",
          ],
          selectors: {
            editable: "input, textarea, select, [contenteditable]",
            container: ".plyr",
            controls: { container: null, wrapper: ".plyr__controls" },
            labels: "[data-plyr]",
            buttons: {
              play: '[data-plyr="play"]',
              pause: '[data-plyr="pause"]',
              restart: '[data-plyr="restart"]',
              rewind: '[data-plyr="rewind"]',
              fastForward: '[data-plyr="fast-forward"]',
              mute: '[data-plyr="mute"]',
              captions: '[data-plyr="captions"]',
              download: '[data-plyr="download"]',
              fullscreen: '[data-plyr="fullscreen"]',
              pip: '[data-plyr="pip"]',
              airplay: '[data-plyr="airplay"]',
              settings: '[data-plyr="settings"]',
              loop: '[data-plyr="loop"]',
            },
            inputs: {
              seek: '[data-plyr="seek"]',
              volume: '[data-plyr="volume"]',
              speed: '[data-plyr="speed"]',
              language: '[data-plyr="language"]',
              quality: '[data-plyr="quality"]',
            },
            display: {
              currentTime: ".plyr__time--current",
              duration: ".plyr__time--duration",
              buffer: ".plyr__progress__buffer",
              loop: ".plyr__progress__loop",
              volume: ".plyr__volume--display",
            },
            progress: ".plyr__progress",
            captions: ".plyr__captions",
            caption: ".plyr__caption",
          },
          classNames: {
            type: "plyr--{0}",
            provider: "plyr--{0}",
            video: "plyr__video-wrapper",
            embed: "plyr__video-embed",
            videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
            embedContainer: "plyr__video-embed__container",
            poster: "plyr__poster",
            posterEnabled: "plyr__poster-enabled",
            ads: "plyr__ads",
            control: "plyr__control",
            controlPressed: "plyr__control--pressed",
            playing: "plyr--playing",
            paused: "plyr--paused",
            stopped: "plyr--stopped",
            loading: "plyr--loading",
            hover: "plyr--hover",
            tooltip: "plyr__tooltip",
            cues: "plyr__cues",
            hidden: "plyr__sr-only",
            hideControls: "plyr--hide-controls",
            isIos: "plyr--is-ios",
            isTouch: "plyr--is-touch",
            uiSupported: "plyr--full-ui",
            noTransition: "plyr--no-transition",
            display: { time: "plyr__time" },
            menu: {
              value: "plyr__menu__value",
              badge: "plyr__badge",
              open: "plyr--menu-open",
            },
            captions: {
              enabled: "plyr--captions-enabled",
              active: "plyr--captions-active",
            },
            fullscreen: {
              enabled: "plyr--fullscreen-enabled",
              fallback: "plyr--fullscreen-fallback",
            },
            pip: {
              supported: "plyr--pip-supported",
              active: "plyr--pip-active",
            },
            airplay: {
              supported: "plyr--airplay-supported",
              active: "plyr--airplay-active",
            },
            tabFocus: "plyr__tab-focus",
            previewThumbnails: {
              thumbContainer: "plyr__preview-thumb",
              thumbContainerShown: "plyr__preview-thumb--is-shown",
              imageContainer: "plyr__preview-thumb__image-container",
              timeContainer: "plyr__preview-thumb__time-container",
              scrubbingContainer: "plyr__preview-scrubbing",
              scrubbingContainerShown: "plyr__preview-scrubbing--is-shown",
            },
          },
          attributes: {
            embed: { provider: "data-plyr-provider", id: "data-plyr-embed-id" },
          },
          ads: { enabled: !1, publisherId: "", tagUrl: "" },
          previewThumbnails: { enabled: !1, src: "" },
          vimeo: {
            byline: !1,
            portrait: !1,
            title: !1,
            speed: !0,
            transparent: !1,
          },
          youtube: {
            noCookie: !1,
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
          },
        },
        tu = "picture-in-picture",
        eu = { html5: "html5", youtube: "youtube", vimeo: "vimeo" },
        nu = "audio",
        iu = "video",
        ou = function () {},
        ru = (function () {
          function t() {
            var e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            (Rr(this, t),
              (this.enabled = window.console && e),
              this.enabled && this.log("Debugging enabled"));
          }
          return (
            $r(t, [
              {
                key: "log",
                get: function () {
                  return this.enabled
                    ? Function.prototype.bind.call(console.log, console)
                    : ou;
                },
              },
              {
                key: "warn",
                get: function () {
                  return this.enabled
                    ? Function.prototype.bind.call(console.warn, console)
                    : ou;
                },
              },
              {
                key: "error",
                get: function () {
                  return this.enabled
                    ? Function.prototype.bind.call(console.error, console)
                    : ou;
                },
              },
            ]),
            t
          );
        })();
      function su() {
        if (this.enabled) {
          var t = this.player.elements.buttons.fullscreen;
          (Hl.element(t) && (t.pressed = this.active),
            Kl.call(
              this.player,
              this.target,
              this.active ? "enterfullscreen" : "exitfullscreen",
              !0,
            ),
            Ul.isIos ||
              function () {
                var t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : null,
                  e =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1];
                if (Hl.element(t)) {
                  var n = dc.call(
                      this,
                      "button:not(:disabled), input:not(:disabled), [tabindex]",
                    ),
                    i = n[0],
                    o = n[n.length - 1];
                  Yl.call(
                    this,
                    this.elements.container,
                    "keydown",
                    function (t) {
                      if ("Tab" === t.key && 9 === t.keyCode) {
                        var e = document.activeElement;
                        e !== o || t.shiftKey
                          ? e === i &&
                            t.shiftKey &&
                            (o.focus(), t.preventDefault())
                          : (i.focus(), t.preventDefault());
                      }
                    },
                    e,
                    !1,
                  );
                }
              }.call(this.player, this.target, this.active));
        }
      }
      function au() {
        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        if (
          (t
            ? (this.scrollPosition = {
                x: window.scrollX || 0,
                y: window.scrollY || 0,
              })
            : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y),
          (document.body.style.overflow = t ? "hidden" : ""),
          cc(this.target, this.player.config.classNames.fullscreen.fallback, t),
          Ul.isIos)
        ) {
          var e = document.head.querySelector('meta[name="viewport"]'),
            n = "viewport-fit=cover";
          e ||
            (e = document.createElement("meta")).setAttribute(
              "name",
              "viewport",
            );
          var i = Hl.string(e.content) && e.content.includes(n);
          t
            ? ((this.cleanupViewport = !i), i || (e.content += ",".concat(n)))
            : this.cleanupViewport &&
              (e.content = e.content
                .split(",")
                .filter(function (t) {
                  return t.trim() !== n;
                })
                .join(","));
        }
        su.call(this);
      }
      var lu = (function () {
          function t(e) {
            var n = this;
            (Rr(this, t),
              (this.player = e),
              (this.prefix = t.prefix),
              (this.property = t.property),
              (this.scrollPosition = { x: 0, y: 0 }),
              (this.forceFallback = "force" === e.config.fullscreen.fallback),
              Xl.call(
                this.player,
                document,
                "ms" === this.prefix
                  ? "MSFullscreenChange"
                  : "".concat(this.prefix, "fullscreenchange"),
                function () {
                  su.call(n);
                },
              ),
              Xl.call(
                this.player,
                this.player.elements.container,
                "dblclick",
                function (t) {
                  (Hl.element(n.player.elements.controls) &&
                    n.player.elements.controls.contains(t.target)) ||
                    n.toggle();
                },
              ),
              this.update());
          }
          return (
            $r(
              t,
              [
                {
                  key: "update",
                  value: function () {
                    var e;
                    (this.enabled
                      ? ((e = this.forceFallback
                          ? "Fallback (forced)"
                          : t.native
                            ? "Native"
                            : "Fallback"),
                        this.player.debug.log(
                          "".concat(e, " fullscreen enabled"),
                        ))
                      : this.player.debug.log(
                          "Fullscreen not supported and fallback disabled",
                        ),
                      cc(
                        this.player.elements.container,
                        this.player.config.classNames.fullscreen.enabled,
                        this.enabled,
                      ));
                  },
                },
                {
                  key: "enter",
                  value: function () {
                    this.enabled &&
                      (Ul.isIos && this.player.config.fullscreen.iosNative
                        ? this.target.webkitEnterFullscreen()
                        : !t.native || this.forceFallback
                          ? au.call(this, !0)
                          : this.prefix
                            ? Hl.empty(this.prefix) ||
                              this.target[
                                ""
                                  .concat(this.prefix, "Request")
                                  .concat(this.property)
                              ]()
                            : this.target.requestFullscreen());
                  },
                },
                {
                  key: "exit",
                  value: function () {
                    if (this.enabled)
                      if (Ul.isIos && this.player.config.fullscreen.iosNative)
                        (this.target.webkitExitFullscreen(),
                          this.player.play());
                      else if (!t.native || this.forceFallback)
                        au.call(this, !1);
                      else if (this.prefix) {
                        if (!Hl.empty(this.prefix)) {
                          var e = "moz" === this.prefix ? "Cancel" : "Exit";
                          document[
                            ""
                              .concat(this.prefix)
                              .concat(e)
                              .concat(this.property)
                          ]();
                        }
                      } else
                        (
                          document.cancelFullScreen || document.exitFullscreen
                        ).call(document);
                  },
                },
                {
                  key: "toggle",
                  value: function () {
                    this.active ? this.exit() : this.enter();
                  },
                },
                {
                  key: "usingNative",
                  get: function () {
                    return t.native && !this.forceFallback;
                  },
                },
                {
                  key: "enabled",
                  get: function () {
                    return (
                      (t.native || this.player.config.fullscreen.fallback) &&
                      this.player.config.fullscreen.enabled &&
                      this.player.supported.ui &&
                      this.player.isVideo
                    );
                  },
                },
                {
                  key: "active",
                  get: function () {
                    return (
                      !!this.enabled &&
                      (!t.native || this.forceFallback
                        ? uc(
                            this.target,
                            this.player.config.classNames.fullscreen.fallback,
                          )
                        : (this.prefix
                            ? document[
                                ""
                                  .concat(this.prefix)
                                  .concat(this.property, "Element")
                              ]
                            : document.fullscreenElement) === this.target)
                    );
                  },
                },
                {
                  key: "target",
                  get: function () {
                    return Ul.isIos && this.player.config.fullscreen.iosNative
                      ? this.player.media
                      : this.player.elements.container;
                  },
                },
              ],
              [
                {
                  key: "native",
                  get: function () {
                    return !!(
                      document.fullscreenEnabled ||
                      document.webkitFullscreenEnabled ||
                      document.mozFullScreenEnabled ||
                      document.msFullscreenEnabled
                    );
                  },
                },
                {
                  key: "prefix",
                  get: function () {
                    if (Hl.function(document.exitFullscreen)) return "";
                    var t = "";
                    return (
                      ["webkit", "moz", "ms"].some(function (e) {
                        return !(
                          (!Hl.function(
                            document["".concat(e, "ExitFullscreen")],
                          ) &&
                            !Hl.function(
                              document["".concat(e, "CancelFullScreen")],
                            )) ||
                          ((t = e), 0)
                        );
                      }),
                      t
                    );
                  },
                },
                {
                  key: "property",
                  get: function () {
                    return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
                  },
                },
              ],
            ),
            t
          );
        })(),
        cu =
          Math.sign ||
          function (t) {
            return 0 == (t = +t) || t != t ? t : t < 0 ? -1 : 1;
          };
      function uu(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
        return new Promise(function (n, i) {
          var o = new Image(),
            r = function () {
              (delete o.onload,
                delete o.onerror,
                (o.naturalWidth >= e ? n : i)(o));
            };
          Object.assign(o, { onload: r, onerror: r, src: t });
        });
      }
      At({ target: "Math", stat: !0 }, { sign: cu });
      var hu = {
          addStyleHook: function () {
            (cc(
              this.elements.container,
              this.config.selectors.container.replace(".", ""),
              !0,
            ),
              cc(
                this.elements.container,
                this.config.classNames.uiSupported,
                this.supported.ui,
              ));
          },
          toggleNativeControls: function () {
            arguments.length > 0 &&
            void 0 !== arguments[0] &&
            arguments[0] &&
            this.isHTML5
              ? this.media.setAttribute("controls", "")
              : this.media.removeAttribute("controls");
          },
          build: function () {
            var t = this;
            if ((this.listeners.media(), !this.supported.ui))
              return (
                this.debug.warn(
                  "Basic support only for "
                    .concat(this.provider, " ")
                    .concat(this.type),
                ),
                void hu.toggleNativeControls.call(this, !0)
              );
            (Hl.element(this.elements.controls) ||
              (Qc.inject.call(this), this.listeners.controls()),
              hu.toggleNativeControls.call(this),
              this.isHTML5 && Zc.setup.call(this),
              (this.volume = null),
              (this.muted = null),
              (this.loop = null),
              (this.quality = null),
              (this.speed = null),
              Qc.updateVolume.call(this),
              Qc.timeUpdate.call(this),
              hu.checkPlaying.call(this),
              cc(
                this.elements.container,
                this.config.classNames.pip.supported,
                vc.pip && this.isHTML5 && this.isVideo,
              ),
              cc(
                this.elements.container,
                this.config.classNames.airplay.supported,
                vc.airplay && this.isHTML5,
              ),
              cc(
                this.elements.container,
                this.config.classNames.isIos,
                Ul.isIos,
              ),
              cc(
                this.elements.container,
                this.config.classNames.isTouch,
                this.touch,
              ),
              (this.ready = !0),
              setTimeout(function () {
                Kl.call(t, t.media, "ready");
              }, 0),
              hu.setTitle.call(this),
              this.poster &&
                hu.setPoster.call(this, this.poster, !1).catch(function () {}),
              this.config.duration && Qc.durationUpdate.call(this));
          },
          setTitle: function () {
            var t = qc("play", this.config);
            if (
              (Hl.string(this.config.title) &&
                !Hl.empty(this.config.title) &&
                (t += ", ".concat(this.config.title)),
              Array.from(this.elements.buttons.play || []).forEach(
                function (e) {
                  e.setAttribute("aria-label", t);
                },
              ),
              this.isEmbed)
            ) {
              var e = fc.call(this, "iframe");
              if (!Hl.element(e)) return;
              var n = Hl.empty(this.config.title) ? "video" : this.config.title,
                i = qc("frameTitle", this.config);
              e.setAttribute("title", i.replace("{title}", n));
            }
          },
          togglePoster: function (t) {
            cc(
              this.elements.container,
              this.config.classNames.posterEnabled,
              t,
            );
          },
          setPoster: function (t) {
            var e = this;
            return (arguments.length > 1 &&
              void 0 !== arguments[1] &&
              !arguments[1]) ||
              !this.poster
              ? (this.media.setAttribute("poster", t),
                function () {
                  var t = this;
                  return new Promise(function (e) {
                    return t.ready
                      ? setTimeout(e, 0)
                      : Xl.call(t, t.elements.container, "ready", e);
                  }).then(function () {});
                }
                  .call(this)
                  .then(function () {
                    return uu(t);
                  })
                  .catch(function (n) {
                    throw (t === e.poster && hu.togglePoster.call(e, !1), n);
                  })
                  .then(function () {
                    if (t !== e.poster)
                      throw new Error(
                        "setPoster cancelled by later call to setPoster",
                      );
                  })
                  .then(function () {
                    return (
                      Object.assign(e.elements.poster.style, {
                        backgroundImage: "url('".concat(t, "')"),
                        backgroundSize: "",
                      }),
                      hu.togglePoster.call(e, !0),
                      t
                    );
                  }))
              : Promise.reject(new Error("Poster already set"));
          },
          checkPlaying: function (t) {
            var e = this;
            (cc(
              this.elements.container,
              this.config.classNames.playing,
              this.playing,
            ),
              cc(
                this.elements.container,
                this.config.classNames.paused,
                this.paused,
              ),
              cc(
                this.elements.container,
                this.config.classNames.stopped,
                this.stopped,
              ),
              Array.from(this.elements.buttons.play || []).forEach(
                function (t) {
                  Object.assign(t, { pressed: e.playing });
                },
              ),
              (Hl.event(t) && "timeupdate" === t.type) ||
                hu.toggleControls.call(this));
          },
          checkLoading: function (t) {
            var e = this;
            ((this.loading = ["stalled", "waiting"].includes(t.type)),
              clearTimeout(this.timers.loading),
              (this.timers.loading = setTimeout(
                function () {
                  (cc(
                    e.elements.container,
                    e.config.classNames.loading,
                    e.loading,
                  ),
                    hu.toggleControls.call(e));
                },
                this.loading ? 250 : 0,
              )));
          },
          toggleControls: function (t) {
            var e = this.elements.controls;
            if (e && this.config.hideControls) {
              var n = this.touch && this.lastSeekTime + 2e3 > Date.now();
              this.toggleControls(
                Boolean(
                  t || this.loading || this.paused || e.pressed || e.hover || n,
                ),
              );
            }
          },
        },
        du = (function () {
          function t(e) {
            (Rr(this, t),
              (this.player = e),
              (this.lastKey = null),
              (this.focusTimer = null),
              (this.lastKeyDown = null),
              (this.handleKey = this.handleKey.bind(this)),
              (this.toggleMenu = this.toggleMenu.bind(this)),
              (this.setTabFocus = this.setTabFocus.bind(this)),
              (this.firstTouch = this.firstTouch.bind(this)));
          }
          return (
            $r(t, [
              {
                key: "handleKey",
                value: function (t) {
                  var e = this.player,
                    n = e.elements,
                    i = t.keyCode ? t.keyCode : t.which,
                    o = "keydown" === t.type,
                    r = o && i === this.lastKey;
                  if (
                    !(t.altKey || t.ctrlKey || t.metaKey || t.shiftKey) &&
                    Hl.number(i)
                  )
                    if (o) {
                      var s = document.activeElement;
                      if (Hl.element(s)) {
                        var a = e.config.selectors.editable;
                        if (s !== n.inputs.seek && hc(s, a)) return;
                        if (
                          32 === t.which &&
                          hc(s, 'button, [role^="menuitem"]')
                        )
                          return;
                      }
                      switch (
                        ([
                          32, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 56,
                          57, 67, 70, 73, 75, 76, 77, 79,
                        ].includes(i) &&
                          (t.preventDefault(), t.stopPropagation()),
                        i)
                      ) {
                        case 48:
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                        case 56:
                        case 57:
                          r || (e.currentTime = (e.duration / 10) * (i - 48));
                          break;
                        case 32:
                        case 75:
                          r || e.togglePlay();
                          break;
                        case 38:
                          e.increaseVolume(0.1);
                          break;
                        case 40:
                          e.decreaseVolume(0.1);
                          break;
                        case 77:
                          r || (e.muted = !e.muted);
                          break;
                        case 39:
                          e.forward();
                          break;
                        case 37:
                          e.rewind();
                          break;
                        case 70:
                          e.fullscreen.toggle();
                          break;
                        case 67:
                          r || e.toggleCaptions();
                          break;
                        case 76:
                          e.loop = !e.loop;
                      }
                      (27 === i &&
                        !e.fullscreen.usingNative &&
                        e.fullscreen.active &&
                        e.fullscreen.toggle(),
                        (this.lastKey = i));
                    } else this.lastKey = null;
                },
              },
              {
                key: "toggleMenu",
                value: function (t) {
                  Qc.toggleMenu.call(this.player, t);
                },
              },
              {
                key: "firstTouch",
                value: function () {
                  var t = this.player,
                    e = t.elements;
                  ((t.touch = !0),
                    cc(e.container, t.config.classNames.isTouch, !0));
                },
              },
              {
                key: "setTabFocus",
                value: function (t) {
                  var e = this.player,
                    n = e.elements;
                  if (
                    (clearTimeout(this.focusTimer),
                    "keydown" !== t.type || 9 === t.which)
                  ) {
                    "keydown" === t.type && (this.lastKeyDown = t.timeStamp);
                    var i,
                      o = t.timeStamp - this.lastKeyDown <= 20;
                    ("focus" !== t.type || o) &&
                      ((i = e.config.classNames.tabFocus),
                      cc(dc.call(e, ".".concat(i)), i, !1),
                      (this.focusTimer = setTimeout(function () {
                        var t = document.activeElement;
                        n.container.contains(t) &&
                          cc(
                            document.activeElement,
                            e.config.classNames.tabFocus,
                            !0,
                          );
                      }, 10)));
                  }
                },
              },
              {
                key: "global",
                value: function () {
                  var t =
                      !(arguments.length > 0 && void 0 !== arguments[0]) ||
                      arguments[0],
                    e = this.player;
                  (e.config.keyboard.global &&
                    Yl.call(e, window, "keydown keyup", this.handleKey, t, !1),
                    Yl.call(e, document.body, "click", this.toggleMenu, t),
                    Gl.call(e, document.body, "touchstart", this.firstTouch),
                    Yl.call(
                      e,
                      document.body,
                      "keydown focus blur",
                      this.setTabFocus,
                      t,
                      !1,
                      !0,
                    ));
                },
              },
              {
                key: "container",
                value: function () {
                  var t = this.player,
                    e = t.config,
                    n = t.elements,
                    i = t.timers;
                  (!e.keyboard.global &&
                    e.keyboard.focused &&
                    Xl.call(
                      t,
                      n.container,
                      "keydown keyup",
                      this.handleKey,
                      !1,
                    ),
                    Xl.call(
                      t,
                      n.container,
                      "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen",
                      function (e) {
                        var o = n.controls;
                        o &&
                          "enterfullscreen" === e.type &&
                          ((o.pressed = !1), (o.hover = !1));
                        var r = 0;
                        (["touchstart", "touchmove", "mousemove"].includes(
                          e.type,
                        ) &&
                          (hu.toggleControls.call(t, !0),
                          (r = t.touch ? 3e3 : 2e3)),
                          clearTimeout(i.controls),
                          (i.controls = setTimeout(function () {
                            return hu.toggleControls.call(t, !1);
                          }, r)));
                      },
                    ));
                  var o = function (e) {
                      if (!e) return xc.call(t);
                      var i = n.container.getBoundingClientRect(),
                        o = i.width,
                        r = i.height;
                      return xc.call(t, "".concat(o, ":").concat(r));
                    },
                    r = function () {
                      (clearTimeout(i.resized),
                        (i.resized = setTimeout(o, 50)));
                    };
                  Xl.call(
                    t,
                    n.container,
                    "enterfullscreen exitfullscreen",
                    function (e) {
                      var i = t.fullscreen,
                        s = i.target,
                        a = i.usingNative;
                      if (
                        s === n.container &&
                        (t.isEmbed || !Hl.empty(t.config.ratio))
                      ) {
                        var l = "enterfullscreen" === e.type,
                          c = o(l);
                        (c.padding,
                          !(function (e, n, i) {
                            if (t.isVimeo) {
                              var o = t.elements.wrapper.firstChild,
                                r = Hr(e, 2)[1],
                                s = Hr(wc.call(t), 2),
                                a = s[0],
                                l = s[1];
                              ((o.style.maxWidth = i
                                ? "".concat((r / l) * a, "px")
                                : null),
                                (o.style.margin = i ? "0 auto" : null));
                            }
                          })(c.ratio, 0, l),
                          a ||
                            (l
                              ? Xl.call(t, window, "resize", r)
                              : Ql.call(t, window, "resize", r)));
                      }
                    },
                  );
                },
              },
              {
                key: "media",
                value: function () {
                  var t = this,
                    e = this.player,
                    n = e.elements;
                  if (
                    (Xl.call(
                      e,
                      e.media,
                      "timeupdate seeking seeked",
                      function (t) {
                        return Qc.timeUpdate.call(e, t);
                      },
                    ),
                    Xl.call(
                      e,
                      e.media,
                      "durationchange loadeddata loadedmetadata",
                      function (t) {
                        return Qc.durationUpdate.call(e, t);
                      },
                    ),
                    Xl.call(e, e.media, "canplay loadeddata", function () {
                      (lc(n.volume, !e.hasAudio),
                        lc(n.buttons.mute, !e.hasAudio));
                    }),
                    Xl.call(e, e.media, "ended", function () {
                      e.isHTML5 &&
                        e.isVideo &&
                        e.config.resetOnEnd &&
                        e.restart();
                    }),
                    Xl.call(
                      e,
                      e.media,
                      "progress playing seeking seeked",
                      function (t) {
                        return Qc.updateProgress.call(e, t);
                      },
                    ),
                    Xl.call(e, e.media, "volumechange", function (t) {
                      return Qc.updateVolume.call(e, t);
                    }),
                    Xl.call(
                      e,
                      e.media,
                      "playing play pause ended emptied timeupdate",
                      function (t) {
                        return hu.checkPlaying.call(e, t);
                      },
                    ),
                    Xl.call(
                      e,
                      e.media,
                      "waiting canplay seeked playing",
                      function (t) {
                        return hu.checkLoading.call(e, t);
                      },
                    ),
                    e.supported.ui && e.config.clickToPlay && !e.isAudio)
                  ) {
                    var i = fc.call(e, ".".concat(e.config.classNames.video));
                    if (!Hl.element(i)) return;
                    Xl.call(e, n.container, "click", function (o) {
                      ([n.container, i].includes(o.target) ||
                        i.contains(o.target)) &&
                        ((e.touch && e.config.hideControls) ||
                          (e.ended
                            ? (t.proxy(o, e.restart, "restart"),
                              t.proxy(o, e.play, "play"))
                            : t.proxy(o, e.togglePlay, "play")));
                    });
                  }
                  (e.supported.ui &&
                    e.config.disableContextMenu &&
                    Xl.call(
                      e,
                      n.wrapper,
                      "contextmenu",
                      function (t) {
                        t.preventDefault();
                      },
                      !1,
                    ),
                    Xl.call(e, e.media, "volumechange", function () {
                      e.storage.set({ volume: e.volume, muted: e.muted });
                    }),
                    Xl.call(e, e.media, "ratechange", function () {
                      (Qc.updateSetting.call(e, "speed"),
                        e.storage.set({ speed: e.speed }));
                    }),
                    Xl.call(e, e.media, "qualitychange", function (t) {
                      Qc.updateSetting.call(
                        e,
                        "quality",
                        null,
                        t.detail.quality,
                      );
                    }),
                    Xl.call(e, e.media, "ready qualitychange", function () {
                      Qc.setDownloadUrl.call(e);
                    }));
                  var o = e.config.events
                    .concat(["keyup", "keydown"])
                    .join(" ");
                  Xl.call(e, e.media, o, function (t) {
                    var i = t.detail,
                      o = void 0 === i ? {} : i;
                    ("error" === t.type && (o = e.media.error),
                      Kl.call(e, n.container, t.type, !0, o));
                  });
                },
              },
              {
                key: "proxy",
                value: function (t, e, n) {
                  var i = this.player,
                    o = i.config.listeners[n],
                    r = !0;
                  (Hl.function(o) && (r = o.call(i, t)),
                    r && Hl.function(e) && e.call(i, t));
                },
              },
              {
                key: "bind",
                value: function (t, e, n, i) {
                  var o = this,
                    r =
                      !(arguments.length > 4 && void 0 !== arguments[4]) ||
                      arguments[4],
                    s = this.player,
                    a = s.config.listeners[i],
                    l = Hl.function(a);
                  Xl.call(
                    s,
                    t,
                    e,
                    function (t) {
                      return o.proxy(t, n, i);
                    },
                    r && !l,
                  );
                },
              },
              {
                key: "controls",
                value: function () {
                  var t = this,
                    e = this.player,
                    n = e.elements,
                    i = Ul.isIE ? "change" : "input";
                  if (
                    (n.buttons.play &&
                      Array.from(n.buttons.play).forEach(function (n) {
                        t.bind(n, "click", e.togglePlay, "play");
                      }),
                    this.bind(n.buttons.restart, "click", e.restart, "restart"),
                    this.bind(n.buttons.rewind, "click", e.rewind, "rewind"),
                    this.bind(
                      n.buttons.fastForward,
                      "click",
                      e.forward,
                      "fastForward",
                    ),
                    this.bind(
                      n.buttons.mute,
                      "click",
                      function () {
                        e.muted = !e.muted;
                      },
                      "mute",
                    ),
                    this.bind(n.buttons.captions, "click", function () {
                      return e.toggleCaptions();
                    }),
                    this.bind(
                      n.buttons.download,
                      "click",
                      function () {
                        Kl.call(e, e.media, "download");
                      },
                      "download",
                    ),
                    this.bind(
                      n.buttons.fullscreen,
                      "click",
                      function () {
                        e.fullscreen.toggle();
                      },
                      "fullscreen",
                    ),
                    this.bind(
                      n.buttons.pip,
                      "click",
                      function () {
                        e.pip = "toggle";
                      },
                      "pip",
                    ),
                    this.bind(n.buttons.airplay, "click", e.airplay, "airplay"),
                    this.bind(n.buttons.settings, "click", function (t) {
                      (t.stopPropagation(), Qc.toggleMenu.call(e, t));
                    }),
                    this.bind(
                      n.buttons.settings,
                      "keyup",
                      function (t) {
                        var n = t.which;
                        [13, 32].includes(n) &&
                          (13 !== n
                            ? (t.preventDefault(),
                              t.stopPropagation(),
                              Qc.toggleMenu.call(e, t))
                            : Qc.focusFirstMenuItem.call(e, null, !0));
                      },
                      null,
                      !1,
                    ),
                    this.bind(n.settings.menu, "keydown", function (t) {
                      27 === t.which && Qc.toggleMenu.call(e, t);
                    }),
                    this.bind(
                      n.inputs.seek,
                      "mousedown mousemove",
                      function (t) {
                        var e = n.progress.getBoundingClientRect(),
                          i = (100 / e.width) * (t.pageX - e.left);
                        t.currentTarget.setAttribute("seek-value", i);
                      },
                    ),
                    this.bind(
                      n.inputs.seek,
                      "mousedown mouseup keydown keyup touchstart touchend",
                      function (t) {
                        var n = t.currentTarget,
                          i = t.keyCode ? t.keyCode : t.which;
                        if (!Hl.keyboardEvent(t) || 39 === i || 37 === i) {
                          e.lastSeekTime = Date.now();
                          var o = n.hasAttribute("play-on-seeked"),
                            r = ["mouseup", "touchend", "keyup"].includes(
                              t.type,
                            );
                          o && r
                            ? (n.removeAttribute("play-on-seeked"), e.play())
                            : !r &&
                              e.playing &&
                              (n.setAttribute("play-on-seeked", ""), e.pause());
                        }
                      },
                    ),
                    Ul.isIos)
                  ) {
                    var o = dc.call(e, 'input[type="range"]');
                    Array.from(o).forEach(function (e) {
                      return t.bind(e, i, function (t) {
                        return Bl(t.target);
                      });
                    });
                  }
                  (this.bind(
                    n.inputs.seek,
                    i,
                    function (t) {
                      var n = t.currentTarget,
                        i = n.getAttribute("seek-value");
                      (Hl.empty(i) && (i = n.value),
                        n.removeAttribute("seek-value"),
                        (e.currentTime = (i / n.max) * e.duration));
                    },
                    "seek",
                  ),
                    this.bind(
                      n.progress,
                      "mouseenter mouseleave mousemove",
                      function (t) {
                        return Qc.updateSeekTooltip.call(e, t);
                      },
                    ),
                    this.bind(n.progress, "mousemove touchmove", function (t) {
                      var n = e.previewThumbnails;
                      n && n.loaded && n.startMove(t);
                    }),
                    this.bind(n.progress, "mouseleave click", function () {
                      var t = e.previewThumbnails;
                      t && t.loaded && t.endMove(!1, !0);
                    }),
                    this.bind(n.progress, "mousedown touchstart", function (t) {
                      var n = e.previewThumbnails;
                      n && n.loaded && n.startScrubbing(t);
                    }),
                    this.bind(n.progress, "mouseup touchend", function (t) {
                      var n = e.previewThumbnails;
                      n && n.loaded && n.endScrubbing(t);
                    }),
                    Ul.isWebkit &&
                      Array.from(dc.call(e, 'input[type="range"]')).forEach(
                        function (n) {
                          t.bind(n, "input", function (t) {
                            return Qc.updateRangeFill.call(e, t.target);
                          });
                        },
                      ),
                    e.config.toggleInvert &&
                      !Hl.element(n.display.duration) &&
                      this.bind(n.display.currentTime, "click", function () {
                        0 !== e.currentTime &&
                          ((e.config.invertTime = !e.config.invertTime),
                          Qc.timeUpdate.call(e));
                      }),
                    this.bind(
                      n.inputs.volume,
                      i,
                      function (t) {
                        e.volume = t.target.value;
                      },
                      "volume",
                    ),
                    this.bind(
                      n.controls,
                      "mouseenter mouseleave",
                      function (t) {
                        n.controls.hover = !e.touch && "mouseenter" === t.type;
                      },
                    ),
                    this.bind(
                      n.controls,
                      "mousedown mouseup touchstart touchend touchcancel",
                      function (t) {
                        n.controls.pressed = [
                          "mousedown",
                          "touchstart",
                        ].includes(t.type);
                      },
                    ),
                    this.bind(n.controls, "focusin", function () {
                      var i = e.config,
                        o = e.timers;
                      (cc(n.controls, i.classNames.noTransition, !0),
                        hu.toggleControls.call(e, !0),
                        setTimeout(function () {
                          cc(n.controls, i.classNames.noTransition, !1);
                        }, 0));
                      var r = t.touch ? 3e3 : 4e3;
                      (clearTimeout(o.controls),
                        (o.controls = setTimeout(function () {
                          return hu.toggleControls.call(e, !1);
                        }, r)));
                    }),
                    this.bind(
                      n.inputs.volume,
                      "wheel",
                      function (t) {
                        var n = t.webkitDirectionInvertedFromDevice,
                          i = Hr(
                            [t.deltaX, -t.deltaY].map(function (t) {
                              return n ? -t : t;
                            }),
                            2,
                          ),
                          o = i[0],
                          r = i[1],
                          s = Math.sign(Math.abs(o) > Math.abs(r) ? o : r);
                        e.increaseVolume(s / 50);
                        var a = e.media.volume;
                        ((1 === s && a < 1) || (-1 === s && a > 0)) &&
                          t.preventDefault();
                      },
                      "volume",
                      !1,
                    ));
                },
              },
            ]),
            t
          );
        })(),
        fu = z.f,
        pu = Function.prototype,
        mu = pu.toString,
        gu = /^\s*function ([^ (]*)/;
      !c ||
        "name" in pu ||
        fu(pu, "name", {
          configurable: !0,
          get: function () {
            try {
              return mu.call(this).match(gu)[1];
            } catch (t) {
              return "";
            }
          },
        });
      var vu = Math.max,
        yu = Math.min;
      At(
        { target: "Array", proto: !0, forced: !xn("splice") },
        {
          splice: function (t, e) {
            var n,
              i,
              o,
              r,
              s,
              a,
              l = Lt(this),
              c = st(l.length),
              u = ct(t, c),
              h = arguments.length;
            if (
              (0 === h
                ? (n = i = 0)
                : 1 === h
                  ? ((n = 0), (i = c - u))
                  : ((n = h - 2), (i = yu(vu(ot(e), 0), c - u))),
              c + n - i > 9007199254740991)
            )
              throw TypeError("Maximum allowed length exceeded");
            for (o = ee(l, i), r = 0; r < i; r++)
              (s = u + r) in l && bn(o, r, l[s]);
            if (((o.length = i), n < i)) {
              for (r = u; r < c - i; r++)
                ((a = r + n), (s = r + i) in l ? (l[a] = l[s]) : delete l[a]);
              for (r = c; r > c - i + n; r--) delete l[r - 1];
            } else if (n > i)
              for (r = c - i; r > u; r--)
                ((a = r + n - 1),
                  (s = r + i - 1) in l ? (l[a] = l[s]) : delete l[a]);
            for (r = 0; r < n; r++) l[r + u] = arguments[r + 2];
            return ((l.length = c - i + n), o);
          },
        },
      );
      var bu = e(function (t, e) {
        t.exports = (function () {
          var t = function () {},
            e = {},
            n = {},
            i = {};
          function o(t, e) {
            if (t) {
              var o = i[t];
              if (((n[t] = e), o))
                for (; o.length; ) (o[0](t, e), o.splice(0, 1));
            }
          }
          function r(e, n) {
            (e.call && (e = { success: e }),
              n.length ? (e.error || t)(n) : (e.success || t)(e));
          }
          function s(e, n, i, o) {
            var r,
              a,
              l = document,
              c = i.async,
              u = (i.numRetries || 0) + 1,
              h = i.before || t,
              d = e.replace(/^(css|img)!/, "");
            ((o = o || 0),
              /(^css!|\.css$)/.test(e)
                ? (((a = l.createElement("link")).rel = "stylesheet"),
                  (a.href = d),
                  (r = "hideFocus" in a) &&
                    a.relList &&
                    ((r = 0), (a.rel = "preload"), (a.as = "style")))
                : /(^img!|\.(png|gif|jpg|svg)$)/.test(e)
                  ? ((a = l.createElement("img")).src = d)
                  : (((a = l.createElement("script")).src = e),
                    (a.async = void 0 === c || c)),
              (a.onload =
                a.onerror =
                a.onbeforeload =
                  function (t) {
                    var l = t.type[0];
                    if (r)
                      try {
                        a.sheet.cssText.length || (l = "e");
                      } catch (t) {
                        18 != t.code && (l = "e");
                      }
                    if ("e" == l) {
                      if ((o += 1) < u) return s(e, n, i, o);
                    } else if ("preload" == a.rel && "style" == a.as)
                      return (a.rel = "stylesheet");
                    n(e, l, t.defaultPrevented);
                  }),
              !1 !== h(e, a) && l.head.appendChild(a));
          }
          function a(t, n, i) {
            var a, l;
            if ((n && n.trim && (a = n), (l = (a ? i : n) || {}), a)) {
              if (a in e) throw "LoadJS";
              e[a] = !0;
            }
            function c(e, n) {
              !(function (t, e, n) {
                var i,
                  o,
                  r = (t = t.push ? t : [t]).length,
                  a = r,
                  l = [];
                for (
                  i = function (t, n, i) {
                    if (("e" == n && l.push(t), "b" == n)) {
                      if (!i) return;
                      l.push(t);
                    }
                    --r || e(l);
                  },
                    o = 0;
                  o < a;
                  o++
                )
                  s(t[o], i, n);
              })(
                t,
                function (t) {
                  (r(l, t), e && r({ success: e, error: n }, t), o(a, t));
                },
                l,
              );
            }
            if (l.returnPromise) return new Promise(c);
            c();
          }
          return (
            (a.ready = function (t, e) {
              return (
                (function (t, e) {
                  t = t.push ? t : [t];
                  var o,
                    r,
                    s,
                    a = [],
                    l = t.length,
                    c = l;
                  for (
                    o = function (t, n) {
                      (n.length && a.push(t), --c || e(a));
                    };
                    l--;
                  )
                    ((r = t[l]),
                      (s = n[r]) ? o(r, s) : (i[r] = i[r] || []).push(o));
                })(t, function (t) {
                  r(e, t);
                }),
                a
              );
            }),
            (a.done = function (t) {
              o(t, []);
            }),
            (a.reset = function () {
              ((e = {}), (n = {}), (i = {}));
            }),
            (a.isDefined = function (t) {
              return t in e;
            }),
            a
          );
        })();
      });
      function wu(t) {
        return new Promise(function (e, n) {
          bu(t, { success: e, error: n });
        });
      }
      function xu(t) {
        (t && !this.embed.hasPlayed && (this.embed.hasPlayed = !0),
          this.media.paused === t &&
            ((this.media.paused = !t),
            Kl.call(this, this.media, t ? "play" : "pause")));
      }
      var Su = {
        setup: function () {
          var t = this;
          (cc(this.elements.wrapper, this.config.classNames.embed, !0),
            xc.call(this),
            Hl.object(window.Vimeo)
              ? Su.ready.call(this)
              : wu(this.config.urls.vimeo.sdk)
                  .then(function () {
                    Su.ready.call(t);
                  })
                  .catch(function (e) {
                    t.debug.warn("Vimeo SDK (player.js) failed to load", e);
                  }));
        },
        ready: function () {
          var t = this,
            e = this,
            n = e.config.vimeo,
            i = Kc(
              Jl(
                {},
                {
                  loop: e.config.loop.active,
                  autoplay: e.autoplay,
                  muted: e.muted,
                  gesture: "media",
                  playsinline: !this.config.fullscreen.iosNative,
                },
                n,
              ),
            ),
            o = e.media.getAttribute("src");
          Hl.empty(o) &&
            (o = e.media.getAttribute(e.config.attributes.embed.id));
          var r,
            s =
              ((r = o),
              Hl.empty(r)
                ? null
                : Hl.number(Number(r))
                  ? r
                  : r.match(/^.*(vimeo.com\/|video\/)(\d+).*/)
                    ? RegExp.$2
                    : r),
            a = nc("iframe"),
            l = Dc(e.config.urls.vimeo.iframe, s, i);
          (a.setAttribute("src", l),
            a.setAttribute("allowfullscreen", ""),
            a.setAttribute("allowtransparency", ""),
            a.setAttribute("allow", "autoplay"));
          var c = nc("div", {
            poster: e.poster,
            class: e.config.classNames.embedContainer,
          });
          (c.appendChild(a),
            (e.media = sc(c, e.media)),
            Wc(Dc(e.config.urls.vimeo.api, s), "json").then(function (t) {
              if (!Hl.empty(t)) {
                var n = new URL(t[0].thumbnail_large);
                ((n.pathname = "".concat(n.pathname.split("_")[0], ".jpg")),
                  hu.setPoster.call(e, n.href).catch(function () {}));
              }
            }),
            (e.embed = new window.Vimeo.Player(a, {
              autopause: e.config.autopause,
              muted: e.muted,
            })),
            (e.media.paused = !0),
            (e.media.currentTime = 0),
            e.supported.ui && e.embed.disableTextTrack(),
            (e.media.play = function () {
              return (xu.call(e, !0), e.embed.play());
            }),
            (e.media.pause = function () {
              return (xu.call(e, !1), e.embed.pause());
            }),
            (e.media.stop = function () {
              (e.pause(), (e.currentTime = 0));
            }));
          var u = e.media.currentTime;
          Object.defineProperty(e.media, "currentTime", {
            get: function () {
              return u;
            },
            set: function (t) {
              var n = e.embed,
                i = e.media,
                o = e.paused,
                r = e.volume,
                s = o && !n.hasPlayed;
              ((i.seeking = !0),
                Kl.call(e, i, "seeking"),
                Promise.resolve(s && n.setVolume(0))
                  .then(function () {
                    return n.setCurrentTime(t);
                  })
                  .then(function () {
                    return s && n.pause();
                  })
                  .then(function () {
                    return s && n.setVolume(r);
                  })
                  .catch(function () {}));
            },
          });
          var h = e.config.speed.selected;
          Object.defineProperty(e.media, "playbackRate", {
            get: function () {
              return h;
            },
            set: function (t) {
              e.embed
                .setPlaybackRate(t)
                .then(function () {
                  ((h = t), Kl.call(e, e.media, "ratechange"));
                })
                .catch(function (t) {
                  "Error" === t.name && Qc.setSpeedMenu.call(e, []);
                });
            },
          });
          var d = e.config.volume;
          Object.defineProperty(e.media, "volume", {
            get: function () {
              return d;
            },
            set: function (t) {
              e.embed.setVolume(t).then(function () {
                ((d = t), Kl.call(e, e.media, "volumechange"));
              });
            },
          });
          var f = e.config.muted;
          Object.defineProperty(e.media, "muted", {
            get: function () {
              return f;
            },
            set: function (t) {
              var n = !!Hl.boolean(t) && t;
              e.embed.setVolume(n ? 0 : e.config.volume).then(function () {
                ((f = n), Kl.call(e, e.media, "volumechange"));
              });
            },
          });
          var p,
            m = e.config.loop;
          (Object.defineProperty(e.media, "loop", {
            get: function () {
              return m;
            },
            set: function (t) {
              var n = Hl.boolean(t) ? t : e.config.loop.active;
              e.embed.setLoop(n).then(function () {
                m = n;
              });
            },
          }),
            e.embed
              .getVideoUrl()
              .then(function (t) {
                ((p = t), Qc.setDownloadUrl.call(e));
              })
              .catch(function (e) {
                t.debug.warn(e);
              }),
            Object.defineProperty(e.media, "currentSrc", {
              get: function () {
                return p;
              },
            }),
            Object.defineProperty(e.media, "ended", {
              get: function () {
                return e.currentTime === e.duration;
              },
            }),
            Promise.all([
              e.embed.getVideoWidth(),
              e.embed.getVideoHeight(),
            ]).then(function (n) {
              var i = Hr(n, 2),
                o = i[0],
                r = i[1];
              ((e.embed.ratio = [o, r]), xc.call(t));
            }),
            e.embed.setAutopause(e.config.autopause).then(function (t) {
              e.config.autopause = t;
            }),
            e.embed.getVideoTitle().then(function (n) {
              ((e.config.title = n), hu.setTitle.call(t));
            }),
            e.embed.getCurrentTime().then(function (t) {
              ((u = t), Kl.call(e, e.media, "timeupdate"));
            }),
            e.embed.getDuration().then(function (t) {
              ((e.media.duration = t), Kl.call(e, e.media, "durationchange"));
            }),
            e.embed.getTextTracks().then(function (t) {
              ((e.media.textTracks = t), Zc.setup.call(e));
            }),
            e.embed.on("cuechange", function (t) {
              var n = t.cues,
                i = (void 0 === n ? [] : n).map(function (t) {
                  return (function (t) {
                    var e = document.createDocumentFragment(),
                      n = document.createElement("div");
                    return (
                      e.appendChild(n),
                      (n.innerHTML = t),
                      e.firstChild.innerText
                    );
                  })(t.text);
                });
              Zc.updateCues.call(e, i);
            }),
            e.embed.on("loaded", function () {
              (e.embed.getPaused().then(function (t) {
                (xu.call(e, !t), t || Kl.call(e, e.media, "playing"));
              }),
                Hl.element(e.embed.element) &&
                  e.supported.ui &&
                  e.embed.element.setAttribute("tabindex", -1));
            }),
            e.embed.on("play", function () {
              (xu.call(e, !0), Kl.call(e, e.media, "playing"));
            }),
            e.embed.on("pause", function () {
              xu.call(e, !1);
            }),
            e.embed.on("timeupdate", function (t) {
              ((e.media.seeking = !1),
                (u = t.seconds),
                Kl.call(e, e.media, "timeupdate"));
            }),
            e.embed.on("progress", function (t) {
              ((e.media.buffered = t.percent),
                Kl.call(e, e.media, "progress"),
                1 === parseInt(t.percent, 10) &&
                  Kl.call(e, e.media, "canplaythrough"),
                e.embed.getDuration().then(function (t) {
                  t !== e.media.duration &&
                    ((e.media.duration = t),
                    Kl.call(e, e.media, "durationchange"));
                }));
            }),
            e.embed.on("seeked", function () {
              ((e.media.seeking = !1), Kl.call(e, e.media, "seeked"));
            }),
            e.embed.on("ended", function () {
              ((e.media.paused = !0), Kl.call(e, e.media, "ended"));
            }),
            e.embed.on("error", function (t) {
              ((e.media.error = t), Kl.call(e, e.media, "error"));
            }),
            setTimeout(function () {
              return hu.build.call(e);
            }, 0));
        },
      };
      function ku(t) {
        (t && !this.embed.hasPlayed && (this.embed.hasPlayed = !0),
          this.media.paused === t &&
            ((this.media.paused = !t),
            Kl.call(this, this.media, t ? "play" : "pause")));
      }
      function Eu(t) {
        return t.noCookie
          ? "https://www.youtube-nocookie.com"
          : "http:" === window.location.protocol
            ? "http://www.youtube.com"
            : void 0;
      }
      var Cu = {
          setup: function () {
            var t = this;
            if (
              (cc(this.elements.wrapper, this.config.classNames.embed, !0),
              Hl.object(window.YT) && Hl.function(window.YT.Player))
            )
              Cu.ready.call(this);
            else {
              var e = window.onYouTubeIframeAPIReady;
              ((window.onYouTubeIframeAPIReady = function () {
                (Hl.function(e) && e(), Cu.ready.call(t));
              }),
                wu(this.config.urls.youtube.sdk).catch(function (e) {
                  t.debug.warn("YouTube API failed to load", e);
                }));
            }
          },
          getTitle: function (t) {
            var e = this;
            Wc(Dc(this.config.urls.youtube.api, t))
              .then(function (t) {
                if (Hl.object(t)) {
                  var n = t.title,
                    i = t.height,
                    o = t.width;
                  ((e.config.title = n),
                    hu.setTitle.call(e),
                    (e.embed.ratio = [o, i]));
                }
                xc.call(e);
              })
              .catch(function () {
                xc.call(e);
              });
          },
          ready: function () {
            var t = this,
              e = t.media && t.media.getAttribute("id");
            if (Hl.empty(e) || !e.startsWith("youtube-")) {
              var n = t.media.getAttribute("src");
              Hl.empty(n) &&
                (n = t.media.getAttribute(this.config.attributes.embed.id));
              var i,
                o,
                r =
                  ((i = n),
                  Hl.empty(i)
                    ? null
                    : i.match(
                          /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/,
                        )
                      ? RegExp.$2
                      : i),
                s =
                  ((o = t.provider),
                  "".concat(o, "-").concat(Math.floor(1e4 * Math.random()))),
                a = nc("div", { id: s, poster: t.poster });
              t.media = sc(a, t.media);
              var l = function (t) {
                return "https://i.ytimg.com/vi/"
                  .concat(r, "/")
                  .concat(t, "default.jpg");
              };
              uu(l("maxres"), 121)
                .catch(function () {
                  return uu(l("sd"), 121);
                })
                .catch(function () {
                  return uu(l("hq"));
                })
                .then(function (e) {
                  return hu.setPoster.call(t, e.src);
                })
                .then(function (e) {
                  e.includes("maxres") ||
                    (t.elements.poster.style.backgroundSize = "cover");
                })
                .catch(function () {});
              var c = t.config.youtube;
              t.embed = new window.YT.Player(s, {
                videoId: r,
                host: Eu(c),
                playerVars: Jl(
                  {},
                  {
                    autoplay: t.config.autoplay ? 1 : 0,
                    hl: t.config.hl,
                    controls: t.supported.ui ? 0 : 1,
                    disablekb: 1,
                    playsinline: t.config.fullscreen.iosNative ? 0 : 1,
                    cc_load_policy: t.captions.active ? 1 : 0,
                    cc_lang_pref: t.config.captions.language,
                    widget_referrer: window ? window.location.href : null,
                  },
                  c,
                ),
                events: {
                  onError: function (e) {
                    if (!t.media.error) {
                      var n = e.data,
                        i =
                          {
                            2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                            5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                            100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                            101: "The owner of the requested video does not allow it to be played in embedded players.",
                            150: "The owner of the requested video does not allow it to be played in embedded players.",
                          }[n] || "An unknown error occured";
                      ((t.media.error = { code: n, message: i }),
                        Kl.call(t, t.media, "error"));
                    }
                  },
                  onPlaybackRateChange: function (e) {
                    var n = e.target;
                    ((t.media.playbackRate = n.getPlaybackRate()),
                      Kl.call(t, t.media, "ratechange"));
                  },
                  onReady: function (e) {
                    if (!Hl.function(t.media.play)) {
                      var n = e.target;
                      (Cu.getTitle.call(t, r),
                        (t.media.play = function () {
                          (ku.call(t, !0), n.playVideo());
                        }),
                        (t.media.pause = function () {
                          (ku.call(t, !1), n.pauseVideo());
                        }),
                        (t.media.stop = function () {
                          n.stopVideo();
                        }),
                        (t.media.duration = n.getDuration()),
                        (t.media.paused = !0),
                        (t.media.currentTime = 0),
                        Object.defineProperty(t.media, "currentTime", {
                          get: function () {
                            return Number(n.getCurrentTime());
                          },
                          set: function (e) {
                            (t.paused && !t.embed.hasPlayed && t.embed.mute(),
                              (t.media.seeking = !0),
                              Kl.call(t, t.media, "seeking"),
                              n.seekTo(e));
                          },
                        }),
                        Object.defineProperty(t.media, "playbackRate", {
                          get: function () {
                            return n.getPlaybackRate();
                          },
                          set: function (t) {
                            n.setPlaybackRate(t);
                          },
                        }));
                      var i = t.config.volume;
                      Object.defineProperty(t.media, "volume", {
                        get: function () {
                          return i;
                        },
                        set: function (e) {
                          ((i = e),
                            n.setVolume(100 * i),
                            Kl.call(t, t.media, "volumechange"));
                        },
                      });
                      var o = t.config.muted;
                      (Object.defineProperty(t.media, "muted", {
                        get: function () {
                          return o;
                        },
                        set: function (e) {
                          var i = Hl.boolean(e) ? e : o;
                          ((o = i),
                            n[i ? "mute" : "unMute"](),
                            Kl.call(t, t.media, "volumechange"));
                        },
                      }),
                        Object.defineProperty(t.media, "currentSrc", {
                          get: function () {
                            return n.getVideoUrl();
                          },
                        }),
                        Object.defineProperty(t.media, "ended", {
                          get: function () {
                            return t.currentTime === t.duration;
                          },
                        }),
                        (t.options.speed = n.getAvailablePlaybackRates()),
                        t.supported.ui && t.media.setAttribute("tabindex", -1),
                        Kl.call(t, t.media, "timeupdate"),
                        Kl.call(t, t.media, "durationchange"),
                        clearInterval(t.timers.buffering),
                        (t.timers.buffering = setInterval(function () {
                          ((t.media.buffered = n.getVideoLoadedFraction()),
                            (null === t.media.lastBuffered ||
                              t.media.lastBuffered < t.media.buffered) &&
                              Kl.call(t, t.media, "progress"),
                            (t.media.lastBuffered = t.media.buffered),
                            1 === t.media.buffered &&
                              (clearInterval(t.timers.buffering),
                              Kl.call(t, t.media, "canplaythrough")));
                        }, 200)),
                        setTimeout(function () {
                          return hu.build.call(t);
                        }, 50));
                    }
                  },
                  onStateChange: function (e) {
                    var n = e.target;
                    switch (
                      (clearInterval(t.timers.playing),
                      t.media.seeking &&
                        [1, 2].includes(e.data) &&
                        ((t.media.seeking = !1), Kl.call(t, t.media, "seeked")),
                      e.data)
                    ) {
                      case -1:
                        (Kl.call(t, t.media, "timeupdate"),
                          (t.media.buffered = n.getVideoLoadedFraction()),
                          Kl.call(t, t.media, "progress"));
                        break;
                      case 0:
                        (ku.call(t, !1),
                          t.media.loop
                            ? (n.stopVideo(), n.playVideo())
                            : Kl.call(t, t.media, "ended"));
                        break;
                      case 1:
                        t.config.autoplay ||
                        !t.media.paused ||
                        t.embed.hasPlayed
                          ? (ku.call(t, !0),
                            Kl.call(t, t.media, "playing"),
                            (t.timers.playing = setInterval(function () {
                              Kl.call(t, t.media, "timeupdate");
                            }, 50)),
                            t.media.duration !== n.getDuration() &&
                              ((t.media.duration = n.getDuration()),
                              Kl.call(t, t.media, "durationchange")))
                          : t.media.pause();
                        break;
                      case 2:
                        (t.muted || t.embed.unMute(), ku.call(t, !1));
                    }
                    Kl.call(t, t.elements.container, "statechange", !1, {
                      code: e.data,
                    });
                  },
                },
              });
            }
          },
        },
        Tu = {
          setup: function () {
            this.media
              ? (cc(
                  this.elements.container,
                  this.config.classNames.type.replace("{0}", this.type),
                  !0,
                ),
                cc(
                  this.elements.container,
                  this.config.classNames.provider.replace("{0}", this.provider),
                  !0,
                ),
                this.isEmbed &&
                  cc(
                    this.elements.container,
                    this.config.classNames.type.replace("{0}", "video"),
                    !0,
                  ),
                this.isVideo &&
                  ((this.elements.wrapper = nc("div", {
                    class: this.config.classNames.video,
                  })),
                  tc(this.media, this.elements.wrapper),
                  (this.elements.poster = nc("div", {
                    class: this.config.classNames.poster,
                  })),
                  this.elements.wrapper.appendChild(this.elements.poster)),
                this.isHTML5
                  ? Sc.extend.call(this)
                  : this.isYouTube
                    ? Cu.setup.call(this)
                    : this.isVimeo && Su.setup.call(this))
              : this.debug.warn("No media element found!");
          },
        },
        Pu = (function () {
          function t(e) {
            var n = this;
            (Rr(this, t),
              (this.player = e),
              (this.config = e.config.ads),
              (this.playing = !1),
              (this.initialized = !1),
              (this.elements = { container: null, displayContainer: null }),
              (this.manager = null),
              (this.loader = null),
              (this.cuePoints = null),
              (this.events = {}),
              (this.safetyTimer = null),
              (this.countdownTimer = null),
              (this.managerPromise = new Promise(function (t, e) {
                (n.on("loaded", t), n.on("error", e));
              })),
              this.load());
          }
          return (
            $r(t, [
              {
                key: "load",
                value: function () {
                  var t = this;
                  this.enabled &&
                    (Hl.object(window.google) && Hl.object(window.google.ima)
                      ? this.ready()
                      : wu(this.player.config.urls.googleIMA.sdk)
                          .then(function () {
                            t.ready();
                          })
                          .catch(function () {
                            t.trigger(
                              "error",
                              new Error("Google IMA SDK failed to load"),
                            );
                          }));
                },
              },
              {
                key: "ready",
                value: function () {
                  var t,
                    e = this;
                  (this.enabled ||
                    ((t = this).manager && t.manager.destroy(),
                    t.elements.displayContainer &&
                      t.elements.displayContainer.destroy(),
                    t.elements.container.remove()),
                    this.startSafetyTimer(12e3, "ready()"),
                    this.managerPromise.then(function () {
                      e.clearSafetyTimer("onAdsManagerLoaded()");
                    }),
                    this.listeners(),
                    this.setupIMA());
                },
              },
              {
                key: "setupIMA",
                value: function () {
                  ((this.elements.container = nc("div", {
                    class: this.player.config.classNames.ads,
                  })),
                    this.player.elements.container.appendChild(
                      this.elements.container,
                    ),
                    google.ima.settings.setVpaidMode(
                      google.ima.ImaSdkSettings.VpaidMode.ENABLED,
                    ),
                    google.ima.settings.setLocale(
                      this.player.config.ads.language,
                    ),
                    google.ima.settings.setDisableCustomPlaybackForIOS10Plus(
                      this.player.config.playsinline,
                    ),
                    (this.elements.displayContainer =
                      new google.ima.AdDisplayContainer(
                        this.elements.container,
                        this.player.media,
                      )),
                    this.requestAds());
                },
              },
              {
                key: "requestAds",
                value: function () {
                  var t = this,
                    e = this.player.elements.container;
                  try {
                    ((this.loader = new google.ima.AdsLoader(
                      this.elements.displayContainer,
                    )),
                      this.loader.addEventListener(
                        google.ima.AdsManagerLoadedEvent.Type
                          .ADS_MANAGER_LOADED,
                        function (e) {
                          return t.onAdsManagerLoaded(e);
                        },
                        !1,
                      ),
                      this.loader.addEventListener(
                        google.ima.AdErrorEvent.Type.AD_ERROR,
                        function (e) {
                          return t.onAdError(e);
                        },
                        !1,
                      ));
                    var n = new google.ima.AdsRequest();
                    ((n.adTagUrl = this.tagUrl),
                      (n.linearAdSlotWidth = e.offsetWidth),
                      (n.linearAdSlotHeight = e.offsetHeight),
                      (n.nonLinearAdSlotWidth = e.offsetWidth),
                      (n.nonLinearAdSlotHeight = e.offsetHeight),
                      (n.forceNonLinearFullSlot = !1),
                      n.setAdWillPlayMuted(!this.player.muted),
                      this.loader.requestAds(n));
                  } catch (t) {
                    this.onAdError(t);
                  }
                },
              },
              {
                key: "pollCountdown",
                value: function () {
                  var t = this;
                  if (
                    !(
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0]
                    )
                  )
                    return (
                      clearInterval(this.countdownTimer),
                      void this.elements.container.removeAttribute(
                        "data-badge-text",
                      )
                    );
                  this.countdownTimer = setInterval(function () {
                    var e = Xc(Math.max(t.manager.getRemainingTime(), 0)),
                      n = ""
                        .concat(qc("advertisement", t.player.config), " - ")
                        .concat(e);
                    t.elements.container.setAttribute("data-badge-text", n);
                  }, 100);
                },
              },
              {
                key: "onAdsManagerLoaded",
                value: function (t) {
                  var e = this;
                  if (this.enabled) {
                    var n = new google.ima.AdsRenderingSettings();
                    ((n.restoreCustomPlaybackStateOnAdBreakComplete = !0),
                      (n.enablePreloading = !0),
                      (this.manager = t.getAdsManager(this.player, n)),
                      (this.cuePoints = this.manager.getCuePoints()),
                      this.manager.addEventListener(
                        google.ima.AdErrorEvent.Type.AD_ERROR,
                        function (t) {
                          return e.onAdError(t);
                        },
                      ),
                      Object.keys(google.ima.AdEvent.Type).forEach(
                        function (t) {
                          e.manager.addEventListener(
                            google.ima.AdEvent.Type[t],
                            function (t) {
                              return e.onAdEvent(t);
                            },
                          );
                        },
                      ),
                      this.trigger("loaded"));
                  }
                },
              },
              {
                key: "addCuePoints",
                value: function () {
                  var t = this;
                  Hl.empty(this.cuePoints) ||
                    this.cuePoints.forEach(function (e) {
                      if (0 !== e && -1 !== e && e < t.player.duration) {
                        var n = t.player.elements.progress;
                        if (Hl.element(n)) {
                          var i = (100 / t.player.duration) * e,
                            o = nc("span", {
                              class: t.player.config.classNames.cues,
                            });
                          ((o.style.left = "".concat(i.toString(), "%")),
                            n.appendChild(o));
                        }
                      }
                    });
                },
              },
              {
                key: "onAdEvent",
                value: function (t) {
                  var e = this,
                    n = this.player.elements.container,
                    i = t.getAd(),
                    o = t.getAdData();
                  switch (
                    ((function (t) {
                      Kl.call(
                        e.player,
                        e.player.media,
                        "ads".concat(t.replace(/_/g, "").toLowerCase()),
                      );
                    })(t.type),
                    t.type)
                  ) {
                    case google.ima.AdEvent.Type.LOADED:
                      (this.trigger("loaded"),
                        this.pollCountdown(!0),
                        i.isLinear() ||
                          ((i.width = n.offsetWidth),
                          (i.height = n.offsetHeight)));
                      break;
                    case google.ima.AdEvent.Type.STARTED:
                      this.manager.setVolume(this.player.volume);
                      break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                      this.loadAds();
                      break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                      this.pauseContent();
                      break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                      (this.pollCountdown(), this.resumeContent());
                      break;
                    case google.ima.AdEvent.Type.LOG:
                      o.adError &&
                        this.player.debug.warn(
                          "Non-fatal ad error: ".concat(o.adError.getMessage()),
                        );
                  }
                },
              },
              {
                key: "onAdError",
                value: function (t) {
                  (this.cancel(), this.player.debug.warn("Ads error", t));
                },
              },
              {
                key: "listeners",
                value: function () {
                  var t,
                    e = this,
                    n = this.player.elements.container;
                  (this.player.on("canplay", function () {
                    e.addCuePoints();
                  }),
                    this.player.on("ended", function () {
                      e.loader.contentComplete();
                    }),
                    this.player.on("timeupdate", function () {
                      t = e.player.currentTime;
                    }),
                    this.player.on("seeked", function () {
                      var n = e.player.currentTime;
                      Hl.empty(e.cuePoints) ||
                        e.cuePoints.forEach(function (i, o) {
                          t < i &&
                            i < n &&
                            (e.manager.discardAdBreak(),
                            e.cuePoints.splice(o, 1));
                        });
                    }),
                    window.addEventListener("resize", function () {
                      e.manager &&
                        e.manager.resize(
                          n.offsetWidth,
                          n.offsetHeight,
                          google.ima.ViewMode.NORMAL,
                        );
                    }));
                },
              },
              {
                key: "play",
                value: function () {
                  var t = this,
                    e = this.player.elements.container;
                  (this.managerPromise || this.resumeContent(),
                    this.managerPromise
                      .then(function () {
                        (t.manager.setVolume(t.player.volume),
                          t.elements.displayContainer.initialize());
                        try {
                          (t.initialized ||
                            (t.manager.init(
                              e.offsetWidth,
                              e.offsetHeight,
                              google.ima.ViewMode.NORMAL,
                            ),
                            t.manager.start()),
                            (t.initialized = !0));
                        } catch (e) {
                          t.onAdError(e);
                        }
                      })
                      .catch(function () {}));
                },
              },
              {
                key: "resumeContent",
                value: function () {
                  ((this.elements.container.style.zIndex = ""),
                    (this.playing = !1),
                    this.player.media.play());
                },
              },
              {
                key: "pauseContent",
                value: function () {
                  ((this.elements.container.style.zIndex = 3),
                    (this.playing = !0),
                    this.player.media.pause());
                },
              },
              {
                key: "cancel",
                value: function () {
                  (this.initialized && this.resumeContent(),
                    this.trigger("error"),
                    this.loadAds());
                },
              },
              {
                key: "loadAds",
                value: function () {
                  var t = this;
                  this.managerPromise
                    .then(function () {
                      (t.manager && t.manager.destroy(),
                        (t.managerPromise = new Promise(function (e) {
                          (t.on("loaded", e), t.player.debug.log(t.manager));
                        })),
                        t.requestAds());
                    })
                    .catch(function () {});
                },
              },
              {
                key: "trigger",
                value: function (t) {
                  for (
                    var e = this,
                      n = arguments.length,
                      i = new Array(n > 1 ? n - 1 : 0),
                      o = 1;
                    o < n;
                    o++
                  )
                    i[o - 1] = arguments[o];
                  var r = this.events[t];
                  Hl.array(r) &&
                    r.forEach(function (t) {
                      Hl.function(t) && t.apply(e, i);
                    });
                },
              },
              {
                key: "on",
                value: function (t, e) {
                  return (
                    Hl.array(this.events[t]) || (this.events[t] = []),
                    this.events[t].push(e),
                    this
                  );
                },
              },
              {
                key: "startSafetyTimer",
                value: function (t, e) {
                  var n = this;
                  (this.player.debug.log(
                    "Safety timer invoked from: ".concat(e),
                  ),
                    (this.safetyTimer = setTimeout(function () {
                      (n.cancel(), n.clearSafetyTimer("startSafetyTimer()"));
                    }, t)));
                },
              },
              {
                key: "clearSafetyTimer",
                value: function (t) {
                  Hl.nullOrUndefined(this.safetyTimer) ||
                    (this.player.debug.log(
                      "Safety timer cleared from: ".concat(t),
                    ),
                    clearTimeout(this.safetyTimer),
                    (this.safetyTimer = null));
                },
              },
              {
                key: "enabled",
                get: function () {
                  var t = this.config;
                  return (
                    this.player.isHTML5 &&
                    this.player.isVideo &&
                    t.enabled &&
                    (!Hl.empty(t.publisherId) || Hl.url(t.tagUrl))
                  );
                },
              },
              {
                key: "tagUrl",
                get: function () {
                  var t = this.config;
                  if (Hl.url(t.tagUrl)) return t.tagUrl;
                  var e = {
                    AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                    AV_CHANNELID: "5a0458dc28a06145e4519d21",
                    AV_URL: window.location.hostname,
                    cb: Date.now(),
                    AV_WIDTH: 640,
                    AV_HEIGHT: 480,
                    AV_CDIM2: this.publisherId,
                  };
                  return ""
                    .concat("https://go.aniview.com/api/adserver6/vast/", "?")
                    .concat(Kc(e));
                },
              },
            ]),
            t
          );
        })(),
        Au = oe.findIndex,
        Iu = !0;
      ("findIndex" in [] &&
        Array(1).findIndex(function () {
          Iu = !1;
        }),
        At(
          { target: "Array", proto: !0, forced: Iu },
          {
            findIndex: function (t) {
              return Au(this, t, arguments.length > 1 ? arguments[1] : void 0);
            },
          },
        ),
        Ye("findIndex"));
      var _u,
        Lu = (function () {
          function t(e) {
            (Rr(this, t),
              (this.player = e),
              (this.thumbnails = []),
              (this.loaded = !1),
              (this.lastMouseMoveTime = Date.now()),
              (this.mouseDown = !1),
              (this.loadedImages = []),
              (this.elements = { thumb: {}, scrubbing: {} }),
              this.load());
          }
          return (
            $r(t, [
              {
                key: "load",
                value: function () {
                  var t = this;
                  (this.player.elements.display.seekTooltip &&
                    (this.player.elements.display.seekTooltip.hidden =
                      this.enabled),
                    this.enabled &&
                      this.getThumbnails().then(function () {
                        t.enabled &&
                          (t.render(),
                          t.determineContainerAutoSizing(),
                          (t.loaded = !0));
                      }));
                },
              },
              {
                key: "getThumbnails",
                value: function () {
                  var t = this;
                  return new Promise(function (e) {
                    var n = t.player.config.previewThumbnails.src;
                    if (Hl.empty(n))
                      throw new Error(
                        "Missing previewThumbnails.src config attribute",
                      );
                    var i = (Hl.string(n) ? [n] : n).map(function (e) {
                      return t.getThumbnail(e);
                    });
                    Promise.all(i).then(function () {
                      (t.thumbnails.sort(function (t, e) {
                        return t.height - e.height;
                      }),
                        t.player.debug.log("Preview thumbnails", t.thumbnails),
                        e());
                    });
                  });
                },
              },
              {
                key: "getThumbnail",
                value: function (t) {
                  var e = this;
                  return new Promise(function (n) {
                    Wc(t).then(function (i) {
                      var o,
                        r,
                        s = {
                          frames:
                            ((o = i),
                            (r = []),
                            o.split(/\r\n\r\n|\n\n|\r\r/).forEach(function (t) {
                              var e = {};
                              (t.split(/\r\n|\n|\r/).forEach(function (t) {
                                if (Hl.number(e.startTime)) {
                                  if (!Hl.empty(t.trim()) && Hl.empty(e.text)) {
                                    var n = t.trim().split("#xywh="),
                                      i = Hr(n, 1);
                                    if (((e.text = i[0]), n[1])) {
                                      var o = Hr(n[1].split(","), 4);
                                      ((e.x = o[0]),
                                        (e.y = o[1]),
                                        (e.w = o[2]),
                                        (e.h = o[3]));
                                    }
                                  }
                                } else {
                                  var r = t.match(
                                    /([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/,
                                  );
                                  r &&
                                    ((e.startTime =
                                      60 * Number(r[1] || 0) * 60 +
                                      60 * Number(r[2]) +
                                      Number(r[3]) +
                                      Number("0.".concat(r[4]))),
                                    (e.endTime =
                                      60 * Number(r[6] || 0) * 60 +
                                      60 * Number(r[7]) +
                                      Number(r[8]) +
                                      Number("0.".concat(r[9]))));
                                }
                              }),
                                e.text && r.push(e));
                            }),
                            r),
                          height: null,
                          urlPrefix: "",
                        };
                      s.frames[0].text.startsWith("/") ||
                        s.frames[0].text.startsWith("http://") ||
                        s.frames[0].text.startsWith("https://") ||
                        (s.urlPrefix = t.substring(0, t.lastIndexOf("/") + 1));
                      var a = new Image();
                      ((a.onload = function () {
                        ((s.height = a.naturalHeight),
                          (s.width = a.naturalWidth),
                          e.thumbnails.push(s),
                          n());
                      }),
                        (a.src = s.urlPrefix + s.frames[0].text));
                    });
                  });
                },
              },
              {
                key: "startMove",
                value: function (t) {
                  if (
                    this.loaded &&
                    Hl.event(t) &&
                    ["touchmove", "mousemove"].includes(t.type) &&
                    this.player.media.duration
                  ) {
                    if ("touchmove" === t.type)
                      this.seekTime =
                        this.player.media.duration *
                        (this.player.elements.inputs.seek.value / 100);
                    else {
                      var e =
                          this.player.elements.progress.getBoundingClientRect(),
                        n = (100 / e.width) * (t.pageX - e.left);
                      ((this.seekTime = this.player.media.duration * (n / 100)),
                        this.seekTime < 0 && (this.seekTime = 0),
                        this.seekTime > this.player.media.duration - 1 &&
                          (this.seekTime = this.player.media.duration - 1),
                        (this.mousePosX = t.pageX),
                        (this.elements.thumb.time.innerText = Xc(
                          this.seekTime,
                        )));
                    }
                    this.showImageAtCurrentTime();
                  }
                },
              },
              {
                key: "endMove",
                value: function () {
                  this.toggleThumbContainer(!1, !0);
                },
              },
              {
                key: "startScrubbing",
                value: function (t) {
                  (!1 !== t.button && 0 !== t.button) ||
                    ((this.mouseDown = !0),
                    this.player.media.duration &&
                      (this.toggleScrubbingContainer(!0),
                      this.toggleThumbContainer(!1, !0),
                      this.showImageAtCurrentTime()));
                },
              },
              {
                key: "endScrubbing",
                value: function () {
                  var t = this;
                  ((this.mouseDown = !1),
                    Math.ceil(this.lastTime) ===
                    Math.ceil(this.player.media.currentTime)
                      ? this.toggleScrubbingContainer(!1)
                      : Gl.call(
                          this.player,
                          this.player.media,
                          "timeupdate",
                          function () {
                            t.mouseDown || t.toggleScrubbingContainer(!1);
                          },
                        ));
                },
              },
              {
                key: "listeners",
                value: function () {
                  var t = this;
                  (this.player.on("play", function () {
                    t.toggleThumbContainer(!1, !0);
                  }),
                    this.player.on("seeked", function () {
                      t.toggleThumbContainer(!1);
                    }),
                    this.player.on("timeupdate", function () {
                      t.lastTime = t.player.media.currentTime;
                    }));
                },
              },
              {
                key: "render",
                value: function () {
                  ((this.elements.thumb.container = nc("div", {
                    class:
                      this.player.config.classNames.previewThumbnails
                        .thumbContainer,
                  })),
                    (this.elements.thumb.imageContainer = nc("div", {
                      class:
                        this.player.config.classNames.previewThumbnails
                          .imageContainer,
                    })),
                    this.elements.thumb.container.appendChild(
                      this.elements.thumb.imageContainer,
                    ));
                  var t = nc("div", {
                    class:
                      this.player.config.classNames.previewThumbnails
                        .timeContainer,
                  });
                  ((this.elements.thumb.time = nc("span", {}, "00:00")),
                    t.appendChild(this.elements.thumb.time),
                    this.elements.thumb.container.appendChild(t),
                    Hl.element(this.player.elements.progress) &&
                      this.player.elements.progress.appendChild(
                        this.elements.thumb.container,
                      ),
                    (this.elements.scrubbing.container = nc("div", {
                      class:
                        this.player.config.classNames.previewThumbnails
                          .scrubbingContainer,
                    })),
                    this.player.elements.wrapper.appendChild(
                      this.elements.scrubbing.container,
                    ));
                },
              },
              {
                key: "showImageAtCurrentTime",
                value: function () {
                  var t = this;
                  this.mouseDown
                    ? this.setScrubbingContainerSize()
                    : this.setThumbContainerSizeAndPos();
                  var e = this.thumbnails[0].frames.findIndex(function (e) {
                      return (
                        t.seekTime >= e.startTime && t.seekTime <= e.endTime
                      );
                    }),
                    n = e >= 0,
                    i = 0;
                  (this.mouseDown || this.toggleThumbContainer(n),
                    n &&
                      (this.thumbnails.forEach(function (n, o) {
                        t.loadedImages.includes(n.frames[e].text) && (i = o);
                      }),
                      e !== this.showingThumb &&
                        ((this.showingThumb = e), this.loadImage(i))));
                },
              },
              {
                key: "loadImage",
                value: function () {
                  var t = this,
                    e =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : 0,
                    n = this.showingThumb,
                    i = this.thumbnails[e],
                    o = i.urlPrefix,
                    r = i.frames[n],
                    s = i.frames[n].text,
                    a = o + s;
                  if (
                    this.currentImageElement &&
                    this.currentImageElement.dataset.filename === s
                  )
                    (this.showImage(this.currentImageElement, r, e, n, s, !1),
                      (this.currentImageElement.dataset.index = n),
                      this.removeOldImages(this.currentImageElement));
                  else {
                    this.loadingImage &&
                      this.usingSprites &&
                      (this.loadingImage.onload = null);
                    var l = new Image();
                    ((l.src = a),
                      (l.dataset.index = n),
                      (l.dataset.filename = s),
                      (this.showingThumbFilename = s),
                      this.player.debug.log("Loading image: ".concat(a)),
                      (l.onload = function () {
                        return t.showImage(l, r, e, n, s, !0);
                      }),
                      (this.loadingImage = l),
                      this.removeOldImages(l));
                  }
                },
              },
              {
                key: "showImage",
                value: function (t, e, n, i, o) {
                  var r =
                    !(arguments.length > 5 && void 0 !== arguments[5]) ||
                    arguments[5];
                  (this.player.debug.log(
                    "Showing thumb: "
                      .concat(o, ". num: ")
                      .concat(i, ". qual: ")
                      .concat(n, ". newimg: ")
                      .concat(r),
                  ),
                    this.setImageSizeAndOffset(t, e),
                    r &&
                      (this.currentImageContainer.appendChild(t),
                      (this.currentImageElement = t),
                      this.loadedImages.includes(o) ||
                        this.loadedImages.push(o)),
                    this.preloadNearby(i, !0)
                      .then(this.preloadNearby(i, !1))
                      .then(this.getHigherQuality(n, t, e, o)));
                },
              },
              {
                key: "removeOldImages",
                value: function (t) {
                  var e = this;
                  Array.from(this.currentImageContainer.children).forEach(
                    function (n) {
                      if ("img" === n.tagName.toLowerCase()) {
                        var i = e.usingSprites ? 500 : 1e3;
                        if (
                          n.dataset.index !== t.dataset.index &&
                          !n.dataset.deleting
                        ) {
                          n.dataset.deleting = !0;
                          var o = e.currentImageContainer;
                          setTimeout(function () {
                            (o.removeChild(n),
                              e.player.debug.log(
                                "Removing thumb: ".concat(n.dataset.filename),
                              ));
                          }, i);
                        }
                      }
                    },
                  );
                },
              },
              {
                key: "preloadNearby",
                value: function (t) {
                  var e = this,
                    n =
                      !(arguments.length > 1 && void 0 !== arguments[1]) ||
                      arguments[1];
                  return new Promise(function (i) {
                    setTimeout(function () {
                      var o = e.thumbnails[0].frames[t].text;
                      if (e.showingThumbFilename === o) {
                        var r;
                        r = n
                          ? e.thumbnails[0].frames.slice(t)
                          : e.thumbnails[0].frames.slice(0, t).reverse();
                        var s = !1;
                        (r.forEach(function (t) {
                          var n = t.text;
                          if (n !== o && !e.loadedImages.includes(n)) {
                            ((s = !0),
                              e.player.debug.log(
                                "Preloading thumb filename: ".concat(n),
                              ));
                            var r = e.thumbnails[0].urlPrefix + n,
                              a = new Image();
                            ((a.src = r),
                              (a.onload = function () {
                                (e.player.debug.log(
                                  "Preloaded thumb filename: ".concat(n),
                                ),
                                  e.loadedImages.includes(n) ||
                                    e.loadedImages.push(n),
                                  i());
                              }));
                          }
                        }),
                          s || i());
                      }
                    }, 300);
                  });
                },
              },
              {
                key: "getHigherQuality",
                value: function (t, e, n, i) {
                  var o = this;
                  if (t < this.thumbnails.length - 1) {
                    var r = e.naturalHeight;
                    (this.usingSprites && (r = n.h),
                      r < this.thumbContainerHeight &&
                        setTimeout(function () {
                          o.showingThumbFilename === i &&
                            (o.player.debug.log(
                              "Showing higher quality thumb for: ".concat(i),
                            ),
                            o.loadImage(t + 1));
                        }, 300));
                  }
                },
              },
              {
                key: "toggleThumbContainer",
                value: function () {
                  var t =
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0],
                    e =
                      arguments.length > 1 &&
                      void 0 !== arguments[1] &&
                      arguments[1],
                    n =
                      this.player.config.classNames.previewThumbnails
                        .thumbContainerShown;
                  (this.elements.thumb.container.classList.toggle(n, t),
                    !t &&
                      e &&
                      ((this.showingThumb = null),
                      (this.showingThumbFilename = null)));
                },
              },
              {
                key: "toggleScrubbingContainer",
                value: function () {
                  var t =
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0],
                    e =
                      this.player.config.classNames.previewThumbnails
                        .scrubbingContainerShown;
                  (this.elements.scrubbing.container.classList.toggle(e, t),
                    t ||
                      ((this.showingThumb = null),
                      (this.showingThumbFilename = null)));
                },
              },
              {
                key: "determineContainerAutoSizing",
                value: function () {
                  this.elements.thumb.imageContainer.clientHeight > 20 &&
                    (this.sizeSpecifiedInCSS = !0);
                },
              },
              {
                key: "setThumbContainerSizeAndPos",
                value: function () {
                  if (!this.sizeSpecifiedInCSS) {
                    var t = Math.floor(
                      this.thumbContainerHeight * this.thumbAspectRatio,
                    );
                    ((this.elements.thumb.imageContainer.style.height =
                      "".concat(this.thumbContainerHeight, "px")),
                      (this.elements.thumb.imageContainer.style.width =
                        "".concat(t, "px")));
                  }
                  this.setThumbContainerPos();
                },
              },
              {
                key: "setThumbContainerPos",
                value: function () {
                  var t = this.player.elements.progress.getBoundingClientRect(),
                    e = this.player.elements.container.getBoundingClientRect(),
                    n = this.elements.thumb.container,
                    i = e.left - t.left + 10,
                    o = e.right - t.left - n.clientWidth - 10,
                    r = this.mousePosX - t.left - n.clientWidth / 2;
                  (r < i && (r = i),
                    r > o && (r = o),
                    (n.style.left = "".concat(r, "px")));
                },
              },
              {
                key: "setScrubbingContainerSize",
                value: function () {
                  ((this.elements.scrubbing.container.style.width = "".concat(
                    this.player.media.clientWidth,
                    "px",
                  )),
                    (this.elements.scrubbing.container.style.height = "".concat(
                      this.player.media.clientWidth / this.thumbAspectRatio,
                      "px",
                    )));
                },
              },
              {
                key: "setImageSizeAndOffset",
                value: function (t, e) {
                  if (this.usingSprites) {
                    var n = this.thumbContainerHeight / e.h;
                    ((t.style.height = "".concat(
                      Math.floor(t.naturalHeight * n),
                      "px",
                    )),
                      (t.style.width = "".concat(
                        Math.floor(t.naturalWidth * n),
                        "px",
                      )),
                      (t.style.left = "-".concat(e.x * n, "px")),
                      (t.style.top = "-".concat(e.y * n, "px")));
                  }
                },
              },
              {
                key: "enabled",
                get: function () {
                  return (
                    this.player.isHTML5 &&
                    this.player.isVideo &&
                    this.player.config.previewThumbnails.enabled
                  );
                },
              },
              {
                key: "currentImageContainer",
                get: function () {
                  return this.mouseDown
                    ? this.elements.scrubbing.container
                    : this.elements.thumb.imageContainer;
                },
              },
              {
                key: "usingSprites",
                get: function () {
                  return Object.keys(this.thumbnails[0].frames[0]).includes(
                    "w",
                  );
                },
              },
              {
                key: "thumbAspectRatio",
                get: function () {
                  return this.usingSprites
                    ? this.thumbnails[0].frames[0].w /
                        this.thumbnails[0].frames[0].h
                    : this.thumbnails[0].width / this.thumbnails[0].height;
                },
              },
              {
                key: "thumbContainerHeight",
                get: function () {
                  return this.mouseDown
                    ? Math.floor(
                        this.player.media.clientWidth / this.thumbAspectRatio,
                      )
                    : Math.floor(
                        this.player.media.clientWidth /
                          this.thumbAspectRatio /
                          4,
                      );
                },
              },
              {
                key: "currentImageElement",
                get: function () {
                  return this.mouseDown
                    ? this.currentScrubbingImageElement
                    : this.currentThumbnailImageElement;
                },
                set: function (t) {
                  this.mouseDown
                    ? (this.currentScrubbingImageElement = t)
                    : (this.currentThumbnailImageElement = t);
                },
              },
            ]),
            t
          );
        })(),
        zu = {
          insertElements: function (t, e) {
            var n = this;
            Hl.string(e)
              ? ic(t, this.media, { src: e })
              : Hl.array(e) &&
                e.forEach(function (e) {
                  ic(t, n.media, e);
                });
          },
          change: function (t) {
            var e = this;
            Zl(t, "sources.length")
              ? (Sc.cancelRequests.call(this),
                this.destroy.call(
                  this,
                  function () {
                    ((e.options.quality = []),
                      oc(e.media),
                      (e.media = null),
                      Hl.element(e.elements.container) &&
                        e.elements.container.removeAttribute("class"));
                    var n = t.sources,
                      i = t.type,
                      o = Hr(n, 1)[0],
                      r = o.provider,
                      s = void 0 === r ? eu.html5 : r,
                      a = o.src,
                      l = "html5" === s ? i : "div",
                      c = "html5" === s ? {} : { src: a };
                    (Object.assign(e, {
                      provider: s,
                      type: i,
                      supported: vc.check(i, s, e.config.playsinline),
                      media: nc(l, c),
                    }),
                      e.elements.container.appendChild(e.media),
                      Hl.boolean(t.autoplay) &&
                        (e.config.autoplay = t.autoplay),
                      e.isHTML5 &&
                        (e.config.crossorigin &&
                          e.media.setAttribute("crossorigin", ""),
                        e.config.autoplay &&
                          e.media.setAttribute("autoplay", ""),
                        Hl.empty(t.poster) || (e.poster = t.poster),
                        e.config.loop.active &&
                          e.media.setAttribute("loop", ""),
                        e.config.muted && e.media.setAttribute("muted", ""),
                        e.config.playsinline &&
                          e.media.setAttribute("playsinline", "")),
                      hu.addStyleHook.call(e),
                      e.isHTML5 && zu.insertElements.call(e, "source", n),
                      (e.config.title = t.title),
                      Tu.setup.call(e),
                      e.isHTML5 &&
                        Object.keys(t).includes("tracks") &&
                        zu.insertElements.call(e, "track", t.tracks),
                      (e.isHTML5 || (e.isEmbed && !e.supported.ui)) &&
                        hu.build.call(e),
                      e.isHTML5 && e.media.load(),
                      e.previewThumbnails && e.previewThumbnails.load(),
                      e.fullscreen.update());
                  },
                  !0,
                ))
              : this.debug.warn("Invalid source format");
          },
        },
        Mu = (function () {
          function t(e, n) {
            var i = this;
            if (
              (Rr(this, t),
              (this.timers = {}),
              (this.ready = !1),
              (this.loading = !1),
              (this.failed = !1),
              (this.touch = vc.touch),
              (this.media = e),
              Hl.string(this.media) &&
                (this.media = document.querySelectorAll(this.media)),
              ((window.jQuery && this.media instanceof jQuery) ||
                Hl.nodeList(this.media) ||
                Hl.array(this.media)) &&
                (this.media = this.media[0]),
              (this.config = Jl(
                {},
                Jc,
                t.defaults,
                n || {},
                (function () {
                  try {
                    return JSON.parse(i.media.getAttribute("data-plyr-config"));
                  } catch (t) {
                    return {};
                  }
                })(),
              )),
              (this.elements = {
                container: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: { popup: null, menu: null, panels: {}, buttons: {} },
              }),
              (this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap(),
              }),
              (this.fullscreen = { active: !1 }),
              (this.options = { speed: [], quality: [] }),
              (this.debug = new ru(this.config.debug)),
              this.debug.log("Config", this.config),
              this.debug.log("Support", vc),
              !Hl.nullOrUndefined(this.media) && Hl.element(this.media))
            )
              if (this.media.plyr) this.debug.warn("Target already setup");
              else if (this.config.enabled)
                if (vc.check().api) {
                  var o = this.media.cloneNode(!0);
                  ((o.autoplay = !1), (this.elements.original = o));
                  var r = this.media.tagName.toLowerCase(),
                    s = null,
                    a = null;
                  switch (r) {
                    case "div":
                      if (
                        ((s = this.media.querySelector("iframe")),
                        Hl.element(s))
                      ) {
                        if (
                          ((a = Gc(s.getAttribute("src"))),
                          (this.provider = (function (t) {
                            return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                              t,
                            )
                              ? eu.youtube
                              : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(
                                    t,
                                  )
                                ? eu.vimeo
                                : null;
                          })(a.toString())),
                          (this.elements.container = this.media),
                          (this.media = s),
                          (this.elements.container.className = ""),
                          a.search.length)
                        ) {
                          var l = ["1", "true"];
                          (l.includes(a.searchParams.get("autoplay")) &&
                            (this.config.autoplay = !0),
                            l.includes(a.searchParams.get("loop")) &&
                              (this.config.loop.active = !0),
                            this.isYouTube
                              ? ((this.config.playsinline = l.includes(
                                  a.searchParams.get("playsinline"),
                                )),
                                (this.config.youtube.hl =
                                  a.searchParams.get("hl")))
                              : (this.config.playsinline = !0));
                        }
                      } else
                        ((this.provider = this.media.getAttribute(
                          this.config.attributes.embed.provider,
                        )),
                          this.media.removeAttribute(
                            this.config.attributes.embed.provider,
                          ));
                      if (
                        Hl.empty(this.provider) ||
                        !Object.keys(eu).includes(this.provider)
                      )
                        return void this.debug.error(
                          "Setup failed: Invalid provider",
                        );
                      this.type = iu;
                      break;
                    case "video":
                    case "audio":
                      ((this.type = r),
                        (this.provider = eu.html5),
                        this.media.hasAttribute("crossorigin") &&
                          (this.config.crossorigin = !0),
                        this.media.hasAttribute("autoplay") &&
                          (this.config.autoplay = !0),
                        (this.media.hasAttribute("playsinline") ||
                          this.media.hasAttribute("webkit-playsinline")) &&
                          (this.config.playsinline = !0),
                        this.media.hasAttribute("muted") &&
                          (this.config.muted = !0),
                        this.media.hasAttribute("loop") &&
                          (this.config.loop.active = !0));
                      break;
                    default:
                      return void this.debug.error(
                        "Setup failed: unsupported type",
                      );
                  }
                  ((this.supported = vc.check(
                    this.type,
                    this.provider,
                    this.config.playsinline,
                  )),
                    this.supported.api
                      ? ((this.eventListeners = []),
                        (this.listeners = new du(this)),
                        (this.storage = new Hc(this)),
                        (this.media.plyr = this),
                        Hl.element(this.elements.container) ||
                          ((this.elements.container = nc("div", {
                            tabindex: 0,
                          })),
                          tc(this.media, this.elements.container)),
                        hu.addStyleHook.call(this),
                        Tu.setup.call(this),
                        this.config.debug &&
                          Xl.call(
                            this,
                            this.elements.container,
                            this.config.events.join(" "),
                            function (t) {
                              i.debug.log("event: ".concat(t.type));
                            },
                          ),
                        (this.isHTML5 ||
                          (this.isEmbed && !this.supported.ui)) &&
                          hu.build.call(this),
                        this.listeners.container(),
                        this.listeners.global(),
                        (this.fullscreen = new lu(this)),
                        this.config.ads.enabled && (this.ads = new Pu(this)),
                        this.isHTML5 &&
                          this.config.autoplay &&
                          setTimeout(function () {
                            return i.play();
                          }, 10),
                        (this.lastSeekTime = 0),
                        this.config.previewThumbnails.enabled &&
                          (this.previewThumbnails = new Lu(this)))
                      : this.debug.error("Setup failed: no support"));
                } else this.debug.error("Setup failed: no support");
              else this.debug.error("Setup failed: disabled by config");
            else this.debug.error("Setup failed: no suitable element passed");
          }
          return (
            $r(
              t,
              [
                {
                  key: "play",
                  value: function () {
                    var t = this;
                    return Hl.function(this.media.play)
                      ? (this.ads &&
                          this.ads.enabled &&
                          this.ads.managerPromise
                            .then(function () {
                              return t.ads.play();
                            })
                            .catch(function () {
                              return t.media.play();
                            }),
                        this.media.play())
                      : null;
                  },
                },
                {
                  key: "pause",
                  value: function () {
                    this.playing &&
                      Hl.function(this.media.pause) &&
                      this.media.pause();
                  },
                },
                {
                  key: "togglePlay",
                  value: function (t) {
                    (Hl.boolean(t) ? t : !this.playing)
                      ? this.play()
                      : this.pause();
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    this.isHTML5
                      ? (this.pause(), this.restart())
                      : Hl.function(this.media.stop) && this.media.stop();
                  },
                },
                {
                  key: "restart",
                  value: function () {
                    this.currentTime = 0;
                  },
                },
                {
                  key: "rewind",
                  value: function (t) {
                    this.currentTime =
                      this.currentTime -
                      (Hl.number(t) ? t : this.config.seekTime);
                  },
                },
                {
                  key: "forward",
                  value: function (t) {
                    this.currentTime =
                      this.currentTime +
                      (Hl.number(t) ? t : this.config.seekTime);
                  },
                },
                {
                  key: "increaseVolume",
                  value: function (t) {
                    var e = this.media.muted ? 0 : this.volume;
                    this.volume = e + (Hl.number(t) ? t : 0);
                  },
                },
                {
                  key: "decreaseVolume",
                  value: function (t) {
                    this.increaseVolume(-t);
                  },
                },
                {
                  key: "toggleCaptions",
                  value: function (t) {
                    Zc.toggle.call(this, t, !1);
                  },
                },
                {
                  key: "airplay",
                  value: function () {
                    vc.airplay && this.media.webkitShowPlaybackTargetPicker();
                  },
                },
                {
                  key: "toggleControls",
                  value: function (t) {
                    if (this.supported.ui && !this.isAudio) {
                      var e = uc(
                          this.elements.container,
                          this.config.classNames.hideControls,
                        ),
                        n = void 0 === t ? void 0 : !t,
                        i = cc(
                          this.elements.container,
                          this.config.classNames.hideControls,
                          n,
                        );
                      if (
                        (i &&
                          this.config.controls.includes("settings") &&
                          !Hl.empty(this.config.settings) &&
                          Qc.toggleMenu.call(this, !1),
                        i !== e)
                      ) {
                        var o = i ? "controlshidden" : "controlsshown";
                        Kl.call(this, this.media, o);
                      }
                      return !i;
                    }
                    return !1;
                  },
                },
                {
                  key: "on",
                  value: function (t, e) {
                    Xl.call(this, this.elements.container, t, e);
                  },
                },
                {
                  key: "once",
                  value: function (t, e) {
                    Gl.call(this, this.elements.container, t, e);
                  },
                },
                {
                  key: "off",
                  value: function (t, e) {
                    Ql(this.elements.container, t, e);
                  },
                },
                {
                  key: "destroy",
                  value: function (t) {
                    var e = this,
                      n =
                        arguments.length > 1 &&
                        void 0 !== arguments[1] &&
                        arguments[1];
                    if (this.ready) {
                      var i = function () {
                        ((document.body.style.overflow = ""),
                          (e.embed = null),
                          n
                            ? (Object.keys(e.elements).length &&
                                (oc(e.elements.buttons.play),
                                oc(e.elements.captions),
                                oc(e.elements.controls),
                                oc(e.elements.wrapper),
                                (e.elements.buttons.play = null),
                                (e.elements.captions = null),
                                (e.elements.controls = null),
                                (e.elements.wrapper = null)),
                              Hl.function(t) && t())
                            : (function () {
                                this &&
                                  this.eventListeners &&
                                  (this.eventListeners.forEach(function (t) {
                                    var e = t.element,
                                      n = t.type,
                                      i = t.callback,
                                      o = t.options;
                                    e.removeEventListener(n, i, o);
                                  }),
                                  (this.eventListeners = []));
                              }.call(e),
                              sc(e.elements.original, e.elements.container),
                              Kl.call(e, e.elements.original, "destroyed", !0),
                              Hl.function(t) && t.call(e.elements.original),
                              (e.ready = !1),
                              setTimeout(function () {
                                ((e.elements = null), (e.media = null));
                              }, 200)));
                      };
                      (this.stop(),
                        clearTimeout(this.timers.loading),
                        clearTimeout(this.timers.controls),
                        clearTimeout(this.timers.resized),
                        this.isHTML5
                          ? (hu.toggleNativeControls.call(this, !0), i())
                          : this.isYouTube
                            ? (clearInterval(this.timers.buffering),
                              clearInterval(this.timers.playing),
                              null !== this.embed &&
                                Hl.function(this.embed.destroy) &&
                                this.embed.destroy(),
                              i())
                            : this.isVimeo &&
                              (null !== this.embed &&
                                this.embed.unload().then(i),
                              setTimeout(i, 200)));
                    }
                  },
                },
                {
                  key: "supports",
                  value: function (t) {
                    return vc.mime.call(this, t);
                  },
                },
                {
                  key: "isHTML5",
                  get: function () {
                    return this.provider === eu.html5;
                  },
                },
                {
                  key: "isEmbed",
                  get: function () {
                    return this.isYouTube || this.isVimeo;
                  },
                },
                {
                  key: "isYouTube",
                  get: function () {
                    return this.provider === eu.youtube;
                  },
                },
                {
                  key: "isVimeo",
                  get: function () {
                    return this.provider === eu.vimeo;
                  },
                },
                {
                  key: "isVideo",
                  get: function () {
                    return this.type === iu;
                  },
                },
                {
                  key: "isAudio",
                  get: function () {
                    return this.type === nu;
                  },
                },
                {
                  key: "playing",
                  get: function () {
                    return Boolean(this.ready && !this.paused && !this.ended);
                  },
                },
                {
                  key: "paused",
                  get: function () {
                    return Boolean(this.media.paused);
                  },
                },
                {
                  key: "stopped",
                  get: function () {
                    return Boolean(this.paused && 0 === this.currentTime);
                  },
                },
                {
                  key: "ended",
                  get: function () {
                    return Boolean(this.media.ended);
                  },
                },
                {
                  key: "currentTime",
                  set: function (t) {
                    if (this.duration) {
                      var e = Hl.number(t) && t > 0;
                      ((this.media.currentTime = e
                        ? Math.min(t, this.duration)
                        : 0),
                        this.debug.log(
                          "Seeking to ".concat(this.currentTime, " seconds"),
                        ));
                    }
                  },
                  get: function () {
                    return Number(this.media.currentTime);
                  },
                },
                {
                  key: "buffered",
                  get: function () {
                    var t = this.media.buffered;
                    return Hl.number(t)
                      ? t
                      : t && t.length && this.duration > 0
                        ? t.end(0) / this.duration
                        : 0;
                  },
                },
                {
                  key: "seeking",
                  get: function () {
                    return Boolean(this.media.seeking);
                  },
                },
                {
                  key: "duration",
                  get: function () {
                    var t = parseFloat(this.config.duration),
                      e = (this.media || {}).duration,
                      n = Hl.number(e) && e !== 1 / 0 ? e : 0;
                    return t || n;
                  },
                },
                {
                  key: "volume",
                  set: function (t) {
                    var e = t;
                    (Hl.string(e) && (e = Number(e)),
                      Hl.number(e) || (e = this.storage.get("volume")),
                      Hl.number(e) || (e = this.config.volume),
                      e > 1 && (e = 1),
                      e < 0 && (e = 0),
                      (this.config.volume = e),
                      (this.media.volume = e),
                      !Hl.empty(t) && this.muted && e > 0 && (this.muted = !1));
                  },
                  get: function () {
                    return Number(this.media.volume);
                  },
                },
                {
                  key: "muted",
                  set: function (t) {
                    var e = t;
                    (Hl.boolean(e) || (e = this.storage.get("muted")),
                      Hl.boolean(e) || (e = this.config.muted),
                      (this.config.muted = e),
                      (this.media.muted = e));
                  },
                  get: function () {
                    return Boolean(this.media.muted);
                  },
                },
                {
                  key: "hasAudio",
                  get: function () {
                    return (
                      !this.isHTML5 ||
                      !!this.isAudio ||
                      Boolean(this.media.mozHasAudio) ||
                      Boolean(this.media.webkitAudioDecodedByteCount) ||
                      Boolean(
                        this.media.audioTracks && this.media.audioTracks.length,
                      )
                    );
                  },
                },
                {
                  key: "speed",
                  set: function (t) {
                    var e = this,
                      n = null;
                    (Hl.number(t) && (n = t),
                      Hl.number(n) || (n = this.storage.get("speed")),
                      Hl.number(n) || (n = this.config.speed.selected));
                    var i = this.minimumSpeed,
                      o = this.maximumSpeed;
                    ((n = (function () {
                      var t =
                          arguments.length > 0 && void 0 !== arguments[0]
                            ? arguments[0]
                            : 0,
                        e =
                          arguments.length > 1 && void 0 !== arguments[1]
                            ? arguments[1]
                            : 0,
                        n =
                          arguments.length > 2 && void 0 !== arguments[2]
                            ? arguments[2]
                            : 255;
                      return Math.min(Math.max(t, e), n);
                    })(n, i, o)),
                      (this.config.speed.selected = n),
                      setTimeout(function () {
                        e.media.playbackRate = n;
                      }, 0));
                  },
                  get: function () {
                    return Number(this.media.playbackRate);
                  },
                },
                {
                  key: "minimumSpeed",
                  get: function () {
                    return this.isYouTube
                      ? Math.min.apply(Math, Wr(this.options.speed))
                      : this.isVimeo
                        ? 0.5
                        : 0.0625;
                  },
                },
                {
                  key: "maximumSpeed",
                  get: function () {
                    return this.isYouTube
                      ? Math.max.apply(Math, Wr(this.options.speed))
                      : this.isVimeo
                        ? 2
                        : 16;
                  },
                },
                {
                  key: "quality",
                  set: function (t) {
                    var e = this.config.quality,
                      n = this.options.quality;
                    if (n.length) {
                      var i = [
                          !Hl.empty(t) && Number(t),
                          this.storage.get("quality"),
                          e.selected,
                          e.default,
                        ].find(Hl.number),
                        o = !0;
                      if (!n.includes(i)) {
                        var r = (function (t, e) {
                          return Hl.array(t) && t.length
                            ? t.reduce(function (t, n) {
                                return Math.abs(n - e) < Math.abs(t - e)
                                  ? n
                                  : t;
                              })
                            : null;
                        })(n, i);
                        (this.debug.warn(
                          "Unsupported quality option: "
                            .concat(i, ", using ")
                            .concat(r, " instead"),
                        ),
                          (i = r),
                          (o = !1));
                      }
                      ((e.selected = i),
                        (this.media.quality = i),
                        o && this.storage.set({ quality: i }));
                    }
                  },
                  get: function () {
                    return this.media.quality;
                  },
                },
                {
                  key: "loop",
                  set: function (t) {
                    var e = Hl.boolean(t) ? t : this.config.loop.active;
                    ((this.config.loop.active = e), (this.media.loop = e));
                  },
                  get: function () {
                    return Boolean(this.media.loop);
                  },
                },
                {
                  key: "source",
                  set: function (t) {
                    zu.change.call(this, t);
                  },
                  get: function () {
                    return this.media.currentSrc;
                  },
                },
                {
                  key: "download",
                  get: function () {
                    var t = this.config.urls.download;
                    return Hl.url(t) ? t : this.source;
                  },
                  set: function (t) {
                    Hl.url(t) &&
                      ((this.config.urls.download = t),
                      Qc.setDownloadUrl.call(this));
                  },
                },
                {
                  key: "poster",
                  set: function (t) {
                    this.isVideo
                      ? hu.setPoster.call(this, t, !1).catch(function () {})
                      : this.debug.warn("Poster can only be set for video");
                  },
                  get: function () {
                    return this.isVideo
                      ? this.media.getAttribute("poster")
                      : null;
                  },
                },
                {
                  key: "ratio",
                  get: function () {
                    if (!this.isVideo) return null;
                    var t = bc(wc.call(this));
                    return Hl.array(t) ? t.join(":") : t;
                  },
                  set: function (t) {
                    this.isVideo
                      ? Hl.string(t) && yc(t)
                        ? ((this.config.ratio = t), xc.call(this))
                        : this.debug.error(
                            "Invalid aspect ratio specified (".concat(t, ")"),
                          )
                      : this.debug.warn(
                          "Aspect ratio can only be set for video",
                        );
                  },
                },
                {
                  key: "autoplay",
                  set: function (t) {
                    var e = Hl.boolean(t) ? t : this.config.autoplay;
                    this.config.autoplay = e;
                  },
                  get: function () {
                    return Boolean(this.config.autoplay);
                  },
                },
                {
                  key: "currentTrack",
                  set: function (t) {
                    Zc.set.call(this, t, !1);
                  },
                  get: function () {
                    var t = this.captions,
                      e = t.toggled,
                      n = t.currentTrack;
                    return e ? n : -1;
                  },
                },
                {
                  key: "language",
                  set: function (t) {
                    Zc.setLanguage.call(this, t, !1);
                  },
                  get: function () {
                    return (Zc.getCurrentTrack.call(this) || {}).language;
                  },
                },
                {
                  key: "pip",
                  set: function (t) {
                    if (vc.pip) {
                      var e = Hl.boolean(t) ? t : !this.pip;
                      (Hl.function(this.media.webkitSetPresentationMode) &&
                        this.media.webkitSetPresentationMode(e ? tu : "inline"),
                        Hl.function(this.media.requestPictureInPicture) &&
                          (!this.pip && e
                            ? this.media.requestPictureInPicture()
                            : this.pip &&
                              !e &&
                              document.exitPictureInPicture()));
                    }
                  },
                  get: function () {
                    return vc.pip
                      ? Hl.empty(this.media.webkitPresentationMode)
                        ? this.media === document.pictureInPictureElement
                        : this.media.webkitPresentationMode === tu
                      : null;
                  },
                },
              ],
              [
                {
                  key: "supported",
                  value: function (t, e, n) {
                    return vc.check(t, e, n);
                  },
                },
                {
                  key: "loadSprite",
                  value: function (t, e) {
                    return Bc(t, e);
                  },
                },
                {
                  key: "setup",
                  value: function (e) {
                    var n =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : {},
                      i = null;
                    return (
                      Hl.string(e)
                        ? (i = Array.from(document.querySelectorAll(e)))
                        : Hl.nodeList(e)
                          ? (i = Array.from(e))
                          : Hl.array(e) && (i = e.filter(Hl.element)),
                      Hl.empty(i)
                        ? null
                        : i.map(function (e) {
                            return new t(e, n);
                          })
                    );
                  },
                },
              ],
            ),
            t
          );
        })();
      return ((Mu.defaults = ((_u = Jc), JSON.parse(JSON.stringify(_u)))), Mu);
    }));